//-----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//-----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class AconexClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * API17051 - POST Aconex Authorization Code
     * @param body (optional) 
     * @return No Content
     */
    postAuthorizationCode(body?: PostAuthorizationCodeRequestModel | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Aconex/authorizationCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostAuthorizationCode(_response);
        });
    }

    protected processPostAuthorizationCode(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 424) {
            const _responseText = response.data;
            let result424: any = null;
            let resultData424 = _responseText;
            result424 = ProblemDetails.fromJS(resultData424);
            return throwException("Failed Dependency", status, _responseText, _headers, result424);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * API17052 - GET Aconex User Profile
     * @return OK
     */
    getUserProfile(cancelToken?: CancelToken): Promise<GetUserProfileResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Aconex/userProfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserProfile(_response);
        });
    }

    protected processGetUserProfile(response: AxiosResponse): Promise<GetUserProfileResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetUserProfileResponseModel.fromJS(resultData200);
            return Promise.resolve<GetUserProfileResponseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserProfileResponseModel>(null as any);
    }

    /**
     * API17053 - GET Aconex Access Token Validity
     * @return OK
     */
    getAccessTokenValidity(cancelToken?: CancelToken): Promise<GetAccessTokenValidityResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Aconex/accessToken/validity";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccessTokenValidity(_response);
        });
    }

    protected processGetAccessTokenValidity(response: AxiosResponse): Promise<GetAccessTokenValidityResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetAccessTokenValidityResponseModel.fromJS(resultData200);
            return Promise.resolve<GetAccessTokenValidityResponseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAccessTokenValidityResponseModel>(null as any);
    }

    /**
     * API17054 - POST Remove Aconex Access Token
     * @return No Content
     */
    postRemoveAconexAccessToken(cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Aconex/accessToken/delete";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostRemoveAconexAccessToken(_response);
        });
    }

    protected processPostRemoveAconexAccessToken(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * API17056 - GET Aconex Projects
     * @return OK
     */
    getAconexProjects(cancelToken?: CancelToken): Promise<GetAconexProjectsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Aconex/projects";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAconexProjects(_response);
        });
    }

    protected processGetAconexProjects(response: AxiosResponse): Promise<GetAconexProjectsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetAconexProjectsResponseModel.fromJS(resultData200);
            return Promise.resolve<GetAconexProjectsResponseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAconexProjectsResponseModel>(null as any);
    }

    /**
     * API17060 - GET Search Aconex Mail
     * @param projectId Aconex Project Id originally obtained from call to <seealso cref="M:OneTrack.Api.V1.AconexController.GetAconexProjects(OneTrack.Api.Commands.Aconex.IGetAconexProjectsCommand,System.Threading.CancellationToken)">API17056 - GET Aconex Projects</seealso>
     * @param mailBox One of:
    <list type="bullet"><item>inbox </item><item>sentbox </item></list> (There is no need for a OneTrack user to be searching draftbox.)
     * @param query (optional) Lucene search query. 

    Field names available for searching: 
    <list type="bullet"><item>attribute </item><item>secondaryattribute </item><item>thirdattribute </item><item>fourthattribute </item><item>closedoutdate </item><item>corrdata </item><item>corrtypeid </item><item>docno </item><item>fromtradingname </item><item>fromuserfullname </item><item>inreftomailno </item><item>reasonforissueid </item><item>responsedate </item><item>sentdate </item><item>subject </item><item>tostatusid </item><item>totradingname </item><item>touserfullname </item></list>

    Note: Without a search_query, every document in the project is returned.
     * @param pageSize (optional) If specified, the value must be a number that is divisible by 25. Without this parameter specified, this defaults to 25. 

    Note: This parameter has a maximum value of 500
     * @param pageNumber (optional) If specified, the value must be between "1" and the value of the "TotalPages" attribute that is in the response, otherwise an error is returned. Without this parameter specified, this defaults to 1.
     * @param sortField (optional) The name of the field to sort the search results by. Results can only be sorted by a single field, although it does not have to be one of the fields specified in the return_fields parameter. 

    Field names available for sorting are:
    <list><item>confidential </item><item>corrtypeid </item><item>docno </item><item>inreftomailno </item><item>reasonforissueid </item><item>responsedate </item><item>sentdate </item><item>subject </item></list>
     * @param sortDirection (optional) One of:
    <list type="bullet"><item>ASC, ascending order </item><item>DESC, descending order </item></list>
    Note: Without this parameter specified, sort defaults to ASC.
     * @return OK
     */
    getSearchAconexMail(projectId: string, mailBox: string, query?: string | null | undefined, pageSize?: number | null | undefined, pageNumber?: number | null | undefined, sortField?: string | null | undefined, sortDirection?: string | null | undefined, cancelToken?: CancelToken): Promise<GetSearchAconexMailResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Aconex/projects/{projectId}/mail/search?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (mailBox === undefined || mailBox === null)
            throw new Error("The parameter 'mailBox' must be defined and cannot be null.");
        else
            url_ += "MailBox=" + encodeURIComponent("" + mailBox) + "&";
        if (query !== undefined && query !== null)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSearchAconexMail(_response);
        });
    }

    protected processGetSearchAconexMail(response: AxiosResponse): Promise<GetSearchAconexMailResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetSearchAconexMailResponseModel.fromJS(resultData200);
            return Promise.resolve<GetSearchAconexMailResponseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSearchAconexMailResponseModel>(null as any);
    }

    /**
     * API17061 - GET Search Aconex Documents
     * @param projectId Aconex Project Id originally obtained from call to <seealso cref="M:OneTrack.Api.V1.AconexController.GetAconexProjects(OneTrack.Api.Commands.Aconex.IGetAconexProjectsCommand,System.Threading.CancellationToken)">API17056 - GET Aconex Projects</seealso>
     * @param query (optional) Lucene search query. 

    Without a search_query, every document in the project is returned. 

    If search query only contains Lucence Single Terms (separated by spaces), a "*" will be automatically appended to each term to do a wildcard search. See more in Apache Lucene - Query Parser Syntax .  

    Please refer to the notes below for further information about Lucene. 

    Field names available for searching are: 
    <list type="bullet"><item>approved </item><item>asBuiltRequired </item><item>attribute </item><item>secondaryattribute </item><item>attribute3 </item><item>attribute4 </item><item>author </item><item>category </item><item>contractnumber </item><item>contractordocumentnumber </item><item>contractorrev </item><item>date1 </item><item>date2 </item><item>discipline </item><item>docno </item><item>doctype </item><item>forreview </item><item>markupdate </item><item>milestonedate </item><item>packagenumber </item><item>plannedsubmissiondate </item><item>received </item><item>reference </item><item>registered </item><item>reviewed </item><item>reviewstatus </item><item>revision </item><item>revisiondate </item><item>scale </item><item>selectlist1 </item><item>selectlist2 </item><item>selectlist3 </item><item>selectlist4 </item><item>selectlist5 </item><item>selectlist6 </item><item>selectlist7 </item><item>selectlist8 </item><item>selectlist9 </item><item>selectlist10 </item><item>statusid </item><item>title </item><item>toclient </item><item>trackingid </item><item>uploaddate </item><item>vdrcode </item><item>vendordocumentnumber </item><item>vendorrev </item></list>
     * @param pageSize (optional) If specified, the value must be a number that is divisible by 25. Without this parameter specified, this defaults to 25. 

    Note: This parameter has a maximum value of 500
     * @param pageNumber (optional) If specified, the value must be between "1" and the value of the "TotalPages" attribute that is in the response, otherwise an error is returned. Without this parameter specified, this defaults to 1.
     * @param sortField (optional) The name of the field to sort the search results by. Results can only be sorted by a single field, although it does not have to be one of the fields specified in the return_fields parameter. 

    Field names available for sorting are:
    <list type="bullet"><item>approved </item><item>asBuiltRequired </item><item>attribute1 </item><item>attribute2 </item><item>attribute3 </item><item>attribute4 </item><item>author </item><item>authorisedBy </item><item>category </item><item>check1 </item><item>check2 </item><item>confidential </item><item>contractDeliverable </item><item>contractnumber </item><item>contractordocumentnumber </item><item>contractorrev </item><item>date1 </item><item>date2 </item><item>docno </item><item>doctype </item><item>fileSize </item><item>fileType </item><item>forreview </item><item>markupLastModifiedDate </item><item>milestonedate </item><item>numberOfMarkups </item><item>packageNumber </item><item>percentComplete </item><item>plannedsubmissiondate </item><item>printSize </item><item>received </item><item>reference </item><item>registered </item><item>reviewed </item><item>reviewSource </item><item>reviewstatus </item><item>revision </item><item>revisiondate </item><item>scale </item><item>statusid </item><item>tagNumber </item><item>toclient </item><item>trackingid </item><item>vdrcode </item><item>vendorrev </item></list>
     * @param sortDirection (optional) One of:
    <list type="bullet"><item>ASC, ascending order </item><item>DESC, descending order </item></list>
    Note: Without this parameter specified, sort defaults to ASC.
     * @return OK
     */
    getSearchAconexDocuments(projectId: string, query?: string | null | undefined, pageSize?: number | null | undefined, pageNumber?: number | null | undefined, sortField?: string | null | undefined, sortDirection?: string | null | undefined, cancelToken?: CancelToken): Promise<GetSearchAconexDocumentsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Aconex/projects/{projectId}/documents/search?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (query !== undefined && query !== null)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSearchAconexDocuments(_response);
        });
    }

    protected processGetSearchAconexDocuments(response: AxiosResponse): Promise<GetSearchAconexDocumentsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetSearchAconexDocumentsResponseModel.fromJS(resultData200);
            return Promise.resolve<GetSearchAconexDocumentsResponseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSearchAconexDocumentsResponseModel>(null as any);
    }

    /**
     * API17062 - GET Aconex Mail Metadata
     * @param projectId Aconex Project Id originally obtained from call to <seealso cref="M:OneTrack.Api.V1.AconexController.GetAconexProjects(OneTrack.Api.Commands.Aconex.IGetAconexProjectsCommand,System.Threading.CancellationToken)">API17056 - GET Aconex Projects</seealso>
     * @param mailId Aconex Mail Id originally obtained from call to <seealso cref="M:OneTrack.Api.V1.AconexController.GetSearchAconexMail(OneTrack.Api.Commands.Aconex.IGetSearchAconexMailCommand,OneTrack.Api.Commands.Aconex.GetSearchAconexMailRequestModel)"> API17061 - GET Search Aconex Mail</seealso>
     * @return OK
     */
    getAconexMailMetadata(projectId: string, mailId: string, cancelToken?: CancelToken): Promise<GetAconexMailMetadataResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Aconex/projects/{projectId}/mail/{mailId}/metadata";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (mailId === undefined || mailId === null)
            throw new Error("The parameter 'mailId' must be defined.");
        url_ = url_.replace("{mailId}", encodeURIComponent("" + mailId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAconexMailMetadata(_response);
        });
    }

    protected processGetAconexMailMetadata(response: AxiosResponse): Promise<GetAconexMailMetadataResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetAconexMailMetadataResponseModel.fromJS(resultData200);
            return Promise.resolve<GetAconexMailMetadataResponseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAconexMailMetadataResponseModel>(null as any);
    }

    /**
     * API17063 - GET Aconex Document Metadata
     * @param projectId Aconex Project Id originally obtained from call to <seealso cref="M:OneTrack.Api.V1.AconexController.GetAconexProjects(OneTrack.Api.Commands.Aconex.IGetAconexProjectsCommand,System.Threading.CancellationToken)">API17056 - GET Aconex Projects</seealso>
     * @param documentId Aconex Document Id originally obtained from call to <seealso cref="M:OneTrack.Api.V1.AconexController.GetSearchAconexDocuments(OneTrack.Api.Commands.Aconex.IGetSearchAconexDocumentsCommand,OneTrack.Api.Commands.Aconex.GetSearchAconexDocumentsRequestModel)"> API17061 - GET Search Aconex Documents</seealso>
     * @return OK
     */
    getAconexDocumentMetadata(projectId: string, documentId: string, cancelToken?: CancelToken): Promise<GetAconexDocumentMetadataResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Aconex/projects/{projectId}/documents/{documentId}/metadata";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAconexDocumentMetadata(_response);
        });
    }

    protected processGetAconexDocumentMetadata(response: AxiosResponse): Promise<GetAconexDocumentMetadataResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetAconexDocumentMetadataResponseModel.fromJS(resultData200);
            return Promise.resolve<GetAconexDocumentMetadataResponseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAconexDocumentMetadataResponseModel>(null as any);
    }

    /**
     * API17066 - Post Create Document from Aconex
     * @param body (optional) 
     * @return OK
     */
    postCreateDocumentFromAconex(projectId: string, body?: PostCreateDocumentFromAconexRequestModel | undefined, cancelToken?: CancelToken): Promise<PostCreateDocumentFromAconexResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Aconex/Projects/{projectId}/createOneTrackDocument";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostCreateDocumentFromAconex(_response);
        });
    }

    protected processPostCreateDocumentFromAconex(response: AxiosResponse): Promise<PostCreateDocumentFromAconexResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = PostCreateDocumentFromAconexResponseModel.fromJS(resultData200);
            return Promise.resolve<PostCreateDocumentFromAconexResponseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostCreateDocumentFromAconexResponseModel>(null as any);
    }
}

export class CalendarClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * API00309 - GET Calendar Details
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @return OK
     */
    getCalendarDetails(gid: string, use_scenario?: any | undefined, cancelToken?: CancelToken): Promise<GetCalendarDetailsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Calendar/{gid}";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCalendarDetails(_response);
        });
    }

    protected processGetCalendarDetails(response: AxiosResponse): Promise<GetCalendarDetailsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetCalendarDetailsResponseModel.fromJS(resultData200);
            return Promise.resolve<GetCalendarDetailsResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCalendarDetailsResponseModel>(null as any);
    }

    /**
     * API00311 - POST Calendar Status
     * @param gid The public identifier for the <seealso cref="T:OneTrack.EFDatabase.App.Models.Organisations.Calendar">Calendar</seealso>
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @param body (optional) 
     * @return No Content
     */
    postCalendarStatus(gid: string, use_scenario?: any | undefined, body?: PostCalendarStatusRequestModel | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Calendar/{gid}/status";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostCalendarStatus(_response);
        });
    }

    protected processPostCalendarStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * API00310 - POST Upsert Calendar
     * @param gid The public identifier for the <seealso cref="T:OneTrack.EFDatabase.App.Models.Organisations.Calendar">Calendar</seealso>
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @param body (optional) 
     * @return No Content
     */
    postCalendarUpsert(gid: string, use_scenario?: any | undefined, body?: PostCalendarUpsertRequestModel | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Calendar/{gid}/upsert";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostCalendarUpsert(_response);
        });
    }

    protected processPostCalendarUpsert(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ContractsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * APIS00811R01 - GET Contracts
     * @param projectGid Gid of the project
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @return OK
     */
    getContracts(projectGid: string, use_scenario?: any | undefined, cancelToken?: CancelToken): Promise<GetContractsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Contracts?";
        if (projectGid === undefined || projectGid === null)
            throw new Error("The parameter 'projectGid' must be defined and cannot be null.");
        else
            url_ += "projectGid=" + encodeURIComponent("" + projectGid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContracts(_response);
        });
    }

    protected processGetContracts(response: AxiosResponse): Promise<GetContractsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetContractsResponseModel.fromJS(resultData200);
            return Promise.resolve<GetContractsResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetContractsResponseModel>(null as any);
    }

    /**
     * API00810R03 - POST Update Contract Status
     * @param body (optional) 
     * @return OK
     */
    postUpdateContractStatus(gid: string, body?: PostUpdateContractStatusRequestModel | undefined, cancelToken?: CancelToken): Promise<EntityModifiedResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Contracts/{gid}/status";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostUpdateContractStatus(_response);
        });
    }

    protected processPostUpdateContractStatus(response: AxiosResponse): Promise<EntityModifiedResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = EntityModifiedResponseModel.fromJS(resultData200);
            return Promise.resolve<EntityModifiedResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityModifiedResponseModel>(null as any);
    }

    /**
     * API00802R04 - GET Contract Details
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @return OK
     */
    getContractDetails(gid: string, use_scenario?: any | undefined, cancelToken?: CancelToken): Promise<GetContractDetailsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Contracts/{gid}";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContractDetails(_response);
        });
    }

    protected processGetContractDetails(response: AxiosResponse): Promise<GetContractDetailsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetContractDetailsResponseModel.fromJS(resultData200);
            return Promise.resolve<GetContractDetailsResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetContractDetailsResponseModel>(null as any);
    }

    /**
     * API01006R03 - GET Contract Segments
     * @param gid Gid of Contract
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @return OK
     */
    getContractSegments(gid: string, use_scenario?: any | undefined, cancelToken?: CancelToken): Promise<GetContractSegmentsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Contracts/{gid}/segements";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContractSegments(_response);
        });
    }

    protected processGetContractSegments(response: AxiosResponse): Promise<GetContractSegmentsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetContractSegmentsResponseModel.fromJS(resultData200);
            return Promise.resolve<GetContractSegmentsResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetContractSegmentsResponseModel>(null as any);
    }

    /**
     * API00803R03 - POST Update Contract Details
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @param body (optional) 
     * @return OK
     */
    postUpdateContractDetails(gid: string, use_scenario?: any | undefined, body?: PostUpdateContractDetailsRequestModel | undefined, cancelToken?: CancelToken): Promise<EntityModifiedResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Contracts/{gid}/details";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostUpdateContractDetails(_response);
        });
    }

    protected processPostUpdateContractDetails(response: AxiosResponse): Promise<EntityModifiedResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = EntityModifiedResponseModel.fromJS(resultData200);
            return Promise.resolve<EntityModifiedResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityModifiedResponseModel>(null as any);
    }

    /**
     * API00806R06 - POST Upsert Contract Workflows
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @param body (optional) 
     * @return OK
     */
    postUpsertContractWorkflows(gid: string, use_scenario?: any | undefined, body?: PostUpsertContractWorkflowsRequestModel | undefined, cancelToken?: CancelToken): Promise<EntityModifiedResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Contracts/{gid}/workflows";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostUpsertContractWorkflows(_response);
        });
    }

    protected processPostUpsertContractWorkflows(response: AxiosResponse): Promise<EntityModifiedResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = EntityModifiedResponseModel.fromJS(resultData200);
            return Promise.resolve<EntityModifiedResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityModifiedResponseModel>(null as any);
    }

    /**
     * API00807R03 - POST Insert New Contract
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @param body (optional) 
     * @return OK
     */
    postInsertContract(use_scenario?: any | undefined, body?: ContractWizardModel | undefined, cancelToken?: CancelToken): Promise<EntityModifiedResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Contracts/insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostInsertContract(_response);
        });
    }

    protected processPostInsertContract(response: AxiosResponse): Promise<EntityModifiedResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = EntityModifiedResponseModel.fromJS(resultData200);
            return Promise.resolve<EntityModifiedResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityModifiedResponseModel>(null as any);
    }

    /**
     * APIS00812 - POST Copy Contract
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @param body (optional) 
     * @return OK
     */
    postCopyContract(gid: string, use_scenario?: any | undefined, body?: PostCopyContractRequestModel | undefined, cancelToken?: CancelToken): Promise<PostCopyContractResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Contracts/{gid}/Copy";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostCopyContract(_response);
        });
    }

    protected processPostCopyContract(response: AxiosResponse): Promise<PostCopyContractResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = PostCopyContractResponseModel.fromJS(resultData200);
            return Promise.resolve<PostCopyContractResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostCopyContractResponseModel>(null as any);
    }

    /**
     * API03209 - GET Contract Users
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @return OK
     */
    getContractUsers(gid: string, use_scenario?: any | undefined, cancelToken?: CancelToken): Promise<GetContractUsersResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Contracts/{gid}/users";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContractUsers(_response);
        });
    }

    protected processGetContractUsers(response: AxiosResponse): Promise<GetContractUsersResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetContractUsersResponseModel.fromJS(resultData200);
            return Promise.resolve<GetContractUsersResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetContractUsersResponseModel>(null as any);
    }

    /**
     * API03210 - GET Contract User Details
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @return OK
     */
    getContractUserDetails(contractGid: string, userGid: string, use_scenario?: any | undefined, cancelToken?: CancelToken): Promise<GetContractUserDetailsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Contracts/{contractGid}/users/{userGid}/details";
        if (contractGid === undefined || contractGid === null)
            throw new Error("The parameter 'contractGid' must be defined.");
        url_ = url_.replace("{contractGid}", encodeURIComponent("" + contractGid));
        if (userGid === undefined || userGid === null)
            throw new Error("The parameter 'userGid' must be defined.");
        url_ = url_.replace("{userGid}", encodeURIComponent("" + userGid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContractUserDetails(_response);
        });
    }

    protected processGetContractUserDetails(response: AxiosResponse): Promise<GetContractUserDetailsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetContractUserDetailsResponseModel.fromJS(resultData200);
            return Promise.resolve<GetContractUserDetailsResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetContractUserDetailsResponseModel>(null as any);
    }

    /**
     * API08046 - POST Reset Contract Date For Practical Completion
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @param body (optional) 
     * @return OK
     */
    postResetContractDateForPracticalCompletion(gid: string, use_scenario?: any | undefined, body?: PostResetContractDateForPracticalCompletionRequestModel | undefined, cancelToken?: CancelToken): Promise<EntityModifiedResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Contracts/{gid}/resetContractDateForPracticalCompletion";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostResetContractDateForPracticalCompletion(_response);
        });
    }

    protected processPostResetContractDateForPracticalCompletion(response: AxiosResponse): Promise<EntityModifiedResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = EntityModifiedResponseModel.fromJS(resultData200);
            return Promise.resolve<EntityModifiedResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityModifiedResponseModel>(null as any);
    }

    /**
     * API00813 - Post Request Contract
     * @param projectGid (optional) Public id for the project this contract is for, specifically for Table: Project
     * @param name (optional) User defined name for this contract
     * @param reference (optional) User defined reference for this contract
     * @param description (optional) Contract description
     * @param contractorName (optional) Contractor contract is contracted to
     * @param contactName (optional) Not divided into first and last name as the form input is a single text field
     * @param contactEmail (optional) 
     * @param contactPhone (optional) 
     * @param timezone (optional) Must be in TzDb format if supplied.
     * @param budget (optional) Budget. Currency value. Required.
     * @param contractStartDate (optional) No time component (yyyy-mm-dd only)
     * @param projectedEndDate (optional) No time component (yyyy-mm-dd only)
     * @param tendersClosedDate (optional) No time component (yyyy-mm-dd only)
     * @param workingCalendarGid (optional) Gid for Table: Calendar
     * @param businessCalendarGid (optional) Gid for Table: Calendar
     * @param comments (optional) User supplied comments and potentially links to files can be placed in here.
     * @param files (optional) Associated files
     * @return No Content
     */
    postRequestContract(projectGid?: string | undefined, name?: string | undefined, reference?: string | undefined, description?: string | null | undefined, contractorName?: string | null | undefined, contactName?: string | null | undefined, contactEmail?: string | null | undefined, contactPhone?: string | null | undefined, timezone?: string | null | undefined, budget?: number | undefined, contractStartDate?: string | null | undefined, projectedEndDate?: string | null | undefined, tendersClosedDate?: string | null | undefined, workingCalendarGid?: string | null | undefined, businessCalendarGid?: string | null | undefined, comments?: string | null | undefined, files?: FileParameter[] | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Contracts/request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (projectGid === null || projectGid === undefined)
            throw new Error("The parameter 'projectGid' cannot be null.");
        else
            content_.append("ProjectGid", projectGid.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (reference === null || reference === undefined)
            throw new Error("The parameter 'reference' cannot be null.");
        else
            content_.append("Reference", reference.toString());
        if (description !== null && description !== undefined)
            content_.append("Description", description.toString());
        if (contractorName !== null && contractorName !== undefined)
            content_.append("ContractorName", contractorName.toString());
        if (contactName !== null && contactName !== undefined)
            content_.append("ContactName", contactName.toString());
        if (contactEmail !== null && contactEmail !== undefined)
            content_.append("ContactEmail", contactEmail.toString());
        if (contactPhone !== null && contactPhone !== undefined)
            content_.append("ContactPhone", contactPhone.toString());
        if (timezone !== null && timezone !== undefined)
            content_.append("Timezone", timezone.toString());
        if (budget === null || budget === undefined)
            throw new Error("The parameter 'budget' cannot be null.");
        else
            content_.append("Budget", budget.toString());
        if (contractStartDate !== null && contractStartDate !== undefined)
            content_.append("ContractStartDate", contractStartDate.toString());
        if (projectedEndDate !== null && projectedEndDate !== undefined)
            content_.append("ProjectedEndDate", projectedEndDate.toString());
        if (tendersClosedDate !== null && tendersClosedDate !== undefined)
            content_.append("TendersClosedDate", tendersClosedDate.toString());
        if (workingCalendarGid !== null && workingCalendarGid !== undefined)
            content_.append("WorkingCalendarGid", workingCalendarGid.toString());
        if (businessCalendarGid !== null && businessCalendarGid !== undefined)
            content_.append("BusinessCalendarGid", businessCalendarGid.toString());
        if (comments !== null && comments !== undefined)
            content_.append("Comments", comments.toString());
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files"));

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostRequestContract(_response);
        });
    }

    protected processPostRequestContract(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 413) {
            const _responseText = response.data;
            let result413: any = null;
            let resultData413 = _responseText;
            result413 = ProblemDetails.fromJS(resultData413);
            return throwException("Content Too Large", status, _responseText, _headers, result413);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ContractTypesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * API00808R02 - GET Contract Types
     * @param organisationGid (optional) 
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @return OK
     */
    getContractTypes(organisationGid?: string | undefined, use_scenario?: any | undefined, cancelToken?: CancelToken): Promise<GetContractTypesResponseModel> {
        let url_ = this.baseUrl + "/api/v1/ContractTypes?";
        if (organisationGid === null)
            throw new Error("The parameter 'organisationGid' cannot be null.");
        else if (organisationGid !== undefined)
            url_ += "organisationGid=" + encodeURIComponent("" + organisationGid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContractTypes(_response);
        });
    }

    protected processGetContractTypes(response: AxiosResponse): Promise<GetContractTypesResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetContractTypesResponseModel.fromJS(resultData200);
            return Promise.resolve<GetContractTypesResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetContractTypesResponseModel>(null as any);
    }

    /**
     * API00809 - GET Available Workflows
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @return OK
     */
    getAvailableWorkflows(gid: string, use_scenario?: any | undefined, cancelToken?: CancelToken): Promise<BasicWorkflowModel[]> {
        let url_ = this.baseUrl + "/api/v1/ContractTypes/{gid}/workflows";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAvailableWorkflows(_response);
        });
    }

    protected processGetAvailableWorkflows(response: AxiosResponse): Promise<BasicWorkflowModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BasicWorkflowModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<BasicWorkflowModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BasicWorkflowModel[]>(null as any);
    }

    /**
     * API00812R02 - POST Save Contract as Contract Template
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @param body (optional) 
     * @return OK
     */
    postSaveContractAsContractTemplate(use_scenario?: any | undefined, body?: PostSaveContractAsContractTemplateRequestModel | undefined, cancelToken?: CancelToken): Promise<PostSaveContractAsContractTemplateResponseModel> {
        let url_ = this.baseUrl + "/api/v1/ContractTypes/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostSaveContractAsContractTemplate(_response);
        });
    }

    protected processPostSaveContractAsContractTemplate(response: AxiosResponse): Promise<PostSaveContractAsContractTemplateResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = PostSaveContractAsContractTemplateResponseModel.fromJS(resultData200);
            return Promise.resolve<PostSaveContractAsContractTemplateResponseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostSaveContractAsContractTemplateResponseModel>(null as any);
    }
}

export class ContractUsersClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * API03237 - GET Contract User Functional Role Titles
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @return OK
     */
    getContractUserFunctionalRoleTitles(use_scenario?: any | undefined, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/ContractUsers/functionalRoleTitles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContractUserFunctionalRoleTitles(_response);
        });
    }

    protected processGetContractUserFunctionalRoleTitles(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * API03244 - POST Set Contract User Status
     * @param body (optional) 
     * @return OK
     */
    postSetContractUserStatus(body?: PostSetContractUserStatusUserStatusModel[] | undefined, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/ContractUsers/setStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostSetContractUserStatus(_response);
        });
    }

    protected processPostSetContractUserStatus(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * API03211 - POST Update Contract User Details
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @param body (optional) 
     * @return No Content
     */
    postUpdateContractUserDetails(gid: string, use_scenario?: any | undefined, body?: PostUpdateContractUserDetailsModel | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/ContractUsers/{gid}/details";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostUpdateContractUserDetails(_response);
        });
    }

    protected processPostUpdateContractUserDetails(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ContractWorkflowsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * API01101 - Get Contract Workflow Amendments Response
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @return OK
     */
    getContractWorkflowAmendmentsResponse(gid: string, use_scenario?: any | undefined, cancelToken?: CancelToken): Promise<DataDrivenInstanceModel> {
        let url_ = this.baseUrl + "/api/v1/ContractWorkflow/{gid}/response";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContractWorkflowAmendmentsResponse(_response);
        });
    }

    protected processGetContractWorkflowAmendmentsResponse(response: AxiosResponse): Promise<DataDrivenInstanceModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = DataDrivenInstanceModel.fromJS(resultData200);
            return Promise.resolve<DataDrivenInstanceModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataDrivenInstanceModel>(null as any);
    }

    /**
     * API01104 - Get Contract Workflow Amendments Definition
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @return OK
     */
    getContractWorkflowAmendmentsDefinition(gid: string, use_scenario?: any | undefined, cancelToken?: CancelToken): Promise<DataDrivenDefinitionModel> {
        let url_ = this.baseUrl + "/api/v1/ContractWorkflow/{gid}/definition";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContractWorkflowAmendmentsDefinition(_response);
        });
    }

    protected processGetContractWorkflowAmendmentsDefinition(response: AxiosResponse): Promise<DataDrivenDefinitionModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = DataDrivenDefinitionModel.fromJS(resultData200);
            return Promise.resolve<DataDrivenDefinitionModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataDrivenDefinitionModel>(null as any);
    }
}

export class SegmentInstancesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * API01102 - Post Contract Workflow Amendments Response
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @param body (optional) 
     * @return No Content
     */
    postContractWorkflowAmendmentsResponse(gid: string, use_scenario?: any | undefined, body?: PostContractWorkflowAmendmentsResponseRequestModel | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/ContractWorkflow/{gid}/response";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostContractWorkflowAmendmentsResponse(_response);
        });
    }

    protected processPostContractWorkflowAmendmentsResponse(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * APIS01001R04 - GET Segment Instances
     * @param contractGid (optional) 
     * @param projectGid (optional) 
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @return OK
     */
    getSegmentInstances(contractGid?: string | null | undefined, projectGid?: string | null | undefined, use_scenario?: any | undefined, cancelToken?: CancelToken): Promise<GetSegmentInstancesResponseModel> {
        let url_ = this.baseUrl + "/api/v1/SegmentInstances?";
        if (contractGid !== undefined && contractGid !== null)
            url_ += "ContractGid=" + encodeURIComponent("" + contractGid) + "&";
        if (projectGid !== undefined && projectGid !== null)
            url_ += "ProjectGid=" + encodeURIComponent("" + projectGid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSegmentInstances(_response);
        });
    }

    protected processGetSegmentInstances(response: AxiosResponse): Promise<GetSegmentInstancesResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetSegmentInstancesResponseModel.fromJS(resultData200);
            return Promise.resolve<GetSegmentInstancesResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSegmentInstancesResponseModel>(null as any);
    }

    /**
     * API01002R08 - GET Segment Instance Details
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @return OK
     */
    getSegmentInstanceDetails(gid: string | null, use_scenario?: any | undefined, cancelToken?: CancelToken): Promise<GetSegmentInstanceDetailsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/SegmentInstances/{gid}";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSegmentInstanceDetails(_response);
        });
    }

    protected processGetSegmentInstanceDetails(response: AxiosResponse): Promise<GetSegmentInstanceDetailsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetSegmentInstanceDetailsResponseModel.fromJS(resultData200);
            return Promise.resolve<GetSegmentInstanceDetailsResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSegmentInstanceDetailsResponseModel>(null as any);
    }

    /**
     * API01003R06 - POST Update Segment Instance Details
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @param body (optional) 
     * @return OK
     */
    postUpdateSegmentInstanceDetails(gid: string, use_scenario?: any | undefined, body?: PostUpdateSegmentInstanceDetailsRequestModel | undefined, cancelToken?: CancelToken): Promise<WorkflowUpdateModel> {
        let url_ = this.baseUrl + "/api/v1/SegmentInstances/{gid}/details";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostUpdateSegmentInstanceDetails(_response);
        });
    }

    protected processPostUpdateSegmentInstanceDetails(response: AxiosResponse): Promise<WorkflowUpdateModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = WorkflowUpdateModel.fromJS(resultData200);
            return Promise.resolve<WorkflowUpdateModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkflowUpdateModel>(null as any);
    }

    /**
     * API01004R09 - POST Insert New Segment Instance
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @param body (optional) 
     * @return OK
     */
    postInsertSegmentInstance(use_scenario?: any | undefined, body?: PostInsertSegmentInstanceRequestModel | undefined, cancelToken?: CancelToken): Promise<WorkflowUpdateModel> {
        let url_ = this.baseUrl + "/api/v1/SegmentInstances/insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostInsertSegmentInstance(_response);
        });
    }

    protected processPostInsertSegmentInstance(response: AxiosResponse): Promise<WorkflowUpdateModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = WorkflowUpdateModel.fromJS(resultData200);
            return Promise.resolve<WorkflowUpdateModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkflowUpdateModel>(null as any);
    }

    /**
     * API01005R05 - POST Update Segment Instance Status
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @param body (optional) 
     * @return OK
     */
    postUpdateSegmentInstanceStatus(gid: string, use_scenario?: any | undefined, body?: PostUpdateSegmentInstanceStatusRequestModel | undefined, cancelToken?: CancelToken): Promise<EntityModifiedResponseModel> {
        let url_ = this.baseUrl + "/api/v1/SegmentInstances/{gid}/status";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostUpdateSegmentInstanceStatus(_response);
        });
    }

    protected processPostUpdateSegmentInstanceStatus(response: AxiosResponse): Promise<EntityModifiedResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = EntityModifiedResponseModel.fromJS(resultData200);
            return Promise.resolve<EntityModifiedResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityModifiedResponseModel>(null as any);
    }

    /**
     * API01007R01 - Get Segment Instance Response
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @return OK
     */
    getSegmentInstanceResponse(gid: string, use_scenario?: any | undefined, cancelToken?: CancelToken): Promise<DataDrivenInstancesModel> {
        let url_ = this.baseUrl + "/api/v1/SegmentInstances/{gid}/response";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSegmentInstanceResponse(_response);
        });
    }

    protected processGetSegmentInstanceResponse(response: AxiosResponse): Promise<DataDrivenInstancesModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = DataDrivenInstancesModel.fromJS(resultData200);
            return Promise.resolve<DataDrivenInstancesModel>(result200);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("No Content", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataDrivenInstancesModel>(null as any);
    }

    /**
     * API01008R02 - Get Segment Definition
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @return OK
     */
    getSegmentDefinition(gid: string | null, use_scenario?: any | undefined, cancelToken?: CancelToken): Promise<GetSegmentDefinitionResponseModel> {
        let url_ = this.baseUrl + "/api/v1/SegmentInstances/{gid}/definition";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSegmentDefinition(_response);
        });
    }

    protected processGetSegmentDefinition(response: AxiosResponse): Promise<GetSegmentDefinitionResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetSegmentDefinitionResponseModel.fromJS(resultData200);
            return Promise.resolve<GetSegmentDefinitionResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSegmentDefinitionResponseModel>(null as any);
    }

    /**
     * API01009R10 - Post Segment Instance Response
     * @param gid Public Unique Identifier for the Segment Instance
     * @param runGid Unique Identifier for the Run that this Evaluation belongs to
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @param body (optional) 
     * @return OK
     */
    postUpdateSegmentInstanceResponse(gid: string, runGid: string, use_scenario?: any | undefined, body?: PostUpdateSegmentInstanceResponseRequestModel | undefined, cancelToken?: CancelToken): Promise<WorkflowUpdateModel> {
        let url_ = this.baseUrl + "/api/v1/SegmentInstances/{gid}/run/{runGid}/response";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        if (runGid === undefined || runGid === null)
            throw new Error("The parameter 'runGid' must be defined.");
        url_ = url_.replace("{runGid}", encodeURIComponent("" + runGid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostUpdateSegmentInstanceResponse(_response);
        });
    }

    protected processPostUpdateSegmentInstanceResponse(response: AxiosResponse): Promise<WorkflowUpdateModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = WorkflowUpdateModel.fromJS(resultData200);
            return Promise.resolve<WorkflowUpdateModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkflowUpdateModel>(null as any);
    }

    /**
     * API01201R08 - POST Finalise Segment Instance
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @param body (optional) 
     * @return OK
     */
    postFinaliseSegmentInstance(gid: string, use_scenario?: any | undefined, body?: PostFinaliseSegmentInstanceRequestModel | undefined, cancelToken?: CancelToken): Promise<PostFinaliseSegmentInstanceResponse> {
        let url_ = this.baseUrl + "/api/v1/SegmentInstances/{gid}/finalise";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostFinaliseSegmentInstance(_response);
        });
    }

    protected processPostFinaliseSegmentInstance(response: AxiosResponse): Promise<PostFinaliseSegmentInstanceResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = PostFinaliseSegmentInstanceResponse.fromJS(resultData200);
            return Promise.resolve<PostFinaliseSegmentInstanceResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostFinaliseSegmentInstanceResponse>(null as any);
    }

    /**
     * API01202R04 - Get Segment Instance Recommendation
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @return OK
     */
    getSegmentInstanceRecommendation(gid: string, use_scenario?: any | undefined, cancelToken?: CancelToken): Promise<GetSegmentInstanceRecommendationResponseModel> {
        let url_ = this.baseUrl + "/api/v1/SegmentInstances/{gid}/recommendation";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSegmentInstanceRecommendation(_response);
        });
    }

    protected processGetSegmentInstanceRecommendation(response: AxiosResponse): Promise<GetSegmentInstanceRecommendationResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetSegmentInstanceRecommendationResponseModel.fromJS(resultData200);
            return Promise.resolve<GetSegmentInstanceRecommendationResponseModel>(result200);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("No Content", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSegmentInstanceRecommendationResponseModel>(null as any);
    }

    /**
     * API01203R08 - Post Segment Instance Recommendation
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @param body (optional) 
     * @return OK
     */
    postSegmentInstanceRecommendation(gid: string, use_scenario?: any | undefined, body?: PostSegmentInstanceRecommendationRequestModel | undefined, cancelToken?: CancelToken): Promise<PostSegmentInstanceRecommendationResponseModel> {
        let url_ = this.baseUrl + "/api/v1/SegmentInstances/{gid}/recommendation";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostSegmentInstanceRecommendation(_response);
        });
    }

    protected processPostSegmentInstanceRecommendation(response: AxiosResponse): Promise<PostSegmentInstanceRecommendationResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = PostSegmentInstanceRecommendationResponseModel.fromJS(resultData200);
            return Promise.resolve<PostSegmentInstanceRecommendationResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409 = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostSegmentInstanceRecommendationResponseModel>(null as any);
    }

    /**
     * API0XXXX - GET Segment Instance Message Details
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @return OK
     */
    getSegmentInstanceMessageDetails(gid: string, use_scenario?: any | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/SegmentInstances/{gid}/MessageDetails";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSegmentInstanceMessageDetails(_response);
        });
    }

    protected processGetSegmentInstanceMessageDetails(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * API01012R01 - API01012 - GET Segment Instance Evaluation
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @return OK
     */
    getSegmentInstanceEvaluation(gid: string | null, use_scenario?: any | undefined, cancelToken?: CancelToken): Promise<ClientEvaluationModel[]> {
        let url_ = this.baseUrl + "/api/v1/SegmentInstances/{gid}/evaluation";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSegmentInstanceEvaluation(_response);
        });
    }

    protected processGetSegmentInstanceEvaluation(response: AxiosResponse): Promise<ClientEvaluationModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientEvaluationModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ClientEvaluationModel[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClientEvaluationModel[]>(null as any);
    }

    /**
     * API09003 - GET Segment Instance Documents And Files
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @return OK
     */
    getSegmentInstanceDocumentsAndFiles(gid: string, use_scenario?: any | undefined, cancelToken?: CancelToken): Promise<GetSegmentInstanceDocumentsAndFilesResponseDocumentModel[]> {
        let url_ = this.baseUrl + "/api/v1/SegmentInstances/{gid}/documents";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSegmentInstanceDocumentsAndFiles(_response);
        });
    }

    protected processGetSegmentInstanceDocumentsAndFiles(response: AxiosResponse): Promise<GetSegmentInstanceDocumentsAndFilesResponseDocumentModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetSegmentInstanceDocumentsAndFilesResponseDocumentModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetSegmentInstanceDocumentsAndFilesResponseDocumentModel[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSegmentInstanceDocumentsAndFilesResponseDocumentModel[]>(null as any);
    }

    /**
     * API01211 - POST Update Segment Instance Documents
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @param body (optional) 
     * @return OK
     */
    postUpdateSegmentInstanceDocuments(gid: string, use_scenario?: any | undefined, body?: PostUpdateSegmentInstanceDocumentsRequestModel | undefined, cancelToken?: CancelToken): Promise<PostUpdateSegmentInstanceDocumentsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/SegmentInstances/{gid}/updateDocuments";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostUpdateSegmentInstanceDocuments(_response);
        });
    }

    protected processPostUpdateSegmentInstanceDocuments(response: AxiosResponse): Promise<PostUpdateSegmentInstanceDocumentsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = PostUpdateSegmentInstanceDocumentsResponseModel.fromJS(resultData200);
            return Promise.resolve<PostUpdateSegmentInstanceDocumentsResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostUpdateSegmentInstanceDocumentsResponseModel>(null as any);
    }
}

export class DocumentsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * API01204 - Get Document Content Description List
     * @return OK
     */
    getDocumentContentDescriptionList(cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/Documents/contentDescriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDocumentContentDescriptionList(_response);
        });
    }

    protected processGetDocumentContentDescriptionList(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * API09004R01 - GET Search Documents
     * @param organisationGids (optional) Public ids of Organisations to search Documents by Association
     * @param projectGids (optional) Public ids of Projects to search Documents by Association
     * @param contractGids (optional) Public ids of Contracts to search Documents by Association
     * @param segmentInstanceGids (optional) Public ids of Segment Instances to search Documents by Association
     * @param includeMyUnassociatedDocuments (optional) Whether to include documents that the current user has created that are not associated with anything.
     * @param keyword (optional) Keyword text to search Documents by Document Name
     * @param contentDescriptions (optional) Content Description texts to search Documents by Document Content Description
     * @param fromDocumentDate (optional) Start Date to search Documents by Document Date (Inclusive)
     * @param toDocumentDate (optional) End Date to search Documents by Document Date (Inclusive)
     * @param documentSources (optional) Array of types of documents to retrieve. Terms to be OR'd together - ie: if OneTrack and AconexDocument are passed, then documents that have no metadata at all, or documents that have aconex document metadata will be returned. Documents that have aconex mail metadata will not
     * @param orderBy (optional) Column to order by
     * @param orderDesc (optional) Order by descending or not
     * @param pageSize (optional) Pagination size
     * @param pageNumber (optional) Page number of paginated data to return. 1 based.
     * @return OK
     */
    getSearchDocuments(organisationGids?: string[] | null | undefined, projectGids?: string[] | null | undefined, contractGids?: string[] | null | undefined, segmentInstanceGids?: string[] | null | undefined, includeMyUnassociatedDocuments?: boolean | undefined, keyword?: string | null | undefined, contentDescriptions?: string[] | null | undefined, fromDocumentDate?: string | null | undefined, toDocumentDate?: string | null | undefined, documentSources?: DocumentSource[] | null | undefined, orderBy?: string | null | undefined, orderDesc?: boolean | null | undefined, pageSize?: number | null | undefined, pageNumber?: number | null | undefined, cancelToken?: CancelToken): Promise<GetSearchDocumentsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Documents/search?";
        if (organisationGids !== undefined && organisationGids !== null)
            organisationGids && organisationGids.forEach(item => { url_ += "OrganisationGids=" + encodeURIComponent("" + item) + "&"; });
        if (projectGids !== undefined && projectGids !== null)
            projectGids && projectGids.forEach(item => { url_ += "ProjectGids=" + encodeURIComponent("" + item) + "&"; });
        if (contractGids !== undefined && contractGids !== null)
            contractGids && contractGids.forEach(item => { url_ += "ContractGids=" + encodeURIComponent("" + item) + "&"; });
        if (segmentInstanceGids !== undefined && segmentInstanceGids !== null)
            segmentInstanceGids && segmentInstanceGids.forEach(item => { url_ += "SegmentInstanceGids=" + encodeURIComponent("" + item) + "&"; });
        if (includeMyUnassociatedDocuments === null)
            throw new Error("The parameter 'includeMyUnassociatedDocuments' cannot be null.");
        else if (includeMyUnassociatedDocuments !== undefined)
            url_ += "IncludeMyUnassociatedDocuments=" + encodeURIComponent("" + includeMyUnassociatedDocuments) + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (contentDescriptions !== undefined && contentDescriptions !== null)
            contentDescriptions && contentDescriptions.forEach(item => { url_ += "ContentDescriptions=" + encodeURIComponent("" + item) + "&"; });
        if (fromDocumentDate !== undefined && fromDocumentDate !== null)
            url_ += "FromDocumentDate=" + encodeURIComponent("" + fromDocumentDate) + "&";
        if (toDocumentDate !== undefined && toDocumentDate !== null)
            url_ += "ToDocumentDate=" + encodeURIComponent("" + toDocumentDate) + "&";
        if (documentSources !== undefined && documentSources !== null)
            documentSources && documentSources.forEach(item => { url_ += "DocumentSources=" + encodeURIComponent("" + item) + "&"; });
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderDesc !== undefined && orderDesc !== null)
            url_ += "OrderDesc=" + encodeURIComponent("" + orderDesc) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSearchDocuments(_response);
        });
    }

    protected processGetSearchDocuments(response: AxiosResponse): Promise<GetSearchDocumentsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetSearchDocumentsResponseModel.fromJS(resultData200);
            return Promise.resolve<GetSearchDocumentsResponseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSearchDocumentsResponseModel>(null as any);
    }

    /**
     * API09006R01 - POST Create Document
     * @param body (optional) 
     * @return OK
     */
    postCreateDocument(body?: PostCreateDocumentRequestModel | undefined, cancelToken?: CancelToken): Promise<PostCreateDocumentResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Documents/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostCreateDocument(_response);
        });
    }

    protected processPostCreateDocument(response: AxiosResponse): Promise<PostCreateDocumentResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = PostCreateDocumentResponseModel.fromJS(resultData200);
            return Promise.resolve<PostCreateDocumentResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostCreateDocumentResponseModel>(null as any);
    }

    /**
     * API09007 - GET Document
     * @param gid Public Identifier for the Document
     * @return OK
     */
    getDocument(gid: string, cancelToken?: CancelToken): Promise<GetDocumentResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Documents/{gid}";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDocument(_response);
        });
    }

    protected processGetDocument(response: AxiosResponse): Promise<GetDocumentResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetDocumentResponseModel.fromJS(resultData200);
            return Promise.resolve<GetDocumentResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDocumentResponseModel>(null as any);
    }

    /**
     * API09008R01 - POST Update Document
     * @param body (optional) 
     * @return OK
     */
    postUpdateDocument(gid: string, body?: PostUpdateDocumentRequestModel | undefined, cancelToken?: CancelToken): Promise<PostUpdateDocumentResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Documents/{gid}/update";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostUpdateDocument(_response);
        });
    }

    protected processPostUpdateDocument(response: AxiosResponse): Promise<PostUpdateDocumentResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = PostUpdateDocumentResponseModel.fromJS(resultData200);
            return Promise.resolve<PostUpdateDocumentResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostUpdateDocumentResponseModel>(null as any);
    }

    /**
     * API09015 - POST Update Document Associations
     * @param body (optional) 
     * @return No Content
     */
    postUpdateDocumentAssociations(gid: string, body?: PostUpdateDocumentAssociationsRequestModel | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Documents/{gid}/updateAssociations";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostUpdateDocumentAssociations(_response);
        });
    }

    protected processPostUpdateDocumentAssociations(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class FailureTestClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Returns a ProblemDetails
     * @return OK
     */
    getGetIActionResultNotFoundBaseClassImplementation(cancelToken?: CancelToken): Promise<TestModel> {
        let url_ = this.baseUrl + "/api/v1/FailureTest/GetIActionResultNotFoundBaseClassImplementation";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGetIActionResultNotFoundBaseClassImplementation(_response);
        });
    }

    protected processGetGetIActionResultNotFoundBaseClassImplementation(response: AxiosResponse): Promise<TestModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = TestModel.fromJS(resultData200);
            return Promise.resolve<TestModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TestModel>(null as any);
    }

    /**
     * Returns a ProblemDetails
     * @return OK
     */
    getGetActionResultNotFoundBaseClassImplementation(cancelToken?: CancelToken): Promise<TestModel> {
        let url_ = this.baseUrl + "/api/v1/FailureTest/GetActionResultNotFoundBaseClassImplementation";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGetActionResultNotFoundBaseClassImplementation(_response);
        });
    }

    protected processGetGetActionResultNotFoundBaseClassImplementation(response: AxiosResponse): Promise<TestModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = TestModel.fromJS(resultData200);
            return Promise.resolve<TestModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TestModel>(null as any);
    }

    /**
     * Returns a ProblemDetails
     * @return OK
     */
    getGetIActionResultNotFoundStatusCodeResult(cancelToken?: CancelToken): Promise<TestModel> {
        let url_ = this.baseUrl + "/api/v1/FailureTest/GetIActionResultNotFoundStatusCodeResult";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGetIActionResultNotFoundStatusCodeResult(_response);
        });
    }

    protected processGetGetIActionResultNotFoundStatusCodeResult(response: AxiosResponse): Promise<TestModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = TestModel.fromJS(resultData200);
            return Promise.resolve<TestModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TestModel>(null as any);
    }

    /**
     * Returns a ProblemDetails
     * @return OK
     */
    getGetActionResultNotFoundStatusCodeResult(cancelToken?: CancelToken): Promise<TestModel> {
        let url_ = this.baseUrl + "/api/v1/FailureTest/GetActionResultNotFoundStatusCodeResult";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGetActionResultNotFoundStatusCodeResult(_response);
        });
    }

    protected processGetGetActionResultNotFoundStatusCodeResult(response: AxiosResponse): Promise<TestModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = TestModel.fromJS(resultData200);
            return Promise.resolve<TestModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TestModel>(null as any);
    }

    /**
     * Does NOT return a ProblemDetails
     * @return OK
     */
    getGetIActionResultNotFoundObjectResult(cancelToken?: CancelToken): Promise<TestModel> {
        let url_ = this.baseUrl + "/api/v1/FailureTest/GetIActionResultNotFoundObjectResult";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGetIActionResultNotFoundObjectResult(_response);
        });
    }

    protected processGetGetIActionResultNotFoundObjectResult(response: AxiosResponse): Promise<TestModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = TestModel.fromJS(resultData200);
            return Promise.resolve<TestModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TestModel>(null as any);
    }

    /**
     * Does NOT return a ProblemDetails
     * @return OK
     */
    getGetActionResultNotFoundObjectResult(cancelToken?: CancelToken): Promise<TestModel> {
        let url_ = this.baseUrl + "/api/v1/FailureTest/GetActionResultNotFoundObjectResult";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGetActionResultNotFoundObjectResult(_response);
        });
    }

    protected processGetGetActionResultNotFoundObjectResult(response: AxiosResponse): Promise<TestModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = TestModel.fromJS(resultData200);
            return Promise.resolve<TestModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TestModel>(null as any);
    }

    /**
     * Returns a ProblemDetails
     * @return OK
     */
    getGetActionResultNotFoundValidateAndProcessResult(cancelToken?: CancelToken): Promise<TestModel> {
        let url_ = this.baseUrl + "/api/v1/FailureTest/GetActionResultNotFoundValidateAndProcessResult";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGetActionResultNotFoundValidateAndProcessResult(_response);
        });
    }

    protected processGetGetActionResultNotFoundValidateAndProcessResult(response: AxiosResponse): Promise<TestModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = TestModel.fromJS(resultData200);
            return Promise.resolve<TestModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TestModel>(null as any);
    }

    /**
     * Returns a ProblemDetails
     * @return OK
     */
    getGetActionResultNotFoundValidateAndProcessResultOfTNullValue(cancelToken?: CancelToken): Promise<TestModel> {
        let url_ = this.baseUrl + "/api/v1/FailureTest/GetActionResultNotFoundValidateAndProcessResultOfTNullValue";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGetActionResultNotFoundValidateAndProcessResultOfTNullValue(_response);
        });
    }

    protected processGetGetActionResultNotFoundValidateAndProcessResultOfTNullValue(response: AxiosResponse): Promise<TestModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = TestModel.fromJS(resultData200);
            return Promise.resolve<TestModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TestModel>(null as any);
    }

    /**
     * Does NOT return a ProblemDetails because we supply an object that overrides it
     * @return OK
     */
    getGetActionResultNotFoundValidateAndProcessResultOfTValueSet(cancelToken?: CancelToken): Promise<TestModel> {
        let url_ = this.baseUrl + "/api/v1/FailureTest/GetActionResultNotFoundValidateAndProcessResultOfTValueSet";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGetActionResultNotFoundValidateAndProcessResultOfTValueSet(_response);
        });
    }

    protected processGetGetActionResultNotFoundValidateAndProcessResultOfTValueSet(response: AxiosResponse): Promise<TestModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = TestModel.fromJS(resultData200);
            return Promise.resolve<TestModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TestModel>(null as any);
    }

    /**
     * Should return a ProblemDetails for anything that's 400 or over
     * @param statusCodeToReturn (optional) 
     * @return OK
     */
    getGetStatusCodeOfYourChoiceValidateAndProcessResultNullValue(statusCodeToReturn?: number | undefined, cancelToken?: CancelToken): Promise<TestModel> {
        let url_ = this.baseUrl + "/api/v1/FailureTest/GetStatusCodeOfYourChoiceValidateAndProcessResultNullValue?";
        if (statusCodeToReturn === null)
            throw new Error("The parameter 'statusCodeToReturn' cannot be null.");
        else if (statusCodeToReturn !== undefined)
            url_ += "statusCodeToReturn=" + encodeURIComponent("" + statusCodeToReturn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGetStatusCodeOfYourChoiceValidateAndProcessResultNullValue(_response);
        });
    }

    protected processGetGetStatusCodeOfYourChoiceValidateAndProcessResultNullValue(response: AxiosResponse): Promise<TestModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = TestModel.fromJS(resultData200);
            return Promise.resolve<TestModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TestModel>(null as any);
    }

    /**
     * Should return a ProblemDetails for anything that's 400 or over
     * @param statusCodeToReturn (optional) 
     * @return OK
     */
    getGetRequiresAuthValidateAndProcessResultNullValue(statusCodeToReturn?: number | undefined, cancelToken?: CancelToken): Promise<TestModel> {
        let url_ = this.baseUrl + "/api/v1/FailureTest/GetRequiresAuthValidateAndProcessResultNullValue?";
        if (statusCodeToReturn === null)
            throw new Error("The parameter 'statusCodeToReturn' cannot be null.");
        else if (statusCodeToReturn !== undefined)
            url_ += "statusCodeToReturn=" + encodeURIComponent("" + statusCodeToReturn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGetRequiresAuthValidateAndProcessResultNullValue(_response);
        });
    }

    protected processGetGetRequiresAuthValidateAndProcessResultNullValue(response: AxiosResponse): Promise<TestModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = TestModel.fromJS(resultData200);
            return Promise.resolve<TestModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TestModel>(null as any);
    }
}

export class FilesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * API09001 - Get File
     * @return OK
     */
    getFile(gid: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Files/{gid}";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFile(_response);
        });
    }

    protected processGetFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * API09005 - POST Upload File - Generated Axios TypeScript code will not work with this endpoint, use a custom method instead
     * @return OK
     */
    postUploadFile(cancelToken?: CancelToken): Promise<PostUploadFileResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Files/upload";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostUploadFile(_response);
        });
    }

    protected processPostUploadFile(response: AxiosResponse): Promise<PostUploadFileResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = PostUploadFileResponseModel.fromJS(resultData200);
            return Promise.resolve<PostUploadFileResponseModel>(result200);

        } else if (status === 415) {
            const _responseText = response.data;
            let result415: any = null;
            let resultData415 = _responseText;
            result415 = ProblemDetails.fromJS(resultData415);
            return throwException("Unsupported Media Type", status, _responseText, _headers, result415);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostUploadFileResponseModel>(null as any);
    }
}

export class InvitationsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * API15001 - GET Invitable Users
     * @param organisationGid (optional) 
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @return OK
     */
    getInvitations(organisationGid?: string | undefined, use_scenario?: any | undefined, cancelToken?: CancelToken): Promise<GetInvitableUsersResponseModel[]> {
        let url_ = this.baseUrl + "/api/v1/Invitations/invitableUsers?";
        if (organisationGid === null)
            throw new Error("The parameter 'organisationGid' cannot be null.");
        else if (organisationGid !== undefined)
            url_ += "organisationGid=" + encodeURIComponent("" + organisationGid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvitations(_response);
        });
    }

    protected processGetInvitations(response: AxiosResponse): Promise<GetInvitableUsersResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetInvitableUsersResponseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetInvitableUsersResponseModel[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetInvitableUsersResponseModel[]>(null as any);
    }

    /**
     * API15002 - GET Projects for Invitation
     * @param emailAddress (optional) 
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @return OK
     */
    getInvitableProjects(organisationGid: string, emailAddress?: string | null | undefined, use_scenario?: any | undefined, cancelToken?: CancelToken): Promise<GetInvitableProjectsResponseModel[]> {
        let url_ = this.baseUrl + "/api/v1/Invitations/invitableProjects?";
        if (organisationGid === undefined || organisationGid === null)
            throw new Error("The parameter 'organisationGid' must be defined and cannot be null.");
        else
            url_ += "organisationGid=" + encodeURIComponent("" + organisationGid) + "&";
        if (emailAddress !== undefined && emailAddress !== null)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvitableProjects(_response);
        });
    }

    protected processGetInvitableProjects(response: AxiosResponse): Promise<GetInvitableProjectsResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetInvitableProjectsResponseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetInvitableProjectsResponseModel[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetInvitableProjectsResponseModel[]>(null as any);
    }

    /**
     * API15003 - GET Contracts for Invitation
     * @param emailAddress (optional) 
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @return OK
     */
    getInvitableContracts(organisationGid: string, emailAddress?: string | null | undefined, use_scenario?: any | undefined, cancelToken?: CancelToken): Promise<GetInvitableContractsResponseModel[]> {
        let url_ = this.baseUrl + "/api/v1/Invitations/invitableContracts?";
        if (organisationGid === undefined || organisationGid === null)
            throw new Error("The parameter 'organisationGid' must be defined and cannot be null.");
        else
            url_ += "organisationGid=" + encodeURIComponent("" + organisationGid) + "&";
        if (emailAddress !== undefined && emailAddress !== null)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvitableContracts(_response);
        });
    }

    protected processGetInvitableContracts(response: AxiosResponse): Promise<GetInvitableContractsResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetInvitableContractsResponseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetInvitableContractsResponseModel[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetInvitableContractsResponseModel[]>(null as any);
    }

    /**
     * API15008 - GET Organisations for Invitation
     * @param emailAddress (optional) 
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @return OK
     */
    getInvitableOrganisations(organisationGid: string, emailAddress?: string | null | undefined, use_scenario?: any | undefined, cancelToken?: CancelToken): Promise<GetInvitableOrganisationsResponseModel[]> {
        let url_ = this.baseUrl + "/api/v1/Invitations/invitableOrganisations?";
        if (organisationGid === undefined || organisationGid === null)
            throw new Error("The parameter 'organisationGid' must be defined and cannot be null.");
        else
            url_ += "organisationGid=" + encodeURIComponent("" + organisationGid) + "&";
        if (emailAddress !== undefined && emailAddress !== null)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvitableOrganisations(_response);
        });
    }

    protected processGetInvitableOrganisations(response: AxiosResponse): Promise<GetInvitableOrganisationsResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetInvitableOrganisationsResponseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetInvitableOrganisationsResponseModel[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetInvitableOrganisationsResponseModel[]>(null as any);
    }

    /**
     * API15009 - GET Invitation Details
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @return OK
     */
    getInvitationDetails(gid: string, use_scenario?: any | undefined, cancelToken?: CancelToken): Promise<GetInvitationDetailsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Invitations/{gid}/details";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvitationDetails(_response);
        });
    }

    protected processGetInvitationDetails(response: AxiosResponse): Promise<GetInvitationDetailsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetInvitationDetailsResponseModel.fromJS(resultData200);
            return Promise.resolve<GetInvitationDetailsResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetInvitationDetailsResponseModel>(null as any);
    }

    /**
     * API15006 - POST Accept Invitation
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @param body (optional) 
     * @return No Content
     */
    postAcceptInvitation(gid: string, use_scenario?: any | undefined, body?: PostAcceptInvitationRequestModel | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Invitations/{gid}/accept";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostAcceptInvitation(_response);
        });
    }

    protected processPostAcceptInvitation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * API15005 - POST Invite User
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @param body (optional) 
     * @return No Content
     */
    postCreateInvitation(use_scenario?: any | undefined, body?: PostCreateInvitationRequestModel | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Invitations/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostCreateInvitation(_response);
        });
    }

    protected processPostCreateInvitation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class OneTrackDbContextScenarioClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getList(cancelToken?: CancelToken): Promise<ScenarioInformationModel[]> {
        let url_ = this.baseUrl + "/OneTrackDbContextScenario/List";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<ScenarioInformationModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScenarioInformationModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ScenarioInformationModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScenarioInformationModel[]>(null as any);
    }

    postApply(scenarioKey?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/OneTrackDbContextScenario/Apply?";
        if (scenarioKey === null)
            throw new Error("The parameter 'scenarioKey' cannot be null.");
        else if (scenarioKey !== undefined)
            url_ += "scenarioKey=" + encodeURIComponent("" + scenarioKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostApply(_response);
        });
    }

    protected processPostApply(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401 = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class OrganisationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * APIS00308 - GET Organisation Calendars
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @return OK
     */
    getOrganisationCalendars(gid: string, use_scenario?: any | undefined, cancelToken?: CancelToken): Promise<GetOrganisationCalendarsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Organisation/{gid}/calendars";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganisationCalendars(_response);
        });
    }

    protected processGetOrganisationCalendars(response: AxiosResponse): Promise<GetOrganisationCalendarsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetOrganisationCalendarsResponseModel.fromJS(resultData200);
            return Promise.resolve<GetOrganisationCalendarsResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetOrganisationCalendarsResponseModel>(null as any);
    }

    /**
     * API07306 - GET Project Types
     * @return OK
     */
    getProjectTypes(gid: string, cancelToken?: CancelToken): Promise<GetProjectTypesResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Organisation/{gid}/projectTypes";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectTypes(_response);
        });
    }

    protected processGetProjectTypes(response: AxiosResponse): Promise<GetProjectTypesResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetProjectTypesResponseModel.fromJS(resultData200);
            return Promise.resolve<GetProjectTypesResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProjectTypesResponseModel>(null as any);
    }

    /**
     * API03106 - GET Organisation Details
     * @return OK
     */
    getOrganisationDetails(gid: string, cancelToken?: CancelToken): Promise<GetOrganisationDetailsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Organisation/{gid}/details";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganisationDetails(_response);
        });
    }

    protected processGetOrganisationDetails(response: AxiosResponse): Promise<GetOrganisationDetailsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetOrganisationDetailsResponseModel.fromJS(resultData200);
            return Promise.resolve<GetOrganisationDetailsResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetOrganisationDetailsResponseModel>(null as any);
    }

    /**
     * API03108 - POST Update Organisation Details
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @param body (optional) 
     * @return No Content
     */
    postUpdateOrganisationDetails(gid: string, use_scenario?: any | undefined, body?: PostUpdateOrganisationDetailsRequestModel | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Organisation/{gid}/details";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostUpdateOrganisationDetails(_response);
        });
    }

    protected processPostUpdateOrganisationDetails(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * API03202 - GET Organisation Users
     * @return OK
     */
    getOrganisationUsers(gid: string, cancelToken?: CancelToken): Promise<GetOrganisationUsersResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Organisation/{gid}/users";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganisationUsers(_response);
        });
    }

    protected processGetOrganisationUsers(response: AxiosResponse): Promise<GetOrganisationUsersResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetOrganisationUsersResponseModel.fromJS(resultData200);
            return Promise.resolve<GetOrganisationUsersResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetOrganisationUsersResponseModel>(null as any);
    }

    /**
     * API03205 - GET Organisation User Contracts
     * @return OK
     */
    getOrganisationUserContracts(organisationGid: string, userGid: string, cancelToken?: CancelToken): Promise<GetOrganisationUserContractsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Organisation/{organisationGid}/users/{userGid}/contracts";
        if (organisationGid === undefined || organisationGid === null)
            throw new Error("The parameter 'organisationGid' must be defined.");
        url_ = url_.replace("{organisationGid}", encodeURIComponent("" + organisationGid));
        if (userGid === undefined || userGid === null)
            throw new Error("The parameter 'userGid' must be defined.");
        url_ = url_.replace("{userGid}", encodeURIComponent("" + userGid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganisationUserContracts(_response);
        });
    }

    protected processGetOrganisationUserContracts(response: AxiosResponse): Promise<GetOrganisationUserContractsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetOrganisationUserContractsResponseModel.fromJS(resultData200);
            return Promise.resolve<GetOrganisationUserContractsResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetOrganisationUserContractsResponseModel>(null as any);
    }

    /**
     * API07303 - GET Organisation User Projects
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @return OK
     */
    getOrganisationUserProjects(organisationGid: string, userGid: string, use_scenario?: any | undefined, cancelToken?: CancelToken): Promise<GetOrganisationUserProjectsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Organisation/{organisationGid}/users/{userGid}/projects";
        if (organisationGid === undefined || organisationGid === null)
            throw new Error("The parameter 'organisationGid' must be defined.");
        url_ = url_.replace("{organisationGid}", encodeURIComponent("" + organisationGid));
        if (userGid === undefined || userGid === null)
            throw new Error("The parameter 'userGid' must be defined.");
        url_ = url_.replace("{userGid}", encodeURIComponent("" + userGid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganisationUserProjects(_response);
        });
    }

    protected processGetOrganisationUserProjects(response: AxiosResponse): Promise<GetOrganisationUserProjectsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetOrganisationUserProjectsResponseModel.fromJS(resultData200);
            return Promise.resolve<GetOrganisationUserProjectsResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetOrganisationUserProjectsResponseModel>(null as any);
    }

    /**
     * API03203 - GET Organisation User Details
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @return OK
     */
    getOrganisationUserDetails(organisationGid: string, userGid: string, use_scenario?: any | undefined, cancelToken?: CancelToken): Promise<GetOrganisationUserDetailsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Organisation/{organisationGid}/users/{userGid}/details";
        if (organisationGid === undefined || organisationGid === null)
            throw new Error("The parameter 'organisationGid' must be defined.");
        url_ = url_.replace("{organisationGid}", encodeURIComponent("" + organisationGid));
        if (userGid === undefined || userGid === null)
            throw new Error("The parameter 'userGid' must be defined.");
        url_ = url_.replace("{userGid}", encodeURIComponent("" + userGid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganisationUserDetails(_response);
        });
    }

    protected processGetOrganisationUserDetails(response: AxiosResponse): Promise<GetOrganisationUserDetailsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetOrganisationUserDetailsResponseModel.fromJS(resultData200);
            return Promise.resolve<GetOrganisationUserDetailsResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetOrganisationUserDetailsResponseModel>(null as any);
    }
}

export class OrganisationUsersClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * API03245 - GET Organisation User Job Titles
     * @return OK
     */
    getOrganisationUserJobTitles(cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/OrganisationUsers/jobTitles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganisationUserJobTitles(_response);
        });
    }

    protected processGetOrganisationUserJobTitles(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * API03204 - POST Update Organisation User Details
     * @param body (optional) 
     * @return OK
     */
    postUpdateOrganisationUserDetails(organisationUserGid: string, body?: PostUpdateOrganisationUserDetailsRequestModel | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/OrganisationUsers/{organisationUserGid}/details";
        if (organisationUserGid === undefined || organisationUserGid === null)
            throw new Error("The parameter 'organisationUserGid' must be defined.");
        url_ = url_.replace("{organisationUserGid}", encodeURIComponent("" + organisationUserGid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostUpdateOrganisationUserDetails(_response);
        });
    }

    protected processPostUpdateOrganisationUserDetails(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * API03242 - POST Set Organisation User Status
     * @param body (optional) 
     * @return OK
     */
    postSetOrganisationUserStatus(body?: PostSetOrganisationUserStatusUserStatusModel[] | undefined, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/OrganisationUsers/setStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostSetOrganisationUserStatus(_response);
        });
    }

    protected processPostSetOrganisationUserStatus(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class ProjectsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * APIS00701 - GET Projects
     * @param permissionLevel (optional) [Permission Level](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Permission-Level)

    1 = View (View only permission)

    2 = Edit (Edit permission)
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @return OK
     */
    getProjects(permissionLevel?: PermissionLevel | undefined, use_scenario?: any | undefined, cancelToken?: CancelToken): Promise<GetProjectsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Projects?";
        if (permissionLevel === null)
            throw new Error("The parameter 'permissionLevel' cannot be null.");
        else if (permissionLevel !== undefined)
            url_ += "permissionLevel=" + encodeURIComponent("" + permissionLevel) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjects(_response);
        });
    }

    protected processGetProjects(response: AxiosResponse): Promise<GetProjectsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetProjectsResponseModel.fromJS(resultData200);
            return Promise.resolve<GetProjectsResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProjectsResponseModel>(null as any);
    }

    /**
     * API00703 - GET Project Details
     * @return OK
     */
    getProjectDetails(gid: string, cancelToken?: CancelToken): Promise<GetProjectDetailsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Projects/{gid}";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectDetails(_response);
        });
    }

    protected processGetProjectDetails(response: AxiosResponse): Promise<GetProjectDetailsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetProjectDetailsResponseModel.fromJS(resultData200);
            return Promise.resolve<GetProjectDetailsResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProjectDetailsResponseModel>(null as any);
    }

    /**
     * API07304 - GET Project Owners
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @return OK
     */
    getProjectOwners(use_scenario?: any | undefined, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/Projects/projectOwners";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectOwners(_response);
        });
    }

    protected processGetProjectOwners(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * API07305 - GET Project Manager Organisations
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @return OK
     */
    getProjectManagerOrganisations(use_scenario?: any | undefined, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/Projects/managerOrganisations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectManagerOrganisations(_response);
        });
    }

    protected processGetProjectManagerOrganisations(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * API07307 - POST Upsert Project Details
     * @param body (optional) 
     * @return No Content
     */
    postUpdateProjectDetails(gid: string, body?: PostUpsertProjectDetailsRequestModel | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Projects/{gid}/details";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostUpdateProjectDetails(_response);
        });
    }

    protected processPostUpdateProjectDetails(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * API07308 - POST Update Project Status
     * @param body (optional) 
     * @return No Content
     */
    postUpdateProjectStatus(gid: string, body?: PostUpdateProjectStatusRequestModel | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Projects/{gid}/status";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostUpdateProjectStatus(_response);
        });
    }

    protected processPostUpdateProjectStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * API03202 - GET Project Users
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @return OK
     */
    getProjectUsers(gid: string, use_scenario?: any | undefined, cancelToken?: CancelToken): Promise<GetProjectUsersResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Projects/{gid}/users";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectUsers(_response);
        });
    }

    protected processGetProjectUsers(response: AxiosResponse): Promise<GetProjectUsersResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetProjectUsersResponseModel.fromJS(resultData200);
            return Promise.resolve<GetProjectUsersResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProjectUsersResponseModel>(null as any);
    }

    /**
     * API03240 - GET Project User Contracts
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @return OK
     */
    getProjectUserContracts(projectGid: string, userGid: string, use_scenario?: any | undefined, cancelToken?: CancelToken): Promise<GetProjectUserContractsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Projects/{projectGid}/users/{userGid}/contracts";
        if (projectGid === undefined || projectGid === null)
            throw new Error("The parameter 'projectGid' must be defined.");
        url_ = url_.replace("{projectGid}", encodeURIComponent("" + projectGid));
        if (userGid === undefined || userGid === null)
            throw new Error("The parameter 'userGid' must be defined.");
        url_ = url_.replace("{userGid}", encodeURIComponent("" + userGid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectUserContracts(_response);
        });
    }

    protected processGetProjectUserContracts(response: AxiosResponse): Promise<GetProjectUserContractsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetProjectUserContractsResponseModel.fromJS(resultData200);
            return Promise.resolve<GetProjectUserContractsResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProjectUserContractsResponseModel>(null as any);
    }

    /**
     * API03207 - GET Project User Details
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @return OK
     */
    getProjectUserDetails(projectGid: string, userGid: string, use_scenario?: any | undefined, cancelToken?: CancelToken): Promise<GetProjectUserDetailsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Projects/{projectGid}/users/{userGid}/details";
        if (projectGid === undefined || projectGid === null)
            throw new Error("The parameter 'projectGid' must be defined.");
        url_ = url_.replace("{projectGid}", encodeURIComponent("" + projectGid));
        if (userGid === undefined || userGid === null)
            throw new Error("The parameter 'userGid' must be defined.");
        url_ = url_.replace("{userGid}", encodeURIComponent("" + userGid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectUserDetails(_response);
        });
    }

    protected processGetProjectUserDetails(response: AxiosResponse): Promise<GetProjectUserDetailsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetProjectUserDetailsResponseModel.fromJS(resultData200);
            return Promise.resolve<GetProjectUserDetailsResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProjectUserDetailsResponseModel>(null as any);
    }
}

export class ProjectUsersClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * API03236 - GET Project User Functional Role Titles
     * @return OK
     */
    getProjectUserJobTitles(cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/ProjectUsers/functionalRoleTitles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectUserJobTitles(_response);
        });
    }

    protected processGetProjectUserJobTitles(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * API03243 - POST Set Project User Status
     * @param body (optional) 
     * @return No Content
     */
    postSetProjectUserStatus(body?: PostSetProjectUserStatusUserStatusModel[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/ProjectUsers/setStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostSetProjectUserStatus(_response);
        });
    }

    protected processPostSetProjectUserStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * API03208 - POST Update Project User Details
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @param body (optional) 
     * @return No Content
     */
    postUpdateProjectUserDetails(gid: string, use_scenario?: any | undefined, body?: PostUpdateProjectUserDetailsModel | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/ProjectUsers/{gid}/details";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostUpdateProjectUserDetails(_response);
        });
    }

    protected processPostUpdateProjectUserDetails(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TemporaryStorageClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * API01001 - GET Temporary Storage
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @return OK
     */
    getTemporaryStorage(use_scenario?: any | undefined, cancelToken?: CancelToken): Promise<GetTemporaryStorageResponseModel> {
        let url_ = this.baseUrl + "/myItems";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTemporaryStorage(_response);
        });
    }

    protected processGetTemporaryStorage(response: AxiosResponse): Promise<GetTemporaryStorageResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetTemporaryStorageResponseModel.fromJS(resultData200);
            return Promise.resolve<GetTemporaryStorageResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTemporaryStorageResponseModel>(null as any);
    }

    /**
     * API00102 - POST Upsert Temporary Storage
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @param body (optional) 
     * @return No Content
     */
    postUpsertTemporaryStorage(gid: string, use_scenario?: any | undefined, body?: PostUpsertTemporaryStorageRequestModel | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/TemporaryStorage/{gid}/upsert";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostUpsertTemporaryStorage(_response);
        });
    }

    protected processPostUpsertTemporaryStorage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * API00103 - POST Delete Temporary Storage
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @param body (optional) 
     * @return No Content
     */
    postDeleteTemporaryStorage(gid: string, use_scenario?: any | undefined, body?: PostDeleteTemporaryStorageRequestModel | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/TemporaryStorage/{gid}/delete";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostDeleteTemporaryStorage(_response);
        });
    }

    protected processPostDeleteTemporaryStorage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UserClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * API00401R04 - GET My User Profile
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @return OK
     */
    getMyProfile(use_scenario?: any | undefined, cancelToken?: CancelToken): Promise<GetMyProfileResponseModel> {
        let url_ = this.baseUrl + "/api/v1/User/myProfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyProfile(_response);
        });
    }

    protected processGetMyProfile(response: AxiosResponse): Promise<GetMyProfileResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetMyProfileResponseModel.fromJS(resultData200);
            return Promise.resolve<GetMyProfileResponseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMyProfileResponseModel>(null as any);
    }

    /**
     * API04005 - POST Edit My User Profile
     * @param body (optional) 
     * @return No Content
     */
    postEditMyUserProfile(body?: PostEditMyUserProfileRequestModel | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/User/myProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostEditMyUserProfile(_response);
        });
    }

    protected processPostEditMyUserProfile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param use_scenario (optional) The name/key of the scenario to use.
     * @return OK
     */
    getProfile(use_scenario?: any | undefined, cancelToken?: CancelToken): Promise<ProfileModel> {
        let url_ = this.baseUrl + "/api/v1/User/Profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "use-scenario": use_scenario !== undefined && use_scenario !== null ? "" + use_scenario : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProfile(_response);
        });
    }

    protected processGetProfile(response: AxiosResponse): Promise<ProfileModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = ProfileModel.fromJS(resultData200);
            return Promise.resolve<ProfileModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProfileModel>(null as any);
    }

    /**
     * DisableUser
     * @param id This is really a Gid
     * @return OK
     */
    postUserDisable(id: string, cancelToken?: CancelToken): Promise<PostDisableUserResponseModel> {
        let url_ = this.baseUrl + "/api/v1/User/{id}/disable";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostUserDisable(_response);
        });
    }

    protected processPostUserDisable(response: AxiosResponse): Promise<PostDisableUserResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = PostDisableUserResponseModel.fromJS(resultData200);
            return Promise.resolve<PostDisableUserResponseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostDisableUserResponseModel>(null as any);
    }

    /**
     * @return OK
     */
    postUserEnable(id: string, cancelToken?: CancelToken): Promise<PostEnableUserResponseModel> {
        let url_ = this.baseUrl + "/api/v1/User/{id}/enable";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostUserEnable(_response);
        });
    }

    protected processPostUserEnable(response: AxiosResponse): Promise<PostEnableUserResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = PostEnableUserResponseModel.fromJS(resultData200);
            return Promise.resolve<PostEnableUserResponseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostEnableUserResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getObject(body?: PostSendTestEmailRequestModel | undefined, cancelToken?: CancelToken): Promise<PostSendTestEmailResponseModel> {
        let url_ = this.baseUrl + "/api/v1/User/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetObject(_response);
        });
    }

    protected processGetObject(response: AxiosResponse): Promise<PostSendTestEmailResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = PostSendTestEmailResponseModel.fromJS(resultData200);
            return Promise.resolve<PostSendTestEmailResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostSendTestEmailResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getObject2(body?: PostSendTestEmailRequestModel | undefined, cancelToken?: CancelToken): Promise<PostSendTestEmailFromIDPResponseModel> {
        let url_ = this.baseUrl + "/api/v1/User/SendTestEmailFromIDP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetObject2(_response);
        });
    }

    protected processGetObject2(response: AxiosResponse): Promise<PostSendTestEmailFromIDPResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = PostSendTestEmailFromIDPResponseModel.fromJS(resultData200);
            return Promise.resolve<PostSendTestEmailFromIDPResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostSendTestEmailFromIDPResponseModel>(null as any);
    }

    /**
     * API04006 - POST Change My Password
     * @param body (optional) 
     * @return No Content
     */
    postChangeMyPassword(body?: PostChangeMyPasswordRequestModel | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/User/myPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostChangeMyPassword(_response);
        });
    }

    protected processPostChangeMyPassword(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422 = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class ValidationProblemDetails implements IValidationProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    errors?: { [key: string]: string[]; } | undefined;

    [key: string]: any;

    constructor(data?: IValidationProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = (<any>this.errors)[key];
            }
        }
        return data;
    }
}

export interface IValidationProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    errors?: { [key: string]: string[]; } | undefined;

    [key: string]: any;
}

export class GetAccessTokenValidityResponseModel implements IGetAccessTokenValidityResponseModel {
    /** The status of the Interaction(s) with Aconex API(s) ([Aconex Interaction Result Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/3082092545/Aconex+Interaction+Result+T+Object)

)

0 = Success (Interaction with the Aconex API was successful)

1 = NoTokenInformation (There was no Token Information available to perform the interaction with the Aconex API)

2 = RefreshTokenExpired (The Refresh Token available to for interaction with the Aconex API has expired)

3 = AccessTokenExpired (The Access Token available to for interaction with the Aconex API has expired (Note: This does not indicate that future interactions will fail, it only indicates that the Access Token will need to be refreshed before the next interaction.))

4 = InteractionFailed (The Aconex API Interaction failed (Usually this indicates that the Aconex API returned a 'non authentication' related error message)) */
    aconexInteractionStatus?: AconexInteractionStatus;
    /** Does the current user have any Aconex Access information, currently valid or otherwise. */
    hasAconexInformation!: boolean;
    /** Does the current user have an Aconex Access Token that is valid for at least the next 5 minutes. */
    isAconexAccessTokenValid!: boolean;

    constructor(data?: IGetAccessTokenValidityResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aconexInteractionStatus = _data["aconexInteractionStatus"];
            this.hasAconexInformation = _data["hasAconexInformation"];
            this.isAconexAccessTokenValid = _data["isAconexAccessTokenValid"];
        }
    }

    static fromJS(data: any): GetAccessTokenValidityResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccessTokenValidityResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aconexInteractionStatus"] = this.aconexInteractionStatus;
        data["hasAconexInformation"] = this.hasAconexInformation;
        data["isAconexAccessTokenValid"] = this.isAconexAccessTokenValid;
        return data;
    }
}

export interface IGetAccessTokenValidityResponseModel {
    /** The status of the Interaction(s) with Aconex API(s) ([Aconex Interaction Result Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/3082092545/Aconex+Interaction+Result+T+Object)

)

0 = Success (Interaction with the Aconex API was successful)

1 = NoTokenInformation (There was no Token Information available to perform the interaction with the Aconex API)

2 = RefreshTokenExpired (The Refresh Token available to for interaction with the Aconex API has expired)

3 = AccessTokenExpired (The Access Token available to for interaction with the Aconex API has expired (Note: This does not indicate that future interactions will fail, it only indicates that the Access Token will need to be refreshed before the next interaction.))

4 = InteractionFailed (The Aconex API Interaction failed (Usually this indicates that the Aconex API returned a 'non authentication' related error message)) */
    aconexInteractionStatus?: AconexInteractionStatus;
    /** Does the current user have any Aconex Access information, currently valid or otherwise. */
    hasAconexInformation: boolean;
    /** Does the current user have an Aconex Access Token that is valid for at least the next 5 minutes. */
    isAconexAccessTokenValid: boolean;
}

export class GetAconexDocumentMetadataResponseModel implements IGetAconexDocumentMetadataResponseModel {
    /** The status of the Interaction(s) with Aconex API(s) ([Aconex Interaction Result Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/3082092545/Aconex+Interaction+Result+T+Object)

)

0 = Success (Interaction with the Aconex API was successful)

1 = NoTokenInformation (There was no Token Information available to perform the interaction with the Aconex API)

2 = RefreshTokenExpired (The Refresh Token available to for interaction with the Aconex API has expired)

3 = AccessTokenExpired (The Access Token available to for interaction with the Aconex API has expired (Note: This does not indicate that future interactions will fail, it only indicates that the Access Token will need to be refreshed before the next interaction.))

4 = InteractionFailed (The Aconex API Interaction failed (Usually this indicates that the Aconex API returned a 'non authentication' related error message)) */
    aconexInteractionStatus?: AconexInteractionStatus;
    /** Result - usually at least partially made up of the response from the interaction(s) with Aconex API(s). Will likely be null unless Status is Success (This is essentially a one to one mapping of the EF AconexDocumentMetadataModel, the difference is that this model is for exposing to the outside world. 

This model is intended to be shared, so can be used by multiple endpoints. 

However it's likely that it won't get used all that much because very few endpoints really need to return this amount of data.) */
    result?: AconexDocumentMetadataModel | undefined;

    constructor(data?: IGetAconexDocumentMetadataResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aconexInteractionStatus = _data["aconexInteractionStatus"];
            this.result = _data["result"] ? AconexDocumentMetadataModel.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAconexDocumentMetadataResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAconexDocumentMetadataResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aconexInteractionStatus"] = this.aconexInteractionStatus;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetAconexDocumentMetadataResponseModel {
    /** The status of the Interaction(s) with Aconex API(s) ([Aconex Interaction Result Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/3082092545/Aconex+Interaction+Result+T+Object)

)

0 = Success (Interaction with the Aconex API was successful)

1 = NoTokenInformation (There was no Token Information available to perform the interaction with the Aconex API)

2 = RefreshTokenExpired (The Refresh Token available to for interaction with the Aconex API has expired)

3 = AccessTokenExpired (The Access Token available to for interaction with the Aconex API has expired (Note: This does not indicate that future interactions will fail, it only indicates that the Access Token will need to be refreshed before the next interaction.))

4 = InteractionFailed (The Aconex API Interaction failed (Usually this indicates that the Aconex API returned a 'non authentication' related error message)) */
    aconexInteractionStatus?: AconexInteractionStatus;
    /** Result - usually at least partially made up of the response from the interaction(s) with Aconex API(s). Will likely be null unless Status is Success (This is essentially a one to one mapping of the EF AconexDocumentMetadataModel, the difference is that this model is for exposing to the outside world. 

This model is intended to be shared, so can be used by multiple endpoints. 

However it's likely that it won't get used all that much because very few endpoints really need to return this amount of data.) */
    result?: AconexDocumentMetadataModel | undefined;
}

export class GetAconexMailMetadataResponseModel implements IGetAconexMailMetadataResponseModel {
    /** The status of the Interaction(s) with Aconex API(s) ([Aconex Interaction Result Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/3082092545/Aconex+Interaction+Result+T+Object)

)

0 = Success (Interaction with the Aconex API was successful)

1 = NoTokenInformation (There was no Token Information available to perform the interaction with the Aconex API)

2 = RefreshTokenExpired (The Refresh Token available to for interaction with the Aconex API has expired)

3 = AccessTokenExpired (The Access Token available to for interaction with the Aconex API has expired (Note: This does not indicate that future interactions will fail, it only indicates that the Access Token will need to be refreshed before the next interaction.))

4 = InteractionFailed (The Aconex API Interaction failed (Usually this indicates that the Aconex API returned a 'non authentication' related error message)) */
    aconexInteractionStatus?: AconexInteractionStatus;
    /** Result - usually at least partially made up of the response from the interaction(s) with Aconex API(s). Will likely be null unless Status is Success (This is essentially a one to one mapping of the EF AconexMailMetadataModel, the difference is that this model is for exposing to the outside world. 

This model is intended to be shared, so can be used by multiple endpoints. 

However it's likely that it won't get used all that much because very few endpoints really need to return this amount of data.) */
    result?: AconexMailMetadataModel | undefined;

    constructor(data?: IGetAconexMailMetadataResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aconexInteractionStatus = _data["aconexInteractionStatus"];
            this.result = _data["result"] ? AconexMailMetadataModel.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAconexMailMetadataResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAconexMailMetadataResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aconexInteractionStatus"] = this.aconexInteractionStatus;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetAconexMailMetadataResponseModel {
    /** The status of the Interaction(s) with Aconex API(s) ([Aconex Interaction Result Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/3082092545/Aconex+Interaction+Result+T+Object)

)

0 = Success (Interaction with the Aconex API was successful)

1 = NoTokenInformation (There was no Token Information available to perform the interaction with the Aconex API)

2 = RefreshTokenExpired (The Refresh Token available to for interaction with the Aconex API has expired)

3 = AccessTokenExpired (The Access Token available to for interaction with the Aconex API has expired (Note: This does not indicate that future interactions will fail, it only indicates that the Access Token will need to be refreshed before the next interaction.))

4 = InteractionFailed (The Aconex API Interaction failed (Usually this indicates that the Aconex API returned a 'non authentication' related error message)) */
    aconexInteractionStatus?: AconexInteractionStatus;
    /** Result - usually at least partially made up of the response from the interaction(s) with Aconex API(s). Will likely be null unless Status is Success (This is essentially a one to one mapping of the EF AconexMailMetadataModel, the difference is that this model is for exposing to the outside world. 

This model is intended to be shared, so can be used by multiple endpoints. 

However it's likely that it won't get used all that much because very few endpoints really need to return this amount of data.) */
    result?: AconexMailMetadataModel | undefined;
}

export class GetAconexProjectsResponseModel implements IGetAconexProjectsResponseModel {
    /** The status of the Interaction(s) with Aconex API(s) ([Aconex Interaction Result Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/3082092545/Aconex+Interaction+Result+T+Object)

)

0 = Success (Interaction with the Aconex API was successful)

1 = NoTokenInformation (There was no Token Information available to perform the interaction with the Aconex API)

2 = RefreshTokenExpired (The Refresh Token available to for interaction with the Aconex API has expired)

3 = AccessTokenExpired (The Access Token available to for interaction with the Aconex API has expired (Note: This does not indicate that future interactions will fail, it only indicates that the Access Token will need to be refreshed before the next interaction.))

4 = InteractionFailed (The Aconex API Interaction failed (Usually this indicates that the Aconex API returned a 'non authentication' related error message)) */
    aconexInteractionStatus?: AconexInteractionStatus;
    /** Result - usually at least partially made up of the response from the interaction(s) with Aconex API(s). Will likely be null unless Status is Success */
    result?: GetAconexProjectsResponseProjectModel[] | undefined;

    constructor(data?: IGetAconexProjectsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aconexInteractionStatus = _data["aconexInteractionStatus"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(GetAconexProjectsResponseProjectModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAconexProjectsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAconexProjectsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aconexInteractionStatus"] = this.aconexInteractionStatus;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAconexProjectsResponseModel {
    /** The status of the Interaction(s) with Aconex API(s) ([Aconex Interaction Result Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/3082092545/Aconex+Interaction+Result+T+Object)

)

0 = Success (Interaction with the Aconex API was successful)

1 = NoTokenInformation (There was no Token Information available to perform the interaction with the Aconex API)

2 = RefreshTokenExpired (The Refresh Token available to for interaction with the Aconex API has expired)

3 = AccessTokenExpired (The Access Token available to for interaction with the Aconex API has expired (Note: This does not indicate that future interactions will fail, it only indicates that the Access Token will need to be refreshed before the next interaction.))

4 = InteractionFailed (The Aconex API Interaction failed (Usually this indicates that the Aconex API returned a 'non authentication' related error message)) */
    aconexInteractionStatus?: AconexInteractionStatus;
    /** Result - usually at least partially made up of the response from the interaction(s) with Aconex API(s). Will likely be null unless Status is Success */
    result?: GetAconexProjectsResponseProjectModel[] | undefined;
}

export class GetAconexProjectsResponseProjectModel implements IGetAconexProjectsResponseProjectModel {
    /** The project ID. (Type: String 
) */
    id?: string | undefined;
    /** The project name. (Type: String(100) 
) */
    name?: string | undefined;
    /** The project short name. (Type: String(20) 
) */
    shortName?: string | undefined;

    constructor(data?: IGetAconexProjectsResponseProjectModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
        }
    }

    static fromJS(data: any): GetAconexProjectsResponseProjectModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAconexProjectsResponseProjectModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        return data;
    }
}

export interface IGetAconexProjectsResponseProjectModel {
    /** The project ID. (Type: String 
) */
    id?: string | undefined;
    /** The project name. (Type: String(100) 
) */
    name?: string | undefined;
    /** The project short name. (Type: String(20) 
) */
    shortName?: string | undefined;
}

export class GetSearchAconexDocumentsResponseDocumentModel implements IGetSearchAconexDocumentsResponseDocumentModel {
    /** Unique identifier for the document. */
    documentId!: string;
    /** Date when the document was approved. (Returned when the return_fields parameter includes the value "approved".) */
    dateApprovedUtc?: Date | undefined;
    /** The author of the document. (String(60) 

Returned when the return_fields parameter includes the value "author".) */
    author?: string | undefined;
    /** The person who authorized the document. (String(60) 

Returned when the return_fields parameter includes the value "authorisedBy". 
) */
    authorisedBy?: string | undefined;
    /** The category of the document. (String(50) 

Returned when the return_fields parameter includes the value "category".) */
    category?: string | undefined;
    /** Comments associated with the document. (String(1024) 

Returned when the return_fields parameter includes the value "comments".) */
    comments?: string | undefined;
    /** Comments2 associated with the document. (String(1024) 

Returned when the return_fields parameter includes the value "comments2".) */
    comments2?: string | undefined;
    /** Indicates if the document is confidential. (Returned when the return_fields parameter includes the value "confidential".) */
    confidential?: boolean | undefined;
    /** Indicates if the document is a contract deliverable. (Returned when the return_fields parameter includes the value "contractDeliverable".) */
    contractDeliverable?: boolean | undefined;
    /** Contract number associated with the document. (String(50) 

Returned when the return_fields parameter includes the value "contractnumber".) */
    contractNumber?: string | undefined;
    /** Contractor document number associated with the document. (String(50) 

Returned when the return_fields parameter includes the value "contractordocumentnumber".) */
    contractorDocumentNumber?: string | undefined;
    /** Contractor revision associated with the document. (String(15) 

Returned when the return_fields parameter includes the value "contractorrev".) */
    contractorRevision?: string | undefined;
    /** Indicates if this is the current revision of the document. (Returned when the return_fields parameter includes the value "current".
Determines whether this revision of the document is the current revision.) */
    current?: boolean | undefined;
    /** Date when the document was created. (Returned when the return_fields parameter includes the value "received".
UTC format.) */
    dateCreatedUtc?: Date | undefined;
    /** Date for review of the document. (Returned when the return_fields parameter includes the value "forreview".
UTC format.) */
    dateForReviewUtc?: Date | undefined;
    /** Date when the document was last modified. (Returned when the return_fields parameter includes the value "registered".
UTC format.) */
    dateModifiedUtc?: Date | undefined;
    /** Date when the document was reviewed. (Returned when the return_fields parameter includes the value "reviewed".
UTC format.) */
    dateReviewedUtc?: Date | undefined;
    /** Discipline associated with the document. (String(50) 

Returned when the return_fields parameter includes the value "discipline".) */
    discipline?: string | undefined;
    /** Document number. (String(210) 

Returned when the return_fields parameter includes the value "docno".) */
    documentNumber?: string | undefined;
    /** The document type. (Returned when the return_fields parameter includes the value "statusid".) */
    documentStatus?: string | undefined;
    /** Type of the document. (Returned when the return_fields parameter includes the value "doctype".) */
    documentType?: string | undefined;
    /** Size of the document file. (Returned when the return_fields parameter includes the value "fileSize".) */
    fileSize?: number | undefined;
    /** Name of the document file. (Returned when the return_fields parameter includes the value "filename".) */
    filename?: string | undefined;
    /** The type of the document file. (String(3) 

Returned when the return_fields parameter includes the value "fileType".) */
    fileType?: string | undefined;
    /** Date when the last markup was made. (Returned when the return_fields parameter includes the value "markupLastModifiedDate".
UTC format.) */
    markupLastModifiedDateUtc?: Date | undefined;
    /** Milestone date associated with the document. (Returned when the return_fields parameter includes the value "milestonedate".
UTC format.) */
    milestoneDateUtc?: Date | undefined;
    /** Count of markups on the document. (Returned when the return_fields parameter includes the value "numberOfMarkups".) */
    numberOfMarkups?: number | undefined;
    /** Package number associated with the document. (String(50) 

Returned when the return_fields parameter includes the value "packagenumber".) */
    packageNumber?: string | undefined;
    /** Percentage of completion for the document. (Returned when the return_fields parameter includes the value "percentComplete".) */
    percentComplete?: number | undefined;
    /** Size of the document when printed. (String(15) 

Returned when the return_fields parameter includes the value "plannedsubmissiondate". 

UTC format.) */
    plannedSubmissionDateUtc?: Date | undefined;
    /** Reference information for the document. (String(120) 

Returned when the return_fields parameter includes the value "reference".) */
    reference?: string | undefined;
    /** Source of the review for the document. (String(50) 

Returned when the return_fields parameter includes the value "reviewSource" 

From Release 21.10: 

The field will include actual "Workflow Number" / "Correspondence Number" / "SupploerDocPackageNumber" if it exists for the document corresponding to type of Source (Workflow / Transmittal / Supplier Document) . 

Eg:  

Workflow : <ReviewSource>WF-000002</ReviewSource>

Transmittal : <ReviewSource>145228</ReviewSource>

Supplier Document : <ReviewSource>SD-000004</ReviewSource>

No Review Source : <ReviewSource>None</ReviewSource>
) */
    reviewSource?: string | undefined;
    /** The Review Status of the document. (String(50) 

Returned when the return_fields parameter includes the value "reviewstatus".) */
    reviewStatus?: string | undefined;
    /** Revision of the document. (String(15) 

Returned when the return_fields parameter includes the value "revision".) */
    revision?: string | undefined;
    /** Revision Date of the document. (Returned when the return_fields parameter includes the value "revisiondate".
UTC format.) */
    revisionDateUtc?: Date | undefined;
    /** Tag number associated with the document. (String(50) 

Returned when the return_fields parameter includes the value "tagNumber".) */
    tagNumber?: string | undefined;
    /** Title of the document. (String(120) 

Returned when the return_fields parameter includes the value "title".) */
    title?: string | undefined;
    /** Date to client. (Returned when the return_fields parameter includes the value "toclient". 

UTC format.) */
    toClientDateUtc?: Date | undefined;
    /** The tracking ID for the document. (The tracking ID is a unique identifier for all versions of a specific document. 

When a document is first registered into Aconex, a unique identifier is generated 

and this value is assigned to all document revisions of that document. 

One can use this tracking identifier to create a chain of documents.) */
    trackingId?: string | undefined;
    /** The version number of the document. (The version number provides information relating to the sequence in 

which the document was registered within the chain of revisions. 

For all documents with the same Tracking Id, the version number will be an integer value starting from 1.

e.g. When a document is newly registered into Aconex, its version number will be 1. 

When it is superseded, a new document with a version number of 2 will be created. 

Both document revisions will be accessible using their respective document Id's.) */
    versionNumber?: number | undefined;
    /** Vendor code associated with the document. (String(50) 

Returned when the return_fields parameter includes the value "vdrcode".) */
    vendorCode?: string | undefined;
    /** Vendor document number associated with the document. (String(50) 

Returned when the return_fields parameter includes the value "vendordocumentnumber".) */
    vendorDocumentNumber?: string | undefined;
    /** Vendor revision associated with the document. (String(15) 

Returned when the return_fields parameter includes the value "vendorrev".) */
    vendorRevision?: string | undefined;

    constructor(data?: IGetSearchAconexDocumentsResponseDocumentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.dateApprovedUtc = _data["dateApprovedUtc"] ? new Date(_data["dateApprovedUtc"].toString()) : <any>undefined;
            this.author = _data["author"];
            this.authorisedBy = _data["authorisedBy"];
            this.category = _data["category"];
            this.comments = _data["comments"];
            this.comments2 = _data["comments2"];
            this.confidential = _data["confidential"];
            this.contractDeliverable = _data["contractDeliverable"];
            this.contractNumber = _data["contractNumber"];
            this.contractorDocumentNumber = _data["contractorDocumentNumber"];
            this.contractorRevision = _data["contractorRevision"];
            this.current = _data["current"];
            this.dateCreatedUtc = _data["dateCreatedUtc"] ? new Date(_data["dateCreatedUtc"].toString()) : <any>undefined;
            this.dateForReviewUtc = _data["dateForReviewUtc"] ? new Date(_data["dateForReviewUtc"].toString()) : <any>undefined;
            this.dateModifiedUtc = _data["dateModifiedUtc"] ? new Date(_data["dateModifiedUtc"].toString()) : <any>undefined;
            this.dateReviewedUtc = _data["dateReviewedUtc"] ? new Date(_data["dateReviewedUtc"].toString()) : <any>undefined;
            this.discipline = _data["discipline"];
            this.documentNumber = _data["documentNumber"];
            this.documentStatus = _data["documentStatus"];
            this.documentType = _data["documentType"];
            this.fileSize = _data["fileSize"];
            this.filename = _data["filename"];
            this.fileType = _data["fileType"];
            this.markupLastModifiedDateUtc = _data["markupLastModifiedDateUtc"] ? new Date(_data["markupLastModifiedDateUtc"].toString()) : <any>undefined;
            this.milestoneDateUtc = _data["milestoneDateUtc"] ? new Date(_data["milestoneDateUtc"].toString()) : <any>undefined;
            this.numberOfMarkups = _data["numberOfMarkups"];
            this.packageNumber = _data["packageNumber"];
            this.percentComplete = _data["percentComplete"];
            this.plannedSubmissionDateUtc = _data["plannedSubmissionDateUtc"] ? new Date(_data["plannedSubmissionDateUtc"].toString()) : <any>undefined;
            this.reference = _data["reference"];
            this.reviewSource = _data["reviewSource"];
            this.reviewStatus = _data["reviewStatus"];
            this.revision = _data["revision"];
            this.revisionDateUtc = _data["revisionDateUtc"] ? new Date(_data["revisionDateUtc"].toString()) : <any>undefined;
            this.tagNumber = _data["tagNumber"];
            this.title = _data["title"];
            this.toClientDateUtc = _data["toClientDateUtc"] ? new Date(_data["toClientDateUtc"].toString()) : <any>undefined;
            this.trackingId = _data["trackingId"];
            this.versionNumber = _data["versionNumber"];
            this.vendorCode = _data["vendorCode"];
            this.vendorDocumentNumber = _data["vendorDocumentNumber"];
            this.vendorRevision = _data["vendorRevision"];
        }
    }

    static fromJS(data: any): GetSearchAconexDocumentsResponseDocumentModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSearchAconexDocumentsResponseDocumentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["dateApprovedUtc"] = this.dateApprovedUtc ? this.dateApprovedUtc.toISOString() : <any>undefined;
        data["author"] = this.author;
        data["authorisedBy"] = this.authorisedBy;
        data["category"] = this.category;
        data["comments"] = this.comments;
        data["comments2"] = this.comments2;
        data["confidential"] = this.confidential;
        data["contractDeliverable"] = this.contractDeliverable;
        data["contractNumber"] = this.contractNumber;
        data["contractorDocumentNumber"] = this.contractorDocumentNumber;
        data["contractorRevision"] = this.contractorRevision;
        data["current"] = this.current;
        data["dateCreatedUtc"] = this.dateCreatedUtc ? this.dateCreatedUtc.toISOString() : <any>undefined;
        data["dateForReviewUtc"] = this.dateForReviewUtc ? this.dateForReviewUtc.toISOString() : <any>undefined;
        data["dateModifiedUtc"] = this.dateModifiedUtc ? this.dateModifiedUtc.toISOString() : <any>undefined;
        data["dateReviewedUtc"] = this.dateReviewedUtc ? this.dateReviewedUtc.toISOString() : <any>undefined;
        data["discipline"] = this.discipline;
        data["documentNumber"] = this.documentNumber;
        data["documentStatus"] = this.documentStatus;
        data["documentType"] = this.documentType;
        data["fileSize"] = this.fileSize;
        data["filename"] = this.filename;
        data["fileType"] = this.fileType;
        data["markupLastModifiedDateUtc"] = this.markupLastModifiedDateUtc ? this.markupLastModifiedDateUtc.toISOString() : <any>undefined;
        data["milestoneDateUtc"] = this.milestoneDateUtc ? this.milestoneDateUtc.toISOString() : <any>undefined;
        data["numberOfMarkups"] = this.numberOfMarkups;
        data["packageNumber"] = this.packageNumber;
        data["percentComplete"] = this.percentComplete;
        data["plannedSubmissionDateUtc"] = this.plannedSubmissionDateUtc ? this.plannedSubmissionDateUtc.toISOString() : <any>undefined;
        data["reference"] = this.reference;
        data["reviewSource"] = this.reviewSource;
        data["reviewStatus"] = this.reviewStatus;
        data["revision"] = this.revision;
        data["revisionDateUtc"] = this.revisionDateUtc ? this.revisionDateUtc.toISOString() : <any>undefined;
        data["tagNumber"] = this.tagNumber;
        data["title"] = this.title;
        data["toClientDateUtc"] = this.toClientDateUtc ? this.toClientDateUtc.toISOString() : <any>undefined;
        data["trackingId"] = this.trackingId;
        data["versionNumber"] = this.versionNumber;
        data["vendorCode"] = this.vendorCode;
        data["vendorDocumentNumber"] = this.vendorDocumentNumber;
        data["vendorRevision"] = this.vendorRevision;
        return data;
    }
}

export interface IGetSearchAconexDocumentsResponseDocumentModel {
    /** Unique identifier for the document. */
    documentId: string;
    /** Date when the document was approved. (Returned when the return_fields parameter includes the value "approved".) */
    dateApprovedUtc?: Date | undefined;
    /** The author of the document. (String(60) 

Returned when the return_fields parameter includes the value "author".) */
    author?: string | undefined;
    /** The person who authorized the document. (String(60) 

Returned when the return_fields parameter includes the value "authorisedBy". 
) */
    authorisedBy?: string | undefined;
    /** The category of the document. (String(50) 

Returned when the return_fields parameter includes the value "category".) */
    category?: string | undefined;
    /** Comments associated with the document. (String(1024) 

Returned when the return_fields parameter includes the value "comments".) */
    comments?: string | undefined;
    /** Comments2 associated with the document. (String(1024) 

Returned when the return_fields parameter includes the value "comments2".) */
    comments2?: string | undefined;
    /** Indicates if the document is confidential. (Returned when the return_fields parameter includes the value "confidential".) */
    confidential?: boolean | undefined;
    /** Indicates if the document is a contract deliverable. (Returned when the return_fields parameter includes the value "contractDeliverable".) */
    contractDeliverable?: boolean | undefined;
    /** Contract number associated with the document. (String(50) 

Returned when the return_fields parameter includes the value "contractnumber".) */
    contractNumber?: string | undefined;
    /** Contractor document number associated with the document. (String(50) 

Returned when the return_fields parameter includes the value "contractordocumentnumber".) */
    contractorDocumentNumber?: string | undefined;
    /** Contractor revision associated with the document. (String(15) 

Returned when the return_fields parameter includes the value "contractorrev".) */
    contractorRevision?: string | undefined;
    /** Indicates if this is the current revision of the document. (Returned when the return_fields parameter includes the value "current".
Determines whether this revision of the document is the current revision.) */
    current?: boolean | undefined;
    /** Date when the document was created. (Returned when the return_fields parameter includes the value "received".
UTC format.) */
    dateCreatedUtc?: Date | undefined;
    /** Date for review of the document. (Returned when the return_fields parameter includes the value "forreview".
UTC format.) */
    dateForReviewUtc?: Date | undefined;
    /** Date when the document was last modified. (Returned when the return_fields parameter includes the value "registered".
UTC format.) */
    dateModifiedUtc?: Date | undefined;
    /** Date when the document was reviewed. (Returned when the return_fields parameter includes the value "reviewed".
UTC format.) */
    dateReviewedUtc?: Date | undefined;
    /** Discipline associated with the document. (String(50) 

Returned when the return_fields parameter includes the value "discipline".) */
    discipline?: string | undefined;
    /** Document number. (String(210) 

Returned when the return_fields parameter includes the value "docno".) */
    documentNumber?: string | undefined;
    /** The document type. (Returned when the return_fields parameter includes the value "statusid".) */
    documentStatus?: string | undefined;
    /** Type of the document. (Returned when the return_fields parameter includes the value "doctype".) */
    documentType?: string | undefined;
    /** Size of the document file. (Returned when the return_fields parameter includes the value "fileSize".) */
    fileSize?: number | undefined;
    /** Name of the document file. (Returned when the return_fields parameter includes the value "filename".) */
    filename?: string | undefined;
    /** The type of the document file. (String(3) 

Returned when the return_fields parameter includes the value "fileType".) */
    fileType?: string | undefined;
    /** Date when the last markup was made. (Returned when the return_fields parameter includes the value "markupLastModifiedDate".
UTC format.) */
    markupLastModifiedDateUtc?: Date | undefined;
    /** Milestone date associated with the document. (Returned when the return_fields parameter includes the value "milestonedate".
UTC format.) */
    milestoneDateUtc?: Date | undefined;
    /** Count of markups on the document. (Returned when the return_fields parameter includes the value "numberOfMarkups".) */
    numberOfMarkups?: number | undefined;
    /** Package number associated with the document. (String(50) 

Returned when the return_fields parameter includes the value "packagenumber".) */
    packageNumber?: string | undefined;
    /** Percentage of completion for the document. (Returned when the return_fields parameter includes the value "percentComplete".) */
    percentComplete?: number | undefined;
    /** Size of the document when printed. (String(15) 

Returned when the return_fields parameter includes the value "plannedsubmissiondate". 

UTC format.) */
    plannedSubmissionDateUtc?: Date | undefined;
    /** Reference information for the document. (String(120) 

Returned when the return_fields parameter includes the value "reference".) */
    reference?: string | undefined;
    /** Source of the review for the document. (String(50) 

Returned when the return_fields parameter includes the value "reviewSource" 

From Release 21.10: 

The field will include actual "Workflow Number" / "Correspondence Number" / "SupploerDocPackageNumber" if it exists for the document corresponding to type of Source (Workflow / Transmittal / Supplier Document) . 

Eg:  

Workflow : <ReviewSource>WF-000002</ReviewSource>

Transmittal : <ReviewSource>145228</ReviewSource>

Supplier Document : <ReviewSource>SD-000004</ReviewSource>

No Review Source : <ReviewSource>None</ReviewSource>
) */
    reviewSource?: string | undefined;
    /** The Review Status of the document. (String(50) 

Returned when the return_fields parameter includes the value "reviewstatus".) */
    reviewStatus?: string | undefined;
    /** Revision of the document. (String(15) 

Returned when the return_fields parameter includes the value "revision".) */
    revision?: string | undefined;
    /** Revision Date of the document. (Returned when the return_fields parameter includes the value "revisiondate".
UTC format.) */
    revisionDateUtc?: Date | undefined;
    /** Tag number associated with the document. (String(50) 

Returned when the return_fields parameter includes the value "tagNumber".) */
    tagNumber?: string | undefined;
    /** Title of the document. (String(120) 

Returned when the return_fields parameter includes the value "title".) */
    title?: string | undefined;
    /** Date to client. (Returned when the return_fields parameter includes the value "toclient". 

UTC format.) */
    toClientDateUtc?: Date | undefined;
    /** The tracking ID for the document. (The tracking ID is a unique identifier for all versions of a specific document. 

When a document is first registered into Aconex, a unique identifier is generated 

and this value is assigned to all document revisions of that document. 

One can use this tracking identifier to create a chain of documents.) */
    trackingId?: string | undefined;
    /** The version number of the document. (The version number provides information relating to the sequence in 

which the document was registered within the chain of revisions. 

For all documents with the same Tracking Id, the version number will be an integer value starting from 1.

e.g. When a document is newly registered into Aconex, its version number will be 1. 

When it is superseded, a new document with a version number of 2 will be created. 

Both document revisions will be accessible using their respective document Id's.) */
    versionNumber?: number | undefined;
    /** Vendor code associated with the document. (String(50) 

Returned when the return_fields parameter includes the value "vdrcode".) */
    vendorCode?: string | undefined;
    /** Vendor document number associated with the document. (String(50) 

Returned when the return_fields parameter includes the value "vendordocumentnumber".) */
    vendorDocumentNumber?: string | undefined;
    /** Vendor revision associated with the document. (String(15) 

Returned when the return_fields parameter includes the value "vendorrev".) */
    vendorRevision?: string | undefined;
}

export class GetSearchAconexDocumentsResponseModel implements IGetSearchAconexDocumentsResponseModel {
    /** The status of the Interaction(s) with Aconex API(s) ([Aconex Interaction Result Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/3082092545/Aconex+Interaction+Result+T+Object)

)

0 = Success (Interaction with the Aconex API was successful)

1 = NoTokenInformation (There was no Token Information available to perform the interaction with the Aconex API)

2 = RefreshTokenExpired (The Refresh Token available to for interaction with the Aconex API has expired)

3 = AccessTokenExpired (The Access Token available to for interaction with the Aconex API has expired (Note: This does not indicate that future interactions will fail, it only indicates that the Access Token will need to be refreshed before the next interaction.))

4 = InteractionFailed (The Aconex API Interaction failed (Usually this indicates that the Aconex API returned a 'non authentication' related error message)) */
    aconexInteractionStatus?: AconexInteractionStatus;
    /** Result - usually at least partially made up of the response from the interaction(s) with Aconex API(s). Will likely be null unless Status is Success */
    result?: GetSearchAconexDocumentsResponseResultModel | undefined;

    constructor(data?: IGetSearchAconexDocumentsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aconexInteractionStatus = _data["aconexInteractionStatus"];
            this.result = _data["result"] ? GetSearchAconexDocumentsResponseResultModel.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSearchAconexDocumentsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSearchAconexDocumentsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aconexInteractionStatus"] = this.aconexInteractionStatus;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSearchAconexDocumentsResponseModel {
    /** The status of the Interaction(s) with Aconex API(s) ([Aconex Interaction Result Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/3082092545/Aconex+Interaction+Result+T+Object)

)

0 = Success (Interaction with the Aconex API was successful)

1 = NoTokenInformation (There was no Token Information available to perform the interaction with the Aconex API)

2 = RefreshTokenExpired (The Refresh Token available to for interaction with the Aconex API has expired)

3 = AccessTokenExpired (The Access Token available to for interaction with the Aconex API has expired (Note: This does not indicate that future interactions will fail, it only indicates that the Access Token will need to be refreshed before the next interaction.))

4 = InteractionFailed (The Aconex API Interaction failed (Usually this indicates that the Aconex API returned a 'non authentication' related error message)) */
    aconexInteractionStatus?: AconexInteractionStatus;
    /** Result - usually at least partially made up of the response from the interaction(s) with Aconex API(s). Will likely be null unless Status is Success */
    result?: GetSearchAconexDocumentsResponseResultModel | undefined;
}

export class GetSearchAconexDocumentsResponseResultModel implements IGetSearchAconexDocumentsResponseResultModel {
    /** Gets or sets the total number of mail items that match the search query. (Type: Integer

Notes: The number of mail items that match the search_query.) */
    totalResults!: number;
    /** Gets or sets the number of results on the current page. (Type: Integer

Notes: Only applicable to a paged search.) */
    totalResultsOnPage!: number;
    /** Gets or sets the total number of pages available for the specified page size. (Type: Integer

Notes: Only applicable to a paged search.) */
    totalPages!: number;
    /** Gets or sets the page size for the search. (Type: Integer

Notes: Will match specified page_size.) */
    pageSize!: number;
    /** Gets or sets the current page of results. (Type: Integer

Notes: Will match specified page_number.) */
    currentPage!: number;
    /** Gets or sets the list of mail search results. */
    searchResults!: GetSearchAconexDocumentsResponseDocumentModel[];

    constructor(data?: IGetSearchAconexDocumentsResponseResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.searchResults = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalResults = _data["totalResults"];
            this.totalResultsOnPage = _data["totalResultsOnPage"];
            this.totalPages = _data["totalPages"];
            this.pageSize = _data["pageSize"];
            this.currentPage = _data["currentPage"];
            if (Array.isArray(_data["searchResults"])) {
                this.searchResults = [] as any;
                for (let item of _data["searchResults"])
                    this.searchResults!.push(GetSearchAconexDocumentsResponseDocumentModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSearchAconexDocumentsResponseResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSearchAconexDocumentsResponseResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalResults"] = this.totalResults;
        data["totalResultsOnPage"] = this.totalResultsOnPage;
        data["totalPages"] = this.totalPages;
        data["pageSize"] = this.pageSize;
        data["currentPage"] = this.currentPage;
        if (Array.isArray(this.searchResults)) {
            data["searchResults"] = [];
            for (let item of this.searchResults)
                data["searchResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSearchAconexDocumentsResponseResultModel {
    /** Gets or sets the total number of mail items that match the search query. (Type: Integer

Notes: The number of mail items that match the search_query.) */
    totalResults: number;
    /** Gets or sets the number of results on the current page. (Type: Integer

Notes: Only applicable to a paged search.) */
    totalResultsOnPage: number;
    /** Gets or sets the total number of pages available for the specified page size. (Type: Integer

Notes: Only applicable to a paged search.) */
    totalPages: number;
    /** Gets or sets the page size for the search. (Type: Integer

Notes: Will match specified page_size.) */
    pageSize: number;
    /** Gets or sets the current page of results. (Type: Integer

Notes: Will match specified page_number.) */
    currentPage: number;
    /** Gets or sets the list of mail search results. */
    searchResults: GetSearchAconexDocumentsResponseDocumentModel[];
}

export class GetSearchAconexMailResponseMailModel implements IGetSearchAconexMailResponseMailModel {
    /** Gets or sets the unique identifier for the mail. (Type: String

Notes: Unique identifier for the mail item.) */
    mailId!: string;
    /** Gets or sets the correspondence type of the mail. (Type: String(200)

Notes: Type of correspondence for the mail.) */
    correspondenceType?: string | undefined;
    /** Gets or sets the recipients of the mail. */
    toUsers?: GetSearchAconexMailResponseRecipientModel[] | undefined;
    /** Gets or sets the mail number. (Type: String

Notes: Mail number for reference.) */
    mailNo?: string | undefined;
    /** Gets or sets the details of the sender. */
    fromUserDetails?: GetSearchAconexMailResponseUserModel | undefined;
    /** Gets or sets the reason for the issue. (Type: String(200)

Notes: Reason for the issue related to the mail.) */
    reasonForIssue?: string | undefined;
    /** Gets or sets the sent date of the mail. (Type: String

Notes: Date when the mail was sent in UTC format.) */
    sentDate?: Date | undefined;
    /** Gets or sets the status of the mail. (Type: String(20)

Notes: Status of the mail (e.g., Outstanding, Closed-Out).) */
    status?: string | undefined;
    /** Gets or sets the subject of the mail. (Type: String(250)

Notes: Subject line of the mail.) */
    subject?: string | undefined;
    /** Gets or sets the reference number of the mail. (Type: String

Notes: Reference number for the mail.) */
    referenceNumber?: string | undefined;
    /** Gets or sets a value indicating whether the mail has attachments. (Type: Boolean

Notes: True if the mail has attachments, otherwise false.) */
    hasAttachments?: boolean | undefined;

    constructor(data?: IGetSearchAconexMailResponseMailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailId = _data["mailId"];
            this.correspondenceType = _data["correspondenceType"];
            if (Array.isArray(_data["toUsers"])) {
                this.toUsers = [] as any;
                for (let item of _data["toUsers"])
                    this.toUsers!.push(GetSearchAconexMailResponseRecipientModel.fromJS(item));
            }
            this.mailNo = _data["mailNo"];
            this.fromUserDetails = _data["fromUserDetails"] ? GetSearchAconexMailResponseUserModel.fromJS(_data["fromUserDetails"]) : <any>undefined;
            this.reasonForIssue = _data["reasonForIssue"];
            this.sentDate = _data["sentDate"] ? new Date(_data["sentDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.subject = _data["subject"];
            this.referenceNumber = _data["referenceNumber"];
            this.hasAttachments = _data["hasAttachments"];
        }
    }

    static fromJS(data: any): GetSearchAconexMailResponseMailModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSearchAconexMailResponseMailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailId"] = this.mailId;
        data["correspondenceType"] = this.correspondenceType;
        if (Array.isArray(this.toUsers)) {
            data["toUsers"] = [];
            for (let item of this.toUsers)
                data["toUsers"].push(item.toJSON());
        }
        data["mailNo"] = this.mailNo;
        data["fromUserDetails"] = this.fromUserDetails ? this.fromUserDetails.toJSON() : <any>undefined;
        data["reasonForIssue"] = this.reasonForIssue;
        data["sentDate"] = this.sentDate ? this.sentDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["subject"] = this.subject;
        data["referenceNumber"] = this.referenceNumber;
        data["hasAttachments"] = this.hasAttachments;
        return data;
    }
}

export interface IGetSearchAconexMailResponseMailModel {
    /** Gets or sets the unique identifier for the mail. (Type: String

Notes: Unique identifier for the mail item.) */
    mailId: string;
    /** Gets or sets the correspondence type of the mail. (Type: String(200)

Notes: Type of correspondence for the mail.) */
    correspondenceType?: string | undefined;
    /** Gets or sets the recipients of the mail. */
    toUsers?: GetSearchAconexMailResponseRecipientModel[] | undefined;
    /** Gets or sets the mail number. (Type: String

Notes: Mail number for reference.) */
    mailNo?: string | undefined;
    /** Gets or sets the details of the sender. */
    fromUserDetails?: GetSearchAconexMailResponseUserModel | undefined;
    /** Gets or sets the reason for the issue. (Type: String(200)

Notes: Reason for the issue related to the mail.) */
    reasonForIssue?: string | undefined;
    /** Gets or sets the sent date of the mail. (Type: String

Notes: Date when the mail was sent in UTC format.) */
    sentDate?: Date | undefined;
    /** Gets or sets the status of the mail. (Type: String(20)

Notes: Status of the mail (e.g., Outstanding, Closed-Out).) */
    status?: string | undefined;
    /** Gets or sets the subject of the mail. (Type: String(250)

Notes: Subject line of the mail.) */
    subject?: string | undefined;
    /** Gets or sets the reference number of the mail. (Type: String

Notes: Reference number for the mail.) */
    referenceNumber?: string | undefined;
    /** Gets or sets a value indicating whether the mail has attachments. (Type: Boolean

Notes: True if the mail has attachments, otherwise false.) */
    hasAttachments?: boolean | undefined;
}

export class GetSearchAconexMailResponseModel implements IGetSearchAconexMailResponseModel {
    /** The status of the Interaction(s) with Aconex API(s) ([Aconex Interaction Result Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/3082092545/Aconex+Interaction+Result+T+Object)

)

0 = Success (Interaction with the Aconex API was successful)

1 = NoTokenInformation (There was no Token Information available to perform the interaction with the Aconex API)

2 = RefreshTokenExpired (The Refresh Token available to for interaction with the Aconex API has expired)

3 = AccessTokenExpired (The Access Token available to for interaction with the Aconex API has expired (Note: This does not indicate that future interactions will fail, it only indicates that the Access Token will need to be refreshed before the next interaction.))

4 = InteractionFailed (The Aconex API Interaction failed (Usually this indicates that the Aconex API returned a 'non authentication' related error message)) */
    aconexInteractionStatus?: AconexInteractionStatus;
    /** Result - usually at least partially made up of the response from the interaction(s) with Aconex API(s). Will likely be null unless Status is Success */
    result?: GetSearchAconexMailResponseResultModel | undefined;

    constructor(data?: IGetSearchAconexMailResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aconexInteractionStatus = _data["aconexInteractionStatus"];
            this.result = _data["result"] ? GetSearchAconexMailResponseResultModel.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSearchAconexMailResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSearchAconexMailResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aconexInteractionStatus"] = this.aconexInteractionStatus;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSearchAconexMailResponseModel {
    /** The status of the Interaction(s) with Aconex API(s) ([Aconex Interaction Result Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/3082092545/Aconex+Interaction+Result+T+Object)

)

0 = Success (Interaction with the Aconex API was successful)

1 = NoTokenInformation (There was no Token Information available to perform the interaction with the Aconex API)

2 = RefreshTokenExpired (The Refresh Token available to for interaction with the Aconex API has expired)

3 = AccessTokenExpired (The Access Token available to for interaction with the Aconex API has expired (Note: This does not indicate that future interactions will fail, it only indicates that the Access Token will need to be refreshed before the next interaction.))

4 = InteractionFailed (The Aconex API Interaction failed (Usually this indicates that the Aconex API returned a 'non authentication' related error message)) */
    aconexInteractionStatus?: AconexInteractionStatus;
    /** Result - usually at least partially made up of the response from the interaction(s) with Aconex API(s). Will likely be null unless Status is Success */
    result?: GetSearchAconexMailResponseResultModel | undefined;
}

export class GetSearchAconexMailResponseRecipientModel implements IGetSearchAconexMailResponseRecipientModel {
    /** Gets or sets the organization ID of the recipient. (Type: String

Notes: Unique identifier for the recipient's organization.) */
    organizationId?: string | undefined;
    /** Gets or sets the organization name of the recipient. (Type: String(60)

Notes: Name of the recipient's organization.) */
    organizationName?: string | undefined;
    /** Gets or sets the first name of the recipient. (Type: String

Notes: First name of the recipient.) */
    firstName?: string | undefined;
    /** Gets or sets the last name of the recipient. (Type: String

Notes: Last name of the recipient.) */
    lastName?: string | undefined;
    /** Gets or sets the user ID of the recipient. (Type: String

Notes: Unique identifier for the recipient.) */
    userId?: string | undefined;
    /** Not documented, but it's on the response */
    name?: string | undefined;
    /** Gets or sets a value indicating whether the mail has been read by the recipient. (Type: Boolean

Notes: True if the mail has been read, otherwise false.) */
    read?: boolean;
    /** Gets or sets the status of the mail for this recipient. (Type: String

Notes: Status of the mail for this recipient.) */
    status?: string | undefined;
    /** Gets or sets the distribution type (TO, CC, BCC). (Type: String

Notes: Type of distribution for the mail.) */
    distributionType?: string | undefined;

    constructor(data?: IGetSearchAconexMailResponseRecipientModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.read = _data["read"];
            this.status = _data["status"];
            this.distributionType = _data["distributionType"];
        }
    }

    static fromJS(data: any): GetSearchAconexMailResponseRecipientModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSearchAconexMailResponseRecipientModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["read"] = this.read;
        data["status"] = this.status;
        data["distributionType"] = this.distributionType;
        return data;
    }
}

export interface IGetSearchAconexMailResponseRecipientModel {
    /** Gets or sets the organization ID of the recipient. (Type: String

Notes: Unique identifier for the recipient's organization.) */
    organizationId?: string | undefined;
    /** Gets or sets the organization name of the recipient. (Type: String(60)

Notes: Name of the recipient's organization.) */
    organizationName?: string | undefined;
    /** Gets or sets the first name of the recipient. (Type: String

Notes: First name of the recipient.) */
    firstName?: string | undefined;
    /** Gets or sets the last name of the recipient. (Type: String

Notes: Last name of the recipient.) */
    lastName?: string | undefined;
    /** Gets or sets the user ID of the recipient. (Type: String

Notes: Unique identifier for the recipient.) */
    userId?: string | undefined;
    /** Not documented, but it's on the response */
    name?: string | undefined;
    /** Gets or sets a value indicating whether the mail has been read by the recipient. (Type: Boolean

Notes: True if the mail has been read, otherwise false.) */
    read?: boolean;
    /** Gets or sets the status of the mail for this recipient. (Type: String

Notes: Status of the mail for this recipient.) */
    status?: string | undefined;
    /** Gets or sets the distribution type (TO, CC, BCC). (Type: String

Notes: Type of distribution for the mail.) */
    distributionType?: string | undefined;
}

export class GetSearchAconexMailResponseResultModel implements IGetSearchAconexMailResponseResultModel {
    /** Gets or sets the total number of mail items that match the search query. (Type: Integer

Notes: The number of mail items that match the search_query.) */
    totalResults!: number;
    /** Gets or sets the number of results on the current page. (Type: Integer

Notes: Only applicable to a paged search.) */
    totalResultsOnPage!: number;
    /** Gets or sets the total number of pages available for the specified page size. (Type: Integer

Notes: Only applicable to a paged search.) */
    totalPages!: number;
    /** Gets or sets the page size for the search. (Type: Integer

Notes: Will match specified page_size.) */
    pageSize!: number;
    /** Gets or sets the current page of results. (Type: Integer

Notes: Will match specified page_number.) */
    currentPage!: number;
    /** Gets or sets the list of mail search results. */
    searchResults!: GetSearchAconexMailResponseMailModel[];

    constructor(data?: IGetSearchAconexMailResponseResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.searchResults = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalResults = _data["totalResults"];
            this.totalResultsOnPage = _data["totalResultsOnPage"];
            this.totalPages = _data["totalPages"];
            this.pageSize = _data["pageSize"];
            this.currentPage = _data["currentPage"];
            if (Array.isArray(_data["searchResults"])) {
                this.searchResults = [] as any;
                for (let item of _data["searchResults"])
                    this.searchResults!.push(GetSearchAconexMailResponseMailModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSearchAconexMailResponseResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSearchAconexMailResponseResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalResults"] = this.totalResults;
        data["totalResultsOnPage"] = this.totalResultsOnPage;
        data["totalPages"] = this.totalPages;
        data["pageSize"] = this.pageSize;
        data["currentPage"] = this.currentPage;
        if (Array.isArray(this.searchResults)) {
            data["searchResults"] = [];
            for (let item of this.searchResults)
                data["searchResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSearchAconexMailResponseResultModel {
    /** Gets or sets the total number of mail items that match the search query. (Type: Integer

Notes: The number of mail items that match the search_query.) */
    totalResults: number;
    /** Gets or sets the number of results on the current page. (Type: Integer

Notes: Only applicable to a paged search.) */
    totalResultsOnPage: number;
    /** Gets or sets the total number of pages available for the specified page size. (Type: Integer

Notes: Only applicable to a paged search.) */
    totalPages: number;
    /** Gets or sets the page size for the search. (Type: Integer

Notes: Will match specified page_size.) */
    pageSize: number;
    /** Gets or sets the current page of results. (Type: Integer

Notes: Will match specified page_number.) */
    currentPage: number;
    /** Gets or sets the list of mail search results. */
    searchResults: GetSearchAconexMailResponseMailModel[];
}

export class GetSearchAconexMailResponseUserModel implements IGetSearchAconexMailResponseUserModel {
    /** Gets or sets the organization ID of the recipient. (Type: String

Notes: Unique identifier for the recipient's organization.) */
    organizationId?: string | undefined;
    /** Gets or sets the organization name of the recipient. (Type: String(60)

Notes: Name of the recipient's organization.) */
    organizationName?: string | undefined;
    /** Gets or sets the first name of the recipient. (Type: String

Notes: First name of the recipient.) */
    firstName?: string | undefined;
    /** Gets or sets the last name of the recipient. (Type: String

Notes: Last name of the recipient.) */
    lastName?: string | undefined;
    /** Gets or sets the user ID of the recipient. (Type: String

Notes: Unique identifier for the recipient.) */
    userId?: string | undefined;
    /** Not documented, but it's on the response */
    name?: string | undefined;

    constructor(data?: IGetSearchAconexMailResponseUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.userId = _data["userId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetSearchAconexMailResponseUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSearchAconexMailResponseUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["userId"] = this.userId;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetSearchAconexMailResponseUserModel {
    /** Gets or sets the organization ID of the recipient. (Type: String

Notes: Unique identifier for the recipient's organization.) */
    organizationId?: string | undefined;
    /** Gets or sets the organization name of the recipient. (Type: String(60)

Notes: Name of the recipient's organization.) */
    organizationName?: string | undefined;
    /** Gets or sets the first name of the recipient. (Type: String

Notes: First name of the recipient.) */
    firstName?: string | undefined;
    /** Gets or sets the last name of the recipient. (Type: String

Notes: Last name of the recipient.) */
    lastName?: string | undefined;
    /** Gets or sets the user ID of the recipient. (Type: String

Notes: Unique identifier for the recipient.) */
    userId?: string | undefined;
    /** Not documented, but it's on the response */
    name?: string | undefined;
}

export class GetUserProfileResponseModel implements IGetUserProfileResponseModel {
    /** The status of the Interaction(s) with Aconex API(s) ([Aconex Interaction Result Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/3082092545/Aconex+Interaction+Result+T+Object)

)

0 = Success (Interaction with the Aconex API was successful)

1 = NoTokenInformation (There was no Token Information available to perform the interaction with the Aconex API)

2 = RefreshTokenExpired (The Refresh Token available to for interaction with the Aconex API has expired)

3 = AccessTokenExpired (The Access Token available to for interaction with the Aconex API has expired (Note: This does not indicate that future interactions will fail, it only indicates that the Access Token will need to be refreshed before the next interaction.))

4 = InteractionFailed (The Aconex API Interaction failed (Usually this indicates that the Aconex API returned a 'non authentication' related error message)) */
    aconexInteractionStatus?: AconexInteractionStatus;
    /** Result - usually at least partially made up of the response from the interaction(s) with Aconex API(s). Will likely be null unless Status is Success */
    result?: GetUserProfileResponseUserModel | undefined;

    constructor(data?: IGetUserProfileResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aconexInteractionStatus = _data["aconexInteractionStatus"];
            this.result = _data["result"] ? GetUserProfileResponseUserModel.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUserProfileResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserProfileResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aconexInteractionStatus"] = this.aconexInteractionStatus;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetUserProfileResponseModel {
    /** The status of the Interaction(s) with Aconex API(s) ([Aconex Interaction Result Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/3082092545/Aconex+Interaction+Result+T+Object)

)

0 = Success (Interaction with the Aconex API was successful)

1 = NoTokenInformation (There was no Token Information available to perform the interaction with the Aconex API)

2 = RefreshTokenExpired (The Refresh Token available to for interaction with the Aconex API has expired)

3 = AccessTokenExpired (The Access Token available to for interaction with the Aconex API has expired (Note: This does not indicate that future interactions will fail, it only indicates that the Access Token will need to be refreshed before the next interaction.))

4 = InteractionFailed (The Aconex API Interaction failed (Usually this indicates that the Aconex API returned a 'non authentication' related error message)) */
    aconexInteractionStatus?: AconexInteractionStatus;
    /** Result - usually at least partially made up of the response from the interaction(s) with Aconex API(s). Will likely be null unless Status is Success */
    result?: GetUserProfileResponseUserModel | undefined;
}

export class GetUserProfileResponseUserModel implements IGetUserProfileResponseUserModel {
    /** Gets or sets the division of the user. (Type: String(100)) */
    division?: string | undefined;
    /** Gets or sets the fax number of the user. (Type: String(30)) */
    fax?: string | undefined;
    /** Gets or sets the mobile number of the user. (Type: String(20)) */
    mobile?: string | undefined;
    /** Gets or sets the organization ID of the user. (Type: String) */
    organizationId?: string | undefined;
    /** Gets or sets the organization name of the user. (Type: String(60)) */
    organizationName?: string | undefined;
    /** Gets or sets the postal address line of the organization. (Type: String(150)) */
    organizationPostalAddressLine?: string | undefined;
    /** Gets or sets the postal city of the organization. (Type: String(40)) */
    organizationPostalCity?: string | undefined;
    /** Gets or sets the postal country of the organization. (Type: String(40)) */
    organizationPostalCountry?: string | undefined;
    /** Gets or sets the postal postcode of the organization. (Type: String(10)) */
    organizationPostalPostCode?: string | undefined;
    /** Gets or sets the postal state of the organization. (Type: String(40)) */
    organizationPostalState?: string | undefined;
    /** Gets or sets the phone number of the user. (Type: String(30)) */
    phone?: string | undefined;
    /** Gets or sets the job title of the user. (Type: String(50)) */
    jobTitle?: string | undefined;
    /** Gets or sets the postal address line of the user. (Type: String(205)) */
    userPostalAddressLine?: string | undefined;
    /** Gets or sets the postal city of the user. (Type: String(50)) */
    userPostalCity?: string | undefined;
    /** Gets or sets the postal country of the user. (Type: String(50)) */
    userPostalCountry?: string | undefined;
    /** Gets or sets the postal postcode of the user. (Type: String(20)) */
    userPostalPostCode?: string | undefined;
    /** Gets or sets the postal state of the user. (Type: String(50)) */
    userPostalState?: string | undefined;
    /** Gets or sets the first name of the user. (Type: String(30)) */
    userFirstName?: string | undefined;
    /** Gets or sets the user ID. (Type: String) */
    userId?: string | undefined;
    /** Gets or sets the last name of the user. (Type: String(30)) */
    userLastName?: string | undefined;
    /** Gets or sets the title of the user. (Type: String(25)) */
    userTitle?: string | undefined;
    /** Gets or sets the username of the user. (Type: String(80)) */
    userName?: string | undefined;
    /** User Site. Value like 'https://au1.aconex.com' */
    userSite?: string | undefined;

    constructor(data?: IGetUserProfileResponseUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.division = _data["division"];
            this.fax = _data["fax"];
            this.mobile = _data["mobile"];
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.organizationPostalAddressLine = _data["organizationPostalAddressLine"];
            this.organizationPostalCity = _data["organizationPostalCity"];
            this.organizationPostalCountry = _data["organizationPostalCountry"];
            this.organizationPostalPostCode = _data["organizationPostalPostCode"];
            this.organizationPostalState = _data["organizationPostalState"];
            this.phone = _data["phone"];
            this.jobTitle = _data["jobTitle"];
            this.userPostalAddressLine = _data["userPostalAddressLine"];
            this.userPostalCity = _data["userPostalCity"];
            this.userPostalCountry = _data["userPostalCountry"];
            this.userPostalPostCode = _data["userPostalPostCode"];
            this.userPostalState = _data["userPostalState"];
            this.userFirstName = _data["userFirstName"];
            this.userId = _data["userId"];
            this.userLastName = _data["userLastName"];
            this.userTitle = _data["userTitle"];
            this.userName = _data["userName"];
            this.userSite = _data["userSite"];
        }
    }

    static fromJS(data: any): GetUserProfileResponseUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserProfileResponseUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["division"] = this.division;
        data["fax"] = this.fax;
        data["mobile"] = this.mobile;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["organizationPostalAddressLine"] = this.organizationPostalAddressLine;
        data["organizationPostalCity"] = this.organizationPostalCity;
        data["organizationPostalCountry"] = this.organizationPostalCountry;
        data["organizationPostalPostCode"] = this.organizationPostalPostCode;
        data["organizationPostalState"] = this.organizationPostalState;
        data["phone"] = this.phone;
        data["jobTitle"] = this.jobTitle;
        data["userPostalAddressLine"] = this.userPostalAddressLine;
        data["userPostalCity"] = this.userPostalCity;
        data["userPostalCountry"] = this.userPostalCountry;
        data["userPostalPostCode"] = this.userPostalPostCode;
        data["userPostalState"] = this.userPostalState;
        data["userFirstName"] = this.userFirstName;
        data["userId"] = this.userId;
        data["userLastName"] = this.userLastName;
        data["userTitle"] = this.userTitle;
        data["userName"] = this.userName;
        data["userSite"] = this.userSite;
        return data;
    }
}

export interface IGetUserProfileResponseUserModel {
    /** Gets or sets the division of the user. (Type: String(100)) */
    division?: string | undefined;
    /** Gets or sets the fax number of the user. (Type: String(30)) */
    fax?: string | undefined;
    /** Gets or sets the mobile number of the user. (Type: String(20)) */
    mobile?: string | undefined;
    /** Gets or sets the organization ID of the user. (Type: String) */
    organizationId?: string | undefined;
    /** Gets or sets the organization name of the user. (Type: String(60)) */
    organizationName?: string | undefined;
    /** Gets or sets the postal address line of the organization. (Type: String(150)) */
    organizationPostalAddressLine?: string | undefined;
    /** Gets or sets the postal city of the organization. (Type: String(40)) */
    organizationPostalCity?: string | undefined;
    /** Gets or sets the postal country of the organization. (Type: String(40)) */
    organizationPostalCountry?: string | undefined;
    /** Gets or sets the postal postcode of the organization. (Type: String(10)) */
    organizationPostalPostCode?: string | undefined;
    /** Gets or sets the postal state of the organization. (Type: String(40)) */
    organizationPostalState?: string | undefined;
    /** Gets or sets the phone number of the user. (Type: String(30)) */
    phone?: string | undefined;
    /** Gets or sets the job title of the user. (Type: String(50)) */
    jobTitle?: string | undefined;
    /** Gets or sets the postal address line of the user. (Type: String(205)) */
    userPostalAddressLine?: string | undefined;
    /** Gets or sets the postal city of the user. (Type: String(50)) */
    userPostalCity?: string | undefined;
    /** Gets or sets the postal country of the user. (Type: String(50)) */
    userPostalCountry?: string | undefined;
    /** Gets or sets the postal postcode of the user. (Type: String(20)) */
    userPostalPostCode?: string | undefined;
    /** Gets or sets the postal state of the user. (Type: String(50)) */
    userPostalState?: string | undefined;
    /** Gets or sets the first name of the user. (Type: String(30)) */
    userFirstName?: string | undefined;
    /** Gets or sets the user ID. (Type: String) */
    userId?: string | undefined;
    /** Gets or sets the last name of the user. (Type: String(30)) */
    userLastName?: string | undefined;
    /** Gets or sets the title of the user. (Type: String(25)) */
    userTitle?: string | undefined;
    /** Gets or sets the username of the user. (Type: String(80)) */
    userName?: string | undefined;
    /** User Site. Value like 'https://au1.aconex.com' */
    userSite?: string | undefined;
}

export class PostAuthorizationCodeRequestModel implements IPostAuthorizationCodeRequestModel {
    authorizationCode!: string;

    constructor(data?: IPostAuthorizationCodeRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authorizationCode = _data["authorizationCode"];
        }
    }

    static fromJS(data: any): PostAuthorizationCodeRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostAuthorizationCodeRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authorizationCode"] = this.authorizationCode;
        return data;
    }
}

export interface IPostAuthorizationCodeRequestModel {
    authorizationCode: string;
}

export class PostCreateDocumentFromAconexRequestModel implements IPostCreateDocumentFromAconexRequestModel {
    /** Aconex Document Id originally obtained from call to <seealso cref="M:OneTrack.Api.V1.AconexController.GetSearchAconexDocuments(OneTrack.Api.Commands.Aconex.IGetSearchAconexDocumentsCommand,OneTrack.Api.Commands.Aconex.GetSearchAconexDocumentsRequestModel)">API17061 - GET Search Aconex Documents</seealso> */
    documentId?: string | undefined;
    /** Aconex Mail Id originally obtained from call to <seealso cref="M:OneTrack.Api.V1.AconexController.GetSearchAconexMail(OneTrack.Api.Commands.Aconex.IGetSearchAconexMailCommand,OneTrack.Api.Commands.Aconex.GetSearchAconexMailRequestModel)">API17060 - GET Search Aconex Mail</seealso> */
    mailId?: string | undefined;
    /** Document Name */
    name!: string;
    /** Document Reference */
    reference!: string;
    /** Description of the content of the document */
    contentDescription?: string | undefined;
    /** Description of the document */
    description?: string | undefined;
    /** Document Date. The date the document was created. 

No time component */
    date?: Date | undefined;
    /** The date and time the document was received in Utc format. */
    receivedUtc?: Date | undefined;
    /** Time zone 'Received Date Time' was supplied to the UI with. 

Required if 'Received Date Time' is set */
    receivedTimeZone?: string | undefined;
    /** The date and time the document was received in Utc format. */
    deemedReceivedUtc?: Date | undefined;
    /** Time zone 'Deemed Received Date Time' was supplied to the UI with. 

Required if 'Deemed Received Date Time' is set */
    deemedReceivedTimeZone?: string | undefined;
    /** Name of the person that sent the document */
    senderPerson?: string | undefined;
    /** Name of the organisation that sent the document */
    senderOrganisation?: string | undefined;
    /** Name of the person that received the document */
    recipientPerson?: string | undefined;
    /** Name of the organisation that received the document */
    recipientOrganisation?: string | undefined;
    /** Identifiers for Organisations to be associated with the Document */
    organisationAssociations?: string[] | undefined;
    /** Identifiers for Projects to be associated with the Document */
    projectAssociations?: string[] | undefined;
    /** Identifiers for Contracts to be associated with the Document */
    contractAssociations?: string[] | undefined;

    constructor(data?: IPostCreateDocumentFromAconexRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.mailId = _data["mailId"];
            this.name = _data["name"];
            this.reference = _data["reference"];
            this.contentDescription = _data["contentDescription"];
            this.description = _data["description"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.receivedUtc = _data["receivedUtc"] ? new Date(_data["receivedUtc"].toString()) : <any>undefined;
            this.receivedTimeZone = _data["receivedTimeZone"];
            this.deemedReceivedUtc = _data["deemedReceivedUtc"] ? new Date(_data["deemedReceivedUtc"].toString()) : <any>undefined;
            this.deemedReceivedTimeZone = _data["deemedReceivedTimeZone"];
            this.senderPerson = _data["senderPerson"];
            this.senderOrganisation = _data["senderOrganisation"];
            this.recipientPerson = _data["recipientPerson"];
            this.recipientOrganisation = _data["recipientOrganisation"];
            if (Array.isArray(_data["organisationAssociations"])) {
                this.organisationAssociations = [] as any;
                for (let item of _data["organisationAssociations"])
                    this.organisationAssociations!.push(item);
            }
            if (Array.isArray(_data["projectAssociations"])) {
                this.projectAssociations = [] as any;
                for (let item of _data["projectAssociations"])
                    this.projectAssociations!.push(item);
            }
            if (Array.isArray(_data["contractAssociations"])) {
                this.contractAssociations = [] as any;
                for (let item of _data["contractAssociations"])
                    this.contractAssociations!.push(item);
            }
        }
    }

    static fromJS(data: any): PostCreateDocumentFromAconexRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostCreateDocumentFromAconexRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["mailId"] = this.mailId;
        data["name"] = this.name;
        data["reference"] = this.reference;
        data["contentDescription"] = this.contentDescription;
        data["description"] = this.description;
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["receivedUtc"] = this.receivedUtc ? this.receivedUtc.toISOString() : <any>undefined;
        data["receivedTimeZone"] = this.receivedTimeZone;
        data["deemedReceivedUtc"] = this.deemedReceivedUtc ? this.deemedReceivedUtc.toISOString() : <any>undefined;
        data["deemedReceivedTimeZone"] = this.deemedReceivedTimeZone;
        data["senderPerson"] = this.senderPerson;
        data["senderOrganisation"] = this.senderOrganisation;
        data["recipientPerson"] = this.recipientPerson;
        data["recipientOrganisation"] = this.recipientOrganisation;
        if (Array.isArray(this.organisationAssociations)) {
            data["organisationAssociations"] = [];
            for (let item of this.organisationAssociations)
                data["organisationAssociations"].push(item);
        }
        if (Array.isArray(this.projectAssociations)) {
            data["projectAssociations"] = [];
            for (let item of this.projectAssociations)
                data["projectAssociations"].push(item);
        }
        if (Array.isArray(this.contractAssociations)) {
            data["contractAssociations"] = [];
            for (let item of this.contractAssociations)
                data["contractAssociations"].push(item);
        }
        return data;
    }
}

export interface IPostCreateDocumentFromAconexRequestModel {
    /** Aconex Document Id originally obtained from call to <seealso cref="M:OneTrack.Api.V1.AconexController.GetSearchAconexDocuments(OneTrack.Api.Commands.Aconex.IGetSearchAconexDocumentsCommand,OneTrack.Api.Commands.Aconex.GetSearchAconexDocumentsRequestModel)">API17061 - GET Search Aconex Documents</seealso> */
    documentId?: string | undefined;
    /** Aconex Mail Id originally obtained from call to <seealso cref="M:OneTrack.Api.V1.AconexController.GetSearchAconexMail(OneTrack.Api.Commands.Aconex.IGetSearchAconexMailCommand,OneTrack.Api.Commands.Aconex.GetSearchAconexMailRequestModel)">API17060 - GET Search Aconex Mail</seealso> */
    mailId?: string | undefined;
    /** Document Name */
    name: string;
    /** Document Reference */
    reference: string;
    /** Description of the content of the document */
    contentDescription?: string | undefined;
    /** Description of the document */
    description?: string | undefined;
    /** Document Date. The date the document was created. 

No time component */
    date?: Date | undefined;
    /** The date and time the document was received in Utc format. */
    receivedUtc?: Date | undefined;
    /** Time zone 'Received Date Time' was supplied to the UI with. 

Required if 'Received Date Time' is set */
    receivedTimeZone?: string | undefined;
    /** The date and time the document was received in Utc format. */
    deemedReceivedUtc?: Date | undefined;
    /** Time zone 'Deemed Received Date Time' was supplied to the UI with. 

Required if 'Deemed Received Date Time' is set */
    deemedReceivedTimeZone?: string | undefined;
    /** Name of the person that sent the document */
    senderPerson?: string | undefined;
    /** Name of the organisation that sent the document */
    senderOrganisation?: string | undefined;
    /** Name of the person that received the document */
    recipientPerson?: string | undefined;
    /** Name of the organisation that received the document */
    recipientOrganisation?: string | undefined;
    /** Identifiers for Organisations to be associated with the Document */
    organisationAssociations?: string[] | undefined;
    /** Identifiers for Projects to be associated with the Document */
    projectAssociations?: string[] | undefined;
    /** Identifiers for Contracts to be associated with the Document */
    contractAssociations?: string[] | undefined;
}

export class PostCreateDocumentFromAconexResponseModel implements IPostCreateDocumentFromAconexResponseModel {
    /** The status of the Interaction(s) with Aconex API(s) ([Aconex Interaction Result Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/3082092545/Aconex+Interaction+Result+T+Object)

)

0 = Success (Interaction with the Aconex API was successful)

1 = NoTokenInformation (There was no Token Information available to perform the interaction with the Aconex API)

2 = RefreshTokenExpired (The Refresh Token available to for interaction with the Aconex API has expired)

3 = AccessTokenExpired (The Access Token available to for interaction with the Aconex API has expired (Note: This does not indicate that future interactions will fail, it only indicates that the Access Token will need to be refreshed before the next interaction.))

4 = InteractionFailed (The Aconex API Interaction failed (Usually this indicates that the Aconex API returned a 'non authentication' related error message)) */
    aconexInteractionStatus?: AconexInteractionStatus;
    /** Result - usually at least partially made up of the response from the interaction(s) with Aconex API(s). Will likely be null unless Status is Success */
    result?: PostCreateDocumentFromAconexResponseResultModel | undefined;

    constructor(data?: IPostCreateDocumentFromAconexResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aconexInteractionStatus = _data["aconexInteractionStatus"];
            this.result = _data["result"] ? PostCreateDocumentFromAconexResponseResultModel.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PostCreateDocumentFromAconexResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostCreateDocumentFromAconexResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aconexInteractionStatus"] = this.aconexInteractionStatus;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPostCreateDocumentFromAconexResponseModel {
    /** The status of the Interaction(s) with Aconex API(s) ([Aconex Interaction Result Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/3082092545/Aconex+Interaction+Result+T+Object)

)

0 = Success (Interaction with the Aconex API was successful)

1 = NoTokenInformation (There was no Token Information available to perform the interaction with the Aconex API)

2 = RefreshTokenExpired (The Refresh Token available to for interaction with the Aconex API has expired)

3 = AccessTokenExpired (The Access Token available to for interaction with the Aconex API has expired (Note: This does not indicate that future interactions will fail, it only indicates that the Access Token will need to be refreshed before the next interaction.))

4 = InteractionFailed (The Aconex API Interaction failed (Usually this indicates that the Aconex API returned a 'non authentication' related error message)) */
    aconexInteractionStatus?: AconexInteractionStatus;
    /** Result - usually at least partially made up of the response from the interaction(s) with Aconex API(s). Will likely be null unless Status is Success */
    result?: PostCreateDocumentFromAconexResponseResultModel | undefined;
}

export class PostCreateDocumentFromAconexResponseResultModel implements IPostCreateDocumentFromAconexResponseResultModel {
    /** Public Identifier for newly created Document */
    documentGid!: string;
    /** Public Identifier for newly created Document Version */
    documentVersionGid!: string;

    constructor(data?: IPostCreateDocumentFromAconexResponseResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentGid = _data["documentGid"];
            this.documentVersionGid = _data["documentVersionGid"];
        }
    }

    static fromJS(data: any): PostCreateDocumentFromAconexResponseResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostCreateDocumentFromAconexResponseResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentGid"] = this.documentGid;
        data["documentVersionGid"] = this.documentVersionGid;
        return data;
    }
}

export interface IPostCreateDocumentFromAconexResponseResultModel {
    /** Public Identifier for newly created Document */
    documentGid: string;
    /** Public Identifier for newly created Document Version */
    documentVersionGid: string;
}

export class GetCalendarDetailsHolidayDateModel implements IGetCalendarDetailsHolidayDateModel {
    gid?: string;
    date?: string;

    constructor(data?: IGetCalendarDetailsHolidayDateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.date = _data["date"];
        }
    }

    static fromJS(data: any): GetCalendarDetailsHolidayDateModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetCalendarDetailsHolidayDateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["date"] = this.date;
        return data;
    }
}

export interface IGetCalendarDetailsHolidayDateModel {
    gid?: string;
    date?: string;
}

export class GetCalendarDetailsHolidayModel implements IGetCalendarDetailsHolidayModel {
    gid?: string;
    name?: string | undefined;
    /** The dates this holiday is held on */
    dates?: GetCalendarDetailsHolidayDateModel[] | undefined;
    /** Guid of calendar this is inherited from */
    calendarGid?: string;

    constructor(data?: IGetCalendarDetailsHolidayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.name = _data["name"];
            if (Array.isArray(_data["dates"])) {
                this.dates = [] as any;
                for (let item of _data["dates"])
                    this.dates!.push(GetCalendarDetailsHolidayDateModel.fromJS(item));
            }
            this.calendarGid = _data["calendarGid"];
        }
    }

    static fromJS(data: any): GetCalendarDetailsHolidayModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetCalendarDetailsHolidayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["name"] = this.name;
        if (Array.isArray(this.dates)) {
            data["dates"] = [];
            for (let item of this.dates)
                data["dates"].push(item.toJSON());
        }
        data["calendarGid"] = this.calendarGid;
        return data;
    }
}

export interface IGetCalendarDetailsHolidayModel {
    gid?: string;
    name?: string | undefined;
    /** The dates this holiday is held on */
    dates?: GetCalendarDetailsHolidayDateModel[] | undefined;
    /** Guid of calendar this is inherited from */
    calendarGid?: string;
}

export class GetCalendarDetailsResponseModel implements IGetCalendarDetailsResponseModel {
    gid?: string;
    /** Defined if this calendar is inherited */
    parentGid?: string | undefined;
    /** Whether or not other calendars inherit from this one (used for validation) */
    hasChildren?: boolean;
    name?: string | undefined;
    /** Object with property for each day of the week. OneTrack.Api.Commands.Calendar.GetCalendarDetailsWorkingWeekHoursModel */
    workingWeekHours?: GetCalendarDetailsWorkingWeekHoursModel | undefined;
    /** Array of OneTrack.Api.Commands.Calendar.GetCalendarDetailsHolidayModel */
    holidays?: GetCalendarDetailsHolidayModel[] | undefined;
    /** [Calendar Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Well+Known+Enums#Calendar-Status)

            Status types calendars can use

1 = Active (Calendar is active)

2 = Inactive (Calendar is inactive) */
    status?: CalendarStatus;
    lastModified?: LastModifiedModel | undefined;

    constructor(data?: IGetCalendarDetailsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.parentGid = _data["parentGid"];
            this.hasChildren = _data["hasChildren"];
            this.name = _data["name"];
            this.workingWeekHours = _data["workingWeekHours"] ? GetCalendarDetailsWorkingWeekHoursModel.fromJS(_data["workingWeekHours"]) : <any>undefined;
            if (Array.isArray(_data["holidays"])) {
                this.holidays = [] as any;
                for (let item of _data["holidays"])
                    this.holidays!.push(GetCalendarDetailsHolidayModel.fromJS(item));
            }
            this.status = _data["status"];
            this.lastModified = _data["lastModified"] ? LastModifiedModel.fromJS(_data["lastModified"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCalendarDetailsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetCalendarDetailsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["parentGid"] = this.parentGid;
        data["hasChildren"] = this.hasChildren;
        data["name"] = this.name;
        data["workingWeekHours"] = this.workingWeekHours ? this.workingWeekHours.toJSON() : <any>undefined;
        if (Array.isArray(this.holidays)) {
            data["holidays"] = [];
            for (let item of this.holidays)
                data["holidays"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["lastModified"] = this.lastModified ? this.lastModified.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCalendarDetailsResponseModel {
    gid?: string;
    /** Defined if this calendar is inherited */
    parentGid?: string | undefined;
    /** Whether or not other calendars inherit from this one (used for validation) */
    hasChildren?: boolean;
    name?: string | undefined;
    /** Object with property for each day of the week. OneTrack.Api.Commands.Calendar.GetCalendarDetailsWorkingWeekHoursModel */
    workingWeekHours?: GetCalendarDetailsWorkingWeekHoursModel | undefined;
    /** Array of OneTrack.Api.Commands.Calendar.GetCalendarDetailsHolidayModel */
    holidays?: GetCalendarDetailsHolidayModel[] | undefined;
    /** [Calendar Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Well+Known+Enums#Calendar-Status)

            Status types calendars can use

1 = Active (Calendar is active)

2 = Inactive (Calendar is inactive) */
    status?: CalendarStatus;
    lastModified?: LastModifiedModel | undefined;
}

export class GetCalendarDetailsWorkingWeekHoursModel implements IGetCalendarDetailsWorkingWeekHoursModel {
    monday?: number;
    tuesday?: number;
    wednesday?: number;
    thursday?: number;
    friday?: number;
    saturday?: number;
    sunday?: number;

    constructor(data?: IGetCalendarDetailsWorkingWeekHoursModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monday = _data["monday"];
            this.tuesday = _data["tuesday"];
            this.wednesday = _data["wednesday"];
            this.thursday = _data["thursday"];
            this.friday = _data["friday"];
            this.saturday = _data["saturday"];
            this.sunday = _data["sunday"];
        }
    }

    static fromJS(data: any): GetCalendarDetailsWorkingWeekHoursModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetCalendarDetailsWorkingWeekHoursModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monday"] = this.monday;
        data["tuesday"] = this.tuesday;
        data["wednesday"] = this.wednesday;
        data["thursday"] = this.thursday;
        data["friday"] = this.friday;
        data["saturday"] = this.saturday;
        data["sunday"] = this.sunday;
        return data;
    }
}

export interface IGetCalendarDetailsWorkingWeekHoursModel {
    monday?: number;
    tuesday?: number;
    wednesday?: number;
    thursday?: number;
    friday?: number;
    saturday?: number;
    sunday?: number;
}

export class PostCalendarDateModel implements IPostCalendarDateModel {
    gid?: string;
    date?: string;

    constructor(data?: IPostCalendarDateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.date = _data["date"];
        }
    }

    static fromJS(data: any): PostCalendarDateModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostCalendarDateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["date"] = this.date;
        return data;
    }
}

export interface IPostCalendarDateModel {
    gid?: string;
    date?: string;
}

export class PostCalendarHolidayModel implements IPostCalendarHolidayModel {
    gid?: string;
    name?: string | undefined;
    /** The dates this holiday is held on */
    dates?: PostCalendarDateModel[] | undefined;

    constructor(data?: IPostCalendarHolidayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.name = _data["name"];
            if (Array.isArray(_data["dates"])) {
                this.dates = [] as any;
                for (let item of _data["dates"])
                    this.dates!.push(PostCalendarDateModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PostCalendarHolidayModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostCalendarHolidayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["name"] = this.name;
        if (Array.isArray(this.dates)) {
            data["dates"] = [];
            for (let item of this.dates)
                data["dates"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPostCalendarHolidayModel {
    gid?: string;
    name?: string | undefined;
    /** The dates this holiday is held on */
    dates?: PostCalendarDateModel[] | undefined;
}

/** Model to supply to [API00311 - POST Calendar Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2154889264/API00311+-+POST+Calendar+Status) */
export class PostCalendarStatusRequestModel implements IPostCalendarStatusRequestModel {
    /** The status to use when updating the Calender

1 = Active (Calendar is active)

2 = Inactive (Calendar is inactive) */
    calendarStatus?: CalendarStatus;

    constructor(data?: IPostCalendarStatusRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.calendarStatus = _data["calendarStatus"];
        }
    }

    static fromJS(data: any): PostCalendarStatusRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostCalendarStatusRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calendarStatus"] = this.calendarStatus;
        return data;
    }
}

/** Model to supply to [API00311 - POST Calendar Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2154889264/API00311+-+POST+Calendar+Status) */
export interface IPostCalendarStatusRequestModel {
    /** The status to use when updating the Calender

1 = Active (Calendar is active)

2 = Inactive (Calendar is inactive) */
    calendarStatus?: CalendarStatus;
}

/** Model to supply to [API00310 - POST Upsert Calendar](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2184577111/API00310+-+POST+Upsert+Calendar) */
export class PostCalendarUpsertRequestModel implements IPostCalendarUpsertRequestModel {
    /** Public identifier for organisation this calendar is for */
    organisationGid?: string;
    /** Defined if this calendar is inherited, Nulls database entry if editing an existing calendar */
    parentCalendarGid?: string | undefined;
    name?: string | undefined;
    /** Object with property for each day of the week */
    workingWeekHours?: PostCalendarUpsertWorkingWeekModel | undefined;
    holidays?: PostCalendarHolidayModel[] | undefined;
    /** [Calendar Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Well+Known+Enums#Calendar-Status)

            Status types calendars can use

1 = Active (Calendar is active)

2 = Inactive (Calendar is inactive) */
    status?: CalendarStatus;

    constructor(data?: IPostCalendarUpsertRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organisationGid = _data["organisationGid"];
            this.parentCalendarGid = _data["parentCalendarGid"];
            this.name = _data["name"];
            this.workingWeekHours = _data["workingWeekHours"] ? PostCalendarUpsertWorkingWeekModel.fromJS(_data["workingWeekHours"]) : <any>undefined;
            if (Array.isArray(_data["holidays"])) {
                this.holidays = [] as any;
                for (let item of _data["holidays"])
                    this.holidays!.push(PostCalendarHolidayModel.fromJS(item));
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): PostCalendarUpsertRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostCalendarUpsertRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organisationGid"] = this.organisationGid;
        data["parentCalendarGid"] = this.parentCalendarGid;
        data["name"] = this.name;
        data["workingWeekHours"] = this.workingWeekHours ? this.workingWeekHours.toJSON() : <any>undefined;
        if (Array.isArray(this.holidays)) {
            data["holidays"] = [];
            for (let item of this.holidays)
                data["holidays"].push(item.toJSON());
        }
        data["status"] = this.status;
        return data;
    }
}

/** Model to supply to [API00310 - POST Upsert Calendar](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2184577111/API00310+-+POST+Upsert+Calendar) */
export interface IPostCalendarUpsertRequestModel {
    /** Public identifier for organisation this calendar is for */
    organisationGid?: string;
    /** Defined if this calendar is inherited, Nulls database entry if editing an existing calendar */
    parentCalendarGid?: string | undefined;
    name?: string | undefined;
    /** Object with property for each day of the week */
    workingWeekHours?: PostCalendarUpsertWorkingWeekModel | undefined;
    holidays?: PostCalendarHolidayModel[] | undefined;
    /** [Calendar Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Well+Known+Enums#Calendar-Status)

            Status types calendars can use

1 = Active (Calendar is active)

2 = Inactive (Calendar is inactive) */
    status?: CalendarStatus;
}

export class PostCalendarUpsertWorkingWeekModel implements IPostCalendarUpsertWorkingWeekModel {
    /** Number of hours are worked on this day */
    monday?: number;
    /** Number of hours are worked on this day */
    tuesday?: number;
    /** Number of hours are worked on this day */
    wednesday?: number;
    /** Number of hours are worked on this day */
    thursday?: number;
    /** Number of hours are worked on this day */
    friday?: number;
    /** Number of hours are worked on this day */
    saturday?: number;
    /** Number of hours are worked on this day */
    sunday?: number;

    constructor(data?: IPostCalendarUpsertWorkingWeekModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monday = _data["monday"];
            this.tuesday = _data["tuesday"];
            this.wednesday = _data["wednesday"];
            this.thursday = _data["thursday"];
            this.friday = _data["friday"];
            this.saturday = _data["saturday"];
            this.sunday = _data["sunday"];
        }
    }

    static fromJS(data: any): PostCalendarUpsertWorkingWeekModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostCalendarUpsertWorkingWeekModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monday"] = this.monday;
        data["tuesday"] = this.tuesday;
        data["wednesday"] = this.wednesday;
        data["thursday"] = this.thursday;
        data["friday"] = this.friday;
        data["saturday"] = this.saturday;
        data["sunday"] = this.sunday;
        return data;
    }
}

export interface IPostCalendarUpsertWorkingWeekModel {
    /** Number of hours are worked on this day */
    monday?: number;
    /** Number of hours are worked on this day */
    tuesday?: number;
    /** Number of hours are worked on this day */
    wednesday?: number;
    /** Number of hours are worked on this day */
    thursday?: number;
    /** Number of hours are worked on this day */
    friday?: number;
    /** Number of hours are worked on this day */
    saturday?: number;
    /** Number of hours are worked on this day */
    sunday?: number;
}

export class GetContractTypesResponseModel implements IGetContractTypesResponseModel {
    contractTypes?: ContractTypeModel[] | undefined;

    constructor(data?: IGetContractTypesResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["contractTypes"])) {
                this.contractTypes = [] as any;
                for (let item of _data["contractTypes"])
                    this.contractTypes!.push(ContractTypeModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetContractTypesResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetContractTypesResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contractTypes)) {
            data["contractTypes"] = [];
            for (let item of this.contractTypes)
                data["contractTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetContractTypesResponseModel {
    contractTypes?: ContractTypeModel[] | undefined;
}

export class PostSaveContractAsContractTemplateRequestModel implements IPostSaveContractAsContractTemplateRequestModel {
    sourceContractGid!: string;
    name!: string;
    description?: string | undefined;

    constructor(data?: IPostSaveContractAsContractTemplateRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceContractGid = _data["sourceContractGid"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PostSaveContractAsContractTemplateRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostSaveContractAsContractTemplateRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceContractGid"] = this.sourceContractGid;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface IPostSaveContractAsContractTemplateRequestModel {
    sourceContractGid: string;
    name: string;
    description?: string | undefined;
}

/** Info about the Contract Type that was just created */
export class PostSaveContractAsContractTemplateResponseModel implements IPostSaveContractAsContractTemplateResponseModel {
    gid!: string;
    name!: string;
    description?: string | undefined;

    constructor(data?: IPostSaveContractAsContractTemplateResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PostSaveContractAsContractTemplateResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostSaveContractAsContractTemplateResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

/** Info about the Contract Type that was just created */
export interface IPostSaveContractAsContractTemplateResponseModel {
    gid: string;
    name: string;
    description?: string | undefined;
}

export class PostSetContractUserStatusUserStatusModel implements IPostSetContractUserStatusUserStatusModel {
    gid!: string;
    /** [Organisation User Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Well+Known+Enums#Organisation-User-Status)

            Status types users can use

1 = Active (Organisation/Project/Contract User is active)

2 = Invited (Organisation/Project/Contract User is Invited)

3 = RejectedInvitation (Organisation/Project/Contract User has Rejected Invitation)

4 = Inactive (Organisation/Project/Contract User is Inactive) */
    status!: OrganisationUserStatus;

    constructor(data?: IPostSetContractUserStatusUserStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): PostSetContractUserStatusUserStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostSetContractUserStatusUserStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["status"] = this.status;
        return data;
    }
}

export interface IPostSetContractUserStatusUserStatusModel {
    gid: string;
    /** [Organisation User Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Well+Known+Enums#Organisation-User-Status)

            Status types users can use

1 = Active (Organisation/Project/Contract User is active)

2 = Invited (Organisation/Project/Contract User is Invited)

3 = RejectedInvitation (Organisation/Project/Contract User has Rejected Invitation)

4 = Inactive (Organisation/Project/Contract User is Inactive) */
    status: OrganisationUserStatus;
}

export class PostUpdateContractUserDetailsModel implements IPostUpdateContractUserDetailsModel {
    functionalRoleTitle!: string;

    constructor(data?: IPostUpdateContractUserDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.functionalRoleTitle = _data["functionalRoleTitle"];
        }
    }

    static fromJS(data: any): PostUpdateContractUserDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostUpdateContractUserDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["functionalRoleTitle"] = this.functionalRoleTitle;
        return data;
    }
}

export interface IPostUpdateContractUserDetailsModel {
    functionalRoleTitle: string;
}

export class PostContractWorkflowAmendmentsResponseRequestModel implements IPostContractWorkflowAmendmentsResponseRequestModel {
    /** Unique Identifier for the Run that this Evaluation belongs to */
    runGid!: string;
    versionId!: number;
    /** For initial request, property will be an empty array */
    responses!: DataDrivenResponseModel[];
    /** Details of the User that created the Instance that this Evaluation is based on. 
 ([Data Driven Modified Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2684387381/Data+Driven+Modified+Object)) */
    created?: DataDrivenModifiedModel | undefined;
    /** Details of the User that completed this Instance. 
 ([Data Driven Modified Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2684387381/Data+Driven+Modified+Object)) */
    finished?: DataDrivenModifiedModel | undefined;
    /** The Key for the Phase associated with the Instance this Evaluation is based on */
    phaseKey?: string | undefined;

    constructor(data?: IPostContractWorkflowAmendmentsResponseRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.responses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.runGid = _data["runGid"];
            this.versionId = _data["versionId"];
            if (Array.isArray(_data["responses"])) {
                this.responses = [] as any;
                for (let item of _data["responses"])
                    this.responses!.push(DataDrivenResponseModel.fromJS(item));
            }
            this.created = _data["created"] ? DataDrivenModifiedModel.fromJS(_data["created"]) : <any>undefined;
            this.finished = _data["finished"] ? DataDrivenModifiedModel.fromJS(_data["finished"]) : <any>undefined;
            this.phaseKey = _data["phaseKey"];
        }
    }

    static fromJS(data: any): PostContractWorkflowAmendmentsResponseRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostContractWorkflowAmendmentsResponseRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["runGid"] = this.runGid;
        data["versionId"] = this.versionId;
        if (Array.isArray(this.responses)) {
            data["responses"] = [];
            for (let item of this.responses)
                data["responses"].push(item.toJSON());
        }
        data["created"] = this.created ? this.created.toJSON() : <any>undefined;
        data["finished"] = this.finished ? this.finished.toJSON() : <any>undefined;
        data["phaseKey"] = this.phaseKey;
        return data;
    }
}

export interface IPostContractWorkflowAmendmentsResponseRequestModel {
    /** Unique Identifier for the Run that this Evaluation belongs to */
    runGid: string;
    versionId: number;
    /** For initial request, property will be an empty array */
    responses: DataDrivenResponseModel[];
    /** Details of the User that created the Instance that this Evaluation is based on. 
 ([Data Driven Modified Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2684387381/Data+Driven+Modified+Object)) */
    created?: DataDrivenModifiedModel | undefined;
    /** Details of the User that completed this Instance. 
 ([Data Driven Modified Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2684387381/Data+Driven+Modified+Object)) */
    finished?: DataDrivenModifiedModel | undefined;
    /** The Key for the Phase associated with the Instance this Evaluation is based on */
    phaseKey?: string | undefined;
}

export class ContractUserStatusesModel implements IContractUserStatusesModel {
    gid!: string;
    firstName!: string;
    lastName!: string;
    email!: string;
    organisations!: UserStatusWithActionsModel[];
    projects!: UserStatusWithActionsModel[];
    contracts!: UserStatusWithActionsModel[];

    constructor(data?: IContractUserStatusesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.organisations = [];
            this.projects = [];
            this.contracts = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            if (Array.isArray(_data["organisations"])) {
                this.organisations = [] as any;
                for (let item of _data["organisations"])
                    this.organisations!.push(UserStatusWithActionsModel.fromJS(item));
            }
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(UserStatusWithActionsModel.fromJS(item));
            }
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(UserStatusWithActionsModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContractUserStatusesModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContractUserStatusesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        if (Array.isArray(this.organisations)) {
            data["organisations"] = [];
            for (let item of this.organisations)
                data["organisations"].push(item.toJSON());
        }
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IContractUserStatusesModel {
    gid: string;
    firstName: string;
    lastName: string;
    email: string;
    organisations: UserStatusWithActionsModel[];
    projects: UserStatusWithActionsModel[];
    contracts: UserStatusWithActionsModel[];
}

export class GetContractDetailsResponseModel implements IGetContractDetailsResponseModel {
    /** Details for a specific Contract ([Contract Details Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2280325580/Contract+Details+Object)) */
    contract?: ContractDetailsModel | undefined;

    constructor(data?: IGetContractDetailsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contract = _data["contract"] ? ContractDetailsModel.fromJS(_data["contract"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetContractDetailsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetContractDetailsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetContractDetailsResponseModel {
    /** Details for a specific Contract ([Contract Details Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2280325580/Contract+Details+Object)) */
    contract?: ContractDetailsModel | undefined;
}

export class GetContractSegmentsResponseModel implements IGetContractSegmentsResponseModel {
    segments?: BasicSegmentModel[] | undefined;

    constructor(data?: IGetContractSegmentsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["segments"])) {
                this.segments = [] as any;
                for (let item of _data["segments"])
                    this.segments!.push(BasicSegmentModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetContractSegmentsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetContractSegmentsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.segments)) {
            data["segments"] = [];
            for (let item of this.segments)
                data["segments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetContractSegmentsResponseModel {
    segments?: BasicSegmentModel[] | undefined;
}

export class GetContractUserDetailsResponseModel implements IGetContractUserDetailsResponseModel {
    /** Public identifier for user */
    gid!: string;
    /** First Name of the User */
    firstName!: string;
    /** Last Name of the User */
    lastName!: string;
    /** Business Name of the User */
    businessName?: string | undefined;
    /** Email of the User */
    email!: string;
    /** Address Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2577727514/Address+Object" /> */
    streetAddress?: AddressModel | undefined;
    /** Address Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2577727514/Address+Object" /> */
    postalAddress?: AddressModel | undefined;
    mobile?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    /** ContractUser Status and Available Actions. 

This property will be null if the provided User is not a ContractUser for the provided Contract. 

This can happen if the user is visible to the current user but not an ContractUser for the Contract. */
    contractUserStatus?: UserStatusWithActionsModel | undefined;
    /** Object with last modification information in it */
    lastModified!: LastModifiedModel;
    /** Can be legitimately null when a new user is invited and has never logged in before */
    lastLoginUtc?: Date | undefined;
    /** Can be legitimately null when a new user is invited and has never logged in before */
    lastLoginIpAddress?: string | undefined;
    /** Public identifier for the Project */
    projectGid!: string;
    /** Name of the Project */
    projectName!: string;
    /** Public identifier for the Contract */
    contractGid!: string;
    /** Name of the Contract */
    contractName!: string;

    constructor(data?: IGetContractUserDetailsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.lastModified = new LastModifiedModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.businessName = _data["businessName"];
            this.email = _data["email"];
            this.streetAddress = _data["streetAddress"] ? AddressModel.fromJS(_data["streetAddress"]) : <any>undefined;
            this.postalAddress = _data["postalAddress"] ? AddressModel.fromJS(_data["postalAddress"]) : <any>undefined;
            this.mobile = _data["mobile"];
            this.phone = _data["phone"];
            this.fax = _data["fax"];
            this.contractUserStatus = _data["contractUserStatus"] ? UserStatusWithActionsModel.fromJS(_data["contractUserStatus"]) : <any>undefined;
            this.lastModified = _data["lastModified"] ? LastModifiedModel.fromJS(_data["lastModified"]) : new LastModifiedModel();
            this.lastLoginUtc = _data["lastLoginUtc"] ? new Date(_data["lastLoginUtc"].toString()) : <any>undefined;
            this.lastLoginIpAddress = _data["lastLoginIpAddress"];
            this.projectGid = _data["projectGid"];
            this.projectName = _data["projectName"];
            this.contractGid = _data["contractGid"];
            this.contractName = _data["contractName"];
        }
    }

    static fromJS(data: any): GetContractUserDetailsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetContractUserDetailsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["businessName"] = this.businessName;
        data["email"] = this.email;
        data["streetAddress"] = this.streetAddress ? this.streetAddress.toJSON() : <any>undefined;
        data["postalAddress"] = this.postalAddress ? this.postalAddress.toJSON() : <any>undefined;
        data["mobile"] = this.mobile;
        data["phone"] = this.phone;
        data["fax"] = this.fax;
        data["contractUserStatus"] = this.contractUserStatus ? this.contractUserStatus.toJSON() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toJSON() : <any>undefined;
        data["lastLoginUtc"] = this.lastLoginUtc ? this.lastLoginUtc.toISOString() : <any>undefined;
        data["lastLoginIpAddress"] = this.lastLoginIpAddress;
        data["projectGid"] = this.projectGid;
        data["projectName"] = this.projectName;
        data["contractGid"] = this.contractGid;
        data["contractName"] = this.contractName;
        return data;
    }
}

export interface IGetContractUserDetailsResponseModel {
    /** Public identifier for user */
    gid: string;
    /** First Name of the User */
    firstName: string;
    /** Last Name of the User */
    lastName: string;
    /** Business Name of the User */
    businessName?: string | undefined;
    /** Email of the User */
    email: string;
    /** Address Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2577727514/Address+Object" /> */
    streetAddress?: AddressModel | undefined;
    /** Address Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2577727514/Address+Object" /> */
    postalAddress?: AddressModel | undefined;
    mobile?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    /** ContractUser Status and Available Actions. 

This property will be null if the provided User is not a ContractUser for the provided Contract. 

This can happen if the user is visible to the current user but not an ContractUser for the Contract. */
    contractUserStatus?: UserStatusWithActionsModel | undefined;
    /** Object with last modification information in it */
    lastModified: LastModifiedModel;
    /** Can be legitimately null when a new user is invited and has never logged in before */
    lastLoginUtc?: Date | undefined;
    /** Can be legitimately null when a new user is invited and has never logged in before */
    lastLoginIpAddress?: string | undefined;
    /** Public identifier for the Project */
    projectGid: string;
    /** Name of the Project */
    projectName: string;
    /** Public identifier for the Contract */
    contractGid: string;
    /** Name of the Contract */
    contractName: string;
}

export class GetContractUsersResponseModel implements IGetContractUsersResponseModel {
    users!: ContractUserStatusesModel[];

    constructor(data?: IGetContractUsersResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.users = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(ContractUserStatusesModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetContractUsersResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetContractUsersResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetContractUsersResponseModel {
    users: ContractUserStatusesModel[];
}

export class GetContractsResponseModel implements IGetContractsResponseModel {
    contracts?: ListContractModel[] | undefined;

    constructor(data?: IGetContractsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(ListContractModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetContractsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetContractsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetContractsResponseModel {
    contracts?: ListContractModel[] | undefined;
}

export class PostCopyContractRequestModel implements IPostCopyContractRequestModel {
    /** User defined name for this contract */
    name?: string | undefined;
    /** User defined reference for this contract */
    reference?: string | undefined;

    constructor(data?: IPostCopyContractRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.reference = _data["reference"];
        }
    }

    static fromJS(data: any): PostCopyContractRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostCopyContractRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["reference"] = this.reference;
        return data;
    }
}

export interface IPostCopyContractRequestModel {
    /** User defined name for this contract */
    name?: string | undefined;
    /** User defined reference for this contract */
    reference?: string | undefined;
}

export class PostCopyContractResponseModel implements IPostCopyContractResponseModel {
    gid?: string;

    constructor(data?: IPostCopyContractResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
        }
    }

    static fromJS(data: any): PostCopyContractResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostCopyContractResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        return data;
    }
}

export interface IPostCopyContractResponseModel {
    gid?: string;
}

export class PostResetContractDateForPracticalCompletionRequestModel implements IPostResetContractDateForPracticalCompletionRequestModel {
    mostRecentlyAgreedDateForPracticalCompletion!: string;
    /** The Row Version for the Contract Entity (It's a byte array, but OpenApi will treat it as a base64 encoded string. 

So if you're using the Swagger UI you want a string that looks something like 'AAAAAAAACj8=') */
    rowVersion!: string;

    constructor(data?: IPostResetContractDateForPracticalCompletionRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mostRecentlyAgreedDateForPracticalCompletion = _data["mostRecentlyAgreedDateForPracticalCompletion"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): PostResetContractDateForPracticalCompletionRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostResetContractDateForPracticalCompletionRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mostRecentlyAgreedDateForPracticalCompletion"] = this.mostRecentlyAgreedDateForPracticalCompletion;
        data["rowVersion"] = this.rowVersion;
        return data;
    }
}

export interface IPostResetContractDateForPracticalCompletionRequestModel {
    mostRecentlyAgreedDateForPracticalCompletion: string;
    /** The Row Version for the Contract Entity (It's a byte array, but OpenApi will treat it as a base64 encoded string. 

So if you're using the Swagger UI you want a string that looks something like 'AAAAAAAACj8=') */
    rowVersion: string;
}

export class PostUpdateContractDetailsRequestModel implements IPostUpdateContractDetailsRequestModel {
    /** User defined name for this contract (Always editable 
) */
    name!: string;
    /** User defined reference for this contract (Only editable if the Contract.ContractStatus is <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Draft" /> or <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Pending" />
) */
    reference!: string;
    /** Type for this contract (Only editable if the Contract.ContractStatus is <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Draft" /> or <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Pending" />
) */
    typeGid?: string | undefined;
    /** Name of Contractor that contract is contracted to. 
 (Referred to as 'Contractor' in the Contract UI
Always editable 
) */
    contractorName?: string | undefined;
    /** Contract description. 
 (Always editable 
) */
    description?: string | undefined;
    /** Not divided into first and last name as the form input is a single text field. 
 (Always editable 
) */
    contactName?: string | undefined;
    /** Email address for the Contract's Contact person (Always editable 
) */
    contactEmail?: string | undefined;
    /** Phone number for the Contract's Contact person (Always editable 
) */
    contactPhone?: string | undefined;
    /** Timezone for contract that matches a tz database entry (Only editable if the Contract.ContractStatus is <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Draft" /> or <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Pending" />
) */
    timezone!: string;
    /** If undefined/empty property on table is to be set to null (Referred to as 'Initial Budget' in the Contract UI 

Always editable 
) */
    budget?: number | undefined;
    /** No time component (yyyy-mm-dd only) 
 (Referred to as 'Date of Contract' in the Contract UI 

Only editable if the Contract.ContractStatus is <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Draft" /> or <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Pending" />
) */
    contractStartDate?: string | undefined;
    /** No time component (yyyy-mm-dd only) (Referred to as 'Initial Date for Practical Completion' in the Contract UI 

Only editable if the Contract.ContractStatus is <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Draft" /> or <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Pending" />
) */
    projectedEndDate!: string;
    /** Leave as Null if no date provided 

No time component (yyyy-mm-dd only) (Referred to as 'Date Tenders Closed' in the Contract UI 

Only editable if the Contract.ContractStatus is <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Draft" /> or <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Pending" />
) */
    tendersClosedDate?: string | undefined;
    /** Public identifier for calendar, specifically for OneTrack.EFDatabase.App.Models.Organisations.Calendar. 
 (Only editable if the Contract.ContractStatus is <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Draft" /> or <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Pending" />
) */
    workingCalendarGid?: string | undefined;
    /** Public identifier for calendar, specifically for OneTrack.EFDatabase.App.Models.Organisations.Calendar. 
 (Only editable if the Contract.ContractStatus is <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Draft" /> or <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Pending" />
) */
    businessCalendarGid?: string | undefined;
    /** Sql Server generated Timestamp that is altered every time the Contract row is modified */
    rowVersion!: string;

    constructor(data?: IPostUpdateContractDetailsRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.reference = _data["reference"];
            this.typeGid = _data["typeGid"];
            this.contractorName = _data["contractorName"];
            this.description = _data["description"];
            this.contactName = _data["contactName"];
            this.contactEmail = _data["contactEmail"];
            this.contactPhone = _data["contactPhone"];
            this.timezone = _data["timezone"];
            this.budget = _data["budget"];
            this.contractStartDate = _data["contractStartDate"];
            this.projectedEndDate = _data["projectedEndDate"];
            this.tendersClosedDate = _data["tendersClosedDate"];
            this.workingCalendarGid = _data["workingCalendarGid"];
            this.businessCalendarGid = _data["businessCalendarGid"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): PostUpdateContractDetailsRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostUpdateContractDetailsRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["reference"] = this.reference;
        data["typeGid"] = this.typeGid;
        data["contractorName"] = this.contractorName;
        data["description"] = this.description;
        data["contactName"] = this.contactName;
        data["contactEmail"] = this.contactEmail;
        data["contactPhone"] = this.contactPhone;
        data["timezone"] = this.timezone;
        data["budget"] = this.budget;
        data["contractStartDate"] = this.contractStartDate;
        data["projectedEndDate"] = this.projectedEndDate;
        data["tendersClosedDate"] = this.tendersClosedDate;
        data["workingCalendarGid"] = this.workingCalendarGid;
        data["businessCalendarGid"] = this.businessCalendarGid;
        data["rowVersion"] = this.rowVersion;
        return data;
    }
}

export interface IPostUpdateContractDetailsRequestModel {
    /** User defined name for this contract (Always editable 
) */
    name: string;
    /** User defined reference for this contract (Only editable if the Contract.ContractStatus is <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Draft" /> or <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Pending" />
) */
    reference: string;
    /** Type for this contract (Only editable if the Contract.ContractStatus is <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Draft" /> or <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Pending" />
) */
    typeGid?: string | undefined;
    /** Name of Contractor that contract is contracted to. 
 (Referred to as 'Contractor' in the Contract UI
Always editable 
) */
    contractorName?: string | undefined;
    /** Contract description. 
 (Always editable 
) */
    description?: string | undefined;
    /** Not divided into first and last name as the form input is a single text field. 
 (Always editable 
) */
    contactName?: string | undefined;
    /** Email address for the Contract's Contact person (Always editable 
) */
    contactEmail?: string | undefined;
    /** Phone number for the Contract's Contact person (Always editable 
) */
    contactPhone?: string | undefined;
    /** Timezone for contract that matches a tz database entry (Only editable if the Contract.ContractStatus is <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Draft" /> or <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Pending" />
) */
    timezone: string;
    /** If undefined/empty property on table is to be set to null (Referred to as 'Initial Budget' in the Contract UI 

Always editable 
) */
    budget?: number | undefined;
    /** No time component (yyyy-mm-dd only) 
 (Referred to as 'Date of Contract' in the Contract UI 

Only editable if the Contract.ContractStatus is <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Draft" /> or <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Pending" />
) */
    contractStartDate?: string | undefined;
    /** No time component (yyyy-mm-dd only) (Referred to as 'Initial Date for Practical Completion' in the Contract UI 

Only editable if the Contract.ContractStatus is <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Draft" /> or <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Pending" />
) */
    projectedEndDate: string;
    /** Leave as Null if no date provided 

No time component (yyyy-mm-dd only) (Referred to as 'Date Tenders Closed' in the Contract UI 

Only editable if the Contract.ContractStatus is <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Draft" /> or <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Pending" />
) */
    tendersClosedDate?: string | undefined;
    /** Public identifier for calendar, specifically for OneTrack.EFDatabase.App.Models.Organisations.Calendar. 
 (Only editable if the Contract.ContractStatus is <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Draft" /> or <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Pending" />
) */
    workingCalendarGid?: string | undefined;
    /** Public identifier for calendar, specifically for OneTrack.EFDatabase.App.Models.Organisations.Calendar. 
 (Only editable if the Contract.ContractStatus is <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Draft" /> or <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Pending" />
) */
    businessCalendarGid?: string | undefined;
    /** Sql Server generated Timestamp that is altered every time the Contract row is modified */
    rowVersion: string;
}

export class PostUpdateContractStatusRequestModel implements IPostUpdateContractStatusRequestModel {
    /** [Contract Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Contract-Status)

            Status types contracts can use

1 = Active (Contract is active, at this point settings can’t be edited)

2 = Pending (Partway through setup or in pending mode where configuration can be edited)

3 = Terminated (Post MVP)

4 = PracticalCompletion (Post MVP)

5 = FinalCompletion (Post MVP)

6 = Suspended (Post MVP)

7 = Draft (Contract is still in wizard phase)

8 = Cancelled (Post MVP) */
    contractStatus!: ContractStatus;
    /** Sql Server generated Timestamp that is altered every time the Contract row is modified */
    rowVersion!: string;

    constructor(data?: IPostUpdateContractStatusRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractStatus = _data["contractStatus"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): PostUpdateContractStatusRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostUpdateContractStatusRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractStatus"] = this.contractStatus;
        data["rowVersion"] = this.rowVersion;
        return data;
    }
}

export interface IPostUpdateContractStatusRequestModel {
    /** [Contract Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Contract-Status)

            Status types contracts can use

1 = Active (Contract is active, at this point settings can’t be edited)

2 = Pending (Partway through setup or in pending mode where configuration can be edited)

3 = Terminated (Post MVP)

4 = PracticalCompletion (Post MVP)

5 = FinalCompletion (Post MVP)

6 = Suspended (Post MVP)

7 = Draft (Contract is still in wizard phase)

8 = Cancelled (Post MVP) */
    contractStatus: ContractStatus;
    /** Sql Server generated Timestamp that is altered every time the Contract row is modified */
    rowVersion: string;
}

export class PostUpsertContractWorkflowsRequestModel implements IPostUpsertContractWorkflowsRequestModel {
    /** The Row Version for the Contract Entity (It's a byte array, but OpenApi will treat it as a base64 encoded string. 

So if you're using the Swagger UI you want a string that looks something like 'AAAAAAAACj8=') */
    rowVersion!: string;
    contractWorkflows!: ContractWorkflowFormModel[];

    constructor(data?: IPostUpsertContractWorkflowsRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.contractWorkflows = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowVersion = _data["rowVersion"];
            if (Array.isArray(_data["contractWorkflows"])) {
                this.contractWorkflows = [] as any;
                for (let item of _data["contractWorkflows"])
                    this.contractWorkflows!.push(ContractWorkflowFormModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PostUpsertContractWorkflowsRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostUpsertContractWorkflowsRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowVersion"] = this.rowVersion;
        if (Array.isArray(this.contractWorkflows)) {
            data["contractWorkflows"] = [];
            for (let item of this.contractWorkflows)
                data["contractWorkflows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPostUpsertContractWorkflowsRequestModel {
    /** The Row Version for the Contract Entity (It's a byte array, but OpenApi will treat it as a base64 encoded string. 

So if you're using the Swagger UI you want a string that looks something like 'AAAAAAAACj8=') */
    rowVersion: string;
    contractWorkflows: ContractWorkflowFormModel[];
}

export class GetDocumentResponseContractDocumentAssociationModel implements IGetDocumentResponseContractDocumentAssociationModel {
    /** The Public Identifier (Gid) of the association with the Document */
    gid!: string;
    /** The Public Identifier (Gid) of the item (Organisation, Project, Contract, Segment Instance) associated with the Document */
    associatedGid!: string;
    /** The Code (or Reference in the case of Contract and Segment Instance) of the associated item (Organisation, Project, Contract, Segment Instance) associated with the Document */
    associatedCode!: string;
    /** The Name of the associated item (Organisation, Project, Contract, but not Segment Instance because it doesn't have a Name) associated with the Document */
    associatedName?: string | undefined;
    /** Distinct set of Actions the User can perform against the Document Association */
    availableActions!: UserActions[];
    /** The DateTime the the Association was created. */
    createdDateUtc!: Date;
    /** The Contract Status of the Contract associated with the Document

1 = Active (Contract is active, at this point settings can’t be edited)

2 = Pending (Partway through setup or in pending mode where configuration can be edited)

3 = Terminated (Post MVP)

4 = PracticalCompletion (Post MVP)

5 = FinalCompletion (Post MVP)

6 = Suspended (Post MVP)

7 = Draft (Contract is still in wizard phase)

8 = Cancelled (Post MVP) */
    status!: ContractStatus;

    constructor(data?: IGetDocumentResponseContractDocumentAssociationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.availableActions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.associatedGid = _data["associatedGid"];
            this.associatedCode = _data["associatedCode"];
            this.associatedName = _data["associatedName"];
            if (Array.isArray(_data["availableActions"])) {
                this.availableActions = [] as any;
                for (let item of _data["availableActions"])
                    this.availableActions!.push(item);
            }
            this.createdDateUtc = _data["createdDateUtc"] ? new Date(_data["createdDateUtc"].toString()) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): GetDocumentResponseContractDocumentAssociationModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentResponseContractDocumentAssociationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["associatedGid"] = this.associatedGid;
        data["associatedCode"] = this.associatedCode;
        data["associatedName"] = this.associatedName;
        if (Array.isArray(this.availableActions)) {
            data["availableActions"] = [];
            for (let item of this.availableActions)
                data["availableActions"].push(item);
        }
        data["createdDateUtc"] = this.createdDateUtc ? this.createdDateUtc.toISOString() : <any>undefined;
        data["status"] = this.status;
        return data;
    }
}

export interface IGetDocumentResponseContractDocumentAssociationModel {
    /** The Public Identifier (Gid) of the association with the Document */
    gid: string;
    /** The Public Identifier (Gid) of the item (Organisation, Project, Contract, Segment Instance) associated with the Document */
    associatedGid: string;
    /** The Code (or Reference in the case of Contract and Segment Instance) of the associated item (Organisation, Project, Contract, Segment Instance) associated with the Document */
    associatedCode: string;
    /** The Name of the associated item (Organisation, Project, Contract, but not Segment Instance because it doesn't have a Name) associated with the Document */
    associatedName?: string | undefined;
    /** Distinct set of Actions the User can perform against the Document Association */
    availableActions: UserActions[];
    /** The DateTime the the Association was created. */
    createdDateUtc: Date;
    /** The Contract Status of the Contract associated with the Document

1 = Active (Contract is active, at this point settings can’t be edited)

2 = Pending (Partway through setup or in pending mode where configuration can be edited)

3 = Terminated (Post MVP)

4 = PracticalCompletion (Post MVP)

5 = FinalCompletion (Post MVP)

6 = Suspended (Post MVP)

7 = Draft (Contract is still in wizard phase)

8 = Cancelled (Post MVP) */
    status: ContractStatus;
}

export class GetDocumentResponseDocumentVersionModel implements IGetDocumentResponseDocumentVersionModel {
    /** Public identifier of the Document Version */
    gid!: string;
    /** The Index of the Version. A number that can be used to create the text "Version 4" */
    index!: number;
    /** Document Name */
    name!: string;
    /** Document Reference */
    reference!: string;
    /** Description of the content of the document */
    contentDescription?: string | undefined;
    /** Description of the document */
    description?: string | undefined;
    /** The date of the Document Version */
    date?: Date | undefined;
    /** Now called Receipt Type in the UI

1 = AusPost (Australia Post)

2 = Courier (Courier)

3 = Email (Email)

4 = Aconex (Aconex)

5 = Fax (Fax)

6 = Other (Other) */
    receivalType?: DocumentReceivalType | undefined;
    /** Only defined if Receival Type is set to 'other' */
    receivalDescription?: string | undefined;
    /** The date and time the document was received in Utc format. */
    receivedUtc?: Date | undefined;
    /** Time zone 'Received Date Time' was supplied to the UI with. Required if 'Received Date Time' is set */
    receivedTimeZone?: string | undefined;
    /** The date and time the document was received in Utc format. */
    deemedReceivedUtc?: Date | undefined;
    /** Time zone 'Deemed Received Date Time' was supplied with. Required if 'Deemed Received Date Time' is set */
    deemedReceivedTimeZone?: string | undefined;
    /** Name of the person that sent the document */
    senderPerson?: string | undefined;
    /** Name of the organisation that sent the document */
    senderOrganisation?: string | undefined;
    /** Name of the person that received the document */
    recipientPerson?: string | undefined;
    /** Name of the organisation that received the document */
    recipientOrganisation?: string | undefined;
    /** Details about all Organisations associated with the Document */
    segmentInstanceAssociations!: GetDocumentResponseSegmentInstanceDocumentAssociationModel[];
    /** Details about the files associated with this version of the Document */
    files!: GetDocumentResponseFileModel[];
    /** Distinct set of Actions the User can perform against the DocumentVersion */
    availableActions!: UserActions[];
    /** The DateTime the DocumentVersion was created. */
    createdDateUtc!: Date;
    /** Aconex Document Metadata will only be present if the Document was originally created from an Aconex Document */
    aconexDocumentMetadata?: AconexDocumentMetadataModel | undefined;
    /** Other versions of the Aconex Document Metadata. Will only be present if 'Aconex Document Metadata' is present. (We might end up using a cutdown model here because we probably don't need all the Aconex Metadata for all the Versions of the Aconex Document.
) */
    aconexDocumentVersions?: AconexDocumentMetadataModel[] | undefined;
    hasMoreRecentAconexDocumentVersion?: boolean;
    /** Aconex Mail Metadata will only be present if the Document was originally created from an Aconex Mail */
    aconexMailMetadata?: AconexMailMetadataModel | undefined;

    constructor(data?: IGetDocumentResponseDocumentVersionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.segmentInstanceAssociations = [];
            this.files = [];
            this.availableActions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.index = _data["index"];
            this.name = _data["name"];
            this.reference = _data["reference"];
            this.contentDescription = _data["contentDescription"];
            this.description = _data["description"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.receivalType = _data["receivalType"];
            this.receivalDescription = _data["receivalDescription"];
            this.receivedUtc = _data["receivedUtc"] ? new Date(_data["receivedUtc"].toString()) : <any>undefined;
            this.receivedTimeZone = _data["receivedTimeZone"];
            this.deemedReceivedUtc = _data["deemedReceivedUtc"] ? new Date(_data["deemedReceivedUtc"].toString()) : <any>undefined;
            this.deemedReceivedTimeZone = _data["deemedReceivedTimeZone"];
            this.senderPerson = _data["senderPerson"];
            this.senderOrganisation = _data["senderOrganisation"];
            this.recipientPerson = _data["recipientPerson"];
            this.recipientOrganisation = _data["recipientOrganisation"];
            if (Array.isArray(_data["segmentInstanceAssociations"])) {
                this.segmentInstanceAssociations = [] as any;
                for (let item of _data["segmentInstanceAssociations"])
                    this.segmentInstanceAssociations!.push(GetDocumentResponseSegmentInstanceDocumentAssociationModel.fromJS(item));
            }
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(GetDocumentResponseFileModel.fromJS(item));
            }
            if (Array.isArray(_data["availableActions"])) {
                this.availableActions = [] as any;
                for (let item of _data["availableActions"])
                    this.availableActions!.push(item);
            }
            this.createdDateUtc = _data["createdDateUtc"] ? new Date(_data["createdDateUtc"].toString()) : <any>undefined;
            this.aconexDocumentMetadata = _data["aconexDocumentMetadata"] ? AconexDocumentMetadataModel.fromJS(_data["aconexDocumentMetadata"]) : <any>undefined;
            if (Array.isArray(_data["aconexDocumentVersions"])) {
                this.aconexDocumentVersions = [] as any;
                for (let item of _data["aconexDocumentVersions"])
                    this.aconexDocumentVersions!.push(AconexDocumentMetadataModel.fromJS(item));
            }
            this.hasMoreRecentAconexDocumentVersion = _data["hasMoreRecentAconexDocumentVersion"];
            this.aconexMailMetadata = _data["aconexMailMetadata"] ? AconexMailMetadataModel.fromJS(_data["aconexMailMetadata"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDocumentResponseDocumentVersionModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentResponseDocumentVersionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["index"] = this.index;
        data["name"] = this.name;
        data["reference"] = this.reference;
        data["contentDescription"] = this.contentDescription;
        data["description"] = this.description;
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["receivalType"] = this.receivalType;
        data["receivalDescription"] = this.receivalDescription;
        data["receivedUtc"] = this.receivedUtc ? this.receivedUtc.toISOString() : <any>undefined;
        data["receivedTimeZone"] = this.receivedTimeZone;
        data["deemedReceivedUtc"] = this.deemedReceivedUtc ? this.deemedReceivedUtc.toISOString() : <any>undefined;
        data["deemedReceivedTimeZone"] = this.deemedReceivedTimeZone;
        data["senderPerson"] = this.senderPerson;
        data["senderOrganisation"] = this.senderOrganisation;
        data["recipientPerson"] = this.recipientPerson;
        data["recipientOrganisation"] = this.recipientOrganisation;
        if (Array.isArray(this.segmentInstanceAssociations)) {
            data["segmentInstanceAssociations"] = [];
            for (let item of this.segmentInstanceAssociations)
                data["segmentInstanceAssociations"].push(item.toJSON());
        }
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        if (Array.isArray(this.availableActions)) {
            data["availableActions"] = [];
            for (let item of this.availableActions)
                data["availableActions"].push(item);
        }
        data["createdDateUtc"] = this.createdDateUtc ? this.createdDateUtc.toISOString() : <any>undefined;
        data["aconexDocumentMetadata"] = this.aconexDocumentMetadata ? this.aconexDocumentMetadata.toJSON() : <any>undefined;
        if (Array.isArray(this.aconexDocumentVersions)) {
            data["aconexDocumentVersions"] = [];
            for (let item of this.aconexDocumentVersions)
                data["aconexDocumentVersions"].push(item.toJSON());
        }
        data["hasMoreRecentAconexDocumentVersion"] = this.hasMoreRecentAconexDocumentVersion;
        data["aconexMailMetadata"] = this.aconexMailMetadata ? this.aconexMailMetadata.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetDocumentResponseDocumentVersionModel {
    /** Public identifier of the Document Version */
    gid: string;
    /** The Index of the Version. A number that can be used to create the text "Version 4" */
    index: number;
    /** Document Name */
    name: string;
    /** Document Reference */
    reference: string;
    /** Description of the content of the document */
    contentDescription?: string | undefined;
    /** Description of the document */
    description?: string | undefined;
    /** The date of the Document Version */
    date?: Date | undefined;
    /** Now called Receipt Type in the UI

1 = AusPost (Australia Post)

2 = Courier (Courier)

3 = Email (Email)

4 = Aconex (Aconex)

5 = Fax (Fax)

6 = Other (Other) */
    receivalType?: DocumentReceivalType | undefined;
    /** Only defined if Receival Type is set to 'other' */
    receivalDescription?: string | undefined;
    /** The date and time the document was received in Utc format. */
    receivedUtc?: Date | undefined;
    /** Time zone 'Received Date Time' was supplied to the UI with. Required if 'Received Date Time' is set */
    receivedTimeZone?: string | undefined;
    /** The date and time the document was received in Utc format. */
    deemedReceivedUtc?: Date | undefined;
    /** Time zone 'Deemed Received Date Time' was supplied with. Required if 'Deemed Received Date Time' is set */
    deemedReceivedTimeZone?: string | undefined;
    /** Name of the person that sent the document */
    senderPerson?: string | undefined;
    /** Name of the organisation that sent the document */
    senderOrganisation?: string | undefined;
    /** Name of the person that received the document */
    recipientPerson?: string | undefined;
    /** Name of the organisation that received the document */
    recipientOrganisation?: string | undefined;
    /** Details about all Organisations associated with the Document */
    segmentInstanceAssociations: GetDocumentResponseSegmentInstanceDocumentAssociationModel[];
    /** Details about the files associated with this version of the Document */
    files: GetDocumentResponseFileModel[];
    /** Distinct set of Actions the User can perform against the DocumentVersion */
    availableActions: UserActions[];
    /** The DateTime the DocumentVersion was created. */
    createdDateUtc: Date;
    /** Aconex Document Metadata will only be present if the Document was originally created from an Aconex Document */
    aconexDocumentMetadata?: AconexDocumentMetadataModel | undefined;
    /** Other versions of the Aconex Document Metadata. Will only be present if 'Aconex Document Metadata' is present. (We might end up using a cutdown model here because we probably don't need all the Aconex Metadata for all the Versions of the Aconex Document.
) */
    aconexDocumentVersions?: AconexDocumentMetadataModel[] | undefined;
    hasMoreRecentAconexDocumentVersion?: boolean;
    /** Aconex Mail Metadata will only be present if the Document was originally created from an Aconex Mail */
    aconexMailMetadata?: AconexMailMetadataModel | undefined;
}

export class GetDocumentResponseFileModel implements IGetDocumentResponseFileModel {
    /** The Public Identifier (Gid) of the File */
    gid!: string;
    /** The Public Identifier (Gid) of the Association between the File and the DocumentVersion */
    associationGid!: string;
    /** Name of the file */
    name!: string;
    /** Format of the file *This will most likely be just the file extension (which is part of the file name anyway) */
    format!: string;
    /** Size of the file in bytes */
    size!: number;
    /** The DateTime the the File was uploaded. */
    createdDateUtc!: Date;
    /** The DateTime the association between the File and the DocumentVersion was created. */
    associationCreatedDateUtc!: Date;

    constructor(data?: IGetDocumentResponseFileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.associationGid = _data["associationGid"];
            this.name = _data["name"];
            this.format = _data["format"];
            this.size = _data["size"];
            this.createdDateUtc = _data["createdDateUtc"] ? new Date(_data["createdDateUtc"].toString()) : <any>undefined;
            this.associationCreatedDateUtc = _data["associationCreatedDateUtc"] ? new Date(_data["associationCreatedDateUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDocumentResponseFileModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentResponseFileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["associationGid"] = this.associationGid;
        data["name"] = this.name;
        data["format"] = this.format;
        data["size"] = this.size;
        data["createdDateUtc"] = this.createdDateUtc ? this.createdDateUtc.toISOString() : <any>undefined;
        data["associationCreatedDateUtc"] = this.associationCreatedDateUtc ? this.associationCreatedDateUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetDocumentResponseFileModel {
    /** The Public Identifier (Gid) of the File */
    gid: string;
    /** The Public Identifier (Gid) of the Association between the File and the DocumentVersion */
    associationGid: string;
    /** Name of the file */
    name: string;
    /** Format of the file *This will most likely be just the file extension (which is part of the file name anyway) */
    format: string;
    /** Size of the file in bytes */
    size: number;
    /** The DateTime the the File was uploaded. */
    createdDateUtc: Date;
    /** The DateTime the association between the File and the DocumentVersion was created. */
    associationCreatedDateUtc: Date;
}

export class GetDocumentResponseModel implements IGetDocumentResponseModel {
    /** The unique identifier for the Document */
    gid!: string;
    /** Details about all Organisations associated with the Document */
    organisationAssociations!: GetDocumentResponseOrganisationDocumentAssociationModel[];
    /** Details about all Projects associated with the Document */
    projectAssociations!: GetDocumentResponseProjectDocumentAssociationModel[];
    /** Details about all Contracts associated with the Document */
    contractAssociations!: GetDocumentResponseContractDocumentAssociationModel[];
    /** Details about all the Versions of the Document */
    versions!: GetDocumentResponseDocumentVersionModel[];
    /** Distinct set of Actions the User can perform against the Document */
    availableActions!: UserActions[];
    /** The DateTime the Document was created in the DB. */
    createdDateUtc!: Date;

    constructor(data?: IGetDocumentResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.organisationAssociations = [];
            this.projectAssociations = [];
            this.contractAssociations = [];
            this.versions = [];
            this.availableActions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            if (Array.isArray(_data["organisationAssociations"])) {
                this.organisationAssociations = [] as any;
                for (let item of _data["organisationAssociations"])
                    this.organisationAssociations!.push(GetDocumentResponseOrganisationDocumentAssociationModel.fromJS(item));
            }
            if (Array.isArray(_data["projectAssociations"])) {
                this.projectAssociations = [] as any;
                for (let item of _data["projectAssociations"])
                    this.projectAssociations!.push(GetDocumentResponseProjectDocumentAssociationModel.fromJS(item));
            }
            if (Array.isArray(_data["contractAssociations"])) {
                this.contractAssociations = [] as any;
                for (let item of _data["contractAssociations"])
                    this.contractAssociations!.push(GetDocumentResponseContractDocumentAssociationModel.fromJS(item));
            }
            if (Array.isArray(_data["versions"])) {
                this.versions = [] as any;
                for (let item of _data["versions"])
                    this.versions!.push(GetDocumentResponseDocumentVersionModel.fromJS(item));
            }
            if (Array.isArray(_data["availableActions"])) {
                this.availableActions = [] as any;
                for (let item of _data["availableActions"])
                    this.availableActions!.push(item);
            }
            this.createdDateUtc = _data["createdDateUtc"] ? new Date(_data["createdDateUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDocumentResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        if (Array.isArray(this.organisationAssociations)) {
            data["organisationAssociations"] = [];
            for (let item of this.organisationAssociations)
                data["organisationAssociations"].push(item.toJSON());
        }
        if (Array.isArray(this.projectAssociations)) {
            data["projectAssociations"] = [];
            for (let item of this.projectAssociations)
                data["projectAssociations"].push(item.toJSON());
        }
        if (Array.isArray(this.contractAssociations)) {
            data["contractAssociations"] = [];
            for (let item of this.contractAssociations)
                data["contractAssociations"].push(item.toJSON());
        }
        if (Array.isArray(this.versions)) {
            data["versions"] = [];
            for (let item of this.versions)
                data["versions"].push(item.toJSON());
        }
        if (Array.isArray(this.availableActions)) {
            data["availableActions"] = [];
            for (let item of this.availableActions)
                data["availableActions"].push(item);
        }
        data["createdDateUtc"] = this.createdDateUtc ? this.createdDateUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetDocumentResponseModel {
    /** The unique identifier for the Document */
    gid: string;
    /** Details about all Organisations associated with the Document */
    organisationAssociations: GetDocumentResponseOrganisationDocumentAssociationModel[];
    /** Details about all Projects associated with the Document */
    projectAssociations: GetDocumentResponseProjectDocumentAssociationModel[];
    /** Details about all Contracts associated with the Document */
    contractAssociations: GetDocumentResponseContractDocumentAssociationModel[];
    /** Details about all the Versions of the Document */
    versions: GetDocumentResponseDocumentVersionModel[];
    /** Distinct set of Actions the User can perform against the Document */
    availableActions: UserActions[];
    /** The DateTime the Document was created in the DB. */
    createdDateUtc: Date;
}

export class GetDocumentResponseOrganisationDocumentAssociationModel implements IGetDocumentResponseOrganisationDocumentAssociationModel {
    /** The Public Identifier (Gid) of the association with the Document */
    gid!: string;
    /** The Public Identifier (Gid) of the item (Organisation, Project, Contract, Segment Instance) associated with the Document */
    associatedGid!: string;
    /** The Code (or Reference in the case of Contract and Segment Instance) of the associated item (Organisation, Project, Contract, Segment Instance) associated with the Document */
    associatedCode!: string;
    /** The Name of the associated item (Organisation, Project, Contract, but not Segment Instance because it doesn't have a Name) associated with the Document */
    associatedName?: string | undefined;
    /** Distinct set of Actions the User can perform against the Document Association */
    availableActions!: UserActions[];
    /** The DateTime the the Association was created. */
    createdDateUtc!: Date;
    /** The Organisation Status of the Organisation associated with the Document

1 = Active (The organisation is active)

2 = Pending (The organisation is pending)

3 = Suspended (The organisation has been suspended)

4 = Inactive (The organisation is inactive) */
    status!: OrganisationStatus;

    constructor(data?: IGetDocumentResponseOrganisationDocumentAssociationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.availableActions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.associatedGid = _data["associatedGid"];
            this.associatedCode = _data["associatedCode"];
            this.associatedName = _data["associatedName"];
            if (Array.isArray(_data["availableActions"])) {
                this.availableActions = [] as any;
                for (let item of _data["availableActions"])
                    this.availableActions!.push(item);
            }
            this.createdDateUtc = _data["createdDateUtc"] ? new Date(_data["createdDateUtc"].toString()) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): GetDocumentResponseOrganisationDocumentAssociationModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentResponseOrganisationDocumentAssociationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["associatedGid"] = this.associatedGid;
        data["associatedCode"] = this.associatedCode;
        data["associatedName"] = this.associatedName;
        if (Array.isArray(this.availableActions)) {
            data["availableActions"] = [];
            for (let item of this.availableActions)
                data["availableActions"].push(item);
        }
        data["createdDateUtc"] = this.createdDateUtc ? this.createdDateUtc.toISOString() : <any>undefined;
        data["status"] = this.status;
        return data;
    }
}

export interface IGetDocumentResponseOrganisationDocumentAssociationModel {
    /** The Public Identifier (Gid) of the association with the Document */
    gid: string;
    /** The Public Identifier (Gid) of the item (Organisation, Project, Contract, Segment Instance) associated with the Document */
    associatedGid: string;
    /** The Code (or Reference in the case of Contract and Segment Instance) of the associated item (Organisation, Project, Contract, Segment Instance) associated with the Document */
    associatedCode: string;
    /** The Name of the associated item (Organisation, Project, Contract, but not Segment Instance because it doesn't have a Name) associated with the Document */
    associatedName?: string | undefined;
    /** Distinct set of Actions the User can perform against the Document Association */
    availableActions: UserActions[];
    /** The DateTime the the Association was created. */
    createdDateUtc: Date;
    /** The Organisation Status of the Organisation associated with the Document

1 = Active (The organisation is active)

2 = Pending (The organisation is pending)

3 = Suspended (The organisation has been suspended)

4 = Inactive (The organisation is inactive) */
    status: OrganisationStatus;
}

export class GetDocumentResponseProjectDocumentAssociationModel implements IGetDocumentResponseProjectDocumentAssociationModel {
    /** The Public Identifier (Gid) of the association with the Document */
    gid!: string;
    /** The Public Identifier (Gid) of the item (Organisation, Project, Contract, Segment Instance) associated with the Document */
    associatedGid!: string;
    /** The Code (or Reference in the case of Contract and Segment Instance) of the associated item (Organisation, Project, Contract, Segment Instance) associated with the Document */
    associatedCode!: string;
    /** The Name of the associated item (Organisation, Project, Contract, but not Segment Instance because it doesn't have a Name) associated with the Document */
    associatedName?: string | undefined;
    /** Distinct set of Actions the User can perform against the Document Association */
    availableActions!: UserActions[];
    /** The DateTime the the Association was created. */
    createdDateUtc!: Date;
    /** The Project Status of the Project associated with the Document

1 = Active (Project is active)

2 = Pending (Project is pending)

3 = Suspended (Project is suspended)

4 = Complete (Project is complete) */
    status!: ProjectStatus;

    constructor(data?: IGetDocumentResponseProjectDocumentAssociationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.availableActions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.associatedGid = _data["associatedGid"];
            this.associatedCode = _data["associatedCode"];
            this.associatedName = _data["associatedName"];
            if (Array.isArray(_data["availableActions"])) {
                this.availableActions = [] as any;
                for (let item of _data["availableActions"])
                    this.availableActions!.push(item);
            }
            this.createdDateUtc = _data["createdDateUtc"] ? new Date(_data["createdDateUtc"].toString()) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): GetDocumentResponseProjectDocumentAssociationModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentResponseProjectDocumentAssociationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["associatedGid"] = this.associatedGid;
        data["associatedCode"] = this.associatedCode;
        data["associatedName"] = this.associatedName;
        if (Array.isArray(this.availableActions)) {
            data["availableActions"] = [];
            for (let item of this.availableActions)
                data["availableActions"].push(item);
        }
        data["createdDateUtc"] = this.createdDateUtc ? this.createdDateUtc.toISOString() : <any>undefined;
        data["status"] = this.status;
        return data;
    }
}

export interface IGetDocumentResponseProjectDocumentAssociationModel {
    /** The Public Identifier (Gid) of the association with the Document */
    gid: string;
    /** The Public Identifier (Gid) of the item (Organisation, Project, Contract, Segment Instance) associated with the Document */
    associatedGid: string;
    /** The Code (or Reference in the case of Contract and Segment Instance) of the associated item (Organisation, Project, Contract, Segment Instance) associated with the Document */
    associatedCode: string;
    /** The Name of the associated item (Organisation, Project, Contract, but not Segment Instance because it doesn't have a Name) associated with the Document */
    associatedName?: string | undefined;
    /** Distinct set of Actions the User can perform against the Document Association */
    availableActions: UserActions[];
    /** The DateTime the the Association was created. */
    createdDateUtc: Date;
    /** The Project Status of the Project associated with the Document

1 = Active (Project is active)

2 = Pending (Project is pending)

3 = Suspended (Project is suspended)

4 = Complete (Project is complete) */
    status: ProjectStatus;
}

export class GetDocumentResponseSegmentInstanceDocumentAssociationModel implements IGetDocumentResponseSegmentInstanceDocumentAssociationModel {
    /** The Public Identifier (Gid) of the association with the Document */
    gid!: string;
    /** The Public Identifier (Gid) of the item (Organisation, Project, Contract, Segment Instance) associated with the Document */
    associatedGid!: string;
    /** The Code (or Reference in the case of Contract and Segment Instance) of the associated item (Organisation, Project, Contract, Segment Instance) associated with the Document */
    associatedCode!: string;
    /** The Name of the associated item (Organisation, Project, Contract, but not Segment Instance because it doesn't have a Name) associated with the Document */
    associatedName?: string | undefined;
    /** Distinct set of Actions the User can perform against the Document Association */
    availableActions!: UserActions[];
    /** The DateTime the the Association was created. */
    createdDateUtc!: Date;
    /** The Segment Instance Status of the Segment Instance associated with the Document Version

1 = InProgress (Segment is unresolved, this is the initial status for most segments)

2 = Suspended (Segment is unresolved but is marked as suspended, post MVP this will include additional logic for ‘Stopping the ticking of clocks’)

3 = InfoRequestedAndNotSuspended (Segment is unresolved and is noting that additional information has been requested)

4 = InfoRequestedAndSuspended (Effectively the same as both ‘Info Requested and Not Suspended’ and ‘Suspended’)

16 = Complete (Segment has been resolved)

17 = Withdrawn (Segment has been withdrawn (this is specially for when a contractor withdraws a claim))

18 = Cancelled (Segment has been cancelled (this is specifically for when the principal cancels a claim))

19 = Disputed (Segment is resolved and has been marked as being in dispute, Post MVP this means an additional dispute workflow as been created)

20 = LegalDispute (Same as Disputed but for Legal Disputes) */
    status!: SegmentInstanceStatus;
    /** The Segment Process Type of the Segment parent of the Segment Instance associated with the Document Version

1 = Notice (Segment (and SegmentInstance) should to be processed as a Notice)

2 = Claim (Segment (and SegmentInstance) should to be processed as a Claim)

3 = Direction (Segment (and SegmentInstance) should be processed as a Direction (note: post-mvp))

4 = RFIInbound (Segment (and SegmentInstance) should be processed as an RFI Inbound)

5 = RFIOutbound (Segment (and SegmentInstance) should be processed as an RFI Outbound)

6 = Variation (Segment (and SegmentInstance) should be processed as a Variation 

This is a variation created by the principal. It might be follow a proposal, or might be stand alone.)

7 = VariationProposal (Segment (and SegmentInstance) should be processed as a Variation Proposal 

This is the principal proposing a variation to the contractor and getting a response to the proposal)

8 = VariationRequest (Segment (and SegmentInstance) should be processed as a Variation Request 

This is the contractor requesting a variation from the principal) */
    segmentProcessType!: SegmentProcessType;
    /** The Short Name of the Segment parent of the Segment Instance associated with the Document Version */
    segmentShortName!: string;
    /** The Name of the Segment parent of the Segment Instance associated with the Document Version */
    segmentName!: string;
    /** The association type (See <seealso cref="T:OneTrack.Data.Enums.SegmentInstanceDocumentVersionAssociationType" /> enum)

0 = Originating (The document was the document that began the workflow)

1 = Supporting (The document is a supporting document for the workflow)

2 = Response (The document was a response to the workflow) */
    associationType!: SegmentInstanceDocumentVersionAssociationType;

    constructor(data?: IGetDocumentResponseSegmentInstanceDocumentAssociationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.availableActions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.associatedGid = _data["associatedGid"];
            this.associatedCode = _data["associatedCode"];
            this.associatedName = _data["associatedName"];
            if (Array.isArray(_data["availableActions"])) {
                this.availableActions = [] as any;
                for (let item of _data["availableActions"])
                    this.availableActions!.push(item);
            }
            this.createdDateUtc = _data["createdDateUtc"] ? new Date(_data["createdDateUtc"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.segmentProcessType = _data["segmentProcessType"];
            this.segmentShortName = _data["segmentShortName"];
            this.segmentName = _data["segmentName"];
            this.associationType = _data["associationType"];
        }
    }

    static fromJS(data: any): GetDocumentResponseSegmentInstanceDocumentAssociationModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentResponseSegmentInstanceDocumentAssociationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["associatedGid"] = this.associatedGid;
        data["associatedCode"] = this.associatedCode;
        data["associatedName"] = this.associatedName;
        if (Array.isArray(this.availableActions)) {
            data["availableActions"] = [];
            for (let item of this.availableActions)
                data["availableActions"].push(item);
        }
        data["createdDateUtc"] = this.createdDateUtc ? this.createdDateUtc.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["segmentProcessType"] = this.segmentProcessType;
        data["segmentShortName"] = this.segmentShortName;
        data["segmentName"] = this.segmentName;
        data["associationType"] = this.associationType;
        return data;
    }
}

export interface IGetDocumentResponseSegmentInstanceDocumentAssociationModel {
    /** The Public Identifier (Gid) of the association with the Document */
    gid: string;
    /** The Public Identifier (Gid) of the item (Organisation, Project, Contract, Segment Instance) associated with the Document */
    associatedGid: string;
    /** The Code (or Reference in the case of Contract and Segment Instance) of the associated item (Organisation, Project, Contract, Segment Instance) associated with the Document */
    associatedCode: string;
    /** The Name of the associated item (Organisation, Project, Contract, but not Segment Instance because it doesn't have a Name) associated with the Document */
    associatedName?: string | undefined;
    /** Distinct set of Actions the User can perform against the Document Association */
    availableActions: UserActions[];
    /** The DateTime the the Association was created. */
    createdDateUtc: Date;
    /** The Segment Instance Status of the Segment Instance associated with the Document Version

1 = InProgress (Segment is unresolved, this is the initial status for most segments)

2 = Suspended (Segment is unresolved but is marked as suspended, post MVP this will include additional logic for ‘Stopping the ticking of clocks’)

3 = InfoRequestedAndNotSuspended (Segment is unresolved and is noting that additional information has been requested)

4 = InfoRequestedAndSuspended (Effectively the same as both ‘Info Requested and Not Suspended’ and ‘Suspended’)

16 = Complete (Segment has been resolved)

17 = Withdrawn (Segment has been withdrawn (this is specially for when a contractor withdraws a claim))

18 = Cancelled (Segment has been cancelled (this is specifically for when the principal cancels a claim))

19 = Disputed (Segment is resolved and has been marked as being in dispute, Post MVP this means an additional dispute workflow as been created)

20 = LegalDispute (Same as Disputed but for Legal Disputes) */
    status: SegmentInstanceStatus;
    /** The Segment Process Type of the Segment parent of the Segment Instance associated with the Document Version

1 = Notice (Segment (and SegmentInstance) should to be processed as a Notice)

2 = Claim (Segment (and SegmentInstance) should to be processed as a Claim)

3 = Direction (Segment (and SegmentInstance) should be processed as a Direction (note: post-mvp))

4 = RFIInbound (Segment (and SegmentInstance) should be processed as an RFI Inbound)

5 = RFIOutbound (Segment (and SegmentInstance) should be processed as an RFI Outbound)

6 = Variation (Segment (and SegmentInstance) should be processed as a Variation 

This is a variation created by the principal. It might be follow a proposal, or might be stand alone.)

7 = VariationProposal (Segment (and SegmentInstance) should be processed as a Variation Proposal 

This is the principal proposing a variation to the contractor and getting a response to the proposal)

8 = VariationRequest (Segment (and SegmentInstance) should be processed as a Variation Request 

This is the contractor requesting a variation from the principal) */
    segmentProcessType: SegmentProcessType;
    /** The Short Name of the Segment parent of the Segment Instance associated with the Document Version */
    segmentShortName: string;
    /** The Name of the Segment parent of the Segment Instance associated with the Document Version */
    segmentName: string;
    /** The association type (See <seealso cref="T:OneTrack.Data.Enums.SegmentInstanceDocumentVersionAssociationType" /> enum)

0 = Originating (The document was the document that began the workflow)

1 = Supporting (The document is a supporting document for the workflow)

2 = Response (The document was a response to the workflow) */
    associationType: SegmentInstanceDocumentVersionAssociationType;
}

export class GetSearchDocumentsResponseDocumentAconexMetadataDocumentModel implements IGetSearchDocumentsResponseDocumentAconexMetadataDocumentModel {
    documentId!: string;
    documentNumber!: string | undefined;
    documentStatus!: string | undefined;
    documentType!: string | undefined;
    reference?: string | undefined;
    title?: string | undefined;
    /** Aconex Project Id for the document. (This property does not appear in the Aconex API version of this model, we have to set it ourselves manually.) */
    projectId!: string;
    userSite?: string | undefined;

    constructor(data?: IGetSearchDocumentsResponseDocumentAconexMetadataDocumentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.documentNumber = _data["documentNumber"];
            this.documentStatus = _data["documentStatus"];
            this.documentType = _data["documentType"];
            this.reference = _data["reference"];
            this.title = _data["title"];
            this.projectId = _data["projectId"];
            this.userSite = _data["userSite"];
        }
    }

    static fromJS(data: any): GetSearchDocumentsResponseDocumentAconexMetadataDocumentModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSearchDocumentsResponseDocumentAconexMetadataDocumentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["documentNumber"] = this.documentNumber;
        data["documentStatus"] = this.documentStatus;
        data["documentType"] = this.documentType;
        data["reference"] = this.reference;
        data["title"] = this.title;
        data["projectId"] = this.projectId;
        data["userSite"] = this.userSite;
        return data;
    }
}

export interface IGetSearchDocumentsResponseDocumentAconexMetadataDocumentModel {
    documentId: string;
    documentNumber: string | undefined;
    documentStatus: string | undefined;
    documentType: string | undefined;
    reference?: string | undefined;
    title?: string | undefined;
    /** Aconex Project Id for the document. (This property does not appear in the Aconex API version of this model, we have to set it ourselves manually.) */
    projectId: string;
    userSite?: string | undefined;
}

export class GetSearchDocumentsResponseDocumentAconexMetadataMailModel implements IGetSearchDocumentsResponseDocumentAconexMetadataMailModel {
    mailId!: string;
    /** The body of the mail. Note: Includes formatting metadata such as font and text alignment. The mail body is capped at a maximum size of 2GB. */
    mailData!: string;
    correspondenceType!: string;
    toUsers!: GetSearchDocumentsResponseMailMetadataRecipientModel[];
    mailNo!: string;
    fromUserDetails!: GetSearchDocumentsResponseMailMetadataUserDetailsModel | undefined;
    /** May be an empty element. */
    reasonForIssue!: string;
    richMailText!: boolean;
    /** Converted from Aconex string response */
    sentDateUtc!: Date | undefined;
    subject!: string;
    projectId!: string;
    userSite?: string | undefined;

    constructor(data?: IGetSearchDocumentsResponseDocumentAconexMetadataMailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.toUsers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailId = _data["mailId"];
            this.mailData = _data["mailData"];
            this.correspondenceType = _data["correspondenceType"];
            if (Array.isArray(_data["toUsers"])) {
                this.toUsers = [] as any;
                for (let item of _data["toUsers"])
                    this.toUsers!.push(GetSearchDocumentsResponseMailMetadataRecipientModel.fromJS(item));
            }
            this.mailNo = _data["mailNo"];
            this.fromUserDetails = _data["fromUserDetails"] ? GetSearchDocumentsResponseMailMetadataUserDetailsModel.fromJS(_data["fromUserDetails"]) : <any>undefined;
            this.reasonForIssue = _data["reasonForIssue"];
            this.richMailText = _data["richMailText"];
            this.sentDateUtc = _data["sentDateUtc"] ? new Date(_data["sentDateUtc"].toString()) : <any>undefined;
            this.subject = _data["subject"];
            this.projectId = _data["projectId"];
            this.userSite = _data["userSite"];
        }
    }

    static fromJS(data: any): GetSearchDocumentsResponseDocumentAconexMetadataMailModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSearchDocumentsResponseDocumentAconexMetadataMailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailId"] = this.mailId;
        data["mailData"] = this.mailData;
        data["correspondenceType"] = this.correspondenceType;
        if (Array.isArray(this.toUsers)) {
            data["toUsers"] = [];
            for (let item of this.toUsers)
                data["toUsers"].push(item.toJSON());
        }
        data["mailNo"] = this.mailNo;
        data["fromUserDetails"] = this.fromUserDetails ? this.fromUserDetails.toJSON() : <any>undefined;
        data["reasonForIssue"] = this.reasonForIssue;
        data["richMailText"] = this.richMailText;
        data["sentDateUtc"] = this.sentDateUtc ? this.sentDateUtc.toISOString() : <any>undefined;
        data["subject"] = this.subject;
        data["projectId"] = this.projectId;
        data["userSite"] = this.userSite;
        return data;
    }
}

export interface IGetSearchDocumentsResponseDocumentAconexMetadataMailModel {
    mailId: string;
    /** The body of the mail. Note: Includes formatting metadata such as font and text alignment. The mail body is capped at a maximum size of 2GB. */
    mailData: string;
    correspondenceType: string;
    toUsers: GetSearchDocumentsResponseMailMetadataRecipientModel[];
    mailNo: string;
    fromUserDetails: GetSearchDocumentsResponseMailMetadataUserDetailsModel | undefined;
    /** May be an empty element. */
    reasonForIssue: string;
    richMailText: boolean;
    /** Converted from Aconex string response */
    sentDateUtc: Date | undefined;
    subject: string;
    projectId: string;
    userSite?: string | undefined;
}

export class GetSearchDocumentsResponseDocumentModel implements IGetSearchDocumentsResponseDocumentModel {
    /** Public Identifier for the Document */
    gid!: string;
    /** Public Identifier for the Document Version */
    documentVersionGid!: string;
    /** Document Reference */
    reference!: string;
    /** Document Name */
    name!: string;
    /** Description of the content of the document */
    contentDescription!: string | undefined;
    /** Document Date. The date the document was created. 

No time component */
    date!: Date | undefined;
    /** Now called Receipt Type in the UI

1 = AusPost (Australia Post)

2 = Courier (Courier)

3 = Email (Email)

4 = Aconex (Aconex)

5 = Fax (Fax)

6 = Other (Other) */
    receivalType!: DocumentReceivalType | undefined;
    /** Only defined if Receival Type is set to 'other' */
    receivalDescription!: string | undefined;
    /** The date and time the document was received in Utc format. */
    deemedReceivedUtc!: Date | undefined;
    /** Time zone 'Deemed Received Date Time' was supplied with. Required if 'Deemed Received Date Time' is set */
    deemedReceivedTimeZone!: string | undefined;
    /** Details about all Organisations associated with the Document */
    organisationAssociations!: GetSearchDocumentsResponseGenericDocumentAssociationModel[];
    /** Details about all Projects associated with the Document */
    projectAssociations!: GetSearchDocumentsResponseGenericDocumentAssociationModel[];
    /** Details about all Contracts associated with the Document */
    contractAssociations!: GetSearchDocumentsResponseGenericDocumentAssociationModel[];
    /** Details about all Organisations associated with the Document */
    segmentInstanceAssociations!: GetSearchDocumentsResponseSegmentInstanceDocumentAssociationModel[];
    /** Distinct set of Actions the User can perform against the Document */
    availableActions!: UserActions[];
    /** Aconex Document Metadata will only be present if the Document was originally created from an Aconex Document */
    aconexDocumentMetadata!: GetSearchDocumentsResponseDocumentAconexMetadataDocumentModel | undefined;
    /** Aconex Mail Metadata will only be present if the Document was originally created from an Aconex Mail */
    aconexMailMetadata!: GetSearchDocumentsResponseDocumentAconexMetadataMailModel | undefined;
    /** The Index of the Version. 
 
A number that can be used to create the text "Version 4" for example. */
    versionIndex!: number;

    constructor(data?: IGetSearchDocumentsResponseDocumentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.organisationAssociations = [];
            this.projectAssociations = [];
            this.contractAssociations = [];
            this.segmentInstanceAssociations = [];
            this.availableActions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.documentVersionGid = _data["documentVersionGid"];
            this.reference = _data["reference"];
            this.name = _data["name"];
            this.contentDescription = _data["contentDescription"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.receivalType = _data["receivalType"];
            this.receivalDescription = _data["receivalDescription"];
            this.deemedReceivedUtc = _data["deemedReceivedUtc"] ? new Date(_data["deemedReceivedUtc"].toString()) : <any>undefined;
            this.deemedReceivedTimeZone = _data["deemedReceivedTimeZone"];
            if (Array.isArray(_data["organisationAssociations"])) {
                this.organisationAssociations = [] as any;
                for (let item of _data["organisationAssociations"])
                    this.organisationAssociations!.push(GetSearchDocumentsResponseGenericDocumentAssociationModel.fromJS(item));
            }
            if (Array.isArray(_data["projectAssociations"])) {
                this.projectAssociations = [] as any;
                for (let item of _data["projectAssociations"])
                    this.projectAssociations!.push(GetSearchDocumentsResponseGenericDocumentAssociationModel.fromJS(item));
            }
            if (Array.isArray(_data["contractAssociations"])) {
                this.contractAssociations = [] as any;
                for (let item of _data["contractAssociations"])
                    this.contractAssociations!.push(GetSearchDocumentsResponseGenericDocumentAssociationModel.fromJS(item));
            }
            if (Array.isArray(_data["segmentInstanceAssociations"])) {
                this.segmentInstanceAssociations = [] as any;
                for (let item of _data["segmentInstanceAssociations"])
                    this.segmentInstanceAssociations!.push(GetSearchDocumentsResponseSegmentInstanceDocumentAssociationModel.fromJS(item));
            }
            if (Array.isArray(_data["availableActions"])) {
                this.availableActions = [] as any;
                for (let item of _data["availableActions"])
                    this.availableActions!.push(item);
            }
            this.aconexDocumentMetadata = _data["aconexDocumentMetadata"] ? GetSearchDocumentsResponseDocumentAconexMetadataDocumentModel.fromJS(_data["aconexDocumentMetadata"]) : <any>undefined;
            this.aconexMailMetadata = _data["aconexMailMetadata"] ? GetSearchDocumentsResponseDocumentAconexMetadataMailModel.fromJS(_data["aconexMailMetadata"]) : <any>undefined;
            this.versionIndex = _data["versionIndex"];
        }
    }

    static fromJS(data: any): GetSearchDocumentsResponseDocumentModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSearchDocumentsResponseDocumentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["documentVersionGid"] = this.documentVersionGid;
        data["reference"] = this.reference;
        data["name"] = this.name;
        data["contentDescription"] = this.contentDescription;
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["receivalType"] = this.receivalType;
        data["receivalDescription"] = this.receivalDescription;
        data["deemedReceivedUtc"] = this.deemedReceivedUtc ? this.deemedReceivedUtc.toISOString() : <any>undefined;
        data["deemedReceivedTimeZone"] = this.deemedReceivedTimeZone;
        if (Array.isArray(this.organisationAssociations)) {
            data["organisationAssociations"] = [];
            for (let item of this.organisationAssociations)
                data["organisationAssociations"].push(item.toJSON());
        }
        if (Array.isArray(this.projectAssociations)) {
            data["projectAssociations"] = [];
            for (let item of this.projectAssociations)
                data["projectAssociations"].push(item.toJSON());
        }
        if (Array.isArray(this.contractAssociations)) {
            data["contractAssociations"] = [];
            for (let item of this.contractAssociations)
                data["contractAssociations"].push(item.toJSON());
        }
        if (Array.isArray(this.segmentInstanceAssociations)) {
            data["segmentInstanceAssociations"] = [];
            for (let item of this.segmentInstanceAssociations)
                data["segmentInstanceAssociations"].push(item.toJSON());
        }
        if (Array.isArray(this.availableActions)) {
            data["availableActions"] = [];
            for (let item of this.availableActions)
                data["availableActions"].push(item);
        }
        data["aconexDocumentMetadata"] = this.aconexDocumentMetadata ? this.aconexDocumentMetadata.toJSON() : <any>undefined;
        data["aconexMailMetadata"] = this.aconexMailMetadata ? this.aconexMailMetadata.toJSON() : <any>undefined;
        data["versionIndex"] = this.versionIndex;
        return data;
    }
}

export interface IGetSearchDocumentsResponseDocumentModel {
    /** Public Identifier for the Document */
    gid: string;
    /** Public Identifier for the Document Version */
    documentVersionGid: string;
    /** Document Reference */
    reference: string;
    /** Document Name */
    name: string;
    /** Description of the content of the document */
    contentDescription: string | undefined;
    /** Document Date. The date the document was created. 

No time component */
    date: Date | undefined;
    /** Now called Receipt Type in the UI

1 = AusPost (Australia Post)

2 = Courier (Courier)

3 = Email (Email)

4 = Aconex (Aconex)

5 = Fax (Fax)

6 = Other (Other) */
    receivalType: DocumentReceivalType | undefined;
    /** Only defined if Receival Type is set to 'other' */
    receivalDescription: string | undefined;
    /** The date and time the document was received in Utc format. */
    deemedReceivedUtc: Date | undefined;
    /** Time zone 'Deemed Received Date Time' was supplied with. Required if 'Deemed Received Date Time' is set */
    deemedReceivedTimeZone: string | undefined;
    /** Details about all Organisations associated with the Document */
    organisationAssociations: GetSearchDocumentsResponseGenericDocumentAssociationModel[];
    /** Details about all Projects associated with the Document */
    projectAssociations: GetSearchDocumentsResponseGenericDocumentAssociationModel[];
    /** Details about all Contracts associated with the Document */
    contractAssociations: GetSearchDocumentsResponseGenericDocumentAssociationModel[];
    /** Details about all Organisations associated with the Document */
    segmentInstanceAssociations: GetSearchDocumentsResponseSegmentInstanceDocumentAssociationModel[];
    /** Distinct set of Actions the User can perform against the Document */
    availableActions: UserActions[];
    /** Aconex Document Metadata will only be present if the Document was originally created from an Aconex Document */
    aconexDocumentMetadata: GetSearchDocumentsResponseDocumentAconexMetadataDocumentModel | undefined;
    /** Aconex Mail Metadata will only be present if the Document was originally created from an Aconex Mail */
    aconexMailMetadata: GetSearchDocumentsResponseDocumentAconexMetadataMailModel | undefined;
    /** The Index of the Version. 
 
A number that can be used to create the text "Version 4" for example. */
    versionIndex: number;
}

export class GetSearchDocumentsResponseGenericDocumentAssociationModel implements IGetSearchDocumentsResponseGenericDocumentAssociationModel {
    /** The Public Identifier (Gid) of the association with the Document (OrganisationDocument.Gid, ProjectDocument.Gid, ContractDocument.Gid, SegmentInstanceDocumentVersion.Gid) */
    gid!: string;
    /** The Public Identifier (Gid) of the item (Organisation.Gid, Project.Gid, Contract.Gid, SegmentInstance.Gid) associated with the Document */
    associatedGid!: string;
    /** The Code or Reference of the associated item (Organisation, Project, Contract, Segment Instance) associated with the Document */
    associatedCode!: string;
    /** The Name of the associated item (Organisation, Project, Contract, but not Segment Instance because it doesn't have a Name) associated with the Document */
    associatedName!: string | undefined;
    /** Distinct set of Actions the User can perform against the Document Association */
    availableActions!: UserActions[];
    createdDateUtc!: Date;

    constructor(data?: IGetSearchDocumentsResponseGenericDocumentAssociationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.availableActions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.associatedGid = _data["associatedGid"];
            this.associatedCode = _data["associatedCode"];
            this.associatedName = _data["associatedName"];
            if (Array.isArray(_data["availableActions"])) {
                this.availableActions = [] as any;
                for (let item of _data["availableActions"])
                    this.availableActions!.push(item);
            }
            this.createdDateUtc = _data["createdDateUtc"] ? new Date(_data["createdDateUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSearchDocumentsResponseGenericDocumentAssociationModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSearchDocumentsResponseGenericDocumentAssociationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["associatedGid"] = this.associatedGid;
        data["associatedCode"] = this.associatedCode;
        data["associatedName"] = this.associatedName;
        if (Array.isArray(this.availableActions)) {
            data["availableActions"] = [];
            for (let item of this.availableActions)
                data["availableActions"].push(item);
        }
        data["createdDateUtc"] = this.createdDateUtc ? this.createdDateUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetSearchDocumentsResponseGenericDocumentAssociationModel {
    /** The Public Identifier (Gid) of the association with the Document (OrganisationDocument.Gid, ProjectDocument.Gid, ContractDocument.Gid, SegmentInstanceDocumentVersion.Gid) */
    gid: string;
    /** The Public Identifier (Gid) of the item (Organisation.Gid, Project.Gid, Contract.Gid, SegmentInstance.Gid) associated with the Document */
    associatedGid: string;
    /** The Code or Reference of the associated item (Organisation, Project, Contract, Segment Instance) associated with the Document */
    associatedCode: string;
    /** The Name of the associated item (Organisation, Project, Contract, but not Segment Instance because it doesn't have a Name) associated with the Document */
    associatedName: string | undefined;
    /** Distinct set of Actions the User can perform against the Document Association */
    availableActions: UserActions[];
    createdDateUtc: Date;
}

export class GetSearchDocumentsResponseMailMetadataRecipientModel implements IGetSearchDocumentsResponseMailMetadataRecipientModel {
    organizationId!: string;
    organizationName!: string;
    status!: string;
    distributionType!: string;
    name!: string;
    userId!: string;

    constructor(data?: IGetSearchDocumentsResponseMailMetadataRecipientModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.status = _data["status"];
            this.distributionType = _data["distributionType"];
            this.name = _data["name"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): GetSearchDocumentsResponseMailMetadataRecipientModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSearchDocumentsResponseMailMetadataRecipientModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["status"] = this.status;
        data["distributionType"] = this.distributionType;
        data["name"] = this.name;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IGetSearchDocumentsResponseMailMetadataRecipientModel {
    organizationId: string;
    organizationName: string;
    status: string;
    distributionType: string;
    name: string;
    userId: string;
}

export class GetSearchDocumentsResponseMailMetadataUserDetailsModel implements IGetSearchDocumentsResponseMailMetadataUserDetailsModel {
    organizationId!: string;
    logoPath?: string | undefined;
    href?: string | undefined;
    organizationName!: string;
    name!: string;
    userId!: string;

    constructor(data?: IGetSearchDocumentsResponseMailMetadataUserDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.logoPath = _data["logoPath"];
            this.href = _data["href"];
            this.organizationName = _data["organizationName"];
            this.name = _data["name"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): GetSearchDocumentsResponseMailMetadataUserDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSearchDocumentsResponseMailMetadataUserDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["logoPath"] = this.logoPath;
        data["href"] = this.href;
        data["organizationName"] = this.organizationName;
        data["name"] = this.name;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IGetSearchDocumentsResponseMailMetadataUserDetailsModel {
    organizationId: string;
    logoPath?: string | undefined;
    href?: string | undefined;
    organizationName: string;
    name: string;
    userId: string;
}

export class GetSearchDocumentsResponseModel implements IGetSearchDocumentsResponseModel {
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
    items?: GetSearchDocumentsResponseDocumentModel[] | undefined;

    constructor(data?: IGetSearchDocumentsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageIndex = _data["pageIndex"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetSearchDocumentsResponseDocumentModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSearchDocumentsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSearchDocumentsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageIndex"] = this.pageIndex;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSearchDocumentsResponseModel {
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
    items?: GetSearchDocumentsResponseDocumentModel[] | undefined;
}

export class GetSearchDocumentsResponseSegmentInstanceDocumentAssociationModel implements IGetSearchDocumentsResponseSegmentInstanceDocumentAssociationModel {
    /** The Public Identifier (Gid) of the association with the Document (OrganisationDocument.Gid, ProjectDocument.Gid, ContractDocument.Gid, SegmentInstanceDocumentVersion.Gid) */
    gid!: string;
    /** The Public Identifier (Gid) of the item (Organisation.Gid, Project.Gid, Contract.Gid, SegmentInstance.Gid) associated with the Document */
    associatedGid!: string;
    /** The Code or Reference of the associated item (Organisation, Project, Contract, Segment Instance) associated with the Document */
    associatedCode!: string;
    /** The Name of the associated item (Organisation, Project, Contract, but not Segment Instance because it doesn't have a Name) associated with the Document */
    associatedName!: string | undefined;
    /** Distinct set of Actions the User can perform against the Document Association */
    availableActions!: UserActions[];
    createdDateUtc!: Date;
    /** The Segment Process Type of the Segment parent of the Segment Instance associated with the Document

1 = Notice (Segment (and SegmentInstance) should to be processed as a Notice)

2 = Claim (Segment (and SegmentInstance) should to be processed as a Claim)

3 = Direction (Segment (and SegmentInstance) should be processed as a Direction (note: post-mvp))

4 = RFIInbound (Segment (and SegmentInstance) should be processed as an RFI Inbound)

5 = RFIOutbound (Segment (and SegmentInstance) should be processed as an RFI Outbound)

6 = Variation (Segment (and SegmentInstance) should be processed as a Variation 

This is a variation created by the principal. It might be follow a proposal, or might be stand alone.)

7 = VariationProposal (Segment (and SegmentInstance) should be processed as a Variation Proposal 

This is the principal proposing a variation to the contractor and getting a response to the proposal)

8 = VariationRequest (Segment (and SegmentInstance) should be processed as a Variation Request 

This is the contractor requesting a variation from the principal) */
    segmentProcessType!: SegmentProcessType;
    /** The Short Name of the Segment parent of the Segment Instance associated with the Document */
    segmentShortName!: string;
    /** The Name of the Segment parent of the Segment Instance associated with the Document */
    segmentName!: string;
    /** The association type (See <seealso cref="T:OneTrack.Data.Enums.SegmentInstanceDocumentVersionAssociationType" /> enum)

0 = Originating (The document was the document that began the workflow)

1 = Supporting (The document is a supporting document for the workflow)

2 = Response (The document was a response to the workflow) */
    associationType!: SegmentInstanceDocumentVersionAssociationType;
    /** Whether this association is locked and can therefore never be removed or not. */
    isLocked!: boolean;
    /** The Index of the Version. 
 
A number that can be used to create the text "Version 4" for example. */
    documentVersionIndex!: number;
    /** Document Reference */
    documentVersionReference!: string;
    /** Document Name */
    documentVersionName!: string;
    /** Description of the content of the document */
    documentVersionContentDescription!: string | undefined;
    /** Document Date. The date the document was created. 

No time component */
    documentVersionDate!: Date | undefined;

    constructor(data?: IGetSearchDocumentsResponseSegmentInstanceDocumentAssociationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.availableActions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.associatedGid = _data["associatedGid"];
            this.associatedCode = _data["associatedCode"];
            this.associatedName = _data["associatedName"];
            if (Array.isArray(_data["availableActions"])) {
                this.availableActions = [] as any;
                for (let item of _data["availableActions"])
                    this.availableActions!.push(item);
            }
            this.createdDateUtc = _data["createdDateUtc"] ? new Date(_data["createdDateUtc"].toString()) : <any>undefined;
            this.segmentProcessType = _data["segmentProcessType"];
            this.segmentShortName = _data["segmentShortName"];
            this.segmentName = _data["segmentName"];
            this.associationType = _data["associationType"];
            this.isLocked = _data["isLocked"];
            this.documentVersionIndex = _data["documentVersionIndex"];
            this.documentVersionReference = _data["documentVersionReference"];
            this.documentVersionName = _data["documentVersionName"];
            this.documentVersionContentDescription = _data["documentVersionContentDescription"];
            this.documentVersionDate = _data["documentVersionDate"] ? new Date(_data["documentVersionDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSearchDocumentsResponseSegmentInstanceDocumentAssociationModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSearchDocumentsResponseSegmentInstanceDocumentAssociationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["associatedGid"] = this.associatedGid;
        data["associatedCode"] = this.associatedCode;
        data["associatedName"] = this.associatedName;
        if (Array.isArray(this.availableActions)) {
            data["availableActions"] = [];
            for (let item of this.availableActions)
                data["availableActions"].push(item);
        }
        data["createdDateUtc"] = this.createdDateUtc ? this.createdDateUtc.toISOString() : <any>undefined;
        data["segmentProcessType"] = this.segmentProcessType;
        data["segmentShortName"] = this.segmentShortName;
        data["segmentName"] = this.segmentName;
        data["associationType"] = this.associationType;
        data["isLocked"] = this.isLocked;
        data["documentVersionIndex"] = this.documentVersionIndex;
        data["documentVersionReference"] = this.documentVersionReference;
        data["documentVersionName"] = this.documentVersionName;
        data["documentVersionContentDescription"] = this.documentVersionContentDescription;
        data["documentVersionDate"] = this.documentVersionDate ? formatDate(this.documentVersionDate) : <any>undefined;
        return data;
    }
}

export interface IGetSearchDocumentsResponseSegmentInstanceDocumentAssociationModel {
    /** The Public Identifier (Gid) of the association with the Document (OrganisationDocument.Gid, ProjectDocument.Gid, ContractDocument.Gid, SegmentInstanceDocumentVersion.Gid) */
    gid: string;
    /** The Public Identifier (Gid) of the item (Organisation.Gid, Project.Gid, Contract.Gid, SegmentInstance.Gid) associated with the Document */
    associatedGid: string;
    /** The Code or Reference of the associated item (Organisation, Project, Contract, Segment Instance) associated with the Document */
    associatedCode: string;
    /** The Name of the associated item (Organisation, Project, Contract, but not Segment Instance because it doesn't have a Name) associated with the Document */
    associatedName: string | undefined;
    /** Distinct set of Actions the User can perform against the Document Association */
    availableActions: UserActions[];
    createdDateUtc: Date;
    /** The Segment Process Type of the Segment parent of the Segment Instance associated with the Document

1 = Notice (Segment (and SegmentInstance) should to be processed as a Notice)

2 = Claim (Segment (and SegmentInstance) should to be processed as a Claim)

3 = Direction (Segment (and SegmentInstance) should be processed as a Direction (note: post-mvp))

4 = RFIInbound (Segment (and SegmentInstance) should be processed as an RFI Inbound)

5 = RFIOutbound (Segment (and SegmentInstance) should be processed as an RFI Outbound)

6 = Variation (Segment (and SegmentInstance) should be processed as a Variation 

This is a variation created by the principal. It might be follow a proposal, or might be stand alone.)

7 = VariationProposal (Segment (and SegmentInstance) should be processed as a Variation Proposal 

This is the principal proposing a variation to the contractor and getting a response to the proposal)

8 = VariationRequest (Segment (and SegmentInstance) should be processed as a Variation Request 

This is the contractor requesting a variation from the principal) */
    segmentProcessType: SegmentProcessType;
    /** The Short Name of the Segment parent of the Segment Instance associated with the Document */
    segmentShortName: string;
    /** The Name of the Segment parent of the Segment Instance associated with the Document */
    segmentName: string;
    /** The association type (See <seealso cref="T:OneTrack.Data.Enums.SegmentInstanceDocumentVersionAssociationType" /> enum)

0 = Originating (The document was the document that began the workflow)

1 = Supporting (The document is a supporting document for the workflow)

2 = Response (The document was a response to the workflow) */
    associationType: SegmentInstanceDocumentVersionAssociationType;
    /** Whether this association is locked and can therefore never be removed or not. */
    isLocked: boolean;
    /** The Index of the Version. 
 
A number that can be used to create the text "Version 4" for example. */
    documentVersionIndex: number;
    /** Document Reference */
    documentVersionReference: string;
    /** Document Name */
    documentVersionName: string;
    /** Description of the content of the document */
    documentVersionContentDescription: string | undefined;
    /** Document Date. The date the document was created. 

No time component */
    documentVersionDate: Date | undefined;
}

export class PostCreateDocumentRequestModel implements IPostCreateDocumentRequestModel {
    /** Document Name */
    name!: string;
    /** Document Reference */
    reference!: string;
    /** Description of the content of the document */
    contentDescription?: string | undefined;
    /** Description of the document */
    description?: string | undefined;
    /** Document Date. The date the document was created. 

No time component */
    date?: Date | undefined;
    /** Now called Receipt Type in the UI

1 = AusPost (Australia Post)

2 = Courier (Courier)

3 = Email (Email)

4 = Aconex (Aconex)

5 = Fax (Fax)

6 = Other (Other) */
    receivalType?: DocumentReceivalType | undefined;
    /** Only defined if Receival Type is set to 'other' */
    receivalDescription?: string | undefined;
    /** The date and time the document was received in Utc format. */
    receivedUtc?: Date | undefined;
    /** Time zone 'Received Date Time' was supplied to the UI with. 

Required if 'Received Date Time' is set */
    receivedTimeZone?: string | undefined;
    /** The date and time the document was received in Utc format. */
    deemedReceivedUtc?: Date | undefined;
    /** Time zone 'Deemed Received Date Time' was supplied to the UI with. 

Required if 'Deemed Received Date Time' is set */
    deemedReceivedTimeZone?: string | undefined;
    /** Name of the person that sent the document */
    senderPerson?: string | undefined;
    /** Name of the organisation that sent the document */
    senderOrganisation?: string | undefined;
    /** Name of the person that received the document */
    recipientPerson?: string | undefined;
    /** Name of the organisation that received the document */
    recipientOrganisation?: string | undefined;
    /** Identifiers for Organisations to be associated with the Document */
    organisationAssociations!: string[];
    /** Identifiers for Projects to be associated with the Document */
    projectAssociations!: string[];
    /** Identifiers for Contracts to be associated with the Document */
    contractAssociations!: string[];
    /** Identifiers for <seealso cref="T:OneTrack.EFDatabase.App.Models.Documents.File">Table: File</seealso>s to be associated with the Document */
    filesToAdd!: string[];

    constructor(data?: IPostCreateDocumentRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.organisationAssociations = [];
            this.projectAssociations = [];
            this.contractAssociations = [];
            this.filesToAdd = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.reference = _data["reference"];
            this.contentDescription = _data["contentDescription"];
            this.description = _data["description"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.receivalType = _data["receivalType"];
            this.receivalDescription = _data["receivalDescription"];
            this.receivedUtc = _data["receivedUtc"] ? new Date(_data["receivedUtc"].toString()) : <any>undefined;
            this.receivedTimeZone = _data["receivedTimeZone"];
            this.deemedReceivedUtc = _data["deemedReceivedUtc"] ? new Date(_data["deemedReceivedUtc"].toString()) : <any>undefined;
            this.deemedReceivedTimeZone = _data["deemedReceivedTimeZone"];
            this.senderPerson = _data["senderPerson"];
            this.senderOrganisation = _data["senderOrganisation"];
            this.recipientPerson = _data["recipientPerson"];
            this.recipientOrganisation = _data["recipientOrganisation"];
            if (Array.isArray(_data["organisationAssociations"])) {
                this.organisationAssociations = [] as any;
                for (let item of _data["organisationAssociations"])
                    this.organisationAssociations!.push(item);
            }
            if (Array.isArray(_data["projectAssociations"])) {
                this.projectAssociations = [] as any;
                for (let item of _data["projectAssociations"])
                    this.projectAssociations!.push(item);
            }
            if (Array.isArray(_data["contractAssociations"])) {
                this.contractAssociations = [] as any;
                for (let item of _data["contractAssociations"])
                    this.contractAssociations!.push(item);
            }
            if (Array.isArray(_data["filesToAdd"])) {
                this.filesToAdd = [] as any;
                for (let item of _data["filesToAdd"])
                    this.filesToAdd!.push(item);
            }
        }
    }

    static fromJS(data: any): PostCreateDocumentRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostCreateDocumentRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["reference"] = this.reference;
        data["contentDescription"] = this.contentDescription;
        data["description"] = this.description;
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["receivalType"] = this.receivalType;
        data["receivalDescription"] = this.receivalDescription;
        data["receivedUtc"] = this.receivedUtc ? this.receivedUtc.toISOString() : <any>undefined;
        data["receivedTimeZone"] = this.receivedTimeZone;
        data["deemedReceivedUtc"] = this.deemedReceivedUtc ? this.deemedReceivedUtc.toISOString() : <any>undefined;
        data["deemedReceivedTimeZone"] = this.deemedReceivedTimeZone;
        data["senderPerson"] = this.senderPerson;
        data["senderOrganisation"] = this.senderOrganisation;
        data["recipientPerson"] = this.recipientPerson;
        data["recipientOrganisation"] = this.recipientOrganisation;
        if (Array.isArray(this.organisationAssociations)) {
            data["organisationAssociations"] = [];
            for (let item of this.organisationAssociations)
                data["organisationAssociations"].push(item);
        }
        if (Array.isArray(this.projectAssociations)) {
            data["projectAssociations"] = [];
            for (let item of this.projectAssociations)
                data["projectAssociations"].push(item);
        }
        if (Array.isArray(this.contractAssociations)) {
            data["contractAssociations"] = [];
            for (let item of this.contractAssociations)
                data["contractAssociations"].push(item);
        }
        if (Array.isArray(this.filesToAdd)) {
            data["filesToAdd"] = [];
            for (let item of this.filesToAdd)
                data["filesToAdd"].push(item);
        }
        return data;
    }
}

export interface IPostCreateDocumentRequestModel {
    /** Document Name */
    name: string;
    /** Document Reference */
    reference: string;
    /** Description of the content of the document */
    contentDescription?: string | undefined;
    /** Description of the document */
    description?: string | undefined;
    /** Document Date. The date the document was created. 

No time component */
    date?: Date | undefined;
    /** Now called Receipt Type in the UI

1 = AusPost (Australia Post)

2 = Courier (Courier)

3 = Email (Email)

4 = Aconex (Aconex)

5 = Fax (Fax)

6 = Other (Other) */
    receivalType?: DocumentReceivalType | undefined;
    /** Only defined if Receival Type is set to 'other' */
    receivalDescription?: string | undefined;
    /** The date and time the document was received in Utc format. */
    receivedUtc?: Date | undefined;
    /** Time zone 'Received Date Time' was supplied to the UI with. 

Required if 'Received Date Time' is set */
    receivedTimeZone?: string | undefined;
    /** The date and time the document was received in Utc format. */
    deemedReceivedUtc?: Date | undefined;
    /** Time zone 'Deemed Received Date Time' was supplied to the UI with. 

Required if 'Deemed Received Date Time' is set */
    deemedReceivedTimeZone?: string | undefined;
    /** Name of the person that sent the document */
    senderPerson?: string | undefined;
    /** Name of the organisation that sent the document */
    senderOrganisation?: string | undefined;
    /** Name of the person that received the document */
    recipientPerson?: string | undefined;
    /** Name of the organisation that received the document */
    recipientOrganisation?: string | undefined;
    /** Identifiers for Organisations to be associated with the Document */
    organisationAssociations: string[];
    /** Identifiers for Projects to be associated with the Document */
    projectAssociations: string[];
    /** Identifiers for Contracts to be associated with the Document */
    contractAssociations: string[];
    /** Identifiers for <seealso cref="T:OneTrack.EFDatabase.App.Models.Documents.File">Table: File</seealso>s to be associated with the Document */
    filesToAdd: string[];
}

export class PostCreateDocumentResponseModel implements IPostCreateDocumentResponseModel {
    /** Public Identifier for newly created Document */
    documentGid!: string;
    /** Public Identifier for newly created Document Version */
    documentVersionGid!: string;

    constructor(data?: IPostCreateDocumentResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentGid = _data["documentGid"];
            this.documentVersionGid = _data["documentVersionGid"];
        }
    }

    static fromJS(data: any): PostCreateDocumentResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostCreateDocumentResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentGid"] = this.documentGid;
        data["documentVersionGid"] = this.documentVersionGid;
        return data;
    }
}

export interface IPostCreateDocumentResponseModel {
    /** Public Identifier for newly created Document */
    documentGid: string;
    /** Public Identifier for newly created Document Version */
    documentVersionGid: string;
}

export class PostUpdateDocumentAssociationsRequestModel implements IPostUpdateDocumentAssociationsRequestModel {
    /** Identifiers for Organisations to be associated with the Document */
    addOrganisationAssociations!: string[];
    /** Identifiers for Projects to be associated with the Document */
    addProjectAssociations!: string[];
    /** Identifiers for Contracts to be associated with the Document */
    addContractAssociations!: string[];
    /** Identifiers for Organisations to be disassociated with the Document */
    removeOrganisationAssociations!: string[];
    /** Identifiers for Projects to be disassociated with the Document */
    removeProjectAssociations!: string[];
    /** Identifiers for Contracts to be disassociated with the Document */
    removeContractAssociations!: string[];

    constructor(data?: IPostUpdateDocumentAssociationsRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.addOrganisationAssociations = [];
            this.addProjectAssociations = [];
            this.addContractAssociations = [];
            this.removeOrganisationAssociations = [];
            this.removeProjectAssociations = [];
            this.removeContractAssociations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["addOrganisationAssociations"])) {
                this.addOrganisationAssociations = [] as any;
                for (let item of _data["addOrganisationAssociations"])
                    this.addOrganisationAssociations!.push(item);
            }
            if (Array.isArray(_data["addProjectAssociations"])) {
                this.addProjectAssociations = [] as any;
                for (let item of _data["addProjectAssociations"])
                    this.addProjectAssociations!.push(item);
            }
            if (Array.isArray(_data["addContractAssociations"])) {
                this.addContractAssociations = [] as any;
                for (let item of _data["addContractAssociations"])
                    this.addContractAssociations!.push(item);
            }
            if (Array.isArray(_data["removeOrganisationAssociations"])) {
                this.removeOrganisationAssociations = [] as any;
                for (let item of _data["removeOrganisationAssociations"])
                    this.removeOrganisationAssociations!.push(item);
            }
            if (Array.isArray(_data["removeProjectAssociations"])) {
                this.removeProjectAssociations = [] as any;
                for (let item of _data["removeProjectAssociations"])
                    this.removeProjectAssociations!.push(item);
            }
            if (Array.isArray(_data["removeContractAssociations"])) {
                this.removeContractAssociations = [] as any;
                for (let item of _data["removeContractAssociations"])
                    this.removeContractAssociations!.push(item);
            }
        }
    }

    static fromJS(data: any): PostUpdateDocumentAssociationsRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostUpdateDocumentAssociationsRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.addOrganisationAssociations)) {
            data["addOrganisationAssociations"] = [];
            for (let item of this.addOrganisationAssociations)
                data["addOrganisationAssociations"].push(item);
        }
        if (Array.isArray(this.addProjectAssociations)) {
            data["addProjectAssociations"] = [];
            for (let item of this.addProjectAssociations)
                data["addProjectAssociations"].push(item);
        }
        if (Array.isArray(this.addContractAssociations)) {
            data["addContractAssociations"] = [];
            for (let item of this.addContractAssociations)
                data["addContractAssociations"].push(item);
        }
        if (Array.isArray(this.removeOrganisationAssociations)) {
            data["removeOrganisationAssociations"] = [];
            for (let item of this.removeOrganisationAssociations)
                data["removeOrganisationAssociations"].push(item);
        }
        if (Array.isArray(this.removeProjectAssociations)) {
            data["removeProjectAssociations"] = [];
            for (let item of this.removeProjectAssociations)
                data["removeProjectAssociations"].push(item);
        }
        if (Array.isArray(this.removeContractAssociations)) {
            data["removeContractAssociations"] = [];
            for (let item of this.removeContractAssociations)
                data["removeContractAssociations"].push(item);
        }
        return data;
    }
}

export interface IPostUpdateDocumentAssociationsRequestModel {
    /** Identifiers for Organisations to be associated with the Document */
    addOrganisationAssociations: string[];
    /** Identifiers for Projects to be associated with the Document */
    addProjectAssociations: string[];
    /** Identifiers for Contracts to be associated with the Document */
    addContractAssociations: string[];
    /** Identifiers for Organisations to be disassociated with the Document */
    removeOrganisationAssociations: string[];
    /** Identifiers for Projects to be disassociated with the Document */
    removeProjectAssociations: string[];
    /** Identifiers for Contracts to be disassociated with the Document */
    removeContractAssociations: string[];
}

export class PostUpdateDocumentRequestModel implements IPostUpdateDocumentRequestModel {
    /** Document Name */
    name!: string;
    /** Document Reference */
    reference!: string;
    /** Description of the content of the document */
    contentDescription?: string | undefined;
    /** Description of the document */
    description?: string | undefined;
    date?: Date | undefined;
    /** Now called Receipt Type in the UI

1 = AusPost (Australia Post)

2 = Courier (Courier)

3 = Email (Email)

4 = Aconex (Aconex)

5 = Fax (Fax)

6 = Other (Other) */
    receivalType?: DocumentReceivalType | undefined;
    /** Only defined if Receival Type is set to 'other' */
    receivalDescription?: string | undefined;
    /** The date and time the document was received in Utc format. */
    receivedUtc?: Date | undefined;
    /** Time zone 'Received Date Time' was supplied to the UI with.
Required if 'Received Date Time' is set */
    receivedTimeZone?: string | undefined;
    /** The date and time the document was received in Utc format. */
    deemedReceivedUtc?: Date | undefined;
    /** Time zone 'Deemed Received Date Time' was supplied to the UI with.
Required if 'Deemed Received Date Time' is set */
    deemedReceivedTimeZone?: string | undefined;
    /** Name of the person that sent the document */
    senderPerson?: string | undefined;
    /** Name of the organisation that sent the document */
    senderOrganisation?: string | undefined;
    /** Name of the person that received the document */
    recipientPerson?: string | undefined;
    /** Name of the organisation that received the document */
    recipientOrganisation?: string | undefined;
    /** Identifiers for Table: Files to be associated with the Document */
    filesToAdd?: string[] | undefined;
    /** An array of public file identifiers that are to have their associations with the Document removed */
    filesToRemove?: string[] | undefined;
    /** Should the latest Aconex Version be downloaded and used as part of the new Document Version. 

Only valid for Documents sourced from an Aconex Document, does not apply to Aconex Mail */
    updateToLatestAconexDocumentVersion?: boolean | undefined;

    constructor(data?: IPostUpdateDocumentRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.reference = _data["reference"];
            this.contentDescription = _data["contentDescription"];
            this.description = _data["description"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.receivalType = _data["receivalType"];
            this.receivalDescription = _data["receivalDescription"];
            this.receivedUtc = _data["receivedUtc"] ? new Date(_data["receivedUtc"].toString()) : <any>undefined;
            this.receivedTimeZone = _data["receivedTimeZone"];
            this.deemedReceivedUtc = _data["deemedReceivedUtc"] ? new Date(_data["deemedReceivedUtc"].toString()) : <any>undefined;
            this.deemedReceivedTimeZone = _data["deemedReceivedTimeZone"];
            this.senderPerson = _data["senderPerson"];
            this.senderOrganisation = _data["senderOrganisation"];
            this.recipientPerson = _data["recipientPerson"];
            this.recipientOrganisation = _data["recipientOrganisation"];
            if (Array.isArray(_data["filesToAdd"])) {
                this.filesToAdd = [] as any;
                for (let item of _data["filesToAdd"])
                    this.filesToAdd!.push(item);
            }
            if (Array.isArray(_data["filesToRemove"])) {
                this.filesToRemove = [] as any;
                for (let item of _data["filesToRemove"])
                    this.filesToRemove!.push(item);
            }
            this.updateToLatestAconexDocumentVersion = _data["updateToLatestAconexDocumentVersion"];
        }
    }

    static fromJS(data: any): PostUpdateDocumentRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostUpdateDocumentRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["reference"] = this.reference;
        data["contentDescription"] = this.contentDescription;
        data["description"] = this.description;
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["receivalType"] = this.receivalType;
        data["receivalDescription"] = this.receivalDescription;
        data["receivedUtc"] = this.receivedUtc ? this.receivedUtc.toISOString() : <any>undefined;
        data["receivedTimeZone"] = this.receivedTimeZone;
        data["deemedReceivedUtc"] = this.deemedReceivedUtc ? this.deemedReceivedUtc.toISOString() : <any>undefined;
        data["deemedReceivedTimeZone"] = this.deemedReceivedTimeZone;
        data["senderPerson"] = this.senderPerson;
        data["senderOrganisation"] = this.senderOrganisation;
        data["recipientPerson"] = this.recipientPerson;
        data["recipientOrganisation"] = this.recipientOrganisation;
        if (Array.isArray(this.filesToAdd)) {
            data["filesToAdd"] = [];
            for (let item of this.filesToAdd)
                data["filesToAdd"].push(item);
        }
        if (Array.isArray(this.filesToRemove)) {
            data["filesToRemove"] = [];
            for (let item of this.filesToRemove)
                data["filesToRemove"].push(item);
        }
        data["updateToLatestAconexDocumentVersion"] = this.updateToLatestAconexDocumentVersion;
        return data;
    }
}

export interface IPostUpdateDocumentRequestModel {
    /** Document Name */
    name: string;
    /** Document Reference */
    reference: string;
    /** Description of the content of the document */
    contentDescription?: string | undefined;
    /** Description of the document */
    description?: string | undefined;
    date?: Date | undefined;
    /** Now called Receipt Type in the UI

1 = AusPost (Australia Post)

2 = Courier (Courier)

3 = Email (Email)

4 = Aconex (Aconex)

5 = Fax (Fax)

6 = Other (Other) */
    receivalType?: DocumentReceivalType | undefined;
    /** Only defined if Receival Type is set to 'other' */
    receivalDescription?: string | undefined;
    /** The date and time the document was received in Utc format. */
    receivedUtc?: Date | undefined;
    /** Time zone 'Received Date Time' was supplied to the UI with.
Required if 'Received Date Time' is set */
    receivedTimeZone?: string | undefined;
    /** The date and time the document was received in Utc format. */
    deemedReceivedUtc?: Date | undefined;
    /** Time zone 'Deemed Received Date Time' was supplied to the UI with.
Required if 'Deemed Received Date Time' is set */
    deemedReceivedTimeZone?: string | undefined;
    /** Name of the person that sent the document */
    senderPerson?: string | undefined;
    /** Name of the organisation that sent the document */
    senderOrganisation?: string | undefined;
    /** Name of the person that received the document */
    recipientPerson?: string | undefined;
    /** Name of the organisation that received the document */
    recipientOrganisation?: string | undefined;
    /** Identifiers for Table: Files to be associated with the Document */
    filesToAdd?: string[] | undefined;
    /** An array of public file identifiers that are to have their associations with the Document removed */
    filesToRemove?: string[] | undefined;
    /** Should the latest Aconex Version be downloaded and used as part of the new Document Version. 

Only valid for Documents sourced from an Aconex Document, does not apply to Aconex Mail */
    updateToLatestAconexDocumentVersion?: boolean | undefined;
}

export class PostUpdateDocumentResponseModel implements IPostUpdateDocumentResponseModel {
    /** Public Identifier for newly created Document */
    documentGid!: string;
    /** Public Identifier for newly created Document Version */
    documentVersionGid!: string;

    constructor(data?: IPostUpdateDocumentResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentGid = _data["documentGid"];
            this.documentVersionGid = _data["documentVersionGid"];
        }
    }

    static fromJS(data: any): PostUpdateDocumentResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostUpdateDocumentResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentGid"] = this.documentGid;
        data["documentVersionGid"] = this.documentVersionGid;
        return data;
    }
}

export interface IPostUpdateDocumentResponseModel {
    /** Public Identifier for newly created Document */
    documentGid: string;
    /** Public Identifier for newly created Document Version */
    documentVersionGid: string;
}

export class PostUploadFileResponseModel implements IPostUploadFileResponseModel {
    /** Public Identifier for newly created File */
    gid!: string;

    constructor(data?: IPostUploadFileResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
        }
    }

    static fromJS(data: any): PostUploadFileResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostUploadFileResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        return data;
    }
}

export interface IPostUploadFileResponseModel {
    /** Public Identifier for newly created File */
    gid: string;
}

export class GetInvitableContractsResponseModel implements IGetInvitableContractsResponseModel {
    gid?: string;
    projectCode?: string | undefined;
    projectName?: string | undefined;
    reference?: string | undefined;
    name?: string | undefined;
    /** User Status Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2615377921/User+Status+With+Actions+object" /> */
    userStatus?: UserStatusWithActionsModel | undefined;

    constructor(data?: IGetInvitableContractsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.projectCode = _data["projectCode"];
            this.projectName = _data["projectName"];
            this.reference = _data["reference"];
            this.name = _data["name"];
            this.userStatus = _data["userStatus"] ? UserStatusWithActionsModel.fromJS(_data["userStatus"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetInvitableContractsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetInvitableContractsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["projectCode"] = this.projectCode;
        data["projectName"] = this.projectName;
        data["reference"] = this.reference;
        data["name"] = this.name;
        data["userStatus"] = this.userStatus ? this.userStatus.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetInvitableContractsResponseModel {
    gid?: string;
    projectCode?: string | undefined;
    projectName?: string | undefined;
    reference?: string | undefined;
    name?: string | undefined;
    /** User Status Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2615377921/User+Status+With+Actions+object" /> */
    userStatus?: UserStatusWithActionsModel | undefined;
}

export class GetInvitableOrganisationsResponseModel implements IGetInvitableOrganisationsResponseModel {
    gid?: string;
    code?: string | undefined;
    name?: string | undefined;
    /** User Status Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2615377921/User+Status+With+Actions+object" /> */
    userStatus?: UserStatusWithActionsModel | undefined;

    constructor(data?: IGetInvitableOrganisationsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.userStatus = _data["userStatus"] ? UserStatusWithActionsModel.fromJS(_data["userStatus"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetInvitableOrganisationsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetInvitableOrganisationsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["code"] = this.code;
        data["name"] = this.name;
        data["userStatus"] = this.userStatus ? this.userStatus.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetInvitableOrganisationsResponseModel {
    gid?: string;
    code?: string | undefined;
    name?: string | undefined;
    /** User Status Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2615377921/User+Status+With+Actions+object" /> */
    userStatus?: UserStatusWithActionsModel | undefined;
}

export class GetInvitableProjectsResponseModel implements IGetInvitableProjectsResponseModel {
    gid?: string;
    code?: string | undefined;
    name?: string | undefined;
    /** User Status Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2615377921/User+Status+With+Actions+object" /> */
    userStatus?: UserStatusWithActionsModel | undefined;

    constructor(data?: IGetInvitableProjectsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.userStatus = _data["userStatus"] ? UserStatusWithActionsModel.fromJS(_data["userStatus"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetInvitableProjectsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetInvitableProjectsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["code"] = this.code;
        data["name"] = this.name;
        data["userStatus"] = this.userStatus ? this.userStatus.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetInvitableProjectsResponseModel {
    gid?: string;
    code?: string | undefined;
    name?: string | undefined;
    /** User Status Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2615377921/User+Status+With+Actions+object" /> */
    userStatus?: UserStatusWithActionsModel | undefined;
}

export class GetInvitableUsersResponseModel implements IGetInvitableUsersResponseModel {
    gid!: string;
    firstName!: string;
    lastName!: string;
    email!: string;

    constructor(data?: IGetInvitableUsersResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): GetInvitableUsersResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetInvitableUsersResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        return data;
    }
}

export interface IGetInvitableUsersResponseModel {
    gid: string;
    firstName: string;
    lastName: string;
    email: string;
}

export class GetInvitationDetailsInvitationComponentModel implements IGetInvitationDetailsInvitationComponentModel {
    /** The public identifier for the Table: Organisation User Invitation, Table: Project User Invitation or Table: Contract User Invitation */
    gid!: string;
    /** The ‘Organisation Job Title’ or ‘Project Functional Role Title’ or ‘Contract Functional Role Title’ the recipient will have if they accept the invitation */
    title!: string;
    /** The Code (or Reference) of the Organisation, Project or Contract this invitation sub component is for */
    code!: string;
    /** The Name of the Organisation, Project or Contract this invitation sub component is for */
    name!: string;

    constructor(data?: IGetInvitationDetailsInvitationComponentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.title = _data["title"];
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetInvitationDetailsInvitationComponentModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetInvitationDetailsInvitationComponentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["title"] = this.title;
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetInvitationDetailsInvitationComponentModel {
    /** The public identifier for the Table: Organisation User Invitation, Table: Project User Invitation or Table: Contract User Invitation */
    gid: string;
    /** The ‘Organisation Job Title’ or ‘Project Functional Role Title’ or ‘Contract Functional Role Title’ the recipient will have if they accept the invitation */
    title: string;
    /** The Code (or Reference) of the Organisation, Project or Contract this invitation sub component is for */
    code: string;
    /** The Name of the Organisation, Project or Contract this invitation sub component is for */
    name: string;
}

export class GetInvitationDetailsResponseModel implements IGetInvitationDetailsResponseModel {
    /** Public Identifier of Invitation */
    gid!: string;
    /** User that created the Invitation First Name */
    inviterFirstName!: string;
    /** User that created the Invitation Last Name */
    inviterLastName!: string;
    /** Invitation Recipient’s First Name */
    recipientFirstName!: string;
    /** Invitation Recipient’s Last Name */
    recipientLastName!: string;
    /** User that created the Invitation Email Address. */
    inviterEmail!: string;
    /** Invitation Recipient’s Email Address. Can be used by the IDP to identify existing user. */
    recipientEmail!: string;
    /** Code of the Organisation that all the components of the Invitation will be for (probably not needed) */
    organisationCode!: string;
    /** Name of the Organisation that all the components of the Invitation will be for */
    organisationName!: string;
    /** Date and Time in UTC that the Invitation was completed. Null if not completed. */
    completedDateUtc?: Date | undefined;
    /** Information about Organisations the Recipient was invited to and whether they accept or reject that part of the invitation. 

This set must match the Invitation set in the DB. */
    organisations!: GetInvitationDetailsInvitationComponentModel[];
    /** Information about Projects the Recipient was invited to and whether they accept or reject that part of the invitation. 

This set must match the Invitation set in the DB. */
    projects!: GetInvitationDetailsInvitationComponentModel[];
    /** Information about Contracts the Recipient was invited to and whether they accept or reject that part of the invitation. 

This set must match the Invitation set in the DB. */
    contracts!: GetInvitationDetailsInvitationComponentModel[];

    constructor(data?: IGetInvitationDetailsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.organisations = [];
            this.projects = [];
            this.contracts = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.inviterFirstName = _data["inviterFirstName"];
            this.inviterLastName = _data["inviterLastName"];
            this.recipientFirstName = _data["recipientFirstName"];
            this.recipientLastName = _data["recipientLastName"];
            this.inviterEmail = _data["inviterEmail"];
            this.recipientEmail = _data["recipientEmail"];
            this.organisationCode = _data["organisationCode"];
            this.organisationName = _data["organisationName"];
            this.completedDateUtc = _data["completedDateUtc"] ? new Date(_data["completedDateUtc"].toString()) : <any>undefined;
            if (Array.isArray(_data["organisations"])) {
                this.organisations = [] as any;
                for (let item of _data["organisations"])
                    this.organisations!.push(GetInvitationDetailsInvitationComponentModel.fromJS(item));
            }
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(GetInvitationDetailsInvitationComponentModel.fromJS(item));
            }
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(GetInvitationDetailsInvitationComponentModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetInvitationDetailsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetInvitationDetailsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["inviterFirstName"] = this.inviterFirstName;
        data["inviterLastName"] = this.inviterLastName;
        data["recipientFirstName"] = this.recipientFirstName;
        data["recipientLastName"] = this.recipientLastName;
        data["inviterEmail"] = this.inviterEmail;
        data["recipientEmail"] = this.recipientEmail;
        data["organisationCode"] = this.organisationCode;
        data["organisationName"] = this.organisationName;
        data["completedDateUtc"] = this.completedDateUtc ? this.completedDateUtc.toISOString() : <any>undefined;
        if (Array.isArray(this.organisations)) {
            data["organisations"] = [];
            for (let item of this.organisations)
                data["organisations"].push(item.toJSON());
        }
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetInvitationDetailsResponseModel {
    /** Public Identifier of Invitation */
    gid: string;
    /** User that created the Invitation First Name */
    inviterFirstName: string;
    /** User that created the Invitation Last Name */
    inviterLastName: string;
    /** Invitation Recipient’s First Name */
    recipientFirstName: string;
    /** Invitation Recipient’s Last Name */
    recipientLastName: string;
    /** User that created the Invitation Email Address. */
    inviterEmail: string;
    /** Invitation Recipient’s Email Address. Can be used by the IDP to identify existing user. */
    recipientEmail: string;
    /** Code of the Organisation that all the components of the Invitation will be for (probably not needed) */
    organisationCode: string;
    /** Name of the Organisation that all the components of the Invitation will be for */
    organisationName: string;
    /** Date and Time in UTC that the Invitation was completed. Null if not completed. */
    completedDateUtc?: Date | undefined;
    /** Information about Organisations the Recipient was invited to and whether they accept or reject that part of the invitation. 

This set must match the Invitation set in the DB. */
    organisations: GetInvitationDetailsInvitationComponentModel[];
    /** Information about Projects the Recipient was invited to and whether they accept or reject that part of the invitation. 

This set must match the Invitation set in the DB. */
    projects: GetInvitationDetailsInvitationComponentModel[];
    /** Information about Contracts the Recipient was invited to and whether they accept or reject that part of the invitation. 

This set must match the Invitation set in the DB. */
    contracts: GetInvitationDetailsInvitationComponentModel[];
}

export class PostAcceptInvitationRequestModel implements IPostAcceptInvitationRequestModel {
    /** Information about Organisations the Recipient was invited to and whether they accept or reject that part of the invitation. 
 
This set must match the Invitation set in the DB. */
    organisations!: PostAcceptInvitationUserContextModel[];
    /** Information about Projects the Recipient was invited to and whether they accept or reject that part of the invitation. 
 
This set must match the Invitation set in the DB. */
    projects!: PostAcceptInvitationUserContextModel[];
    /** Information about Contracts the Recipient was invited to and whether they accept or reject that part of the invitation. 
 
This set must match the Invitation set in the DB. */
    contracts!: PostAcceptInvitationUserContextModel[];

    constructor(data?: IPostAcceptInvitationRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.organisations = [];
            this.projects = [];
            this.contracts = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["organisations"])) {
                this.organisations = [] as any;
                for (let item of _data["organisations"])
                    this.organisations!.push(PostAcceptInvitationUserContextModel.fromJS(item));
            }
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(PostAcceptInvitationUserContextModel.fromJS(item));
            }
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(PostAcceptInvitationUserContextModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PostAcceptInvitationRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostAcceptInvitationRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.organisations)) {
            data["organisations"] = [];
            for (let item of this.organisations)
                data["organisations"].push(item.toJSON());
        }
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPostAcceptInvitationRequestModel {
    /** Information about Organisations the Recipient was invited to and whether they accept or reject that part of the invitation. 
 
This set must match the Invitation set in the DB. */
    organisations: PostAcceptInvitationUserContextModel[];
    /** Information about Projects the Recipient was invited to and whether they accept or reject that part of the invitation. 
 
This set must match the Invitation set in the DB. */
    projects: PostAcceptInvitationUserContextModel[];
    /** Information about Contracts the Recipient was invited to and whether they accept or reject that part of the invitation. 
 
This set must match the Invitation set in the DB. */
    contracts: PostAcceptInvitationUserContextModel[];
}

export class PostAcceptInvitationUserContextModel implements IPostAcceptInvitationUserContextModel {
    /** The public identifier for the Table: Organisation User Invitation, Table: Project User Invitation or Table: Contract User Invitation */
    gid!: string;
    /** Indicates that the user has accepted this section of the Invitation */
    accepted!: boolean;

    constructor(data?: IPostAcceptInvitationUserContextModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.accepted = _data["accepted"];
        }
    }

    static fromJS(data: any): PostAcceptInvitationUserContextModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostAcceptInvitationUserContextModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["accepted"] = this.accepted;
        return data;
    }
}

export interface IPostAcceptInvitationUserContextModel {
    /** The public identifier for the Table: Organisation User Invitation, Table: Project User Invitation or Table: Contract User Invitation */
    gid: string;
    /** Indicates that the user has accepted this section of the Invitation */
    accepted: boolean;
}

export class PostCreateInvitationRequestModel implements IPostCreateInvitationRequestModel {
    /** Invitation Recipient’s Email Address */
    email!: string;
    /** Invitation Recipient’s First Name */
    firstName!: string;
    /** Invitation Recipient’s Last Name */
    lastName!: string;
    /** Organisations the Recipient will be invited to */
    organisations!: PostCreateInvitationUserContextModel[];
    /** Projects the Recipient will be invited to */
    projects!: PostCreateInvitationUserContextModel[];
    /** Contracts the Recipient will be invited to */
    contracts!: PostCreateInvitationUserContextModel[];

    constructor(data?: IPostCreateInvitationRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.organisations = [];
            this.projects = [];
            this.contracts = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            if (Array.isArray(_data["organisations"])) {
                this.organisations = [] as any;
                for (let item of _data["organisations"])
                    this.organisations!.push(PostCreateInvitationUserContextModel.fromJS(item));
            }
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(PostCreateInvitationUserContextModel.fromJS(item));
            }
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(PostCreateInvitationUserContextModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PostCreateInvitationRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostCreateInvitationRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        if (Array.isArray(this.organisations)) {
            data["organisations"] = [];
            for (let item of this.organisations)
                data["organisations"].push(item.toJSON());
        }
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPostCreateInvitationRequestModel {
    /** Invitation Recipient’s Email Address */
    email: string;
    /** Invitation Recipient’s First Name */
    firstName: string;
    /** Invitation Recipient’s Last Name */
    lastName: string;
    /** Organisations the Recipient will be invited to */
    organisations: PostCreateInvitationUserContextModel[];
    /** Projects the Recipient will be invited to */
    projects: PostCreateInvitationUserContextModel[];
    /** Contracts the Recipient will be invited to */
    contracts: PostCreateInvitationUserContextModel[];
}

export class PostCreateInvitationUserContextModel implements IPostCreateInvitationUserContextModel {
    /** Public Identifier for the Organisation, Project or Contract that the recipient is being invited to. */
    parentGid!: string;
    /** The ‘Organisation Job Title’ or ‘Project Functional Role Title’ or ‘Contract Functional Role Title’ the recipient will have if they accept the invitation */
    title!: string;

    constructor(data?: IPostCreateInvitationUserContextModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentGid = _data["parentGid"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): PostCreateInvitationUserContextModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostCreateInvitationUserContextModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentGid"] = this.parentGid;
        data["title"] = this.title;
        return data;
    }
}

export interface IPostCreateInvitationUserContextModel {
    /** Public Identifier for the Organisation, Project or Contract that the recipient is being invited to. */
    parentGid: string;
    /** The ‘Organisation Job Title’ or ‘Project Functional Role Title’ or ‘Contract Functional Role Title’ the recipient will have if they accept the invitation */
    title: string;
}

export class GetOrganisationCalendarsCalendarModel implements IGetOrganisationCalendarsCalendarModel {
    calendarGid?: string;
    calendarName?: string | undefined;
    /** [Calendar Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Well+Known+Enums#Calendar-Status)

            Status types calendars can use

1 = Active (Calendar is active)

2 = Inactive (Calendar is inactive) */
    calendarStatus?: CalendarStatus;
    hasParent?: boolean;

    constructor(data?: IGetOrganisationCalendarsCalendarModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.calendarGid = _data["calendarGid"];
            this.calendarName = _data["calendarName"];
            this.calendarStatus = _data["calendarStatus"];
            this.hasParent = _data["hasParent"];
        }
    }

    static fromJS(data: any): GetOrganisationCalendarsCalendarModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrganisationCalendarsCalendarModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calendarGid"] = this.calendarGid;
        data["calendarName"] = this.calendarName;
        data["calendarStatus"] = this.calendarStatus;
        data["hasParent"] = this.hasParent;
        return data;
    }
}

export interface IGetOrganisationCalendarsCalendarModel {
    calendarGid?: string;
    calendarName?: string | undefined;
    /** [Calendar Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Well+Known+Enums#Calendar-Status)

            Status types calendars can use

1 = Active (Calendar is active)

2 = Inactive (Calendar is inactive) */
    calendarStatus?: CalendarStatus;
    hasParent?: boolean;
}

export class GetOrganisationCalendarsResponseModel implements IGetOrganisationCalendarsResponseModel {
    calendars?: GetOrganisationCalendarsCalendarModel[] | undefined;

    constructor(data?: IGetOrganisationCalendarsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["calendars"])) {
                this.calendars = [] as any;
                for (let item of _data["calendars"])
                    this.calendars!.push(GetOrganisationCalendarsCalendarModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetOrganisationCalendarsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrganisationCalendarsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.calendars)) {
            data["calendars"] = [];
            for (let item of this.calendars)
                data["calendars"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetOrganisationCalendarsResponseModel {
    calendars?: GetOrganisationCalendarsCalendarModel[] | undefined;
}

export class GetOrganisationDetailsResponseModel implements IGetOrganisationDetailsResponseModel {
    gid!: string;
    name!: string;
    code!: string;
    abn!: string;
    acn?: string | undefined;
    arbn?: string | undefined;
    /** Address Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2577727514/Address+Object" /> */
    streetAddress!: AddressModel;
    /** Address Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2577727514/Address+Object" /> */
    postalAddress!: AddressModel;
    /** [Organisation Type](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Organisation-Type)

            Type that an Organisation can be

1 = NotSet (A more specific organisation type has not been set)

2 = Principal (The organisation is active)

3 = HeadContractor (Head Contractor)

4 = ProjectManager (Project Manager)

5 = Subcontractor (Subcontractor)

6 = DevelopmentManagementConsultancy (Development Management Consultancy) */
    organisationType!: OrganisationType;
    /** [Organisation Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Well+Known+Enums#Organisation-Status)

            Status types organisations can use

1 = Active (The organisation is active)

2 = Pending (The organisation is pending)

3 = Suspended (The organisation has been suspended)

4 = Inactive (The organisation is inactive) */
    organisationStatus!: OrganisationStatus;
    contactName!: string;
    contactJobTitle?: string | undefined;
    contactMobile!: string;
    contactPhone?: string | undefined;
    contactEmail!: string;
    contactFax?: string | undefined;
    phone!: string;
    fax?: string | undefined;
    email!: string;
    /** Mostly used for defaulting timezones for Projects, which are inturn used to defauly Timezones for Contracts */
    timezone!: string;
    activeUserCount!: number;

    constructor(data?: IGetOrganisationDetailsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.streetAddress = new AddressModel();
            this.postalAddress = new AddressModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.abn = _data["abn"];
            this.acn = _data["acn"];
            this.arbn = _data["arbn"];
            this.streetAddress = _data["streetAddress"] ? AddressModel.fromJS(_data["streetAddress"]) : new AddressModel();
            this.postalAddress = _data["postalAddress"] ? AddressModel.fromJS(_data["postalAddress"]) : new AddressModel();
            this.organisationType = _data["organisationType"];
            this.organisationStatus = _data["organisationStatus"];
            this.contactName = _data["contactName"];
            this.contactJobTitle = _data["contactJobTitle"];
            this.contactMobile = _data["contactMobile"];
            this.contactPhone = _data["contactPhone"];
            this.contactEmail = _data["contactEmail"];
            this.contactFax = _data["contactFax"];
            this.phone = _data["phone"];
            this.fax = _data["fax"];
            this.email = _data["email"];
            this.timezone = _data["timezone"];
            this.activeUserCount = _data["activeUserCount"];
        }
    }

    static fromJS(data: any): GetOrganisationDetailsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrganisationDetailsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["name"] = this.name;
        data["code"] = this.code;
        data["abn"] = this.abn;
        data["acn"] = this.acn;
        data["arbn"] = this.arbn;
        data["streetAddress"] = this.streetAddress ? this.streetAddress.toJSON() : <any>undefined;
        data["postalAddress"] = this.postalAddress ? this.postalAddress.toJSON() : <any>undefined;
        data["organisationType"] = this.organisationType;
        data["organisationStatus"] = this.organisationStatus;
        data["contactName"] = this.contactName;
        data["contactJobTitle"] = this.contactJobTitle;
        data["contactMobile"] = this.contactMobile;
        data["contactPhone"] = this.contactPhone;
        data["contactEmail"] = this.contactEmail;
        data["contactFax"] = this.contactFax;
        data["phone"] = this.phone;
        data["fax"] = this.fax;
        data["email"] = this.email;
        data["timezone"] = this.timezone;
        data["activeUserCount"] = this.activeUserCount;
        return data;
    }
}

export interface IGetOrganisationDetailsResponseModel {
    gid: string;
    name: string;
    code: string;
    abn: string;
    acn?: string | undefined;
    arbn?: string | undefined;
    /** Address Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2577727514/Address+Object" /> */
    streetAddress: AddressModel;
    /** Address Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2577727514/Address+Object" /> */
    postalAddress: AddressModel;
    /** [Organisation Type](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Organisation-Type)

            Type that an Organisation can be

1 = NotSet (A more specific organisation type has not been set)

2 = Principal (The organisation is active)

3 = HeadContractor (Head Contractor)

4 = ProjectManager (Project Manager)

5 = Subcontractor (Subcontractor)

6 = DevelopmentManagementConsultancy (Development Management Consultancy) */
    organisationType: OrganisationType;
    /** [Organisation Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Well+Known+Enums#Organisation-Status)

            Status types organisations can use

1 = Active (The organisation is active)

2 = Pending (The organisation is pending)

3 = Suspended (The organisation has been suspended)

4 = Inactive (The organisation is inactive) */
    organisationStatus: OrganisationStatus;
    contactName: string;
    contactJobTitle?: string | undefined;
    contactMobile: string;
    contactPhone?: string | undefined;
    contactEmail: string;
    contactFax?: string | undefined;
    phone: string;
    fax?: string | undefined;
    email: string;
    /** Mostly used for defaulting timezones for Projects, which are inturn used to defauly Timezones for Contracts */
    timezone: string;
    activeUserCount: number;
}

export class GetOrganisationUserContractsContractModel implements IGetOrganisationUserContractsContractModel {
    /** Contract Public Identifier */
    gid!: string;
    /** Contract Reference */
    reference!: string;
    /** Contract Name */
    name!: string;
    /** Contract Status

1 = Active (Contract is active, at this point settings can’t be edited)

2 = Pending (Partway through setup or in pending mode where configuration can be edited)

3 = Terminated (Post MVP)

4 = PracticalCompletion (Post MVP)

5 = FinalCompletion (Post MVP)

6 = Suspended (Post MVP)

7 = Draft (Contract is still in wizard phase)

8 = Cancelled (Post MVP) */
    status!: ContractStatus;
    /** Parent Project's Organisation Public Identifier */
    organisationGid!: string;
    /** Parent Project Public Identifier */
    projectGid!: string;
    /** Parent Project Code */
    projectCode!: string;
    /** Parent Project Name */
    projectName!: string;
    /** Parent Project Status

1 = Active (Project is active)

2 = Pending (Project is pending)

3 = Suspended (Project is suspended)

4 = Complete (Project is complete) */
    projectStatus!: ProjectStatus;
    /** Supplied User’s Organisation User Status info for the Organisation that has the Project */
    organisationUser?: UserStatusModel | undefined;
    /** Supplied User’s Project User Status info for the Project that has the Contract */
    projectUser?: UserStatusModel | undefined;
    /** Supplied User’s Contract User Status info for the Contract */
    contractUser?: UserStatusModel | undefined;
    /** Current User’s Organisation User Status info for the Organisation that has the Project */
    currentUserOrganisationUser?: UserStatusModel | undefined;
    /** Current User’s Project User Status info for the Project that has the Contract */
    currentUserProjectUser?: UserStatusModel | undefined;
    /** Current User’s Contract User Status info for the Contract */
    currentUserContractUser?: UserStatusModel | undefined;

    constructor(data?: IGetOrganisationUserContractsContractModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.reference = _data["reference"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.organisationGid = _data["organisationGid"];
            this.projectGid = _data["projectGid"];
            this.projectCode = _data["projectCode"];
            this.projectName = _data["projectName"];
            this.projectStatus = _data["projectStatus"];
            this.organisationUser = _data["organisationUser"] ? UserStatusModel.fromJS(_data["organisationUser"]) : <any>undefined;
            this.projectUser = _data["projectUser"] ? UserStatusModel.fromJS(_data["projectUser"]) : <any>undefined;
            this.contractUser = _data["contractUser"] ? UserStatusModel.fromJS(_data["contractUser"]) : <any>undefined;
            this.currentUserOrganisationUser = _data["currentUserOrganisationUser"] ? UserStatusModel.fromJS(_data["currentUserOrganisationUser"]) : <any>undefined;
            this.currentUserProjectUser = _data["currentUserProjectUser"] ? UserStatusModel.fromJS(_data["currentUserProjectUser"]) : <any>undefined;
            this.currentUserContractUser = _data["currentUserContractUser"] ? UserStatusModel.fromJS(_data["currentUserContractUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOrganisationUserContractsContractModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrganisationUserContractsContractModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["reference"] = this.reference;
        data["name"] = this.name;
        data["status"] = this.status;
        data["organisationGid"] = this.organisationGid;
        data["projectGid"] = this.projectGid;
        data["projectCode"] = this.projectCode;
        data["projectName"] = this.projectName;
        data["projectStatus"] = this.projectStatus;
        data["organisationUser"] = this.organisationUser ? this.organisationUser.toJSON() : <any>undefined;
        data["projectUser"] = this.projectUser ? this.projectUser.toJSON() : <any>undefined;
        data["contractUser"] = this.contractUser ? this.contractUser.toJSON() : <any>undefined;
        data["currentUserOrganisationUser"] = this.currentUserOrganisationUser ? this.currentUserOrganisationUser.toJSON() : <any>undefined;
        data["currentUserProjectUser"] = this.currentUserProjectUser ? this.currentUserProjectUser.toJSON() : <any>undefined;
        data["currentUserContractUser"] = this.currentUserContractUser ? this.currentUserContractUser.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetOrganisationUserContractsContractModel {
    /** Contract Public Identifier */
    gid: string;
    /** Contract Reference */
    reference: string;
    /** Contract Name */
    name: string;
    /** Contract Status

1 = Active (Contract is active, at this point settings can’t be edited)

2 = Pending (Partway through setup or in pending mode where configuration can be edited)

3 = Terminated (Post MVP)

4 = PracticalCompletion (Post MVP)

5 = FinalCompletion (Post MVP)

6 = Suspended (Post MVP)

7 = Draft (Contract is still in wizard phase)

8 = Cancelled (Post MVP) */
    status: ContractStatus;
    /** Parent Project's Organisation Public Identifier */
    organisationGid: string;
    /** Parent Project Public Identifier */
    projectGid: string;
    /** Parent Project Code */
    projectCode: string;
    /** Parent Project Name */
    projectName: string;
    /** Parent Project Status

1 = Active (Project is active)

2 = Pending (Project is pending)

3 = Suspended (Project is suspended)

4 = Complete (Project is complete) */
    projectStatus: ProjectStatus;
    /** Supplied User’s Organisation User Status info for the Organisation that has the Project */
    organisationUser?: UserStatusModel | undefined;
    /** Supplied User’s Project User Status info for the Project that has the Contract */
    projectUser?: UserStatusModel | undefined;
    /** Supplied User’s Contract User Status info for the Contract */
    contractUser?: UserStatusModel | undefined;
    /** Current User’s Organisation User Status info for the Organisation that has the Project */
    currentUserOrganisationUser?: UserStatusModel | undefined;
    /** Current User’s Project User Status info for the Project that has the Contract */
    currentUserProjectUser?: UserStatusModel | undefined;
    /** Current User’s Contract User Status info for the Contract */
    currentUserContractUser?: UserStatusModel | undefined;
}

export class GetOrganisationUserContractsResponseModel implements IGetOrganisationUserContractsResponseModel {
    contracts!: GetOrganisationUserContractsContractModel[];

    constructor(data?: IGetOrganisationUserContractsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.contracts = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(GetOrganisationUserContractsContractModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetOrganisationUserContractsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrganisationUserContractsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetOrganisationUserContractsResponseModel {
    contracts: GetOrganisationUserContractsContractModel[];
}

export class GetOrganisationUserDetailsResponseModel implements IGetOrganisationUserDetailsResponseModel {
    /** Public identifier for user */
    gid!: string;
    /** First Name of the User */
    firstName!: string;
    /** Last Name of the User */
    lastName!: string;
    /** Business Name of the User */
    businessName?: string | undefined;
    /** Email of the User */
    email!: string;
    /** Address Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2577727514/Address+Object" /> */
    streetAddress?: AddressModel | undefined;
    /** Address Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2577727514/Address+Object" /> */
    postalAddress?: AddressModel | undefined;
    mobile?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    /** OrganisationUser Status and Available Actions. 

This property will be null if the provided User is not an OrganisationUser for the provided Organisation. 

This can happen if the user is visible to the current user but not an OrganisationUser for the Organisation. */
    organisationUserStatus?: UserStatusWithActionsModel | undefined;
    /** Object with last modification information in it */
    lastModified!: LastModifiedModel;
    /** Can be legitimately null when a new user is invited and has never logged in before */
    lastLoginUtc?: Date | undefined;
    /** Can be legitimately null when a new user is invited and has never logged in before */
    lastLoginIpAddress?: string | undefined;
    /** Public identifier for the organisation */
    organisationGid!: string;
    /** Name of the Organisation */
    organisationName!: string;

    constructor(data?: IGetOrganisationUserDetailsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.lastModified = new LastModifiedModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.businessName = _data["businessName"];
            this.email = _data["email"];
            this.streetAddress = _data["streetAddress"] ? AddressModel.fromJS(_data["streetAddress"]) : <any>undefined;
            this.postalAddress = _data["postalAddress"] ? AddressModel.fromJS(_data["postalAddress"]) : <any>undefined;
            this.mobile = _data["mobile"];
            this.phone = _data["phone"];
            this.fax = _data["fax"];
            this.organisationUserStatus = _data["organisationUserStatus"] ? UserStatusWithActionsModel.fromJS(_data["organisationUserStatus"]) : <any>undefined;
            this.lastModified = _data["lastModified"] ? LastModifiedModel.fromJS(_data["lastModified"]) : new LastModifiedModel();
            this.lastLoginUtc = _data["lastLoginUtc"] ? new Date(_data["lastLoginUtc"].toString()) : <any>undefined;
            this.lastLoginIpAddress = _data["lastLoginIpAddress"];
            this.organisationGid = _data["organisationGid"];
            this.organisationName = _data["organisationName"];
        }
    }

    static fromJS(data: any): GetOrganisationUserDetailsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrganisationUserDetailsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["businessName"] = this.businessName;
        data["email"] = this.email;
        data["streetAddress"] = this.streetAddress ? this.streetAddress.toJSON() : <any>undefined;
        data["postalAddress"] = this.postalAddress ? this.postalAddress.toJSON() : <any>undefined;
        data["mobile"] = this.mobile;
        data["phone"] = this.phone;
        data["fax"] = this.fax;
        data["organisationUserStatus"] = this.organisationUserStatus ? this.organisationUserStatus.toJSON() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toJSON() : <any>undefined;
        data["lastLoginUtc"] = this.lastLoginUtc ? this.lastLoginUtc.toISOString() : <any>undefined;
        data["lastLoginIpAddress"] = this.lastLoginIpAddress;
        data["organisationGid"] = this.organisationGid;
        data["organisationName"] = this.organisationName;
        return data;
    }
}

export interface IGetOrganisationUserDetailsResponseModel {
    /** Public identifier for user */
    gid: string;
    /** First Name of the User */
    firstName: string;
    /** Last Name of the User */
    lastName: string;
    /** Business Name of the User */
    businessName?: string | undefined;
    /** Email of the User */
    email: string;
    /** Address Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2577727514/Address+Object" /> */
    streetAddress?: AddressModel | undefined;
    /** Address Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2577727514/Address+Object" /> */
    postalAddress?: AddressModel | undefined;
    mobile?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    /** OrganisationUser Status and Available Actions. 

This property will be null if the provided User is not an OrganisationUser for the provided Organisation. 

This can happen if the user is visible to the current user but not an OrganisationUser for the Organisation. */
    organisationUserStatus?: UserStatusWithActionsModel | undefined;
    /** Object with last modification information in it */
    lastModified: LastModifiedModel;
    /** Can be legitimately null when a new user is invited and has never logged in before */
    lastLoginUtc?: Date | undefined;
    /** Can be legitimately null when a new user is invited and has never logged in before */
    lastLoginIpAddress?: string | undefined;
    /** Public identifier for the organisation */
    organisationGid: string;
    /** Name of the Organisation */
    organisationName: string;
}

export class GetOrganisationUserProjectsContractModel implements IGetOrganisationUserProjectsContractModel {
    gid!: string;
    name!: string;
    /** [Contract Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Contract-Status)

            Status types contracts can use

1 = Active (Contract is active, at this point settings can’t be edited)

2 = Pending (Partway through setup or in pending mode where configuration can be edited)

3 = Terminated (Post MVP)

4 = PracticalCompletion (Post MVP)

5 = FinalCompletion (Post MVP)

6 = Suspended (Post MVP)

7 = Draft (Contract is still in wizard phase)

8 = Cancelled (Post MVP) */
    status!: ContractStatus;
    /** User Status Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2588213249/User+Status+object" /> */
    contractUser?: UserStatusModel | undefined;
    /** User Status Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2588213249/User+Status+object" /> */
    currentUserContractUser?: UserStatusModel | undefined;

    constructor(data?: IGetOrganisationUserProjectsContractModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.contractUser = _data["contractUser"] ? UserStatusModel.fromJS(_data["contractUser"]) : <any>undefined;
            this.currentUserContractUser = _data["currentUserContractUser"] ? UserStatusModel.fromJS(_data["currentUserContractUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOrganisationUserProjectsContractModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrganisationUserProjectsContractModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["name"] = this.name;
        data["status"] = this.status;
        data["contractUser"] = this.contractUser ? this.contractUser.toJSON() : <any>undefined;
        data["currentUserContractUser"] = this.currentUserContractUser ? this.currentUserContractUser.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetOrganisationUserProjectsContractModel {
    gid: string;
    name: string;
    /** [Contract Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Contract-Status)

            Status types contracts can use

1 = Active (Contract is active, at this point settings can’t be edited)

2 = Pending (Partway through setup or in pending mode where configuration can be edited)

3 = Terminated (Post MVP)

4 = PracticalCompletion (Post MVP)

5 = FinalCompletion (Post MVP)

6 = Suspended (Post MVP)

7 = Draft (Contract is still in wizard phase)

8 = Cancelled (Post MVP) */
    status: ContractStatus;
    /** User Status Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2588213249/User+Status+object" /> */
    contractUser?: UserStatusModel | undefined;
    /** User Status Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2588213249/User+Status+object" /> */
    currentUserContractUser?: UserStatusModel | undefined;
}

export class GetOrganisationUserProjectsProjectModel implements IGetOrganisationUserProjectsProjectModel {
    gid!: string;
    code!: string;
    name!: string;
    /** [Project Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Project-Status)

            Status types projects can use

1 = Active (Project is active)

2 = Pending (Project is pending)

3 = Suspended (Project is suspended)

4 = Complete (Project is complete) */
    status!: ProjectStatus;
    contracts!: GetOrganisationUserProjectsContractModel[];
    /** User Status Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2588213249/User+Status+object" /> */
    organisationUser?: UserStatusModel | undefined;
    /** User Status Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2588213249/User+Status+object" /> */
    projectUser?: UserStatusModel | undefined;
    /** User Status Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2588213249/User+Status+object" /> */
    currentUserOrganisationUser?: UserStatusModel | undefined;
    /** User Status Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2588213249/User+Status+object" /> */
    currentUserProjectUser?: UserStatusModel | undefined;

    constructor(data?: IGetOrganisationUserProjectsProjectModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.contracts = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.status = _data["status"];
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(GetOrganisationUserProjectsContractModel.fromJS(item));
            }
            this.organisationUser = _data["organisationUser"] ? UserStatusModel.fromJS(_data["organisationUser"]) : <any>undefined;
            this.projectUser = _data["projectUser"] ? UserStatusModel.fromJS(_data["projectUser"]) : <any>undefined;
            this.currentUserOrganisationUser = _data["currentUserOrganisationUser"] ? UserStatusModel.fromJS(_data["currentUserOrganisationUser"]) : <any>undefined;
            this.currentUserProjectUser = _data["currentUserProjectUser"] ? UserStatusModel.fromJS(_data["currentUserProjectUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOrganisationUserProjectsProjectModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrganisationUserProjectsProjectModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["code"] = this.code;
        data["name"] = this.name;
        data["status"] = this.status;
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item.toJSON());
        }
        data["organisationUser"] = this.organisationUser ? this.organisationUser.toJSON() : <any>undefined;
        data["projectUser"] = this.projectUser ? this.projectUser.toJSON() : <any>undefined;
        data["currentUserOrganisationUser"] = this.currentUserOrganisationUser ? this.currentUserOrganisationUser.toJSON() : <any>undefined;
        data["currentUserProjectUser"] = this.currentUserProjectUser ? this.currentUserProjectUser.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetOrganisationUserProjectsProjectModel {
    gid: string;
    code: string;
    name: string;
    /** [Project Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Project-Status)

            Status types projects can use

1 = Active (Project is active)

2 = Pending (Project is pending)

3 = Suspended (Project is suspended)

4 = Complete (Project is complete) */
    status: ProjectStatus;
    contracts: GetOrganisationUserProjectsContractModel[];
    /** User Status Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2588213249/User+Status+object" /> */
    organisationUser?: UserStatusModel | undefined;
    /** User Status Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2588213249/User+Status+object" /> */
    projectUser?: UserStatusModel | undefined;
    /** User Status Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2588213249/User+Status+object" /> */
    currentUserOrganisationUser?: UserStatusModel | undefined;
    /** User Status Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2588213249/User+Status+object" /> */
    currentUserProjectUser?: UserStatusModel | undefined;
}

export class GetOrganisationUserProjectsResponseModel implements IGetOrganisationUserProjectsResponseModel {
    projects!: GetOrganisationUserProjectsProjectModel[];

    constructor(data?: IGetOrganisationUserProjectsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.projects = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(GetOrganisationUserProjectsProjectModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetOrganisationUserProjectsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrganisationUserProjectsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetOrganisationUserProjectsResponseModel {
    projects: GetOrganisationUserProjectsProjectModel[];
}

export class GetOrganisationUsersResponseModel implements IGetOrganisationUsersResponseModel {
    users!: UserInformationModel[];

    constructor(data?: IGetOrganisationUsersResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.users = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserInformationModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetOrganisationUsersResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrganisationUsersResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetOrganisationUsersResponseModel {
    users: UserInformationModel[];
}

export class GetProjectTypesResponseModel implements IGetProjectTypesResponseModel {
    projectTypes!: ProjectTypeModel[];

    constructor(data?: IGetProjectTypesResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.projectTypes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["projectTypes"])) {
                this.projectTypes = [] as any;
                for (let item of _data["projectTypes"])
                    this.projectTypes!.push(ProjectTypeModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProjectTypesResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectTypesResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projectTypes)) {
            data["projectTypes"] = [];
            for (let item of this.projectTypes)
                data["projectTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetProjectTypesResponseModel {
    projectTypes: ProjectTypeModel[];
}

export class PostUpdateOrganisationDetailsRequestModel implements IPostUpdateOrganisationDetailsRequestModel {
    name!: string;
    code!: string;
    abn!: string;
    acn?: string | undefined;
    arbn?: string | undefined;
    /** Address Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2577727514/Address+Object" /> */
    streetAddress!: AddressModel;
    /** Address Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2577727514/Address+Object" /> */
    postalAddress!: AddressModel;
    /** [Organisation Type](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Organisation-Type)

            Type that an Organisation can be

1 = NotSet (A more specific organisation type has not been set)

2 = Principal (The organisation is active)

3 = HeadContractor (Head Contractor)

4 = ProjectManager (Project Manager)

5 = Subcontractor (Subcontractor)

6 = DevelopmentManagementConsultancy (Development Management Consultancy) */
    organisationType!: OrganisationType;
    contactName!: string;
    contactJobTitle?: string | undefined;
    contactMobile!: string;
    contactPhone?: string | undefined;
    contactEmail!: string;
    contactFax?: string | undefined;
    phone!: string;
    fax?: string | undefined;
    email!: string;
    /** Mostly used for defaulting timezones for Projects, which are inturn used to defauly Timezones for Contracts */
    timezone?: string | undefined;

    constructor(data?: IPostUpdateOrganisationDetailsRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.streetAddress = new AddressModel();
            this.postalAddress = new AddressModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.abn = _data["abn"];
            this.acn = _data["acn"];
            this.arbn = _data["arbn"];
            this.streetAddress = _data["streetAddress"] ? AddressModel.fromJS(_data["streetAddress"]) : new AddressModel();
            this.postalAddress = _data["postalAddress"] ? AddressModel.fromJS(_data["postalAddress"]) : new AddressModel();
            this.organisationType = _data["organisationType"];
            this.contactName = _data["contactName"];
            this.contactJobTitle = _data["contactJobTitle"];
            this.contactMobile = _data["contactMobile"];
            this.contactPhone = _data["contactPhone"];
            this.contactEmail = _data["contactEmail"];
            this.contactFax = _data["contactFax"];
            this.phone = _data["phone"];
            this.fax = _data["fax"];
            this.email = _data["email"];
            this.timezone = _data["timezone"];
        }
    }

    static fromJS(data: any): PostUpdateOrganisationDetailsRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostUpdateOrganisationDetailsRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["abn"] = this.abn;
        data["acn"] = this.acn;
        data["arbn"] = this.arbn;
        data["streetAddress"] = this.streetAddress ? this.streetAddress.toJSON() : <any>undefined;
        data["postalAddress"] = this.postalAddress ? this.postalAddress.toJSON() : <any>undefined;
        data["organisationType"] = this.organisationType;
        data["contactName"] = this.contactName;
        data["contactJobTitle"] = this.contactJobTitle;
        data["contactMobile"] = this.contactMobile;
        data["contactPhone"] = this.contactPhone;
        data["contactEmail"] = this.contactEmail;
        data["contactFax"] = this.contactFax;
        data["phone"] = this.phone;
        data["fax"] = this.fax;
        data["email"] = this.email;
        data["timezone"] = this.timezone;
        return data;
    }
}

export interface IPostUpdateOrganisationDetailsRequestModel {
    name: string;
    code: string;
    abn: string;
    acn?: string | undefined;
    arbn?: string | undefined;
    /** Address Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2577727514/Address+Object" /> */
    streetAddress: AddressModel;
    /** Address Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2577727514/Address+Object" /> */
    postalAddress: AddressModel;
    /** [Organisation Type](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Organisation-Type)

            Type that an Organisation can be

1 = NotSet (A more specific organisation type has not been set)

2 = Principal (The organisation is active)

3 = HeadContractor (Head Contractor)

4 = ProjectManager (Project Manager)

5 = Subcontractor (Subcontractor)

6 = DevelopmentManagementConsultancy (Development Management Consultancy) */
    organisationType: OrganisationType;
    contactName: string;
    contactJobTitle?: string | undefined;
    contactMobile: string;
    contactPhone?: string | undefined;
    contactEmail: string;
    contactFax?: string | undefined;
    phone: string;
    fax?: string | undefined;
    email: string;
    /** Mostly used for defaulting timezones for Projects, which are inturn used to defauly Timezones for Contracts */
    timezone?: string | undefined;
}

export class ProjectTypeModel implements IProjectTypeModel {
    gid!: string;
    name!: string;

    constructor(data?: IProjectTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ProjectTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["name"] = this.name;
        return data;
    }
}

export interface IProjectTypeModel {
    gid: string;
    name: string;
}

export class UserInformationModel implements IUserInformationModel {
    gid!: string;
    firstName!: string;
    lastName!: string;
    email!: string;
    organisations!: UserStatusWithActionsModel[];
    projects!: UserStatusWithActionsModel[];
    contracts!: UserStatusWithActionsModel[];

    constructor(data?: IUserInformationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.organisations = [];
            this.projects = [];
            this.contracts = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            if (Array.isArray(_data["organisations"])) {
                this.organisations = [] as any;
                for (let item of _data["organisations"])
                    this.organisations!.push(UserStatusWithActionsModel.fromJS(item));
            }
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(UserStatusWithActionsModel.fromJS(item));
            }
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(UserStatusWithActionsModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserInformationModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserInformationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        if (Array.isArray(this.organisations)) {
            data["organisations"] = [];
            for (let item of this.organisations)
                data["organisations"].push(item.toJSON());
        }
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserInformationModel {
    gid: string;
    firstName: string;
    lastName: string;
    email: string;
    organisations: UserStatusWithActionsModel[];
    projects: UserStatusWithActionsModel[];
    contracts: UserStatusWithActionsModel[];
}

export class PostSetOrganisationUserStatusUserStatusModel implements IPostSetOrganisationUserStatusUserStatusModel {
    gid!: string;
    /** [Organisation User Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Well+Known+Enums#Organisation-User-Status)

            Status types users can use

1 = Active (Organisation/Project/Contract User is active)

2 = Invited (Organisation/Project/Contract User is Invited)

3 = RejectedInvitation (Organisation/Project/Contract User has Rejected Invitation)

4 = Inactive (Organisation/Project/Contract User is Inactive) */
    status!: OrganisationUserStatus;

    constructor(data?: IPostSetOrganisationUserStatusUserStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): PostSetOrganisationUserStatusUserStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostSetOrganisationUserStatusUserStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["status"] = this.status;
        return data;
    }
}

export interface IPostSetOrganisationUserStatusUserStatusModel {
    gid: string;
    /** [Organisation User Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Well+Known+Enums#Organisation-User-Status)

            Status types users can use

1 = Active (Organisation/Project/Contract User is active)

2 = Invited (Organisation/Project/Contract User is Invited)

3 = RejectedInvitation (Organisation/Project/Contract User has Rejected Invitation)

4 = Inactive (Organisation/Project/Contract User is Inactive) */
    status: OrganisationUserStatus;
}

export class PostUpdateOrganisationUserDetailsRequestModel implements IPostUpdateOrganisationUserDetailsRequestModel {
    jobTitle!: string;

    constructor(data?: IPostUpdateOrganisationUserDetailsRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobTitle = _data["jobTitle"];
        }
    }

    static fromJS(data: any): PostUpdateOrganisationUserDetailsRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostUpdateOrganisationUserDetailsRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobTitle"] = this.jobTitle;
        return data;
    }
}

export interface IPostUpdateOrganisationUserDetailsRequestModel {
    jobTitle: string;
}

export class PostSetProjectUserStatusUserStatusModel implements IPostSetProjectUserStatusUserStatusModel {
    gid!: string;
    /** [Organisation User Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Well+Known+Enums#Organisation-User-Status)

            Status types users can use

1 = Active (Organisation/Project/Contract User is active)

2 = Invited (Organisation/Project/Contract User is Invited)

3 = RejectedInvitation (Organisation/Project/Contract User has Rejected Invitation)

4 = Inactive (Organisation/Project/Contract User is Inactive) */
    status!: OrganisationUserStatus;

    constructor(data?: IPostSetProjectUserStatusUserStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): PostSetProjectUserStatusUserStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostSetProjectUserStatusUserStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["status"] = this.status;
        return data;
    }
}

export interface IPostSetProjectUserStatusUserStatusModel {
    gid: string;
    /** [Organisation User Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Well+Known+Enums#Organisation-User-Status)

            Status types users can use

1 = Active (Organisation/Project/Contract User is active)

2 = Invited (Organisation/Project/Contract User is Invited)

3 = RejectedInvitation (Organisation/Project/Contract User has Rejected Invitation)

4 = Inactive (Organisation/Project/Contract User is Inactive) */
    status: OrganisationUserStatus;
}

export class PostUpdateProjectUserDetailsModel implements IPostUpdateProjectUserDetailsModel {
    functionalRoleTitle!: string;

    constructor(data?: IPostUpdateProjectUserDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.functionalRoleTitle = _data["functionalRoleTitle"];
        }
    }

    static fromJS(data: any): PostUpdateProjectUserDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostUpdateProjectUserDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["functionalRoleTitle"] = this.functionalRoleTitle;
        return data;
    }
}

export interface IPostUpdateProjectUserDetailsModel {
    functionalRoleTitle: string;
}

export class ContractModel implements IContractModel {
    gid!: string;
    reference!: string;
    name!: string;
    /** [Contract Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Contract-Status)

            Status types contracts can use

1 = Active (Contract is active, at this point settings can’t be edited)

2 = Pending (Partway through setup or in pending mode where configuration can be edited)

3 = Terminated (Post MVP)

4 = PracticalCompletion (Post MVP)

5 = FinalCompletion (Post MVP)

6 = Suspended (Post MVP)

7 = Draft (Contract is still in wizard phase)

8 = Cancelled (Post MVP) */
    status!: ContractStatus;
    organisationGid!: string;
    projectGid!: string;
    projectCode!: string;
    projectName!: string;
    /** [Project Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Project-Status)

            Status types projects can use

1 = Active (Project is active)

2 = Pending (Project is pending)

3 = Suspended (Project is suspended)

4 = Complete (Project is complete) */
    projectStatus!: ProjectStatus;
    organisations!: UserStatusWithActionsModel[];
    projects!: UserStatusWithActionsModel[];
    contracts!: UserStatusWithActionsModel[];

    constructor(data?: IContractModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.organisations = [];
            this.projects = [];
            this.contracts = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.reference = _data["reference"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.organisationGid = _data["organisationGid"];
            this.projectGid = _data["projectGid"];
            this.projectCode = _data["projectCode"];
            this.projectName = _data["projectName"];
            this.projectStatus = _data["projectStatus"];
            if (Array.isArray(_data["organisations"])) {
                this.organisations = [] as any;
                for (let item of _data["organisations"])
                    this.organisations!.push(UserStatusWithActionsModel.fromJS(item));
            }
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(UserStatusWithActionsModel.fromJS(item));
            }
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(UserStatusWithActionsModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContractModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContractModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["reference"] = this.reference;
        data["name"] = this.name;
        data["status"] = this.status;
        data["organisationGid"] = this.organisationGid;
        data["projectGid"] = this.projectGid;
        data["projectCode"] = this.projectCode;
        data["projectName"] = this.projectName;
        data["projectStatus"] = this.projectStatus;
        if (Array.isArray(this.organisations)) {
            data["organisations"] = [];
            for (let item of this.organisations)
                data["organisations"].push(item.toJSON());
        }
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IContractModel {
    gid: string;
    reference: string;
    name: string;
    /** [Contract Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Contract-Status)

            Status types contracts can use

1 = Active (Contract is active, at this point settings can’t be edited)

2 = Pending (Partway through setup or in pending mode where configuration can be edited)

3 = Terminated (Post MVP)

4 = PracticalCompletion (Post MVP)

5 = FinalCompletion (Post MVP)

6 = Suspended (Post MVP)

7 = Draft (Contract is still in wizard phase)

8 = Cancelled (Post MVP) */
    status: ContractStatus;
    organisationGid: string;
    projectGid: string;
    projectCode: string;
    projectName: string;
    /** [Project Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Project-Status)

            Status types projects can use

1 = Active (Project is active)

2 = Pending (Project is pending)

3 = Suspended (Project is suspended)

4 = Complete (Project is complete) */
    projectStatus: ProjectStatus;
    organisations: UserStatusWithActionsModel[];
    projects: UserStatusWithActionsModel[];
    contracts: UserStatusWithActionsModel[];
}

export class GetProjectDetailsResponseModel implements IGetProjectDetailsResponseModel {
    /** The projects Gid */
    gid!: string;
    /** Public Identifier for the Organisation that the Project belongs to */
    organisationGid!: string;
    /** The name of the Organisation the project belongs to */
    organisationName!: string;
    /** The projects name */
    name!: string;
    /** The projects code */
    code!: string;
    /** The projects description */
    description!: string;
    /** The projects Status

1 = Active (Project is active)

2 = Pending (Project is pending)

3 = Suspended (Project is suspended)

4 = Complete (Project is complete) */
    status!: ProjectStatus;
    /** Public Identifier for the Project Type */
    projectTypeGid!: string;
    /** The projects type */
    projectTypeName!: string;
    /** The address of the project */
    address!: AddressModel;
    /** The organisation name of the project owner */
    ownerOrganisationName!: string;
    /** The name of the project owner */
    ownerName!: string;
    /** The job title of the project owner */
    ownerJobTitle?: string | undefined;
    /** The mobile of the project owner */
    ownerMobile!: string;
    /** The phone of the project owner */
    ownerPhone?: string | undefined;
    /** The email of the project owner */
    ownerEmail!: string;
    /** The fax of the project owner */
    ownerFax?: string | undefined;
    /** The organisation name of the project manager */
    managerOrganisationName!: string;
    /** The name of the project manager */
    managerName!: string;
    /** The job title of the project manager */
    managerJobTitle?: string | undefined;
    /** The mobile of the project manager */
    managerMobile!: string;
    /** The phone of the project manager */
    managerPhone?: string | undefined;
    /** The email of the project manager */
    managerEmail!: string;
    /** The fax of the project manager */
    managerFax?: string | undefined;
    /** The budget amount of the project */
    budgetAmount!: number;
    /** The cost contingency of the project */
    costContingency?: number | undefined;
    /** The end date of the project */
    projectEndDate!: string;
    /** The adjusted project completion date of the project */
    adjustedProjectCompletionDate!: string;
    /** The time contingency in days for the project */
    timeContingencyDays?: number | undefined;
    /** Used for defaulting timezone for contracts */
    timezone!: string;
    /** The total active user count for the project */
    totalActiveUserCount!: number;
    /** Current User’s Organisation User Status info for the Organisation of the Project */
    organisationUser?: UserStatusModel | undefined;
    /** Current User’s Project User Status info for the Project */
    projectUser?: UserStatusModel | undefined;
    /** Current User’s Contract User Status info for contracts of the Project */
    contractUsers!: UserStatusModel[];

    constructor(data?: IGetProjectDetailsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.address = new AddressModel();
            this.contractUsers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.organisationGid = _data["organisationGid"];
            this.organisationName = _data["organisationName"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.projectTypeGid = _data["projectTypeGid"];
            this.projectTypeName = _data["projectTypeName"];
            this.address = _data["address"] ? AddressModel.fromJS(_data["address"]) : new AddressModel();
            this.ownerOrganisationName = _data["ownerOrganisationName"];
            this.ownerName = _data["ownerName"];
            this.ownerJobTitle = _data["ownerJobTitle"];
            this.ownerMobile = _data["ownerMobile"];
            this.ownerPhone = _data["ownerPhone"];
            this.ownerEmail = _data["ownerEmail"];
            this.ownerFax = _data["ownerFax"];
            this.managerOrganisationName = _data["managerOrganisationName"];
            this.managerName = _data["managerName"];
            this.managerJobTitle = _data["managerJobTitle"];
            this.managerMobile = _data["managerMobile"];
            this.managerPhone = _data["managerPhone"];
            this.managerEmail = _data["managerEmail"];
            this.managerFax = _data["managerFax"];
            this.budgetAmount = _data["budgetAmount"];
            this.costContingency = _data["costContingency"];
            this.projectEndDate = _data["projectEndDate"];
            this.adjustedProjectCompletionDate = _data["adjustedProjectCompletionDate"];
            this.timeContingencyDays = _data["timeContingencyDays"];
            this.timezone = _data["timezone"];
            this.totalActiveUserCount = _data["totalActiveUserCount"];
            this.organisationUser = _data["organisationUser"] ? UserStatusModel.fromJS(_data["organisationUser"]) : <any>undefined;
            this.projectUser = _data["projectUser"] ? UserStatusModel.fromJS(_data["projectUser"]) : <any>undefined;
            if (Array.isArray(_data["contractUsers"])) {
                this.contractUsers = [] as any;
                for (let item of _data["contractUsers"])
                    this.contractUsers!.push(UserStatusModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProjectDetailsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectDetailsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["organisationGid"] = this.organisationGid;
        data["organisationName"] = this.organisationName;
        data["name"] = this.name;
        data["code"] = this.code;
        data["description"] = this.description;
        data["status"] = this.status;
        data["projectTypeGid"] = this.projectTypeGid;
        data["projectTypeName"] = this.projectTypeName;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["ownerOrganisationName"] = this.ownerOrganisationName;
        data["ownerName"] = this.ownerName;
        data["ownerJobTitle"] = this.ownerJobTitle;
        data["ownerMobile"] = this.ownerMobile;
        data["ownerPhone"] = this.ownerPhone;
        data["ownerEmail"] = this.ownerEmail;
        data["ownerFax"] = this.ownerFax;
        data["managerOrganisationName"] = this.managerOrganisationName;
        data["managerName"] = this.managerName;
        data["managerJobTitle"] = this.managerJobTitle;
        data["managerMobile"] = this.managerMobile;
        data["managerPhone"] = this.managerPhone;
        data["managerEmail"] = this.managerEmail;
        data["managerFax"] = this.managerFax;
        data["budgetAmount"] = this.budgetAmount;
        data["costContingency"] = this.costContingency;
        data["projectEndDate"] = this.projectEndDate;
        data["adjustedProjectCompletionDate"] = this.adjustedProjectCompletionDate;
        data["timeContingencyDays"] = this.timeContingencyDays;
        data["timezone"] = this.timezone;
        data["totalActiveUserCount"] = this.totalActiveUserCount;
        data["organisationUser"] = this.organisationUser ? this.organisationUser.toJSON() : <any>undefined;
        data["projectUser"] = this.projectUser ? this.projectUser.toJSON() : <any>undefined;
        if (Array.isArray(this.contractUsers)) {
            data["contractUsers"] = [];
            for (let item of this.contractUsers)
                data["contractUsers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetProjectDetailsResponseModel {
    /** The projects Gid */
    gid: string;
    /** Public Identifier for the Organisation that the Project belongs to */
    organisationGid: string;
    /** The name of the Organisation the project belongs to */
    organisationName: string;
    /** The projects name */
    name: string;
    /** The projects code */
    code: string;
    /** The projects description */
    description: string;
    /** The projects Status

1 = Active (Project is active)

2 = Pending (Project is pending)

3 = Suspended (Project is suspended)

4 = Complete (Project is complete) */
    status: ProjectStatus;
    /** Public Identifier for the Project Type */
    projectTypeGid: string;
    /** The projects type */
    projectTypeName: string;
    /** The address of the project */
    address: AddressModel;
    /** The organisation name of the project owner */
    ownerOrganisationName: string;
    /** The name of the project owner */
    ownerName: string;
    /** The job title of the project owner */
    ownerJobTitle?: string | undefined;
    /** The mobile of the project owner */
    ownerMobile: string;
    /** The phone of the project owner */
    ownerPhone?: string | undefined;
    /** The email of the project owner */
    ownerEmail: string;
    /** The fax of the project owner */
    ownerFax?: string | undefined;
    /** The organisation name of the project manager */
    managerOrganisationName: string;
    /** The name of the project manager */
    managerName: string;
    /** The job title of the project manager */
    managerJobTitle?: string | undefined;
    /** The mobile of the project manager */
    managerMobile: string;
    /** The phone of the project manager */
    managerPhone?: string | undefined;
    /** The email of the project manager */
    managerEmail: string;
    /** The fax of the project manager */
    managerFax?: string | undefined;
    /** The budget amount of the project */
    budgetAmount: number;
    /** The cost contingency of the project */
    costContingency?: number | undefined;
    /** The end date of the project */
    projectEndDate: string;
    /** The adjusted project completion date of the project */
    adjustedProjectCompletionDate: string;
    /** The time contingency in days for the project */
    timeContingencyDays?: number | undefined;
    /** Used for defaulting timezone for contracts */
    timezone: string;
    /** The total active user count for the project */
    totalActiveUserCount: number;
    /** Current User’s Organisation User Status info for the Organisation of the Project */
    organisationUser?: UserStatusModel | undefined;
    /** Current User’s Project User Status info for the Project */
    projectUser?: UserStatusModel | undefined;
    /** Current User’s Contract User Status info for contracts of the Project */
    contractUsers: UserStatusModel[];
}

export class GetProjectUserContractsResponseModel implements IGetProjectUserContractsResponseModel {
    contracts!: ContractModel[];

    constructor(data?: IGetProjectUserContractsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.contracts = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(ContractModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProjectUserContractsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectUserContractsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetProjectUserContractsResponseModel {
    contracts: ContractModel[];
}

export class GetProjectUserDetailsResponseModel implements IGetProjectUserDetailsResponseModel {
    /** Public identifier for user */
    gid!: string;
    /** First Name of the User */
    firstName!: string;
    /** Last Name of the User */
    lastName!: string;
    /** Business Name of the User */
    businessName?: string | undefined;
    /** Email of the User */
    email!: string;
    /** Address Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2577727514/Address+Object" /> */
    streetAddress?: AddressModel | undefined;
    /** Address Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2577727514/Address+Object" /> */
    postalAddress?: AddressModel | undefined;
    mobile?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    /** ProjectUser Status and Available Actions. 

This property will be null if the provided User is not a ProjectUser for the provided Project. 

This can happen if the user is an OrganisationUser for the Organisation that contains the Project or if the user is a ContractUser for a Contract that is part of the Project. */
    projectUserStatus?: UserStatusWithActionsModel | undefined;
    /** Object with last modification information in it */
    lastModified!: LastModifiedModel;
    /** Can be legitimately null when a new user is invited and has never logged in before */
    lastLoginUtc?: Date | undefined;
    /** Can be legitimately null when a new user is invited and has never logged in before */
    lastLoginIpAddress?: string | undefined;
    /** Public identifier for the organisation */
    projectGid!: string;
    /** Name of the Project */
    projectName!: string;

    constructor(data?: IGetProjectUserDetailsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.lastModified = new LastModifiedModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.businessName = _data["businessName"];
            this.email = _data["email"];
            this.streetAddress = _data["streetAddress"] ? AddressModel.fromJS(_data["streetAddress"]) : <any>undefined;
            this.postalAddress = _data["postalAddress"] ? AddressModel.fromJS(_data["postalAddress"]) : <any>undefined;
            this.mobile = _data["mobile"];
            this.phone = _data["phone"];
            this.fax = _data["fax"];
            this.projectUserStatus = _data["projectUserStatus"] ? UserStatusWithActionsModel.fromJS(_data["projectUserStatus"]) : <any>undefined;
            this.lastModified = _data["lastModified"] ? LastModifiedModel.fromJS(_data["lastModified"]) : new LastModifiedModel();
            this.lastLoginUtc = _data["lastLoginUtc"] ? new Date(_data["lastLoginUtc"].toString()) : <any>undefined;
            this.lastLoginIpAddress = _data["lastLoginIpAddress"];
            this.projectGid = _data["projectGid"];
            this.projectName = _data["projectName"];
        }
    }

    static fromJS(data: any): GetProjectUserDetailsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectUserDetailsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["businessName"] = this.businessName;
        data["email"] = this.email;
        data["streetAddress"] = this.streetAddress ? this.streetAddress.toJSON() : <any>undefined;
        data["postalAddress"] = this.postalAddress ? this.postalAddress.toJSON() : <any>undefined;
        data["mobile"] = this.mobile;
        data["phone"] = this.phone;
        data["fax"] = this.fax;
        data["projectUserStatus"] = this.projectUserStatus ? this.projectUserStatus.toJSON() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toJSON() : <any>undefined;
        data["lastLoginUtc"] = this.lastLoginUtc ? this.lastLoginUtc.toISOString() : <any>undefined;
        data["lastLoginIpAddress"] = this.lastLoginIpAddress;
        data["projectGid"] = this.projectGid;
        data["projectName"] = this.projectName;
        return data;
    }
}

export interface IGetProjectUserDetailsResponseModel {
    /** Public identifier for user */
    gid: string;
    /** First Name of the User */
    firstName: string;
    /** Last Name of the User */
    lastName: string;
    /** Business Name of the User */
    businessName?: string | undefined;
    /** Email of the User */
    email: string;
    /** Address Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2577727514/Address+Object" /> */
    streetAddress?: AddressModel | undefined;
    /** Address Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2577727514/Address+Object" /> */
    postalAddress?: AddressModel | undefined;
    mobile?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    /** ProjectUser Status and Available Actions. 

This property will be null if the provided User is not a ProjectUser for the provided Project. 

This can happen if the user is an OrganisationUser for the Organisation that contains the Project or if the user is a ContractUser for a Contract that is part of the Project. */
    projectUserStatus?: UserStatusWithActionsModel | undefined;
    /** Object with last modification information in it */
    lastModified: LastModifiedModel;
    /** Can be legitimately null when a new user is invited and has never logged in before */
    lastLoginUtc?: Date | undefined;
    /** Can be legitimately null when a new user is invited and has never logged in before */
    lastLoginIpAddress?: string | undefined;
    /** Public identifier for the organisation */
    projectGid: string;
    /** Name of the Project */
    projectName: string;
}

export class GetProjectUsersResponseModel implements IGetProjectUsersResponseModel {
    users!: ProjectUserStatusesModel[];

    constructor(data?: IGetProjectUsersResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.users = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(ProjectUserStatusesModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProjectUsersResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectUsersResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetProjectUsersResponseModel {
    users: ProjectUserStatusesModel[];
}

export class GetProjectsContractModel implements IGetProjectsContractModel {
    gid!: string;
    name!: string;
    reference!: string;
    /** [Contract Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Contract-Status)

            Status types contracts can use

1 = Active (Contract is active, at this point settings can’t be edited)

2 = Pending (Partway through setup or in pending mode where configuration can be edited)

3 = Terminated (Post MVP)

4 = PracticalCompletion (Post MVP)

5 = FinalCompletion (Post MVP)

6 = Suspended (Post MVP)

7 = Draft (Contract is still in wizard phase)

8 = Cancelled (Post MVP) */
    status!: ContractStatus;
    segmentInstances!: GetProjectsSegmentInstanceModel[];
    /** User Status Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2588213249/User+Status+object" /> */
    contractUser!: UserStatusModel | undefined;

    constructor(data?: IGetProjectsContractModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.segmentInstances = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.name = _data["name"];
            this.reference = _data["reference"];
            this.status = _data["status"];
            if (Array.isArray(_data["segmentInstances"])) {
                this.segmentInstances = [] as any;
                for (let item of _data["segmentInstances"])
                    this.segmentInstances!.push(GetProjectsSegmentInstanceModel.fromJS(item));
            }
            this.contractUser = _data["contractUser"] ? UserStatusModel.fromJS(_data["contractUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProjectsContractModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectsContractModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["name"] = this.name;
        data["reference"] = this.reference;
        data["status"] = this.status;
        if (Array.isArray(this.segmentInstances)) {
            data["segmentInstances"] = [];
            for (let item of this.segmentInstances)
                data["segmentInstances"].push(item.toJSON());
        }
        data["contractUser"] = this.contractUser ? this.contractUser.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetProjectsContractModel {
    gid: string;
    name: string;
    reference: string;
    /** [Contract Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Contract-Status)

            Status types contracts can use

1 = Active (Contract is active, at this point settings can’t be edited)

2 = Pending (Partway through setup or in pending mode where configuration can be edited)

3 = Terminated (Post MVP)

4 = PracticalCompletion (Post MVP)

5 = FinalCompletion (Post MVP)

6 = Suspended (Post MVP)

7 = Draft (Contract is still in wizard phase)

8 = Cancelled (Post MVP) */
    status: ContractStatus;
    segmentInstances: GetProjectsSegmentInstanceModel[];
    /** User Status Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2588213249/User+Status+object" /> */
    contractUser: UserStatusModel | undefined;
}

export class GetProjectsProjectModel implements IGetProjectsProjectModel {
    /** Project public Id */
    gid!: string;
    /** Project Name */
    name!: string;
    /** Project Code */
    code!: string;
    /** Organisation project is associated with */
    organisationGid!: string;
    /** Organisation project is associated to */
    organisationName!: string;
    /** The projects status (OneTrack.Data.Enums.ProjectStatus
<seealso href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Project-Status">Enums | Project-Status</seealso>)

1 = Active (Project is active)

2 = Pending (Project is pending)

3 = Suspended (Project is suspended)

4 = Complete (Project is complete) */
    status!: ProjectStatus;
    /** Traffic Lights Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2328756336/Traffic+lights+object" /> */
    trafficLights!: TrafficLightsModel;
    adjustedProjectCompletionDate!: string;
    contracts!: GetProjectsContractModel[];
    /** User Status Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2588213249/User+Status+object" /> */
    organisationUser!: UserStatusModel | undefined;
    /** User Status Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2588213249/User+Status+object" /> */
    projectUser!: UserStatusModel | undefined;

    constructor(data?: IGetProjectsProjectModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.trafficLights = new TrafficLightsModel();
            this.contracts = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.organisationGid = _data["organisationGid"];
            this.organisationName = _data["organisationName"];
            this.status = _data["status"];
            this.trafficLights = _data["trafficLights"] ? TrafficLightsModel.fromJS(_data["trafficLights"]) : new TrafficLightsModel();
            this.adjustedProjectCompletionDate = _data["adjustedProjectCompletionDate"];
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(GetProjectsContractModel.fromJS(item));
            }
            this.organisationUser = _data["organisationUser"] ? UserStatusModel.fromJS(_data["organisationUser"]) : <any>undefined;
            this.projectUser = _data["projectUser"] ? UserStatusModel.fromJS(_data["projectUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProjectsProjectModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectsProjectModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["name"] = this.name;
        data["code"] = this.code;
        data["organisationGid"] = this.organisationGid;
        data["organisationName"] = this.organisationName;
        data["status"] = this.status;
        data["trafficLights"] = this.trafficLights ? this.trafficLights.toJSON() : <any>undefined;
        data["adjustedProjectCompletionDate"] = this.adjustedProjectCompletionDate;
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item.toJSON());
        }
        data["organisationUser"] = this.organisationUser ? this.organisationUser.toJSON() : <any>undefined;
        data["projectUser"] = this.projectUser ? this.projectUser.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetProjectsProjectModel {
    /** Project public Id */
    gid: string;
    /** Project Name */
    name: string;
    /** Project Code */
    code: string;
    /** Organisation project is associated with */
    organisationGid: string;
    /** Organisation project is associated to */
    organisationName: string;
    /** The projects status (OneTrack.Data.Enums.ProjectStatus
<seealso href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Project-Status">Enums | Project-Status</seealso>)

1 = Active (Project is active)

2 = Pending (Project is pending)

3 = Suspended (Project is suspended)

4 = Complete (Project is complete) */
    status: ProjectStatus;
    /** Traffic Lights Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2328756336/Traffic+lights+object" /> */
    trafficLights: TrafficLightsModel;
    adjustedProjectCompletionDate: string;
    contracts: GetProjectsContractModel[];
    /** User Status Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2588213249/User+Status+object" /> */
    organisationUser: UserStatusModel | undefined;
    /** User Status Object
<see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2588213249/User+Status+object" /> */
    projectUser: UserStatusModel | undefined;
}

export class GetProjectsResponseModel implements IGetProjectsResponseModel {
    projects!: GetProjectsProjectModel[];

    constructor(data?: IGetProjectsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.projects = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(GetProjectsProjectModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProjectsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetProjectsResponseModel {
    projects: GetProjectsProjectModel[];
}

export class GetProjectsSegmentInstanceModel implements IGetProjectsSegmentInstanceModel {
    gid!: string;
    reference!: string;
    dueDate!: string | undefined;
    /** [Segment Instance Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Segment-Instance-Status)

            The status of the Segment Instance (The status type is how this status is broadly referenced within the system and is used in logic. 

For the sake of simplifying logic 'Open' statuses have a value less than 16 and 'Closed' statuses are equal to or greater than 16.
<seealso cref="F:OneTrack.Data.SegmentInstanceStatusConstants.MinOpenValue" />,  <seealso cref="F:OneTrack.Data.SegmentInstanceStatusConstants.MaxOpenValue" />, <seealso cref="F:OneTrack.Data.SegmentInstanceStatusConstants.MinClosedValue" /> and  <seealso cref="F:OneTrack.Data.SegmentInstanceStatusConstants.MaxClosedValue" />)

1 = InProgress (Segment is unresolved, this is the initial status for most segments)

2 = Suspended (Segment is unresolved but is marked as suspended, post MVP this will include additional logic for ‘Stopping the ticking of clocks’)

3 = InfoRequestedAndNotSuspended (Segment is unresolved and is noting that additional information has been requested)

4 = InfoRequestedAndSuspended (Effectively the same as both ‘Info Requested and Not Suspended’ and ‘Suspended’)

16 = Complete (Segment has been resolved)

17 = Withdrawn (Segment has been withdrawn (this is specially for when a contractor withdraws a claim))

18 = Cancelled (Segment has been cancelled (this is specifically for when the principal cancels a claim))

19 = Disputed (Segment is resolved and has been marked as being in dispute, Post MVP this means an additional dispute workflow as been created)

20 = LegalDispute (Same as Disputed but for Legal Disputes) */
    status!: SegmentInstanceStatus;
    /** 

1 = Accepted (Segment has been accepted, claimed time/budget granted by the principal is added to the contract.)

2 = Rejected (Segment has been rejected, any claimed time/budget is noted but not added to the contract.)

3 = Indeterminate (Resolution not possible at this point.) */
    resolution!: SegmentInstanceResolution | undefined;

    constructor(data?: IGetProjectsSegmentInstanceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.reference = _data["reference"];
            this.dueDate = _data["dueDate"];
            this.status = _data["status"];
            this.resolution = _data["resolution"];
        }
    }

    static fromJS(data: any): GetProjectsSegmentInstanceModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectsSegmentInstanceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["reference"] = this.reference;
        data["dueDate"] = this.dueDate;
        data["status"] = this.status;
        data["resolution"] = this.resolution;
        return data;
    }
}

export interface IGetProjectsSegmentInstanceModel {
    gid: string;
    reference: string;
    dueDate: string | undefined;
    /** [Segment Instance Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Segment-Instance-Status)

            The status of the Segment Instance (The status type is how this status is broadly referenced within the system and is used in logic. 

For the sake of simplifying logic 'Open' statuses have a value less than 16 and 'Closed' statuses are equal to or greater than 16.
<seealso cref="F:OneTrack.Data.SegmentInstanceStatusConstants.MinOpenValue" />,  <seealso cref="F:OneTrack.Data.SegmentInstanceStatusConstants.MaxOpenValue" />, <seealso cref="F:OneTrack.Data.SegmentInstanceStatusConstants.MinClosedValue" /> and  <seealso cref="F:OneTrack.Data.SegmentInstanceStatusConstants.MaxClosedValue" />)

1 = InProgress (Segment is unresolved, this is the initial status for most segments)

2 = Suspended (Segment is unresolved but is marked as suspended, post MVP this will include additional logic for ‘Stopping the ticking of clocks’)

3 = InfoRequestedAndNotSuspended (Segment is unresolved and is noting that additional information has been requested)

4 = InfoRequestedAndSuspended (Effectively the same as both ‘Info Requested and Not Suspended’ and ‘Suspended’)

16 = Complete (Segment has been resolved)

17 = Withdrawn (Segment has been withdrawn (this is specially for when a contractor withdraws a claim))

18 = Cancelled (Segment has been cancelled (this is specifically for when the principal cancels a claim))

19 = Disputed (Segment is resolved and has been marked as being in dispute, Post MVP this means an additional dispute workflow as been created)

20 = LegalDispute (Same as Disputed but for Legal Disputes) */
    status: SegmentInstanceStatus;
    /** 

1 = Accepted (Segment has been accepted, claimed time/budget granted by the principal is added to the contract.)

2 = Rejected (Segment has been rejected, any claimed time/budget is noted but not added to the contract.)

3 = Indeterminate (Resolution not possible at this point.) */
    resolution: SegmentInstanceResolution | undefined;
}

export class PostUpdateProjectStatusRequestModel implements IPostUpdateProjectStatusRequestModel {
    /** Status for the Project

1 = Active (Project is active)

2 = Pending (Project is pending)

3 = Suspended (Project is suspended)

4 = Complete (Project is complete) */
    status!: ProjectStatus;

    constructor(data?: IPostUpdateProjectStatusRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): PostUpdateProjectStatusRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostUpdateProjectStatusRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        return data;
    }
}

export interface IPostUpdateProjectStatusRequestModel {
    /** Status for the Project

1 = Active (Project is active)

2 = Pending (Project is pending)

3 = Suspended (Project is suspended)

4 = Complete (Project is complete) */
    status: ProjectStatus;
}

export class PostUpsertProjectDetailsRequestModel implements IPostUpsertProjectDetailsRequestModel {
    /** Public Identifier for the Organisation that the Project belongs to */
    organisationGid!: string;
    /** The projects code */
    code!: string;
    /** The projects name */
    name!: string;
    /** The projects description */
    description!: string;
    /** Status for the Project

1 = Active (Project is active)

2 = Pending (Project is pending)

3 = Suspended (Project is suspended)

4 = Complete (Project is complete) */
    projectStatus!: ProjectStatus;
    /** The projects type */
    projectTypeName!: string;
    /** The address of the project */
    address!: AddressModel;
    /** The organisation name of the project owner */
    ownerOrganisationName!: string;
    /** The name of the project owner */
    ownerName!: string;
    /** The job title of the project owner */
    ownerJobTitle?: string | undefined;
    /** The mobile of the project owner */
    ownerMobile!: string;
    /** The phone of the project owner */
    ownerPhone?: string | undefined;
    /** The email of the project owner */
    ownerEmail!: string;
    /** The fax of the project owner */
    ownerFax?: string | undefined;
    /** The organisation name of the project manager */
    managerOrganisationName!: string;
    /** The name of the project manager */
    managerName!: string;
    /** The job title of the project manager */
    managerJobTitle?: string | undefined;
    /** The mobile of the project manager */
    managerMobile!: string;
    /** The phone of the project manager */
    managerPhone?: string | undefined;
    /** The email of the project manager */
    managerEmail!: string;
    /** The fax of the project manager */
    managerFax?: string | undefined;
    /** The budget amount of the project */
    budgetAmount!: number;
    /** The cost contingency of the project */
    costContingency!: number;
    /** The end date of the project */
    projectEndDate!: string;
    /** The time contingency in days for the project */
    timeContingencyDays!: number;
    /** Used for defaulting timezone for contracts */
    timezone!: string;

    constructor(data?: IPostUpsertProjectDetailsRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.address = new AddressModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organisationGid = _data["organisationGid"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.projectStatus = _data["projectStatus"];
            this.projectTypeName = _data["projectTypeName"];
            this.address = _data["address"] ? AddressModel.fromJS(_data["address"]) : new AddressModel();
            this.ownerOrganisationName = _data["ownerOrganisationName"];
            this.ownerName = _data["ownerName"];
            this.ownerJobTitle = _data["ownerJobTitle"];
            this.ownerMobile = _data["ownerMobile"];
            this.ownerPhone = _data["ownerPhone"];
            this.ownerEmail = _data["ownerEmail"];
            this.ownerFax = _data["ownerFax"];
            this.managerOrganisationName = _data["managerOrganisationName"];
            this.managerName = _data["managerName"];
            this.managerJobTitle = _data["managerJobTitle"];
            this.managerMobile = _data["managerMobile"];
            this.managerPhone = _data["managerPhone"];
            this.managerEmail = _data["managerEmail"];
            this.managerFax = _data["managerFax"];
            this.budgetAmount = _data["budgetAmount"];
            this.costContingency = _data["costContingency"];
            this.projectEndDate = _data["projectEndDate"];
            this.timeContingencyDays = _data["timeContingencyDays"];
            this.timezone = _data["timezone"];
        }
    }

    static fromJS(data: any): PostUpsertProjectDetailsRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostUpsertProjectDetailsRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organisationGid"] = this.organisationGid;
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["projectStatus"] = this.projectStatus;
        data["projectTypeName"] = this.projectTypeName;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["ownerOrganisationName"] = this.ownerOrganisationName;
        data["ownerName"] = this.ownerName;
        data["ownerJobTitle"] = this.ownerJobTitle;
        data["ownerMobile"] = this.ownerMobile;
        data["ownerPhone"] = this.ownerPhone;
        data["ownerEmail"] = this.ownerEmail;
        data["ownerFax"] = this.ownerFax;
        data["managerOrganisationName"] = this.managerOrganisationName;
        data["managerName"] = this.managerName;
        data["managerJobTitle"] = this.managerJobTitle;
        data["managerMobile"] = this.managerMobile;
        data["managerPhone"] = this.managerPhone;
        data["managerEmail"] = this.managerEmail;
        data["managerFax"] = this.managerFax;
        data["budgetAmount"] = this.budgetAmount;
        data["costContingency"] = this.costContingency;
        data["projectEndDate"] = this.projectEndDate;
        data["timeContingencyDays"] = this.timeContingencyDays;
        data["timezone"] = this.timezone;
        return data;
    }
}

export interface IPostUpsertProjectDetailsRequestModel {
    /** Public Identifier for the Organisation that the Project belongs to */
    organisationGid: string;
    /** The projects code */
    code: string;
    /** The projects name */
    name: string;
    /** The projects description */
    description: string;
    /** Status for the Project

1 = Active (Project is active)

2 = Pending (Project is pending)

3 = Suspended (Project is suspended)

4 = Complete (Project is complete) */
    projectStatus: ProjectStatus;
    /** The projects type */
    projectTypeName: string;
    /** The address of the project */
    address: AddressModel;
    /** The organisation name of the project owner */
    ownerOrganisationName: string;
    /** The name of the project owner */
    ownerName: string;
    /** The job title of the project owner */
    ownerJobTitle?: string | undefined;
    /** The mobile of the project owner */
    ownerMobile: string;
    /** The phone of the project owner */
    ownerPhone?: string | undefined;
    /** The email of the project owner */
    ownerEmail: string;
    /** The fax of the project owner */
    ownerFax?: string | undefined;
    /** The organisation name of the project manager */
    managerOrganisationName: string;
    /** The name of the project manager */
    managerName: string;
    /** The job title of the project manager */
    managerJobTitle?: string | undefined;
    /** The mobile of the project manager */
    managerMobile: string;
    /** The phone of the project manager */
    managerPhone?: string | undefined;
    /** The email of the project manager */
    managerEmail: string;
    /** The fax of the project manager */
    managerFax?: string | undefined;
    /** The budget amount of the project */
    budgetAmount: number;
    /** The cost contingency of the project */
    costContingency: number;
    /** The end date of the project */
    projectEndDate: string;
    /** The time contingency in days for the project */
    timeContingencyDays: number;
    /** Used for defaulting timezone for contracts */
    timezone: string;
}

export class ProjectUserStatusesModel implements IProjectUserStatusesModel {
    gid!: string;
    firstName!: string;
    lastName!: string;
    email!: string;
    organisations!: UserStatusWithActionsModel[];
    projects!: UserStatusWithActionsModel[];
    contracts!: UserStatusWithActionsModel[];

    constructor(data?: IProjectUserStatusesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.organisations = [];
            this.projects = [];
            this.contracts = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            if (Array.isArray(_data["organisations"])) {
                this.organisations = [] as any;
                for (let item of _data["organisations"])
                    this.organisations!.push(UserStatusWithActionsModel.fromJS(item));
            }
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(UserStatusWithActionsModel.fromJS(item));
            }
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(UserStatusWithActionsModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectUserStatusesModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectUserStatusesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        if (Array.isArray(this.organisations)) {
            data["organisations"] = [];
            for (let item of this.organisations)
                data["organisations"].push(item.toJSON());
        }
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectUserStatusesModel {
    gid: string;
    firstName: string;
    lastName: string;
    email: string;
    organisations: UserStatusWithActionsModel[];
    projects: UserStatusWithActionsModel[];
    contracts: UserStatusWithActionsModel[];
}

export class ChildDetailsModel implements IChildDetailsModel {
    /** User defined reference, unique per Contract */
    reference!: string;

    constructor(data?: IChildDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reference = _data["reference"];
        }
    }

    static fromJS(data: any): ChildDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChildDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reference"] = this.reference;
        return data;
    }
}

export interface IChildDetailsModel {
    /** User defined reference, unique per Contract */
    reference: string;
}

export class GetSegmentDefinitionResponseModel implements IGetSegmentDefinitionResponseModel {
    /** Definition Object to define data driven form for either Workflow Amendments or Segment definition. Object is in the form of a Json document. 
 ([Data Driven Definition Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2373091347/Data+Driven+Definition+Object)) */
    definition!: DataDrivenDefinitionModel;
    /** Configuration details for a segment 
 ([Data Driven Segment Config Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2438923005/Segment+Config+Object)) */
    config!: DataDrivenSegmentConfigModel;

    constructor(data?: IGetSegmentDefinitionResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.definition = new DataDrivenDefinitionModel();
            this.config = new DataDrivenSegmentConfigModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.definition = _data["definition"] ? DataDrivenDefinitionModel.fromJS(_data["definition"]) : new DataDrivenDefinitionModel();
            this.config = _data["config"] ? DataDrivenSegmentConfigModel.fromJS(_data["config"]) : new DataDrivenSegmentConfigModel();
        }
    }

    static fromJS(data: any): GetSegmentDefinitionResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSegmentDefinitionResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["definition"] = this.definition ? this.definition.toJSON() : <any>undefined;
        data["config"] = this.config ? this.config.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSegmentDefinitionResponseModel {
    /** Definition Object to define data driven form for either Workflow Amendments or Segment definition. Object is in the form of a Json document. 
 ([Data Driven Definition Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2373091347/Data+Driven+Definition+Object)) */
    definition: DataDrivenDefinitionModel;
    /** Configuration details for a segment 
 ([Data Driven Segment Config Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2438923005/Segment+Config+Object)) */
    config: DataDrivenSegmentConfigModel;
}

export class GetSegmentInstanceDetailsResponseModel implements IGetSegmentInstanceDetailsResponseModel {
    /** Public Id for OneTrack.EFDatabase.App.Models.Workflows.SegmentInstance */
    gid!: string;
    /** A user defined contract identifier */
    reference!: string;
    /** The time this entry was added to the database in UTC */
    createdUtc!: Date;
    /** No time component */
    dueDate?: string | undefined;
    /** OneTrack.Data.Enums.SegmentInstanceStatus
<seealso href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Segment-Instance-Status">Enums | Segment Instance Status</seealso>

1 = InProgress (Segment is unresolved, this is the initial status for most segments)

2 = Suspended (Segment is unresolved but is marked as suspended, post MVP this will include additional logic for ‘Stopping the ticking of clocks’)

3 = InfoRequestedAndNotSuspended (Segment is unresolved and is noting that additional information has been requested)

4 = InfoRequestedAndSuspended (Effectively the same as both ‘Info Requested and Not Suspended’ and ‘Suspended’)

16 = Complete (Segment has been resolved)

17 = Withdrawn (Segment has been withdrawn (this is specially for when a contractor withdraws a claim))

18 = Cancelled (Segment has been cancelled (this is specifically for when the principal cancels a claim))

19 = Disputed (Segment is resolved and has been marked as being in dispute, Post MVP this means an additional dispute workflow as been created)

20 = LegalDispute (Same as Disputed but for Legal Disputes) */
    status!: SegmentInstanceStatus;
    /** Segment Instance Granted Time */
    grantedTime?: number | undefined;
    /** OneTrack.Data.Enums.TimePeriodUnit

<seealso href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Time-Period-Unit">Enums | Time Period Unit</seealso>

1 = Hours (A time period of hours)

2 = Days (A time period of days)

3 = Weeks (A time period of weeks) */
    grantedTimeUnit?: TimePeriodUnit | undefined;
    /** OneTrack.Data.Enums.TimePeriodUnit

<seealso href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Well+Known+Enums#Calendar-Type">Enums | Calendar Type</seealso>

1 = Working (Working calendar)

2 = Business (Business calendar)

3 = CalendarDays (Every regular calendar day (Every regular calendar day, no weekdays or weekends and no holidays. Just regular sequential days.)) */
    grantedTimeCalendarType?: CalendarType | undefined;
    /** OneTrack.Data.Enums.SegmentInstanceResolution

<seealso href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Segment-Instance-Resolution">Enums | Segment Instance Resolution</seealso>

1 = Accepted (Segment has been accepted, claimed time/budget granted by the principal is added to the contract.)

2 = Rejected (Segment has been rejected, any claimed time/budget is noted but not added to the contract.)

3 = Indeterminate (Resolution not possible at this point.) */
    resolution?: SegmentInstanceResolution | undefined;
    /** Whether or not the resolution of this segment has been changed */
    resolutionChanged!: boolean;
    /** Basic details for associated OneTrack.EFDatabase.App.Models.Contracts.Contract */
    contract!: BasicContractModel;
    /** Basic details for associated OneTrack.EFDatabase.App.Models.Workflows.Workflow */
    workflowSegment!: BasicSegmentModel;
    /** In the future the object this property uses will become more complex, when this happens this should be replaced with a simple object. */
    project!: BasicProjectModel;
    /** Are Response Time Alerts (Traffic Lights) Enabled for this SegmentInstance */
    responseTimeAlertsEnabled!: boolean;
    /** Whether or not the SegmentInstance is to be excluded from Practical Completion Date Calculations. */
    noLongerAffectingPC!: boolean;
    /** The traffic light colour to use for the segment instance

0 = None (There is no colour)

1 = Green (Green - usually indicates a everything is going swimmingly)

2 = Amber (Amber - usually indicates a warning that something is almost overdue)

3 = Red (Red - usually indicates Overdue) */
    trafficLightColour!: TrafficLightColour;
    /** Parent Claim */
    parentClaim?: BasicClaimModel | undefined;
    /** Root Claim */
    rootClaim?: BasicClaimModel | undefined;
    /** A collection of all emails that have been sent for this Segment Instance. 

For Incomplete Segment Instances this will be empty.  
For most Complete Segment Instances there will be only a single item.  
Multiple items will exist for Segment Instances that have been Completed multiple times. */
    emails!: SegmentInstanceEmailModel[];
    /** Summaries taken from available Evaluations */
    summaries!: BasicSummaryModel[];

    constructor(data?: IGetSegmentInstanceDetailsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.contract = new BasicContractModel();
            this.workflowSegment = new BasicSegmentModel();
            this.project = new BasicProjectModel();
            this.emails = [];
            this.summaries = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.reference = _data["reference"];
            this.createdUtc = _data["createdUtc"] ? new Date(_data["createdUtc"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"];
            this.status = _data["status"];
            this.grantedTime = _data["grantedTime"];
            this.grantedTimeUnit = _data["grantedTimeUnit"];
            this.grantedTimeCalendarType = _data["grantedTimeCalendarType"];
            this.resolution = _data["resolution"];
            this.resolutionChanged = _data["resolutionChanged"];
            this.contract = _data["contract"] ? BasicContractModel.fromJS(_data["contract"]) : new BasicContractModel();
            this.workflowSegment = _data["workflowSegment"] ? BasicSegmentModel.fromJS(_data["workflowSegment"]) : new BasicSegmentModel();
            this.project = _data["project"] ? BasicProjectModel.fromJS(_data["project"]) : new BasicProjectModel();
            this.responseTimeAlertsEnabled = _data["responseTimeAlertsEnabled"];
            this.noLongerAffectingPC = _data["noLongerAffectingPC"];
            this.trafficLightColour = _data["trafficLightColour"];
            this.parentClaim = _data["parentClaim"] ? BasicClaimModel.fromJS(_data["parentClaim"]) : <any>undefined;
            this.rootClaim = _data["rootClaim"] ? BasicClaimModel.fromJS(_data["rootClaim"]) : <any>undefined;
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(SegmentInstanceEmailModel.fromJS(item));
            }
            if (Array.isArray(_data["summaries"])) {
                this.summaries = [] as any;
                for (let item of _data["summaries"])
                    this.summaries!.push(BasicSummaryModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSegmentInstanceDetailsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSegmentInstanceDetailsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["reference"] = this.reference;
        data["createdUtc"] = this.createdUtc ? this.createdUtc.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate;
        data["status"] = this.status;
        data["grantedTime"] = this.grantedTime;
        data["grantedTimeUnit"] = this.grantedTimeUnit;
        data["grantedTimeCalendarType"] = this.grantedTimeCalendarType;
        data["resolution"] = this.resolution;
        data["resolutionChanged"] = this.resolutionChanged;
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        data["workflowSegment"] = this.workflowSegment ? this.workflowSegment.toJSON() : <any>undefined;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["responseTimeAlertsEnabled"] = this.responseTimeAlertsEnabled;
        data["noLongerAffectingPC"] = this.noLongerAffectingPC;
        data["trafficLightColour"] = this.trafficLightColour;
        data["parentClaim"] = this.parentClaim ? this.parentClaim.toJSON() : <any>undefined;
        data["rootClaim"] = this.rootClaim ? this.rootClaim.toJSON() : <any>undefined;
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item.toJSON());
        }
        if (Array.isArray(this.summaries)) {
            data["summaries"] = [];
            for (let item of this.summaries)
                data["summaries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSegmentInstanceDetailsResponseModel {
    /** Public Id for OneTrack.EFDatabase.App.Models.Workflows.SegmentInstance */
    gid: string;
    /** A user defined contract identifier */
    reference: string;
    /** The time this entry was added to the database in UTC */
    createdUtc: Date;
    /** No time component */
    dueDate?: string | undefined;
    /** OneTrack.Data.Enums.SegmentInstanceStatus
<seealso href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Segment-Instance-Status">Enums | Segment Instance Status</seealso>

1 = InProgress (Segment is unresolved, this is the initial status for most segments)

2 = Suspended (Segment is unresolved but is marked as suspended, post MVP this will include additional logic for ‘Stopping the ticking of clocks’)

3 = InfoRequestedAndNotSuspended (Segment is unresolved and is noting that additional information has been requested)

4 = InfoRequestedAndSuspended (Effectively the same as both ‘Info Requested and Not Suspended’ and ‘Suspended’)

16 = Complete (Segment has been resolved)

17 = Withdrawn (Segment has been withdrawn (this is specially for when a contractor withdraws a claim))

18 = Cancelled (Segment has been cancelled (this is specifically for when the principal cancels a claim))

19 = Disputed (Segment is resolved and has been marked as being in dispute, Post MVP this means an additional dispute workflow as been created)

20 = LegalDispute (Same as Disputed but for Legal Disputes) */
    status: SegmentInstanceStatus;
    /** Segment Instance Granted Time */
    grantedTime?: number | undefined;
    /** OneTrack.Data.Enums.TimePeriodUnit

<seealso href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Time-Period-Unit">Enums | Time Period Unit</seealso>

1 = Hours (A time period of hours)

2 = Days (A time period of days)

3 = Weeks (A time period of weeks) */
    grantedTimeUnit?: TimePeriodUnit | undefined;
    /** OneTrack.Data.Enums.TimePeriodUnit

<seealso href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Well+Known+Enums#Calendar-Type">Enums | Calendar Type</seealso>

1 = Working (Working calendar)

2 = Business (Business calendar)

3 = CalendarDays (Every regular calendar day (Every regular calendar day, no weekdays or weekends and no holidays. Just regular sequential days.)) */
    grantedTimeCalendarType?: CalendarType | undefined;
    /** OneTrack.Data.Enums.SegmentInstanceResolution

<seealso href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Segment-Instance-Resolution">Enums | Segment Instance Resolution</seealso>

1 = Accepted (Segment has been accepted, claimed time/budget granted by the principal is added to the contract.)

2 = Rejected (Segment has been rejected, any claimed time/budget is noted but not added to the contract.)

3 = Indeterminate (Resolution not possible at this point.) */
    resolution?: SegmentInstanceResolution | undefined;
    /** Whether or not the resolution of this segment has been changed */
    resolutionChanged: boolean;
    /** Basic details for associated OneTrack.EFDatabase.App.Models.Contracts.Contract */
    contract: BasicContractModel;
    /** Basic details for associated OneTrack.EFDatabase.App.Models.Workflows.Workflow */
    workflowSegment: BasicSegmentModel;
    /** In the future the object this property uses will become more complex, when this happens this should be replaced with a simple object. */
    project: BasicProjectModel;
    /** Are Response Time Alerts (Traffic Lights) Enabled for this SegmentInstance */
    responseTimeAlertsEnabled: boolean;
    /** Whether or not the SegmentInstance is to be excluded from Practical Completion Date Calculations. */
    noLongerAffectingPC: boolean;
    /** The traffic light colour to use for the segment instance

0 = None (There is no colour)

1 = Green (Green - usually indicates a everything is going swimmingly)

2 = Amber (Amber - usually indicates a warning that something is almost overdue)

3 = Red (Red - usually indicates Overdue) */
    trafficLightColour: TrafficLightColour;
    /** Parent Claim */
    parentClaim?: BasicClaimModel | undefined;
    /** Root Claim */
    rootClaim?: BasicClaimModel | undefined;
    /** A collection of all emails that have been sent for this Segment Instance. 

For Incomplete Segment Instances this will be empty.  
For most Complete Segment Instances there will be only a single item.  
Multiple items will exist for Segment Instances that have been Completed multiple times. */
    emails: SegmentInstanceEmailModel[];
    /** Summaries taken from available Evaluations */
    summaries: BasicSummaryModel[];
}

export class GetSegmentInstanceDocumentsAndFilesResponseDocumentModel implements IGetSegmentInstanceDocumentsAndFilesResponseDocumentModel {
    /** Document Gid */
    gid!: string;
    /** Document Version Gid */
    documentVersionGid!: string;
    /** The Index of the Version. 
 
A number that can be used to create the text "Version 4" for example. */
    documentVersionIndex!: number;
    /** Is this the latest version of the document */
    documentVersionIsLatestVersion!: boolean;
    /** Segment Instance Document Version Gid */
    segmentInstanceDocumentVersionGid!: string;
    /** Document Name */
    name!: string;
    /** Document Reference */
    reference!: string;
    /** Description of the content of the document */
    contentDescription!: string | undefined;
    /** The Association Type

0 = Originating (The document was the document that began the workflow)

1 = Supporting (The document is a supporting document for the workflow)

2 = Response (The document was a response to the workflow) */
    associationType!: SegmentInstanceDocumentVersionAssociationType;
    /** Whether this association is locked and can therefore never be removed or not. */
    isLocked!: boolean;
    /** The date and time the document was received in Utc format. */
    deemedReceivedUtc!: Date | undefined;
    /** Time zone <seealso cref="P:OneTrack.Api.Commands.SegmentInstances.GetSegmentInstanceDocumentsAndFilesResponseDocumentModel.DeemedReceivedUtc" /> was supplied with. (Required if <seealso cref="P:OneTrack.Api.Commands.SegmentInstances.GetSegmentInstanceDocumentsAndFilesResponseDocumentModel.DeemedReceivedUtc" /> is set
 Any valid entry from the <seealso href="https://www.iana.org/time-zones">Iana Time Zone Database(tzdb)</seealso>,  see also: <seealso href="https://en.wikipedia.org/wiki/List_of_tz_database_time_zones">List of tz database time zones</seealso>) */
    deemedReceivedTimeZone!: string | undefined;
    /** How the document was received

1 = AusPost (Australia Post)

2 = Courier (Courier)

3 = Email (Email)

4 = Aconex (Aconex)

5 = Fax (Fax)

6 = Other (Other) */
    receivalType!: DocumentReceivalType | undefined;
    /** This is only intended to be defined if OneTrack.Api.Commands.SegmentInstances.GetSegmentInstanceDocumentsAndFilesResponseDocumentModel.ReceivalType is OneTrack.Data.Enums.DocumentReceivalType.Other */
    receivalDescription!: string | undefined;
    /** List of Files associated with the Document Version */
    files?: GetSegmentInstanceDocumentsAndFilesResponseFileModel[] | undefined;

    constructor(data?: IGetSegmentInstanceDocumentsAndFilesResponseDocumentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.documentVersionGid = _data["documentVersionGid"];
            this.documentVersionIndex = _data["documentVersionIndex"];
            this.documentVersionIsLatestVersion = _data["documentVersionIsLatestVersion"];
            this.segmentInstanceDocumentVersionGid = _data["segmentInstanceDocumentVersionGid"];
            this.name = _data["name"];
            this.reference = _data["reference"];
            this.contentDescription = _data["contentDescription"];
            this.associationType = _data["associationType"];
            this.isLocked = _data["isLocked"];
            this.deemedReceivedUtc = _data["deemedReceivedUtc"] ? new Date(_data["deemedReceivedUtc"].toString()) : <any>undefined;
            this.deemedReceivedTimeZone = _data["deemedReceivedTimeZone"];
            this.receivalType = _data["receivalType"];
            this.receivalDescription = _data["receivalDescription"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(GetSegmentInstanceDocumentsAndFilesResponseFileModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSegmentInstanceDocumentsAndFilesResponseDocumentModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSegmentInstanceDocumentsAndFilesResponseDocumentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["documentVersionGid"] = this.documentVersionGid;
        data["documentVersionIndex"] = this.documentVersionIndex;
        data["documentVersionIsLatestVersion"] = this.documentVersionIsLatestVersion;
        data["segmentInstanceDocumentVersionGid"] = this.segmentInstanceDocumentVersionGid;
        data["name"] = this.name;
        data["reference"] = this.reference;
        data["contentDescription"] = this.contentDescription;
        data["associationType"] = this.associationType;
        data["isLocked"] = this.isLocked;
        data["deemedReceivedUtc"] = this.deemedReceivedUtc ? this.deemedReceivedUtc.toISOString() : <any>undefined;
        data["deemedReceivedTimeZone"] = this.deemedReceivedTimeZone;
        data["receivalType"] = this.receivalType;
        data["receivalDescription"] = this.receivalDescription;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSegmentInstanceDocumentsAndFilesResponseDocumentModel {
    /** Document Gid */
    gid: string;
    /** Document Version Gid */
    documentVersionGid: string;
    /** The Index of the Version. 
 
A number that can be used to create the text "Version 4" for example. */
    documentVersionIndex: number;
    /** Is this the latest version of the document */
    documentVersionIsLatestVersion: boolean;
    /** Segment Instance Document Version Gid */
    segmentInstanceDocumentVersionGid: string;
    /** Document Name */
    name: string;
    /** Document Reference */
    reference: string;
    /** Description of the content of the document */
    contentDescription: string | undefined;
    /** The Association Type

0 = Originating (The document was the document that began the workflow)

1 = Supporting (The document is a supporting document for the workflow)

2 = Response (The document was a response to the workflow) */
    associationType: SegmentInstanceDocumentVersionAssociationType;
    /** Whether this association is locked and can therefore never be removed or not. */
    isLocked: boolean;
    /** The date and time the document was received in Utc format. */
    deemedReceivedUtc: Date | undefined;
    /** Time zone <seealso cref="P:OneTrack.Api.Commands.SegmentInstances.GetSegmentInstanceDocumentsAndFilesResponseDocumentModel.DeemedReceivedUtc" /> was supplied with. (Required if <seealso cref="P:OneTrack.Api.Commands.SegmentInstances.GetSegmentInstanceDocumentsAndFilesResponseDocumentModel.DeemedReceivedUtc" /> is set
 Any valid entry from the <seealso href="https://www.iana.org/time-zones">Iana Time Zone Database(tzdb)</seealso>,  see also: <seealso href="https://en.wikipedia.org/wiki/List_of_tz_database_time_zones">List of tz database time zones</seealso>) */
    deemedReceivedTimeZone: string | undefined;
    /** How the document was received

1 = AusPost (Australia Post)

2 = Courier (Courier)

3 = Email (Email)

4 = Aconex (Aconex)

5 = Fax (Fax)

6 = Other (Other) */
    receivalType: DocumentReceivalType | undefined;
    /** This is only intended to be defined if OneTrack.Api.Commands.SegmentInstances.GetSegmentInstanceDocumentsAndFilesResponseDocumentModel.ReceivalType is OneTrack.Data.Enums.DocumentReceivalType.Other */
    receivalDescription: string | undefined;
    /** List of Files associated with the Document Version */
    files?: GetSegmentInstanceDocumentsAndFilesResponseFileModel[] | undefined;
}

export class GetSegmentInstanceDocumentsAndFilesResponseFileModel implements IGetSegmentInstanceDocumentsAndFilesResponseFileModel {
    /** Global/public identifier for the File */
    gid!: string;
    /** Global/public identifier for the DocumentVersionFile */
    documentVersionFileGid!: string;
    /** DocumentVersionFile Name */
    name!: string;
    /** Format of the file 

*This will more likely be just the file extensions */
    format!: string;
    /** Content Type of the file, also known as Mime Type */
    contentType!: string;
    /** Size of the file in bytes */
    size!: number;

    constructor(data?: IGetSegmentInstanceDocumentsAndFilesResponseFileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.documentVersionFileGid = _data["documentVersionFileGid"];
            this.name = _data["name"];
            this.format = _data["format"];
            this.contentType = _data["contentType"];
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): GetSegmentInstanceDocumentsAndFilesResponseFileModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSegmentInstanceDocumentsAndFilesResponseFileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["documentVersionFileGid"] = this.documentVersionFileGid;
        data["name"] = this.name;
        data["format"] = this.format;
        data["contentType"] = this.contentType;
        data["size"] = this.size;
        return data;
    }
}

export interface IGetSegmentInstanceDocumentsAndFilesResponseFileModel {
    /** Global/public identifier for the File */
    gid: string;
    /** Global/public identifier for the DocumentVersionFile */
    documentVersionFileGid: string;
    /** DocumentVersionFile Name */
    name: string;
    /** Format of the file 

*This will more likely be just the file extensions */
    format: string;
    /** Content Type of the file, also known as Mime Type */
    contentType: string;
    /** Size of the file in bytes */
    size: number;
}

export class GetSegmentInstanceRecommendationAttachmentModel implements IGetSegmentInstanceRecommendationAttachmentModel {
    /** Public identifier for the File */
    fileGid!: string;
    /** Public identifier for the DocumentVersionFile */
    documentVersionFileGid!: string;
    /** Public identifier for the DocumentVersion */
    documentVersionGid!: string;
    /** Public identifier for the Document */
    documentGid!: string;
    /** File Name from the File table */
    fileName!: string;
    /** Index from the DocumentVersion table */
    documentVersionIndex!: number;
    /** Name from the DocumentVersion table */
    documentVersionName!: string;
    /** Description from the DocumentVersion table */
    documentVersionDescription?: string | undefined;
    /** Association Type from the SegmentInstanceDocumentVersion table

0 = Originating (The document was the document that began the workflow)

1 = Supporting (The document is a supporting document for the workflow)

2 = Response (The document was a response to the workflow) */
    associationType!: SegmentInstanceDocumentVersionAssociationType;
    /** Size of the file, in bytes */
    fileSize!: number;

    constructor(data?: IGetSegmentInstanceRecommendationAttachmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileGid = _data["fileGid"];
            this.documentVersionFileGid = _data["documentVersionFileGid"];
            this.documentVersionGid = _data["documentVersionGid"];
            this.documentGid = _data["documentGid"];
            this.fileName = _data["fileName"];
            this.documentVersionIndex = _data["documentVersionIndex"];
            this.documentVersionName = _data["documentVersionName"];
            this.documentVersionDescription = _data["documentVersionDescription"];
            this.associationType = _data["associationType"];
            this.fileSize = _data["fileSize"];
        }
    }

    static fromJS(data: any): GetSegmentInstanceRecommendationAttachmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSegmentInstanceRecommendationAttachmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileGid"] = this.fileGid;
        data["documentVersionFileGid"] = this.documentVersionFileGid;
        data["documentVersionGid"] = this.documentVersionGid;
        data["documentGid"] = this.documentGid;
        data["fileName"] = this.fileName;
        data["documentVersionIndex"] = this.documentVersionIndex;
        data["documentVersionName"] = this.documentVersionName;
        data["documentVersionDescription"] = this.documentVersionDescription;
        data["associationType"] = this.associationType;
        data["fileSize"] = this.fileSize;
        return data;
    }
}

export interface IGetSegmentInstanceRecommendationAttachmentModel {
    /** Public identifier for the File */
    fileGid: string;
    /** Public identifier for the DocumentVersionFile */
    documentVersionFileGid: string;
    /** Public identifier for the DocumentVersion */
    documentVersionGid: string;
    /** Public identifier for the Document */
    documentGid: string;
    /** File Name from the File table */
    fileName: string;
    /** Index from the DocumentVersion table */
    documentVersionIndex: number;
    /** Name from the DocumentVersion table */
    documentVersionName: string;
    /** Description from the DocumentVersion table */
    documentVersionDescription?: string | undefined;
    /** Association Type from the SegmentInstanceDocumentVersion table

0 = Originating (The document was the document that began the workflow)

1 = Supporting (The document is a supporting document for the workflow)

2 = Response (The document was a response to the workflow) */
    associationType: SegmentInstanceDocumentVersionAssociationType;
    /** Size of the file, in bytes */
    fileSize: number;
}

export class GetSegmentInstanceRecommendationEmailModel implements IGetSegmentInstanceRecommendationEmailModel {
    /** The Run Gid the email is associated with */
    runGid?: string;
    /** Recommended email contents to send to the contractor. */
    content?: string | undefined;
    /** Details of the recommended email that should be sent on completion of the workflow. */
    emailDetails?: EmailPropertiesModel | undefined;
    sentDateTimeUTC?: Date;
    /** List of Attachments that were included on the email */
    attachments?: GetSegmentInstanceRecommendationAttachmentModel[] | undefined;

    constructor(data?: IGetSegmentInstanceRecommendationEmailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.runGid = _data["runGid"];
            this.content = _data["content"];
            this.emailDetails = _data["emailDetails"] ? EmailPropertiesModel.fromJS(_data["emailDetails"]) : <any>undefined;
            this.sentDateTimeUTC = _data["sentDateTimeUTC"] ? new Date(_data["sentDateTimeUTC"].toString()) : <any>undefined;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(GetSegmentInstanceRecommendationAttachmentModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSegmentInstanceRecommendationEmailModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSegmentInstanceRecommendationEmailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["runGid"] = this.runGid;
        data["content"] = this.content;
        data["emailDetails"] = this.emailDetails ? this.emailDetails.toJSON() : <any>undefined;
        data["sentDateTimeUTC"] = this.sentDateTimeUTC ? this.sentDateTimeUTC.toISOString() : <any>undefined;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSegmentInstanceRecommendationEmailModel {
    /** The Run Gid the email is associated with */
    runGid?: string;
    /** Recommended email contents to send to the contractor. */
    content?: string | undefined;
    /** Details of the recommended email that should be sent on completion of the workflow. */
    emailDetails?: EmailPropertiesModel | undefined;
    sentDateTimeUTC?: Date;
    /** List of Attachments that were included on the email */
    attachments?: GetSegmentInstanceRecommendationAttachmentModel[] | undefined;
}

export class GetSegmentInstanceRecommendationRecommendationModel implements IGetSegmentInstanceRecommendationRecommendationModel {
    /** The Run Gid the Evaluation Information is associated with */
    runGid?: string;
    /** Indicates the recommended response for this claim / segment

1 = Accepted (Segment has been accepted, claimed time/budget granted by the principal is added to the contract.)

2 = Rejected (Segment has been rejected, any claimed time/budget is noted but not added to the contract.)

3 = Indeterminate (Resolution not possible at this point.) */
    recommendationOutcome?: SegmentInstanceResolution;
    /** Recommendation duration in days for this claim (Set to 0 if recommendation is to reject claim) */
    recommendationDuration?: number | undefined;
    /** Recommendation duration calendar for this claim

1 = Working (Working calendar)

2 = Business (Business calendar)

3 = CalendarDays (Every regular calendar day (Every regular calendar day, no weekdays or weekends and no holidays. Just regular sequential days.)) */
    recommendationCalendar?: CalendarType | undefined;
    /** Indicates the final response for this claim / segment

1 = Accepted (Segment has been accepted, claimed time/budget granted by the principal is added to the contract.)

2 = Rejected (Segment has been rejected, any claimed time/budget is noted but not added to the contract.)

3 = Indeterminate (Resolution not possible at this point.) */
    resultOutcome?: SegmentInstanceResolution | undefined;
    /** Final duration in days for this claim (Set to 0 if recommendation is to reject claim) */
    resultDuration?: number | undefined;
    /** Final duration calendar for this claim

1 = Working (Working calendar)

2 = Business (Business calendar)

3 = CalendarDays (Every regular calendar day (Every regular calendar day, no weekdays or weekends and no holidays. Just regular sequential days.)) */
    resultCalendar?: CalendarType | undefined;
    /** Description of the result. Will be the override reason if UseRecommended was set to false when finalising the claim */
    resultDescription?: string | undefined;
    /** List of string (html) messages containing explanation for the recommendation */
    recommendationMessages?: string[] | undefined;

    constructor(data?: IGetSegmentInstanceRecommendationRecommendationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.runGid = _data["runGid"];
            this.recommendationOutcome = _data["recommendationOutcome"];
            this.recommendationDuration = _data["recommendationDuration"];
            this.recommendationCalendar = _data["recommendationCalendar"];
            this.resultOutcome = _data["resultOutcome"];
            this.resultDuration = _data["resultDuration"];
            this.resultCalendar = _data["resultCalendar"];
            this.resultDescription = _data["resultDescription"];
            if (Array.isArray(_data["recommendationMessages"])) {
                this.recommendationMessages = [] as any;
                for (let item of _data["recommendationMessages"])
                    this.recommendationMessages!.push(item);
            }
        }
    }

    static fromJS(data: any): GetSegmentInstanceRecommendationRecommendationModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSegmentInstanceRecommendationRecommendationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["runGid"] = this.runGid;
        data["recommendationOutcome"] = this.recommendationOutcome;
        data["recommendationDuration"] = this.recommendationDuration;
        data["recommendationCalendar"] = this.recommendationCalendar;
        data["resultOutcome"] = this.resultOutcome;
        data["resultDuration"] = this.resultDuration;
        data["resultCalendar"] = this.resultCalendar;
        data["resultDescription"] = this.resultDescription;
        if (Array.isArray(this.recommendationMessages)) {
            data["recommendationMessages"] = [];
            for (let item of this.recommendationMessages)
                data["recommendationMessages"].push(item);
        }
        return data;
    }
}

export interface IGetSegmentInstanceRecommendationRecommendationModel {
    /** The Run Gid the Evaluation Information is associated with */
    runGid?: string;
    /** Indicates the recommended response for this claim / segment

1 = Accepted (Segment has been accepted, claimed time/budget granted by the principal is added to the contract.)

2 = Rejected (Segment has been rejected, any claimed time/budget is noted but not added to the contract.)

3 = Indeterminate (Resolution not possible at this point.) */
    recommendationOutcome?: SegmentInstanceResolution;
    /** Recommendation duration in days for this claim (Set to 0 if recommendation is to reject claim) */
    recommendationDuration?: number | undefined;
    /** Recommendation duration calendar for this claim

1 = Working (Working calendar)

2 = Business (Business calendar)

3 = CalendarDays (Every regular calendar day (Every regular calendar day, no weekdays or weekends and no holidays. Just regular sequential days.)) */
    recommendationCalendar?: CalendarType | undefined;
    /** Indicates the final response for this claim / segment

1 = Accepted (Segment has been accepted, claimed time/budget granted by the principal is added to the contract.)

2 = Rejected (Segment has been rejected, any claimed time/budget is noted but not added to the contract.)

3 = Indeterminate (Resolution not possible at this point.) */
    resultOutcome?: SegmentInstanceResolution | undefined;
    /** Final duration in days for this claim (Set to 0 if recommendation is to reject claim) */
    resultDuration?: number | undefined;
    /** Final duration calendar for this claim

1 = Working (Working calendar)

2 = Business (Business calendar)

3 = CalendarDays (Every regular calendar day (Every regular calendar day, no weekdays or weekends and no holidays. Just regular sequential days.)) */
    resultCalendar?: CalendarType | undefined;
    /** Description of the result. Will be the override reason if UseRecommended was set to false when finalising the claim */
    resultDescription?: string | undefined;
    /** List of string (html) messages containing explanation for the recommendation */
    recommendationMessages?: string[] | undefined;
}

export class GetSegmentInstanceRecommendationResponseModel implements IGetSegmentInstanceRecommendationResponseModel {
    /** All Recommendations and Results associated with the SegmentInstance */
    recommendations?: GetSegmentInstanceRecommendationRecommendationModel[] | undefined;
    /** All Emails associated with the SegmentInstance */
    emails?: GetSegmentInstanceRecommendationEmailModel[] | undefined;

    constructor(data?: IGetSegmentInstanceRecommendationResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["recommendations"])) {
                this.recommendations = [] as any;
                for (let item of _data["recommendations"])
                    this.recommendations!.push(GetSegmentInstanceRecommendationRecommendationModel.fromJS(item));
            }
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(GetSegmentInstanceRecommendationEmailModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSegmentInstanceRecommendationResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSegmentInstanceRecommendationResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.recommendations)) {
            data["recommendations"] = [];
            for (let item of this.recommendations)
                data["recommendations"].push(item.toJSON());
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSegmentInstanceRecommendationResponseModel {
    /** All Recommendations and Results associated with the SegmentInstance */
    recommendations?: GetSegmentInstanceRecommendationRecommendationModel[] | undefined;
    /** All Emails associated with the SegmentInstance */
    emails?: GetSegmentInstanceRecommendationEmailModel[] | undefined;
}

export class GetSegmentInstancesResponseModel implements IGetSegmentInstancesResponseModel {
    segmentInstances?: ListSegmentInstanceModel[] | undefined;

    constructor(data?: IGetSegmentInstancesResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["segmentInstances"])) {
                this.segmentInstances = [] as any;
                for (let item of _data["segmentInstances"])
                    this.segmentInstances!.push(ListSegmentInstanceModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSegmentInstancesResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSegmentInstancesResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.segmentInstances)) {
            data["segmentInstances"] = [];
            for (let item of this.segmentInstances)
                data["segmentInstances"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSegmentInstancesResponseModel {
    segmentInstances?: ListSegmentInstanceModel[] | undefined;
}

export class PostFinaliseSegmentInstanceRequestActionOverrideModel implements IPostFinaliseSegmentInstanceRequestActionOverrideModel {
    /** Use Recommended */
    useRecommended!: boolean;
    /** Mandatory if UseRecommended is false, ignored otherwise

1 = Accepted (Segment has been accepted, claimed time/budget granted by the principal is added to the contract.)

2 = Rejected (Segment has been rejected, any claimed time/budget is noted but not added to the contract.)

3 = Indeterminate (Resolution not possible at this point.) */
    overruleOutcome?: SegmentInstanceResolution | undefined;
    /** Mandatory if SegmentProcessType is Claim, UserRecommended is false, and OverruleOutcome is Valid; ignored otherwise. */
    overruleGrant?: number | undefined;
    /** Mandatory is SegmentProcessType is Claim, UserRecommended is false, and OverruleOutcome is Valid; ignored otherwise.

1 = Working (Working calendar)

2 = Business (Business calendar)

3 = CalendarDays (Every regular calendar day (Every regular calendar day, no weekdays or weekends and no holidays. Just regular sequential days.)) */
    overruleSelectedCalendarType?: CalendarType | undefined;
    /** Mandatory if UseRecommended is false, ignored otherwise */
    overruleReason?: string | undefined;

    constructor(data?: IPostFinaliseSegmentInstanceRequestActionOverrideModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.useRecommended = _data["useRecommended"];
            this.overruleOutcome = _data["overruleOutcome"];
            this.overruleGrant = _data["overruleGrant"];
            this.overruleSelectedCalendarType = _data["overruleSelectedCalendarType"];
            this.overruleReason = _data["overruleReason"];
        }
    }

    static fromJS(data: any): PostFinaliseSegmentInstanceRequestActionOverrideModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostFinaliseSegmentInstanceRequestActionOverrideModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["useRecommended"] = this.useRecommended;
        data["overruleOutcome"] = this.overruleOutcome;
        data["overruleGrant"] = this.overruleGrant;
        data["overruleSelectedCalendarType"] = this.overruleSelectedCalendarType;
        data["overruleReason"] = this.overruleReason;
        return data;
    }
}

export interface IPostFinaliseSegmentInstanceRequestActionOverrideModel {
    /** Use Recommended */
    useRecommended: boolean;
    /** Mandatory if UseRecommended is false, ignored otherwise

1 = Accepted (Segment has been accepted, claimed time/budget granted by the principal is added to the contract.)

2 = Rejected (Segment has been rejected, any claimed time/budget is noted but not added to the contract.)

3 = Indeterminate (Resolution not possible at this point.) */
    overruleOutcome?: SegmentInstanceResolution | undefined;
    /** Mandatory if SegmentProcessType is Claim, UserRecommended is false, and OverruleOutcome is Valid; ignored otherwise. */
    overruleGrant?: number | undefined;
    /** Mandatory is SegmentProcessType is Claim, UserRecommended is false, and OverruleOutcome is Valid; ignored otherwise.

1 = Working (Working calendar)

2 = Business (Business calendar)

3 = CalendarDays (Every regular calendar day (Every regular calendar day, no weekdays or weekends and no holidays. Just regular sequential days.)) */
    overruleSelectedCalendarType?: CalendarType | undefined;
    /** Mandatory if UseRecommended is false, ignored otherwise */
    overruleReason?: string | undefined;
}

export class PostFinaliseSegmentInstanceRequestEmailDetailsModel implements IPostFinaliseSegmentInstanceRequestEmailDetailsModel {
    subject!: string;
    /** Will contain multiple lines and formatting */
    content!: string;
    /** Public identifiers of DocumentVersionFiles to be attach to the email */
    documentVersionFileGids!: string[];

    constructor(data?: IPostFinaliseSegmentInstanceRequestEmailDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.documentVersionFileGids = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"];
            this.content = _data["content"];
            if (Array.isArray(_data["documentVersionFileGids"])) {
                this.documentVersionFileGids = [] as any;
                for (let item of _data["documentVersionFileGids"])
                    this.documentVersionFileGids!.push(item);
            }
        }
    }

    static fromJS(data: any): PostFinaliseSegmentInstanceRequestEmailDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostFinaliseSegmentInstanceRequestEmailDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        data["content"] = this.content;
        if (Array.isArray(this.documentVersionFileGids)) {
            data["documentVersionFileGids"] = [];
            for (let item of this.documentVersionFileGids)
                data["documentVersionFileGids"].push(item);
        }
        return data;
    }
}

export interface IPostFinaliseSegmentInstanceRequestEmailDetailsModel {
    subject: string;
    /** Will contain multiple lines and formatting */
    content: string;
    /** Public identifiers of DocumentVersionFiles to be attach to the email */
    documentVersionFileGids: string[];
}

export class PostFinaliseSegmentInstanceRequestModel implements IPostFinaliseSegmentInstanceRequestModel {
    /** Guid indicating which Available Action the user has selected */
    availableActionKey?: string | undefined;
    /** Required if AvailableActionGid is not supplied */
    actionOverride?: PostFinaliseSegmentInstanceRequestActionOverrideModel | undefined;
    /** Required if AvailableActionGid is not supplied
Required if AvailableActionGid matches an Data Driven Available Action that has SendEmail set to true */
    emailDetails?: PostFinaliseSegmentInstanceRequestEmailDetailsModel | undefined;
    /** The Row Version for the Contract Entity (It's a byte array, but OpenApi will treat it as a base64 encoded string. 

So if you're using the Swagger UI you want a string that looks something like 'AAAAAAAACj8=') */
    contractRowVersion!: string;
    /** User defined reference, unique per Contract (Required if a new child SegmentInstance is going to be created. 

If <seealso cref="P:OneTrack.DataDriven.Models.DataDrivenAvailableActionModel.TypeOfChildSegmentInstanceToCreate" /> has a value, that indicates a new child SegmentInstance will be created and therefore ChildDetails is required.) */
    childDetails?: ChildDetailsModel | undefined;

    constructor(data?: IPostFinaliseSegmentInstanceRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.availableActionKey = _data["availableActionKey"];
            this.actionOverride = _data["actionOverride"] ? PostFinaliseSegmentInstanceRequestActionOverrideModel.fromJS(_data["actionOverride"]) : <any>undefined;
            this.emailDetails = _data["emailDetails"] ? PostFinaliseSegmentInstanceRequestEmailDetailsModel.fromJS(_data["emailDetails"]) : <any>undefined;
            this.contractRowVersion = _data["contractRowVersion"];
            this.childDetails = _data["childDetails"] ? ChildDetailsModel.fromJS(_data["childDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PostFinaliseSegmentInstanceRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostFinaliseSegmentInstanceRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["availableActionKey"] = this.availableActionKey;
        data["actionOverride"] = this.actionOverride ? this.actionOverride.toJSON() : <any>undefined;
        data["emailDetails"] = this.emailDetails ? this.emailDetails.toJSON() : <any>undefined;
        data["contractRowVersion"] = this.contractRowVersion;
        data["childDetails"] = this.childDetails ? this.childDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPostFinaliseSegmentInstanceRequestModel {
    /** Guid indicating which Available Action the user has selected */
    availableActionKey?: string | undefined;
    /** Required if AvailableActionGid is not supplied */
    actionOverride?: PostFinaliseSegmentInstanceRequestActionOverrideModel | undefined;
    /** Required if AvailableActionGid is not supplied
Required if AvailableActionGid matches an Data Driven Available Action that has SendEmail set to true */
    emailDetails?: PostFinaliseSegmentInstanceRequestEmailDetailsModel | undefined;
    /** The Row Version for the Contract Entity (It's a byte array, but OpenApi will treat it as a base64 encoded string. 

So if you're using the Swagger UI you want a string that looks something like 'AAAAAAAACj8=') */
    contractRowVersion: string;
    /** User defined reference, unique per Contract (Required if a new child SegmentInstance is going to be created. 

If <seealso cref="P:OneTrack.DataDriven.Models.DataDrivenAvailableActionModel.TypeOfChildSegmentInstanceToCreate" /> has a value, that indicates a new child SegmentInstance will be created and therefore ChildDetails is required.) */
    childDetails?: ChildDetailsModel | undefined;
}

export class PostFinaliseSegmentInstanceResponse implements IPostFinaliseSegmentInstanceResponse {
    /** The gid of the newly created child SegmentInstance IF one was created. */
    segmentInstanceGid?: string | undefined;
    /** The gid of the newly created Run */
    runGid?: string | undefined;
    /** The Key of the Phase used for the newly created Run */
    phaseKey?: string | undefined;
    /** The Row Version for the Contract Entity after it has been updated (It's a byte array, but OpenApi will treat it as a base64 encoded string. 

So if you're using the Swagger UI you want a string that looks something like 'AAAAAAAACj8=') */
    contractRowVersion!: string;

    constructor(data?: IPostFinaliseSegmentInstanceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.segmentInstanceGid = _data["segmentInstanceGid"];
            this.runGid = _data["runGid"];
            this.phaseKey = _data["phaseKey"];
            this.contractRowVersion = _data["contractRowVersion"];
        }
    }

    static fromJS(data: any): PostFinaliseSegmentInstanceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PostFinaliseSegmentInstanceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["segmentInstanceGid"] = this.segmentInstanceGid;
        data["runGid"] = this.runGid;
        data["phaseKey"] = this.phaseKey;
        data["contractRowVersion"] = this.contractRowVersion;
        return data;
    }
}

export interface IPostFinaliseSegmentInstanceResponse {
    /** The gid of the newly created child SegmentInstance IF one was created. */
    segmentInstanceGid?: string | undefined;
    /** The gid of the newly created Run */
    runGid?: string | undefined;
    /** The Key of the Phase used for the newly created Run */
    phaseKey?: string | undefined;
    /** The Row Version for the Contract Entity after it has been updated (It's a byte array, but OpenApi will treat it as a base64 encoded string. 

So if you're using the Swagger UI you want a string that looks something like 'AAAAAAAACj8=') */
    contractRowVersion: string;
}

export class PostInsertSegmentInstanceRequestModel implements IPostInsertSegmentInstanceRequestModel {
    /** User defined reference, unique per Contract */
    reference!: string;
    /** Public Id for Table: Segment Instance */
    segmentInstanceGid!: string;
    /** Public Id for Table: Segment */
    segmentGid!: string;
    /** The WorkflowInstance this form is continuing Table: Workflow Instance */
    parentSegmentInstanceGid?: string | undefined;

    constructor(data?: IPostInsertSegmentInstanceRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reference = _data["reference"];
            this.segmentInstanceGid = _data["segmentInstanceGid"];
            this.segmentGid = _data["segmentGid"];
            this.parentSegmentInstanceGid = _data["parentSegmentInstanceGid"];
        }
    }

    static fromJS(data: any): PostInsertSegmentInstanceRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostInsertSegmentInstanceRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reference"] = this.reference;
        data["segmentInstanceGid"] = this.segmentInstanceGid;
        data["segmentGid"] = this.segmentGid;
        data["parentSegmentInstanceGid"] = this.parentSegmentInstanceGid;
        return data;
    }
}

export interface IPostInsertSegmentInstanceRequestModel {
    /** User defined reference, unique per Contract */
    reference: string;
    /** Public Id for Table: Segment Instance */
    segmentInstanceGid: string;
    /** Public Id for Table: Segment */
    segmentGid: string;
    /** The WorkflowInstance this form is continuing Table: Workflow Instance */
    parentSegmentInstanceGid?: string | undefined;
}

export class PostSegmentInstanceRecommendationRequestModel implements IPostSegmentInstanceRecommendationRequestModel {
    /** The Row Version for the Contract Entity (It's a byte array, but OpenApi will treat it as a base64 encoded string. 

So if you're using the Swagger UI you want a string that looks something like 'AAAAAAAACj8=') */
    contractRowVersion!: string;

    constructor(data?: IPostSegmentInstanceRecommendationRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractRowVersion = _data["contractRowVersion"];
        }
    }

    static fromJS(data: any): PostSegmentInstanceRecommendationRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostSegmentInstanceRecommendationRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractRowVersion"] = this.contractRowVersion;
        return data;
    }
}

export interface IPostSegmentInstanceRecommendationRequestModel {
    /** The Row Version for the Contract Entity (It's a byte array, but OpenApi will treat it as a base64 encoded string. 

So if you're using the Swagger UI you want a string that looks something like 'AAAAAAAACj8=') */
    contractRowVersion: string;
}

export class PostSegmentInstanceRecommendationResponseModel implements IPostSegmentInstanceRecommendationResponseModel {
    /** Indicates the recommended response for this claim / segment

1 = Accepted (Segment has been accepted, claimed time/budget granted by the principal is added to the contract.)

2 = Rejected (Segment has been rejected, any claimed time/budget is noted but not added to the contract.)

3 = Indeterminate (Resolution not possible at this point.) */
    recommendationOutcome!: SegmentInstanceResolution;
    /** Recommendation duration in days for this claim (Set to 0 if recommendation is to reject claim) */
    recommendationDuration!: number;
    /** Recommendation duration calendar for this claim

1 = Working (Working calendar)

2 = Business (Business calendar)

3 = CalendarDays (Every regular calendar day (Every regular calendar day, no weekdays or weekends and no holidays. Just regular sequential days.)) */
    recommendationCalendar!: CalendarType;
    /** List of string (html) messages containing explanation for the recommendation */
    recommendationMessages!: string[];
    /** Recommended email contents to send to the contractor. */
    emailMessage!: string;
    /** Details of the recommended email that should be sent on completion of the workflow. */
    emailDetails!: EmailPropertiesModel;
    /** Text to be displayed on screen to indicate the time for a response to be sent and the consequences for not meeting this. */
    responseText?: string | undefined;
    /** The type of process to perform on the Segment

1 = Notice (Segment (and SegmentInstance) should to be processed as a Notice)

2 = Claim (Segment (and SegmentInstance) should to be processed as a Claim)

3 = Direction (Segment (and SegmentInstance) should be processed as a Direction (note: post-mvp))

4 = RFIInbound (Segment (and SegmentInstance) should be processed as an RFI Inbound)

5 = RFIOutbound (Segment (and SegmentInstance) should be processed as an RFI Outbound)

6 = Variation (Segment (and SegmentInstance) should be processed as a Variation 

This is a variation created by the principal. It might be follow a proposal, or might be stand alone.)

7 = VariationProposal (Segment (and SegmentInstance) should be processed as a Variation Proposal 

This is the principal proposing a variation to the contractor and getting a response to the proposal)

8 = VariationRequest (Segment (and SegmentInstance) should be processed as a Variation Request 

This is the contractor requesting a variation from the principal) */
    segmentProcessType?: SegmentProcessType;
    /** For storing what the next Available Actions are, usually set by Rules. 
If null or empty, previous/old behaviour will be maintained for backwards compatibility. */
    availableActions!: DataDrivenAvailableActionModel[];
    /** Workflow Update Model 
[Workflow Update Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2689859618/Workflow+Update+Object) */
    workflowUpdate!: WorkflowUpdateModel;

    constructor(data?: IPostSegmentInstanceRecommendationResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.recommendationMessages = [];
            this.emailDetails = new EmailPropertiesModel();
            this.availableActions = [];
            this.workflowUpdate = new WorkflowUpdateModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recommendationOutcome = _data["recommendationOutcome"];
            this.recommendationDuration = _data["recommendationDuration"];
            this.recommendationCalendar = _data["recommendationCalendar"];
            if (Array.isArray(_data["recommendationMessages"])) {
                this.recommendationMessages = [] as any;
                for (let item of _data["recommendationMessages"])
                    this.recommendationMessages!.push(item);
            }
            this.emailMessage = _data["emailMessage"];
            this.emailDetails = _data["emailDetails"] ? EmailPropertiesModel.fromJS(_data["emailDetails"]) : new EmailPropertiesModel();
            this.responseText = _data["responseText"];
            this.segmentProcessType = _data["segmentProcessType"];
            if (Array.isArray(_data["availableActions"])) {
                this.availableActions = [] as any;
                for (let item of _data["availableActions"])
                    this.availableActions!.push(DataDrivenAvailableActionModel.fromJS(item));
            }
            this.workflowUpdate = _data["workflowUpdate"] ? WorkflowUpdateModel.fromJS(_data["workflowUpdate"]) : new WorkflowUpdateModel();
        }
    }

    static fromJS(data: any): PostSegmentInstanceRecommendationResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostSegmentInstanceRecommendationResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recommendationOutcome"] = this.recommendationOutcome;
        data["recommendationDuration"] = this.recommendationDuration;
        data["recommendationCalendar"] = this.recommendationCalendar;
        if (Array.isArray(this.recommendationMessages)) {
            data["recommendationMessages"] = [];
            for (let item of this.recommendationMessages)
                data["recommendationMessages"].push(item);
        }
        data["emailMessage"] = this.emailMessage;
        data["emailDetails"] = this.emailDetails ? this.emailDetails.toJSON() : <any>undefined;
        data["responseText"] = this.responseText;
        data["segmentProcessType"] = this.segmentProcessType;
        if (Array.isArray(this.availableActions)) {
            data["availableActions"] = [];
            for (let item of this.availableActions)
                data["availableActions"].push(item.toJSON());
        }
        data["workflowUpdate"] = this.workflowUpdate ? this.workflowUpdate.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPostSegmentInstanceRecommendationResponseModel {
    /** Indicates the recommended response for this claim / segment

1 = Accepted (Segment has been accepted, claimed time/budget granted by the principal is added to the contract.)

2 = Rejected (Segment has been rejected, any claimed time/budget is noted but not added to the contract.)

3 = Indeterminate (Resolution not possible at this point.) */
    recommendationOutcome: SegmentInstanceResolution;
    /** Recommendation duration in days for this claim (Set to 0 if recommendation is to reject claim) */
    recommendationDuration: number;
    /** Recommendation duration calendar for this claim

1 = Working (Working calendar)

2 = Business (Business calendar)

3 = CalendarDays (Every regular calendar day (Every regular calendar day, no weekdays or weekends and no holidays. Just regular sequential days.)) */
    recommendationCalendar: CalendarType;
    /** List of string (html) messages containing explanation for the recommendation */
    recommendationMessages: string[];
    /** Recommended email contents to send to the contractor. */
    emailMessage: string;
    /** Details of the recommended email that should be sent on completion of the workflow. */
    emailDetails: EmailPropertiesModel;
    /** Text to be displayed on screen to indicate the time for a response to be sent and the consequences for not meeting this. */
    responseText?: string | undefined;
    /** The type of process to perform on the Segment

1 = Notice (Segment (and SegmentInstance) should to be processed as a Notice)

2 = Claim (Segment (and SegmentInstance) should to be processed as a Claim)

3 = Direction (Segment (and SegmentInstance) should be processed as a Direction (note: post-mvp))

4 = RFIInbound (Segment (and SegmentInstance) should be processed as an RFI Inbound)

5 = RFIOutbound (Segment (and SegmentInstance) should be processed as an RFI Outbound)

6 = Variation (Segment (and SegmentInstance) should be processed as a Variation 

This is a variation created by the principal. It might be follow a proposal, or might be stand alone.)

7 = VariationProposal (Segment (and SegmentInstance) should be processed as a Variation Proposal 

This is the principal proposing a variation to the contractor and getting a response to the proposal)

8 = VariationRequest (Segment (and SegmentInstance) should be processed as a Variation Request 

This is the contractor requesting a variation from the principal) */
    segmentProcessType?: SegmentProcessType;
    /** For storing what the next Available Actions are, usually set by Rules. 
If null or empty, previous/old behaviour will be maintained for backwards compatibility. */
    availableActions: DataDrivenAvailableActionModel[];
    /** Workflow Update Model 
[Workflow Update Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2689859618/Workflow+Update+Object) */
    workflowUpdate: WorkflowUpdateModel;
}

export class PostUpdateSegmentInstanceDetailsRequestModel implements IPostUpdateSegmentInstanceDetailsRequestModel {
    /** User defined reference, unique per Contract */
    reference!: string;
    /** The Row Version for the Contract Entity (It's a byte array, but OpenApi will treat it as a base64 encoded string. 

So if you're using the Swagger UI you want a string that looks something like 'AAAAAAAACj8=') */
    contractRowVersion!: string;

    constructor(data?: IPostUpdateSegmentInstanceDetailsRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reference = _data["reference"];
            this.contractRowVersion = _data["contractRowVersion"];
        }
    }

    static fromJS(data: any): PostUpdateSegmentInstanceDetailsRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostUpdateSegmentInstanceDetailsRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reference"] = this.reference;
        data["contractRowVersion"] = this.contractRowVersion;
        return data;
    }
}

export interface IPostUpdateSegmentInstanceDetailsRequestModel {
    /** User defined reference, unique per Contract */
    reference: string;
    /** The Row Version for the Contract Entity (It's a byte array, but OpenApi will treat it as a base64 encoded string. 

So if you're using the Swagger UI you want a string that looks something like 'AAAAAAAACj8=') */
    contractRowVersion: string;
}

export class PostUpdateSegmentInstanceDocumentsRequestDocumentVersionAssociationModel implements IPostUpdateSegmentInstanceDocumentsRequestDocumentVersionAssociationModel {
    /** Public Identifier for the Table: Document Version to be associated with the Table: Segment Instance */
    gid?: string;
    /** Association Type of the Document Version to Segment Instance association

0 = Originating (The document was the document that began the workflow)

1 = Supporting (The document is a supporting document for the workflow)

2 = Response (The document was a response to the workflow) */
    associationType?: SegmentInstanceDocumentVersionAssociationType;

    constructor(data?: IPostUpdateSegmentInstanceDocumentsRequestDocumentVersionAssociationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.associationType = _data["associationType"];
        }
    }

    static fromJS(data: any): PostUpdateSegmentInstanceDocumentsRequestDocumentVersionAssociationModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostUpdateSegmentInstanceDocumentsRequestDocumentVersionAssociationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["associationType"] = this.associationType;
        return data;
    }
}

export interface IPostUpdateSegmentInstanceDocumentsRequestDocumentVersionAssociationModel {
    /** Public Identifier for the Table: Document Version to be associated with the Table: Segment Instance */
    gid?: string;
    /** Association Type of the Document Version to Segment Instance association

0 = Originating (The document was the document that began the workflow)

1 = Supporting (The document is a supporting document for the workflow)

2 = Response (The document was a response to the workflow) */
    associationType?: SegmentInstanceDocumentVersionAssociationType;
}

export class PostUpdateSegmentInstanceDocumentsRequestModel implements IPostUpdateSegmentInstanceDocumentsRequestModel {
    /** Details of Table: Document Version to be associated with the Segment Instance */
    associationsToAdd!: PostUpdateSegmentInstanceDocumentsRequestDocumentVersionAssociationModel[];
    /** Details of Table: Document Version to be associated with the Segment Instance */
    associationsToUpdate!: PostUpdateSegmentInstanceDocumentsRequestSegmentInstanceDocumentVersionAssociationModel[];
    /** Public Identifiers for Table: Segment Instance Document Version associations to be removed */
    associationsToRemove!: string[];

    constructor(data?: IPostUpdateSegmentInstanceDocumentsRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.associationsToAdd = [];
            this.associationsToUpdate = [];
            this.associationsToRemove = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["associationsToAdd"])) {
                this.associationsToAdd = [] as any;
                for (let item of _data["associationsToAdd"])
                    this.associationsToAdd!.push(PostUpdateSegmentInstanceDocumentsRequestDocumentVersionAssociationModel.fromJS(item));
            }
            if (Array.isArray(_data["associationsToUpdate"])) {
                this.associationsToUpdate = [] as any;
                for (let item of _data["associationsToUpdate"])
                    this.associationsToUpdate!.push(PostUpdateSegmentInstanceDocumentsRequestSegmentInstanceDocumentVersionAssociationModel.fromJS(item));
            }
            if (Array.isArray(_data["associationsToRemove"])) {
                this.associationsToRemove = [] as any;
                for (let item of _data["associationsToRemove"])
                    this.associationsToRemove!.push(item);
            }
        }
    }

    static fromJS(data: any): PostUpdateSegmentInstanceDocumentsRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostUpdateSegmentInstanceDocumentsRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.associationsToAdd)) {
            data["associationsToAdd"] = [];
            for (let item of this.associationsToAdd)
                data["associationsToAdd"].push(item.toJSON());
        }
        if (Array.isArray(this.associationsToUpdate)) {
            data["associationsToUpdate"] = [];
            for (let item of this.associationsToUpdate)
                data["associationsToUpdate"].push(item.toJSON());
        }
        if (Array.isArray(this.associationsToRemove)) {
            data["associationsToRemove"] = [];
            for (let item of this.associationsToRemove)
                data["associationsToRemove"].push(item);
        }
        return data;
    }
}

export interface IPostUpdateSegmentInstanceDocumentsRequestModel {
    /** Details of Table: Document Version to be associated with the Segment Instance */
    associationsToAdd: PostUpdateSegmentInstanceDocumentsRequestDocumentVersionAssociationModel[];
    /** Details of Table: Document Version to be associated with the Segment Instance */
    associationsToUpdate: PostUpdateSegmentInstanceDocumentsRequestSegmentInstanceDocumentVersionAssociationModel[];
    /** Public Identifiers for Table: Segment Instance Document Version associations to be removed */
    associationsToRemove: string[];
}

export class PostUpdateSegmentInstanceDocumentsRequestSegmentInstanceDocumentVersionAssociationModel implements IPostUpdateSegmentInstanceDocumentsRequestSegmentInstanceDocumentVersionAssociationModel {
    /** Public Identifier for the  Table: Segment Instance Document Version that is already associated with the Table: Segment Instance */
    gid?: string;
    /** Association Type of the Document Version to Segment Instance association

0 = Originating (The document was the document that began the workflow)

1 = Supporting (The document is a supporting document for the workflow)

2 = Response (The document was a response to the workflow) */
    associationType?: SegmentInstanceDocumentVersionAssociationType;

    constructor(data?: IPostUpdateSegmentInstanceDocumentsRequestSegmentInstanceDocumentVersionAssociationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.associationType = _data["associationType"];
        }
    }

    static fromJS(data: any): PostUpdateSegmentInstanceDocumentsRequestSegmentInstanceDocumentVersionAssociationModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostUpdateSegmentInstanceDocumentsRequestSegmentInstanceDocumentVersionAssociationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["associationType"] = this.associationType;
        return data;
    }
}

export interface IPostUpdateSegmentInstanceDocumentsRequestSegmentInstanceDocumentVersionAssociationModel {
    /** Public Identifier for the  Table: Segment Instance Document Version that is already associated with the Table: Segment Instance */
    gid?: string;
    /** Association Type of the Document Version to Segment Instance association

0 = Originating (The document was the document that began the workflow)

1 = Supporting (The document is a supporting document for the workflow)

2 = Response (The document was a response to the workflow) */
    associationType?: SegmentInstanceDocumentVersionAssociationType;
}

export class PostUpdateSegmentInstanceDocumentsResponseModel implements IPostUpdateSegmentInstanceDocumentsResponseModel {
    /** Whether the update resulted in the workflow being reprocessed. If true, UpdateResult should be non null. If false, UpdateResult will be null */
    didProcessWorkflow!: boolean;
    /** The results of processing the claim. Will be null if DidProcessWorkflow is false */
    updateResult!: WorkflowUpdateModel | undefined;

    constructor(data?: IPostUpdateSegmentInstanceDocumentsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.didProcessWorkflow = _data["didProcessWorkflow"];
            this.updateResult = _data["updateResult"] ? WorkflowUpdateModel.fromJS(_data["updateResult"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PostUpdateSegmentInstanceDocumentsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostUpdateSegmentInstanceDocumentsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["didProcessWorkflow"] = this.didProcessWorkflow;
        data["updateResult"] = this.updateResult ? this.updateResult.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPostUpdateSegmentInstanceDocumentsResponseModel {
    /** Whether the update resulted in the workflow being reprocessed. If true, UpdateResult should be non null. If false, UpdateResult will be null */
    didProcessWorkflow: boolean;
    /** The results of processing the claim. Will be null if DidProcessWorkflow is false */
    updateResult: WorkflowUpdateModel | undefined;
}

export class PostUpdateSegmentInstanceResponseRequestModel implements IPostUpdateSegmentInstanceResponseRequestModel {
    /** For initial request, property will be an empty array */
    responses!: DataDrivenResponseModel[];

    constructor(data?: IPostUpdateSegmentInstanceResponseRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.responses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["responses"])) {
                this.responses = [] as any;
                for (let item of _data["responses"])
                    this.responses!.push(DataDrivenResponseModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PostUpdateSegmentInstanceResponseRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostUpdateSegmentInstanceResponseRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.responses)) {
            data["responses"] = [];
            for (let item of this.responses)
                data["responses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPostUpdateSegmentInstanceResponseRequestModel {
    /** For initial request, property will be an empty array */
    responses: DataDrivenResponseModel[];
}

export class PostUpdateSegmentInstanceStatusRequestModel implements IPostUpdateSegmentInstanceStatusRequestModel {
    /** [Segment Instance Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Segment-Instance-Status)

            The status of the Segment Instance (The status type is how this status is broadly referenced within the system and is used in logic. 

For the sake of simplifying logic 'Open' statuses have a value less than 16 and 'Closed' statuses are equal to or greater than 16.
<seealso cref="F:OneTrack.Data.SegmentInstanceStatusConstants.MinOpenValue" />,  <seealso cref="F:OneTrack.Data.SegmentInstanceStatusConstants.MaxOpenValue" />, <seealso cref="F:OneTrack.Data.SegmentInstanceStatusConstants.MinClosedValue" /> and  <seealso cref="F:OneTrack.Data.SegmentInstanceStatusConstants.MaxClosedValue" />)

1 = InProgress (Segment is unresolved, this is the initial status for most segments)

2 = Suspended (Segment is unresolved but is marked as suspended, post MVP this will include additional logic for ‘Stopping the ticking of clocks’)

3 = InfoRequestedAndNotSuspended (Segment is unresolved and is noting that additional information has been requested)

4 = InfoRequestedAndSuspended (Effectively the same as both ‘Info Requested and Not Suspended’ and ‘Suspended’)

16 = Complete (Segment has been resolved)

17 = Withdrawn (Segment has been withdrawn (this is specially for when a contractor withdraws a claim))

18 = Cancelled (Segment has been cancelled (this is specifically for when the principal cancels a claim))

19 = Disputed (Segment is resolved and has been marked as being in dispute, Post MVP this means an additional dispute workflow as been created)

20 = LegalDispute (Same as Disputed but for Legal Disputes) */
    status!: SegmentInstanceStatus;
    reason?: string | undefined;
    /** The Row Version for the Contract Entity (It's a byte array, but OpenApi will treat it as a base64 encoded string. 

So if you're using the Swagger UI you want a string that looks something like 'AAAAAAAACj8=') */
    contractRowVersion!: string;

    constructor(data?: IPostUpdateSegmentInstanceStatusRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.reason = _data["reason"];
            this.contractRowVersion = _data["contractRowVersion"];
        }
    }

    static fromJS(data: any): PostUpdateSegmentInstanceStatusRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostUpdateSegmentInstanceStatusRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["reason"] = this.reason;
        data["contractRowVersion"] = this.contractRowVersion;
        return data;
    }
}

export interface IPostUpdateSegmentInstanceStatusRequestModel {
    /** [Segment Instance Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Segment-Instance-Status)

            The status of the Segment Instance (The status type is how this status is broadly referenced within the system and is used in logic. 

For the sake of simplifying logic 'Open' statuses have a value less than 16 and 'Closed' statuses are equal to or greater than 16.
<seealso cref="F:OneTrack.Data.SegmentInstanceStatusConstants.MinOpenValue" />,  <seealso cref="F:OneTrack.Data.SegmentInstanceStatusConstants.MaxOpenValue" />, <seealso cref="F:OneTrack.Data.SegmentInstanceStatusConstants.MinClosedValue" /> and  <seealso cref="F:OneTrack.Data.SegmentInstanceStatusConstants.MaxClosedValue" />)

1 = InProgress (Segment is unresolved, this is the initial status for most segments)

2 = Suspended (Segment is unresolved but is marked as suspended, post MVP this will include additional logic for ‘Stopping the ticking of clocks’)

3 = InfoRequestedAndNotSuspended (Segment is unresolved and is noting that additional information has been requested)

4 = InfoRequestedAndSuspended (Effectively the same as both ‘Info Requested and Not Suspended’ and ‘Suspended’)

16 = Complete (Segment has been resolved)

17 = Withdrawn (Segment has been withdrawn (this is specially for when a contractor withdraws a claim))

18 = Cancelled (Segment has been cancelled (this is specifically for when the principal cancels a claim))

19 = Disputed (Segment is resolved and has been marked as being in dispute, Post MVP this means an additional dispute workflow as been created)

20 = LegalDispute (Same as Disputed but for Legal Disputes) */
    status: SegmentInstanceStatus;
    reason?: string | undefined;
    /** The Row Version for the Contract Entity (It's a byte array, but OpenApi will treat it as a base64 encoded string. 

So if you're using the Swagger UI you want a string that looks something like 'AAAAAAAACj8=') */
    contractRowVersion: string;
}

export class GetTemporaryStorageObjectModel implements IGetTemporaryStorageObjectModel {
    /** Data objects Gid */
    gid?: string;
    /** Should match a value from [Well known Temporary Storage Types](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2271084579/Well+known+Temporary+Storage+Types)
This however isn’t enforced by the API or database */
    type?: string | undefined;
    /** The data being stored, this will likely be json */
    data?: string | undefined;

    constructor(data?: IGetTemporaryStorageObjectModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.type = _data["type"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): GetTemporaryStorageObjectModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetTemporaryStorageObjectModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["type"] = this.type;
        data["data"] = this.data;
        return data;
    }
}

export interface IGetTemporaryStorageObjectModel {
    /** Data objects Gid */
    gid?: string;
    /** Should match a value from [Well known Temporary Storage Types](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2271084579/Well+known+Temporary+Storage+Types)
This however isn’t enforced by the API or database */
    type?: string | undefined;
    /** The data being stored, this will likely be json */
    data?: string | undefined;
}

export class GetTemporaryStorageResponseModel implements IGetTemporaryStorageResponseModel {
    items?: GetTemporaryStorageObjectModel[] | undefined;

    constructor(data?: IGetTemporaryStorageResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetTemporaryStorageObjectModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTemporaryStorageResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetTemporaryStorageResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTemporaryStorageResponseModel {
    items?: GetTemporaryStorageObjectModel[] | undefined;
}

export class PostDeleteTemporaryStorageRequestModel implements IPostDeleteTemporaryStorageRequestModel {

    constructor(data?: IPostDeleteTemporaryStorageRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): PostDeleteTemporaryStorageRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostDeleteTemporaryStorageRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IPostDeleteTemporaryStorageRequestModel {
}

export class PostUpsertTemporaryStorageRequestModel implements IPostUpsertTemporaryStorageRequestModel {
    /** The kind of data we are storing, 

this should match one of the values in  Well known Temporary Storage Types,  

this however isn’t enforced by the API 
 */
    type!: string;
    /** The data we are storing, this will usually be json but can technically be anything inside of a string */
    data!: string;

    constructor(data?: IPostUpsertTemporaryStorageRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): PostUpsertTemporaryStorageRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostUpsertTemporaryStorageRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["data"] = this.data;
        return data;
    }
}

export interface IPostUpsertTemporaryStorageRequestModel {
    /** The kind of data we are storing, 

this should match one of the values in  Well known Temporary Storage Types,  

this however isn’t enforced by the API 
 */
    type: string;
    /** The data we are storing, this will usually be json but can technically be anything inside of a string */
    data: string;
}

export class GetMyProfileOrganisationModel implements IGetMyProfileOrganisationModel {
    /** Public identifier for user’s organisation */
    gid!: string;
    /** User's Organisation's Name */
    name!: string;
    /** User's Organisation's Name */
    code!: string;
    /** User's Organisation's Status. (OneTrack.Data.Enums.OrganisationStatus
<seealso href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Organisation-Status">Enums Organisation Status</seealso>)

1 = Active (The organisation is active)

2 = Pending (The organisation is pending)

3 = Suspended (The organisation has been suspended)

4 = Inactive (The organisation is inactive) */
    status!: OrganisationStatus;
    /** Contact Number of the User's Organisation */
    phone!: string;
    /** Object that includes all the address details 

These details are from [Table: Organisation](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/1340834309/Table+Organisation) */
    address!: AddressModel;
    /** This value is found in [Table: Organisation User](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/1891041317/Table+Organisation+User) */
    organisationUser!: UserStatusModel;

    constructor(data?: IGetMyProfileOrganisationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.address = new AddressModel();
            this.organisationUser = new UserStatusModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.status = _data["status"];
            this.phone = _data["phone"];
            this.address = _data["address"] ? AddressModel.fromJS(_data["address"]) : new AddressModel();
            this.organisationUser = _data["organisationUser"] ? UserStatusModel.fromJS(_data["organisationUser"]) : new UserStatusModel();
        }
    }

    static fromJS(data: any): GetMyProfileOrganisationModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyProfileOrganisationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["name"] = this.name;
        data["code"] = this.code;
        data["status"] = this.status;
        data["phone"] = this.phone;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["organisationUser"] = this.organisationUser ? this.organisationUser.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMyProfileOrganisationModel {
    /** Public identifier for user’s organisation */
    gid: string;
    /** User's Organisation's Name */
    name: string;
    /** User's Organisation's Name */
    code: string;
    /** User's Organisation's Status. (OneTrack.Data.Enums.OrganisationStatus
<seealso href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Organisation-Status">Enums Organisation Status</seealso>)

1 = Active (The organisation is active)

2 = Pending (The organisation is pending)

3 = Suspended (The organisation has been suspended)

4 = Inactive (The organisation is inactive) */
    status: OrganisationStatus;
    /** Contact Number of the User's Organisation */
    phone: string;
    /** Object that includes all the address details 

These details are from [Table: Organisation](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/1340834309/Table+Organisation) */
    address: AddressModel;
    /** This value is found in [Table: Organisation User](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/1891041317/Table+Organisation+User) */
    organisationUser: UserStatusModel;
}

export class GetMyProfileResponseAconexApiInteractionModel implements IGetMyProfileResponseAconexApiInteractionModel {
    /** The status of the Interaction(s) with Aconex API(s) ([Aconex Interaction Result Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/3082092545/Aconex+Interaction+Result+T+Object)

)

0 = Success (Interaction with the Aconex API was successful)

1 = NoTokenInformation (There was no Token Information available to perform the interaction with the Aconex API)

2 = RefreshTokenExpired (The Refresh Token available to for interaction with the Aconex API has expired)

3 = AccessTokenExpired (The Access Token available to for interaction with the Aconex API has expired (Note: This does not indicate that future interactions will fail, it only indicates that the Access Token will need to be refreshed before the next interaction.))

4 = InteractionFailed (The Aconex API Interaction failed (Usually this indicates that the Aconex API returned a 'non authentication' related error message)) */
    aconexInteractionStatus?: AconexInteractionStatus;
    /** Result - usually at least partially made up of the response from the interaction(s) with Aconex API(s). Will likely be null unless Status is Success */
    result?: GetMyProfileResponseAconexUserModel | undefined;

    constructor(data?: IGetMyProfileResponseAconexApiInteractionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aconexInteractionStatus = _data["aconexInteractionStatus"];
            this.result = _data["result"] ? GetMyProfileResponseAconexUserModel.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMyProfileResponseAconexApiInteractionModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyProfileResponseAconexApiInteractionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aconexInteractionStatus"] = this.aconexInteractionStatus;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMyProfileResponseAconexApiInteractionModel {
    /** The status of the Interaction(s) with Aconex API(s) ([Aconex Interaction Result Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/3082092545/Aconex+Interaction+Result+T+Object)

)

0 = Success (Interaction with the Aconex API was successful)

1 = NoTokenInformation (There was no Token Information available to perform the interaction with the Aconex API)

2 = RefreshTokenExpired (The Refresh Token available to for interaction with the Aconex API has expired)

3 = AccessTokenExpired (The Access Token available to for interaction with the Aconex API has expired (Note: This does not indicate that future interactions will fail, it only indicates that the Access Token will need to be refreshed before the next interaction.))

4 = InteractionFailed (The Aconex API Interaction failed (Usually this indicates that the Aconex API returned a 'non authentication' related error message)) */
    aconexInteractionStatus?: AconexInteractionStatus;
    /** Result - usually at least partially made up of the response from the interaction(s) with Aconex API(s). Will likely be null unless Status is Success */
    result?: GetMyProfileResponseAconexUserModel | undefined;
}

export class GetMyProfileResponseAconexUserModel implements IGetMyProfileResponseAconexUserModel {
    /** Gets or sets the organization name of the user. (Type: String(60)) */
    organizationName?: string | undefined;
    /** Gets or sets the first name of the user. (Type: String(30)) */
    userFirstName?: string | undefined;
    /** Gets or sets the last name of the user. (Type: String(30)) */
    userLastName?: string | undefined;
    /** Gets or sets the username of the user. (Type: String(80)) */
    userName?: string | undefined;
    /** Gets or sets the job title of the user. (Type: String(50)) */
    jobTitle?: string | undefined;
    /** Gets or sets the division of the user. (Type: String(100)) */
    division?: string | undefined;
    /** User Site. Value like 'https://au1.aconex.com' */
    userSite?: string | undefined;

    constructor(data?: IGetMyProfileResponseAconexUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationName = _data["organizationName"];
            this.userFirstName = _data["userFirstName"];
            this.userLastName = _data["userLastName"];
            this.userName = _data["userName"];
            this.jobTitle = _data["jobTitle"];
            this.division = _data["division"];
            this.userSite = _data["userSite"];
        }
    }

    static fromJS(data: any): GetMyProfileResponseAconexUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyProfileResponseAconexUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationName"] = this.organizationName;
        data["userFirstName"] = this.userFirstName;
        data["userLastName"] = this.userLastName;
        data["userName"] = this.userName;
        data["jobTitle"] = this.jobTitle;
        data["division"] = this.division;
        data["userSite"] = this.userSite;
        return data;
    }
}

export interface IGetMyProfileResponseAconexUserModel {
    /** Gets or sets the organization name of the user. (Type: String(60)) */
    organizationName?: string | undefined;
    /** Gets or sets the first name of the user. (Type: String(30)) */
    userFirstName?: string | undefined;
    /** Gets or sets the last name of the user. (Type: String(30)) */
    userLastName?: string | undefined;
    /** Gets or sets the username of the user. (Type: String(80)) */
    userName?: string | undefined;
    /** Gets or sets the job title of the user. (Type: String(50)) */
    jobTitle?: string | undefined;
    /** Gets or sets the division of the user. (Type: String(100)) */
    division?: string | undefined;
    /** User Site. Value like 'https://au1.aconex.com' */
    userSite?: string | undefined;
}

export class GetMyProfileResponseModel implements IGetMyProfileResponseModel {
    /** Public identifier for user */
    gid!: string;
    /** First Name of the User */
    firstName!: string;
    /** Last Name of the User */
    lastName!: string;
    /** Email of the User */
    email!: string;
    /** BusinessName of the User */
    businessName?: string | undefined;
    /** Object that includes all the street address details for the User 
 */
    streetAddress?: AddressModel | undefined;
    /** Object that includes all the postal address details for the User 
 */
    postalAddress?: AddressModel | undefined;
    /** Mobile Number of the User */
    mobile?: string | undefined;
    /** Phone Number of the User */
    phone?: string | undefined;
    /** Fax Number of the User */
    fax?: string | undefined;
    /** User’s organisations */
    organisations!: GetMyProfileOrganisationModel[];
    /** Whether the user can create Contracts or not */
    canCreateContract!: boolean;
    /** Object with last modification information in it */
    lastModified!: LastModifiedModel;
    /** While this is technically not required it should, in practice, always return a value */
    lastLoginUtc?: Date | undefined;
    /** While this is technically not required it should, in practice, always return a value */
    lastLoginIpAddress?: string | undefined;
    /** Aconex User Information Interaction Result */
    aconexUserInformation!: GetMyProfileResponseAconexApiInteractionModel;

    constructor(data?: IGetMyProfileResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.organisations = [];
            this.lastModified = new LastModifiedModel();
            this.aconexUserInformation = new GetMyProfileResponseAconexApiInteractionModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.businessName = _data["businessName"];
            this.streetAddress = _data["streetAddress"] ? AddressModel.fromJS(_data["streetAddress"]) : <any>undefined;
            this.postalAddress = _data["postalAddress"] ? AddressModel.fromJS(_data["postalAddress"]) : <any>undefined;
            this.mobile = _data["mobile"];
            this.phone = _data["phone"];
            this.fax = _data["fax"];
            if (Array.isArray(_data["organisations"])) {
                this.organisations = [] as any;
                for (let item of _data["organisations"])
                    this.organisations!.push(GetMyProfileOrganisationModel.fromJS(item));
            }
            this.canCreateContract = _data["canCreateContract"];
            this.lastModified = _data["lastModified"] ? LastModifiedModel.fromJS(_data["lastModified"]) : new LastModifiedModel();
            this.lastLoginUtc = _data["lastLoginUtc"] ? new Date(_data["lastLoginUtc"].toString()) : <any>undefined;
            this.lastLoginIpAddress = _data["lastLoginIpAddress"];
            this.aconexUserInformation = _data["aconexUserInformation"] ? GetMyProfileResponseAconexApiInteractionModel.fromJS(_data["aconexUserInformation"]) : new GetMyProfileResponseAconexApiInteractionModel();
        }
    }

    static fromJS(data: any): GetMyProfileResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyProfileResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["businessName"] = this.businessName;
        data["streetAddress"] = this.streetAddress ? this.streetAddress.toJSON() : <any>undefined;
        data["postalAddress"] = this.postalAddress ? this.postalAddress.toJSON() : <any>undefined;
        data["mobile"] = this.mobile;
        data["phone"] = this.phone;
        data["fax"] = this.fax;
        if (Array.isArray(this.organisations)) {
            data["organisations"] = [];
            for (let item of this.organisations)
                data["organisations"].push(item.toJSON());
        }
        data["canCreateContract"] = this.canCreateContract;
        data["lastModified"] = this.lastModified ? this.lastModified.toJSON() : <any>undefined;
        data["lastLoginUtc"] = this.lastLoginUtc ? this.lastLoginUtc.toISOString() : <any>undefined;
        data["lastLoginIpAddress"] = this.lastLoginIpAddress;
        data["aconexUserInformation"] = this.aconexUserInformation ? this.aconexUserInformation.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMyProfileResponseModel {
    /** Public identifier for user */
    gid: string;
    /** First Name of the User */
    firstName: string;
    /** Last Name of the User */
    lastName: string;
    /** Email of the User */
    email: string;
    /** BusinessName of the User */
    businessName?: string | undefined;
    /** Object that includes all the street address details for the User 
 */
    streetAddress?: AddressModel | undefined;
    /** Object that includes all the postal address details for the User 
 */
    postalAddress?: AddressModel | undefined;
    /** Mobile Number of the User */
    mobile?: string | undefined;
    /** Phone Number of the User */
    phone?: string | undefined;
    /** Fax Number of the User */
    fax?: string | undefined;
    /** User’s organisations */
    organisations: GetMyProfileOrganisationModel[];
    /** Whether the user can create Contracts or not */
    canCreateContract: boolean;
    /** Object with last modification information in it */
    lastModified: LastModifiedModel;
    /** While this is technically not required it should, in practice, always return a value */
    lastLoginUtc?: Date | undefined;
    /** While this is technically not required it should, in practice, always return a value */
    lastLoginIpAddress?: string | undefined;
    /** Aconex User Information Interaction Result */
    aconexUserInformation: GetMyProfileResponseAconexApiInteractionModel;
}

export class PostChangeMyPasswordRequestModel implements IPostChangeMyPasswordRequestModel {
    /** Current Password of the Current User */
    currentPassword!: string;
    /** New Password for the Current User */
    newPassword!: string;

    constructor(data?: IPostChangeMyPasswordRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): PostChangeMyPasswordRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostChangeMyPasswordRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IPostChangeMyPasswordRequestModel {
    /** Current Password of the Current User */
    currentPassword: string;
    /** New Password for the Current User */
    newPassword: string;
}

export class PostDisableUserResponseModel implements IPostDisableUserResponseModel {
    success?: boolean;

    constructor(data?: IPostDisableUserResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): PostDisableUserResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostDisableUserResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface IPostDisableUserResponseModel {
    success?: boolean;
}

export class PostEditMyUserProfileRequestModel implements IPostEditMyUserProfileRequestModel {
    /** First Name of the User */
    firstName!: string;
    /** Last Name of the User */
    lastName!: string;
    /** BusinessName of the User */
    businessName?: string | undefined;
    /** Object that includes all the street address details for the User 
 */
    streetAddress?: AddressModel | undefined;
    /** Object that includes all the postal address details for the User 
 */
    postalAddress?: AddressModel | undefined;
    /** Mobile Number of the User */
    mobile?: string | undefined;
    /** Phone Number of the User */
    phone?: string | undefined;
    /** Fax Number of the User */
    fax?: string | undefined;
    /** Email of the User */
    email!: string;

    constructor(data?: IPostEditMyUserProfileRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.businessName = _data["businessName"];
            this.streetAddress = _data["streetAddress"] ? AddressModel.fromJS(_data["streetAddress"]) : <any>undefined;
            this.postalAddress = _data["postalAddress"] ? AddressModel.fromJS(_data["postalAddress"]) : <any>undefined;
            this.mobile = _data["mobile"];
            this.phone = _data["phone"];
            this.fax = _data["fax"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): PostEditMyUserProfileRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostEditMyUserProfileRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["businessName"] = this.businessName;
        data["streetAddress"] = this.streetAddress ? this.streetAddress.toJSON() : <any>undefined;
        data["postalAddress"] = this.postalAddress ? this.postalAddress.toJSON() : <any>undefined;
        data["mobile"] = this.mobile;
        data["phone"] = this.phone;
        data["fax"] = this.fax;
        data["email"] = this.email;
        return data;
    }
}

export interface IPostEditMyUserProfileRequestModel {
    /** First Name of the User */
    firstName: string;
    /** Last Name of the User */
    lastName: string;
    /** BusinessName of the User */
    businessName?: string | undefined;
    /** Object that includes all the street address details for the User 
 */
    streetAddress?: AddressModel | undefined;
    /** Object that includes all the postal address details for the User 
 */
    postalAddress?: AddressModel | undefined;
    /** Mobile Number of the User */
    mobile?: string | undefined;
    /** Phone Number of the User */
    phone?: string | undefined;
    /** Fax Number of the User */
    fax?: string | undefined;
    /** Email of the User */
    email: string;
}

export class PostEnableUserResponseModel implements IPostEnableUserResponseModel {
    success?: boolean;

    constructor(data?: IPostEnableUserResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): PostEnableUserResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostEnableUserResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface IPostEnableUserResponseModel {
    success?: boolean;
}

export class PostSendTestEmailFromIDPResponseModel implements IPostSendTestEmailFromIDPResponseModel {
    message?: string | undefined;
    success?: boolean;

    constructor(data?: IPostSendTestEmailFromIDPResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): PostSendTestEmailFromIDPResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostSendTestEmailFromIDPResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["success"] = this.success;
        return data;
    }
}

export interface IPostSendTestEmailFromIDPResponseModel {
    message?: string | undefined;
    success?: boolean;
}

export class PostSendTestEmailRequestModel implements IPostSendTestEmailRequestModel {
    email?: string | undefined;

    constructor(data?: IPostSendTestEmailRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): PostSendTestEmailRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostSendTestEmailRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IPostSendTestEmailRequestModel {
    email?: string | undefined;
}

export class PostSendTestEmailResponseModel implements IPostSendTestEmailResponseModel {
    message?: string | undefined;
    success?: boolean;

    constructor(data?: IPostSendTestEmailResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): PostSendTestEmailResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostSendTestEmailResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["success"] = this.success;
        return data;
    }
}

export interface IPostSendTestEmailResponseModel {
    message?: string | undefined;
    success?: boolean;
}

/** Contains Aconex Document Metadata that is relevant to OneTrack. (This is essentially a one to one mapping of the EF AconexDocumentMetadataModel, the difference is that this model is for exposing to the outside world. This model is intended to be shared, so can be used by multiple endpoints. However it's likely that it won't get used all that much because very few endpoints really need to return this amount of data.) */
export class AconexDocumentMetadataModel implements IAconexDocumentMetadataModel {
    /** Aconex Project Id for the document. (This property does not appear in the Aconex API version of this model, we have to set it ourselves manually.) */
    projectId?: string | undefined;
    /** The User Site of the user that the document is associated with. This is usually either the current user, or the user who originally imported the Document from Aconex. (This property does not appear in the Aconex API version of this model, we have to set it ourselves manually.) */
    userSite?: string | undefined;
    /** Unique identifier for the document. */
    documentId?: string | undefined;
    /** Date when the document was approved. (Returned when the return_fields parameter includes the value "approved".) */
    dateApprovedUtc?: Date | undefined;
    /** The author of the document. (String(60)
Returned when the return_fields parameter includes the value "author".) */
    author?: string | undefined;
    /** The person who authorized the document. (String(60)
Returned when the return_fields parameter includes the value "authorisedBy".) */
    authorisedBy?: string | undefined;
    /** The category of the document. (String(50)
Returned when the return_fields parameter includes the value "category".) */
    category?: string | undefined;
    /** Comments associated with the document. (String(1024)
Returned when the return_fields parameter includes the value "comments".) */
    comments?: string | undefined;
    /** Comments2 associated with the document. (String(1024)
Returned when the return_fields parameter includes the value "comments2".) */
    comments2?: string | undefined;
    /** Indicates if the document is confidential. (Returned when the return_fields parameter includes the value "confidential".) */
    confidential?: boolean | undefined;
    /** Indicates if the document is a contract deliverable. (Returned when the return_fields parameter includes the value "contractDeliverable".) */
    contractDeliverable?: boolean | undefined;
    /** Contract number associated with the document. (String(50)
Returned when the return_fields parameter includes the value "contractnumber".) */
    contractNumber?: string | undefined;
    /** Contractor document number associated with the document. (String(50)
Returned when the return_fields parameter includes the value "contractordocumentnumber".) */
    contractorDocumentNumber?: string | undefined;
    /** Contractor revision associated with the document. (String(15)
Returned when the return_fields parameter includes the value "contractorrev".) */
    contractorRevision?: string | undefined;
    /** Indicates if this is the current revision of the document. (Returned when the return_fields parameter includes the value "current".
Determines whether this revision of the document is the current revision.) */
    current?: boolean | undefined;
    /** Date when the document was created. (Returned when the return_fields parameter includes the value "received".
UTC format.) */
    dateCreatedUtc?: Date | undefined;
    /** Date for review of the document. (Returned when the return_fields parameter includes the value "forreview".
UTC format.) */
    dateForReviewUtc?: Date | undefined;
    /** Date when the document was last modified. (Returned when the return_fields parameter includes the value "registered".
UTC format.) */
    dateModifiedUtc?: Date | undefined;
    /** Date when the document was reviewed. (Returned when the return_fields parameter includes the value "reviewed".
UTC format.) */
    dateReviewedUtc?: Date | undefined;
    /** Discipline associated with the document. (String(50)
Returned when the return_fields parameter includes the value "discipline".) */
    discipline?: string | undefined;
    /** Document number. (String(210)
Returned when the return_fields parameter includes the value "docno".) */
    documentNumber?: string | undefined;
    /** The document type. (Returned when the return_fields parameter includes the value "statusid".) */
    documentStatus?: string | undefined;
    /** Type of the document. (Returned when the return_fields parameter includes the value "doctype".) */
    documentType?: string | undefined;
    /** Size of the document file. (Returned when the return_fields parameter includes the value "fileSize".) */
    fileSize?: number | undefined;
    /** Name of the document file. (Returned when the return_fields parameter includes the value "filename".) */
    filename?: string | undefined;
    /** The type of the document file. (String(3)
Returned when the return_fields parameter includes the value "fileType".) */
    fileType?: string | undefined;
    /** Date when the last markup was made. (Returned when the return_fields parameter includes the value "markupLastModifiedDate".
UTC format.) */
    markupLastModifiedDateUtc?: Date | undefined;
    /** Milestone date associated with the document. (Returned when the return_fields parameter includes the value "milestonedate".
UTC format.) */
    milestoneDateUtc?: Date | undefined;
    /** Count of markups on the document. (Returned when the return_fields parameter includes the value "numberOfMarkups".) */
    numberOfMarkups?: number | undefined;
    /** Package number associated with the document. (String(50)
Returned when the return_fields parameter includes the value "packagenumber".) */
    packageNumber?: string | undefined;
    /** Percentage of completion for the document. (Returned when the return_fields parameter includes the value "percentComplete".) */
    percentComplete?: number | undefined;
    /** Planned submission date for the document. (String(15)
Returned when the return_fields parameter includes the value "plannedsubmissiondate".
UTC format.) */
    plannedSubmissionDateUtc?: Date | undefined;
    /** Size of the document when printed. (String(15)
Returned when the return_fields parameter includes the value "printSize".) */
    printSize?: string | undefined;
    /** Reference information for the document. (String(120)
Returned when the return_fields parameter includes the value "reference".) */
    reference?: string | undefined;
    /** Source of the review for the document. (String(50)
Returned when the return_fields parameter includes the value "reviewSource"
From Release 21.10:
The field will include actual "Workflow Number" / "Correspondence Number" / "SupploerDocPackageNumber" if it exists for the document corresponding to type of Source (Workflow / Transmittal / Supplier Document).

Eg:
Workflow : <ReviewSource>WF-000002</ReviewSource>
Transmittal : <ReviewSource>145228</ReviewSource> 
Supplier Document : <ReviewSource>SD-000004</ReviewSource> 
No Review Source : <ReviewSource>None</ReviewSource>) */
    reviewSource?: string | undefined;
    /** The Review Status of the document. (String(50)
Returned when the return_fields parameter includes the value "reviewstatus".) */
    reviewStatus?: string | undefined;
    /** Revision of the document. (String(15) 

Returned when the return_fields parameter includes the value "revision".) */
    revision?: string | undefined;
    /** Revision Date of the document. (Returned when the return_fields parameter includes the value "revisiondate".
UTC format.) */
    revisionDateUtc?: Date | undefined;
    /** Tag number associated with the document. (String(50)
Returned when the return_fields parameter includes the value "tagNumber".) */
    tagNumber?: string | undefined;
    /** Title of the document. (String(210)
Returned when the return_fields parameter includes the value "title".) */
    title?: string | undefined;
    /** Date when the document was sent to client. (Returned when the return_fields parameter includes the value "toclient".
UTC format.) */
    toClientDateUtc?: Date | undefined;
    /** The tracking ID for the document. (The tracking ID is a unique identifier for all versions of a specific document. 

When a document is first registered into Aconex, a unique identifier is generated 

and this value is assigned to all document revisions of that document. 

One can use this tracking identifier to create a chain of documents.) */
    trackingId?: string | undefined;
    /** The version number of the document. (The version number provides information relating to the sequence in 

which the document was registered within the chain of revisions. 

For all documents with the same Tracking Id, the version number will be an integer value starting from 1.

e.g. When a document is newly registered into Aconex, its version number will be 1. 

When it is superseded, a new document with a version number of 2 will be created. 

Both document revisions will be accessible using their respective document Id's.) */
    versionNumber?: number | undefined;
    /** Vendor code associated with the document. (String(50)
Returned when the return_fields parameter includes the value "vdrcode".) */
    vdrcode?: string | undefined;
    /** Vendor document number. (String(50)
Returned when the return_fields parameter includes the value "vendordocumentnumber".) */
    vendorDocumentNumber?: string | undefined;
    /** Vendor revision. (String(15)
Returned when the return_fields parameter includes the value "vendorrev".) */
    vendorRevision?: string | undefined;

    constructor(data?: IAconexDocumentMetadataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.userSite = _data["userSite"];
            this.documentId = _data["documentId"];
            this.dateApprovedUtc = _data["dateApprovedUtc"] ? new Date(_data["dateApprovedUtc"].toString()) : <any>undefined;
            this.author = _data["author"];
            this.authorisedBy = _data["authorisedBy"];
            this.category = _data["category"];
            this.comments = _data["comments"];
            this.comments2 = _data["comments2"];
            this.confidential = _data["confidential"];
            this.contractDeliverable = _data["contractDeliverable"];
            this.contractNumber = _data["contractNumber"];
            this.contractorDocumentNumber = _data["contractorDocumentNumber"];
            this.contractorRevision = _data["contractorRevision"];
            this.current = _data["current"];
            this.dateCreatedUtc = _data["dateCreatedUtc"] ? new Date(_data["dateCreatedUtc"].toString()) : <any>undefined;
            this.dateForReviewUtc = _data["dateForReviewUtc"] ? new Date(_data["dateForReviewUtc"].toString()) : <any>undefined;
            this.dateModifiedUtc = _data["dateModifiedUtc"] ? new Date(_data["dateModifiedUtc"].toString()) : <any>undefined;
            this.dateReviewedUtc = _data["dateReviewedUtc"] ? new Date(_data["dateReviewedUtc"].toString()) : <any>undefined;
            this.discipline = _data["discipline"];
            this.documentNumber = _data["documentNumber"];
            this.documentStatus = _data["documentStatus"];
            this.documentType = _data["documentType"];
            this.fileSize = _data["fileSize"];
            this.filename = _data["filename"];
            this.fileType = _data["fileType"];
            this.markupLastModifiedDateUtc = _data["markupLastModifiedDateUtc"] ? new Date(_data["markupLastModifiedDateUtc"].toString()) : <any>undefined;
            this.milestoneDateUtc = _data["milestoneDateUtc"] ? new Date(_data["milestoneDateUtc"].toString()) : <any>undefined;
            this.numberOfMarkups = _data["numberOfMarkups"];
            this.packageNumber = _data["packageNumber"];
            this.percentComplete = _data["percentComplete"];
            this.plannedSubmissionDateUtc = _data["plannedSubmissionDateUtc"] ? new Date(_data["plannedSubmissionDateUtc"].toString()) : <any>undefined;
            this.printSize = _data["printSize"];
            this.reference = _data["reference"];
            this.reviewSource = _data["reviewSource"];
            this.reviewStatus = _data["reviewStatus"];
            this.revision = _data["revision"];
            this.revisionDateUtc = _data["revisionDateUtc"] ? new Date(_data["revisionDateUtc"].toString()) : <any>undefined;
            this.tagNumber = _data["tagNumber"];
            this.title = _data["title"];
            this.toClientDateUtc = _data["toClientDateUtc"] ? new Date(_data["toClientDateUtc"].toString()) : <any>undefined;
            this.trackingId = _data["trackingId"];
            this.versionNumber = _data["versionNumber"];
            this.vdrcode = _data["vdrcode"];
            this.vendorDocumentNumber = _data["vendorDocumentNumber"];
            this.vendorRevision = _data["vendorRevision"];
        }
    }

    static fromJS(data: any): AconexDocumentMetadataModel {
        data = typeof data === 'object' ? data : {};
        let result = new AconexDocumentMetadataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["userSite"] = this.userSite;
        data["documentId"] = this.documentId;
        data["dateApprovedUtc"] = this.dateApprovedUtc ? this.dateApprovedUtc.toISOString() : <any>undefined;
        data["author"] = this.author;
        data["authorisedBy"] = this.authorisedBy;
        data["category"] = this.category;
        data["comments"] = this.comments;
        data["comments2"] = this.comments2;
        data["confidential"] = this.confidential;
        data["contractDeliverable"] = this.contractDeliverable;
        data["contractNumber"] = this.contractNumber;
        data["contractorDocumentNumber"] = this.contractorDocumentNumber;
        data["contractorRevision"] = this.contractorRevision;
        data["current"] = this.current;
        data["dateCreatedUtc"] = this.dateCreatedUtc ? this.dateCreatedUtc.toISOString() : <any>undefined;
        data["dateForReviewUtc"] = this.dateForReviewUtc ? this.dateForReviewUtc.toISOString() : <any>undefined;
        data["dateModifiedUtc"] = this.dateModifiedUtc ? this.dateModifiedUtc.toISOString() : <any>undefined;
        data["dateReviewedUtc"] = this.dateReviewedUtc ? this.dateReviewedUtc.toISOString() : <any>undefined;
        data["discipline"] = this.discipline;
        data["documentNumber"] = this.documentNumber;
        data["documentStatus"] = this.documentStatus;
        data["documentType"] = this.documentType;
        data["fileSize"] = this.fileSize;
        data["filename"] = this.filename;
        data["fileType"] = this.fileType;
        data["markupLastModifiedDateUtc"] = this.markupLastModifiedDateUtc ? this.markupLastModifiedDateUtc.toISOString() : <any>undefined;
        data["milestoneDateUtc"] = this.milestoneDateUtc ? this.milestoneDateUtc.toISOString() : <any>undefined;
        data["numberOfMarkups"] = this.numberOfMarkups;
        data["packageNumber"] = this.packageNumber;
        data["percentComplete"] = this.percentComplete;
        data["plannedSubmissionDateUtc"] = this.plannedSubmissionDateUtc ? this.plannedSubmissionDateUtc.toISOString() : <any>undefined;
        data["printSize"] = this.printSize;
        data["reference"] = this.reference;
        data["reviewSource"] = this.reviewSource;
        data["reviewStatus"] = this.reviewStatus;
        data["revision"] = this.revision;
        data["revisionDateUtc"] = this.revisionDateUtc ? this.revisionDateUtc.toISOString() : <any>undefined;
        data["tagNumber"] = this.tagNumber;
        data["title"] = this.title;
        data["toClientDateUtc"] = this.toClientDateUtc ? this.toClientDateUtc.toISOString() : <any>undefined;
        data["trackingId"] = this.trackingId;
        data["versionNumber"] = this.versionNumber;
        data["vdrcode"] = this.vdrcode;
        data["vendorDocumentNumber"] = this.vendorDocumentNumber;
        data["vendorRevision"] = this.vendorRevision;
        return data;
    }
}

/** Contains Aconex Document Metadata that is relevant to OneTrack. (This is essentially a one to one mapping of the EF AconexDocumentMetadataModel, the difference is that this model is for exposing to the outside world. This model is intended to be shared, so can be used by multiple endpoints. However it's likely that it won't get used all that much because very few endpoints really need to return this amount of data.) */
export interface IAconexDocumentMetadataModel {
    /** Aconex Project Id for the document. (This property does not appear in the Aconex API version of this model, we have to set it ourselves manually.) */
    projectId?: string | undefined;
    /** The User Site of the user that the document is associated with. This is usually either the current user, or the user who originally imported the Document from Aconex. (This property does not appear in the Aconex API version of this model, we have to set it ourselves manually.) */
    userSite?: string | undefined;
    /** Unique identifier for the document. */
    documentId?: string | undefined;
    /** Date when the document was approved. (Returned when the return_fields parameter includes the value "approved".) */
    dateApprovedUtc?: Date | undefined;
    /** The author of the document. (String(60)
Returned when the return_fields parameter includes the value "author".) */
    author?: string | undefined;
    /** The person who authorized the document. (String(60)
Returned when the return_fields parameter includes the value "authorisedBy".) */
    authorisedBy?: string | undefined;
    /** The category of the document. (String(50)
Returned when the return_fields parameter includes the value "category".) */
    category?: string | undefined;
    /** Comments associated with the document. (String(1024)
Returned when the return_fields parameter includes the value "comments".) */
    comments?: string | undefined;
    /** Comments2 associated with the document. (String(1024)
Returned when the return_fields parameter includes the value "comments2".) */
    comments2?: string | undefined;
    /** Indicates if the document is confidential. (Returned when the return_fields parameter includes the value "confidential".) */
    confidential?: boolean | undefined;
    /** Indicates if the document is a contract deliverable. (Returned when the return_fields parameter includes the value "contractDeliverable".) */
    contractDeliverable?: boolean | undefined;
    /** Contract number associated with the document. (String(50)
Returned when the return_fields parameter includes the value "contractnumber".) */
    contractNumber?: string | undefined;
    /** Contractor document number associated with the document. (String(50)
Returned when the return_fields parameter includes the value "contractordocumentnumber".) */
    contractorDocumentNumber?: string | undefined;
    /** Contractor revision associated with the document. (String(15)
Returned when the return_fields parameter includes the value "contractorrev".) */
    contractorRevision?: string | undefined;
    /** Indicates if this is the current revision of the document. (Returned when the return_fields parameter includes the value "current".
Determines whether this revision of the document is the current revision.) */
    current?: boolean | undefined;
    /** Date when the document was created. (Returned when the return_fields parameter includes the value "received".
UTC format.) */
    dateCreatedUtc?: Date | undefined;
    /** Date for review of the document. (Returned when the return_fields parameter includes the value "forreview".
UTC format.) */
    dateForReviewUtc?: Date | undefined;
    /** Date when the document was last modified. (Returned when the return_fields parameter includes the value "registered".
UTC format.) */
    dateModifiedUtc?: Date | undefined;
    /** Date when the document was reviewed. (Returned when the return_fields parameter includes the value "reviewed".
UTC format.) */
    dateReviewedUtc?: Date | undefined;
    /** Discipline associated with the document. (String(50)
Returned when the return_fields parameter includes the value "discipline".) */
    discipline?: string | undefined;
    /** Document number. (String(210)
Returned when the return_fields parameter includes the value "docno".) */
    documentNumber?: string | undefined;
    /** The document type. (Returned when the return_fields parameter includes the value "statusid".) */
    documentStatus?: string | undefined;
    /** Type of the document. (Returned when the return_fields parameter includes the value "doctype".) */
    documentType?: string | undefined;
    /** Size of the document file. (Returned when the return_fields parameter includes the value "fileSize".) */
    fileSize?: number | undefined;
    /** Name of the document file. (Returned when the return_fields parameter includes the value "filename".) */
    filename?: string | undefined;
    /** The type of the document file. (String(3)
Returned when the return_fields parameter includes the value "fileType".) */
    fileType?: string | undefined;
    /** Date when the last markup was made. (Returned when the return_fields parameter includes the value "markupLastModifiedDate".
UTC format.) */
    markupLastModifiedDateUtc?: Date | undefined;
    /** Milestone date associated with the document. (Returned when the return_fields parameter includes the value "milestonedate".
UTC format.) */
    milestoneDateUtc?: Date | undefined;
    /** Count of markups on the document. (Returned when the return_fields parameter includes the value "numberOfMarkups".) */
    numberOfMarkups?: number | undefined;
    /** Package number associated with the document. (String(50)
Returned when the return_fields parameter includes the value "packagenumber".) */
    packageNumber?: string | undefined;
    /** Percentage of completion for the document. (Returned when the return_fields parameter includes the value "percentComplete".) */
    percentComplete?: number | undefined;
    /** Planned submission date for the document. (String(15)
Returned when the return_fields parameter includes the value "plannedsubmissiondate".
UTC format.) */
    plannedSubmissionDateUtc?: Date | undefined;
    /** Size of the document when printed. (String(15)
Returned when the return_fields parameter includes the value "printSize".) */
    printSize?: string | undefined;
    /** Reference information for the document. (String(120)
Returned when the return_fields parameter includes the value "reference".) */
    reference?: string | undefined;
    /** Source of the review for the document. (String(50)
Returned when the return_fields parameter includes the value "reviewSource"
From Release 21.10:
The field will include actual "Workflow Number" / "Correspondence Number" / "SupploerDocPackageNumber" if it exists for the document corresponding to type of Source (Workflow / Transmittal / Supplier Document).

Eg:
Workflow : <ReviewSource>WF-000002</ReviewSource>
Transmittal : <ReviewSource>145228</ReviewSource> 
Supplier Document : <ReviewSource>SD-000004</ReviewSource> 
No Review Source : <ReviewSource>None</ReviewSource>) */
    reviewSource?: string | undefined;
    /** The Review Status of the document. (String(50)
Returned when the return_fields parameter includes the value "reviewstatus".) */
    reviewStatus?: string | undefined;
    /** Revision of the document. (String(15) 

Returned when the return_fields parameter includes the value "revision".) */
    revision?: string | undefined;
    /** Revision Date of the document. (Returned when the return_fields parameter includes the value "revisiondate".
UTC format.) */
    revisionDateUtc?: Date | undefined;
    /** Tag number associated with the document. (String(50)
Returned when the return_fields parameter includes the value "tagNumber".) */
    tagNumber?: string | undefined;
    /** Title of the document. (String(210)
Returned when the return_fields parameter includes the value "title".) */
    title?: string | undefined;
    /** Date when the document was sent to client. (Returned when the return_fields parameter includes the value "toclient".
UTC format.) */
    toClientDateUtc?: Date | undefined;
    /** The tracking ID for the document. (The tracking ID is a unique identifier for all versions of a specific document. 

When a document is first registered into Aconex, a unique identifier is generated 

and this value is assigned to all document revisions of that document. 

One can use this tracking identifier to create a chain of documents.) */
    trackingId?: string | undefined;
    /** The version number of the document. (The version number provides information relating to the sequence in 

which the document was registered within the chain of revisions. 

For all documents with the same Tracking Id, the version number will be an integer value starting from 1.

e.g. When a document is newly registered into Aconex, its version number will be 1. 

When it is superseded, a new document with a version number of 2 will be created. 

Both document revisions will be accessible using their respective document Id's.) */
    versionNumber?: number | undefined;
    /** Vendor code associated with the document. (String(50)
Returned when the return_fields parameter includes the value "vdrcode".) */
    vdrcode?: string | undefined;
    /** Vendor document number. (String(50)
Returned when the return_fields parameter includes the value "vendordocumentnumber".) */
    vendorDocumentNumber?: string | undefined;
    /** Vendor revision. (String(15)
Returned when the return_fields parameter includes the value "vendorrev".) */
    vendorRevision?: string | undefined;
}

export class AconexMailMetadataAttachmentsModel implements IAconexMailMetadataAttachmentsModel {
    /** Gets or sets the list of registered document attachments. (Type: Group

This section lists attachments on this mail.) */
    registeredDocumentAttachments?: AconexMailMetadataRegisteredDocumentAttachmentModel[] | undefined;
    /** Gets or sets the list of local file attachments. (Type: Group

Local files may only be attached to mail items that are not either "Transmittal" or "Tender Transmittal" mail types.) */
    localFileAttachments?: AconexMailMetadataLocalFileAttachmentModel[] | undefined;
    /** Gets or sets the list of other mail attachments. (Type: Group

Other mails may be attached to mails of any mail type.) */
    mailAttachments?: AconexMailMetadataMailAttachmentModel[] | undefined;

    constructor(data?: IAconexMailMetadataAttachmentsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["registeredDocumentAttachments"])) {
                this.registeredDocumentAttachments = [] as any;
                for (let item of _data["registeredDocumentAttachments"])
                    this.registeredDocumentAttachments!.push(AconexMailMetadataRegisteredDocumentAttachmentModel.fromJS(item));
            }
            if (Array.isArray(_data["localFileAttachments"])) {
                this.localFileAttachments = [] as any;
                for (let item of _data["localFileAttachments"])
                    this.localFileAttachments!.push(AconexMailMetadataLocalFileAttachmentModel.fromJS(item));
            }
            if (Array.isArray(_data["mailAttachments"])) {
                this.mailAttachments = [] as any;
                for (let item of _data["mailAttachments"])
                    this.mailAttachments!.push(AconexMailMetadataMailAttachmentModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AconexMailMetadataAttachmentsModel {
        data = typeof data === 'object' ? data : {};
        let result = new AconexMailMetadataAttachmentsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.registeredDocumentAttachments)) {
            data["registeredDocumentAttachments"] = [];
            for (let item of this.registeredDocumentAttachments)
                data["registeredDocumentAttachments"].push(item.toJSON());
        }
        if (Array.isArray(this.localFileAttachments)) {
            data["localFileAttachments"] = [];
            for (let item of this.localFileAttachments)
                data["localFileAttachments"].push(item.toJSON());
        }
        if (Array.isArray(this.mailAttachments)) {
            data["mailAttachments"] = [];
            for (let item of this.mailAttachments)
                data["mailAttachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAconexMailMetadataAttachmentsModel {
    /** Gets or sets the list of registered document attachments. (Type: Group

This section lists attachments on this mail.) */
    registeredDocumentAttachments?: AconexMailMetadataRegisteredDocumentAttachmentModel[] | undefined;
    /** Gets or sets the list of local file attachments. (Type: Group

Local files may only be attached to mail items that are not either "Transmittal" or "Tender Transmittal" mail types.) */
    localFileAttachments?: AconexMailMetadataLocalFileAttachmentModel[] | undefined;
    /** Gets or sets the list of other mail attachments. (Type: Group

Other mails may be attached to mails of any mail type.) */
    mailAttachments?: AconexMailMetadataMailAttachmentModel[] | undefined;
}

export class AconexMailMetadataLinkModel implements IAconexMailMetadataLinkModel {
    /** Should be one of: "replyMailSchema" or "forwardMailSchema" */
    rel!: string;
    /** URI for the resource */
    href!: string;

    constructor(data?: IAconexMailMetadataLinkModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rel = _data["rel"];
            this.href = _data["href"];
        }
    }

    static fromJS(data: any): AconexMailMetadataLinkModel {
        data = typeof data === 'object' ? data : {};
        let result = new AconexMailMetadataLinkModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rel"] = this.rel;
        data["href"] = this.href;
        return data;
    }
}

export interface IAconexMailMetadataLinkModel {
    /** Should be one of: "replyMailSchema" or "forwardMailSchema" */
    rel: string;
    /** URI for the resource */
    href: string;
}

export class AconexMailMetadataLocalFileAttachmentModel implements IAconexMailMetadataLocalFileAttachmentModel {
    /** This is a reference to the attached file. */
    attachmentId!: string;
    /** The filesize of the attachment (measured in bytes). */
    fileSize!: number;
    fileName!: string;

    constructor(data?: IAconexMailMetadataLocalFileAttachmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attachmentId = _data["attachmentId"];
            this.fileSize = _data["fileSize"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): AconexMailMetadataLocalFileAttachmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new AconexMailMetadataLocalFileAttachmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachmentId"] = this.attachmentId;
        data["fileSize"] = this.fileSize;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IAconexMailMetadataLocalFileAttachmentModel {
    /** This is a reference to the attached file. */
    attachmentId: string;
    /** The filesize of the attachment (measured in bytes). */
    fileSize: number;
    fileName: string;
}

export class AconexMailMetadataMailAttachmentModel implements IAconexMailMetadataMailAttachmentModel {
    /** The id of the mail attached to this mail. */
    mailId!: string;
    /** FirstName + " " + LastName */
    fromName!: string;
    /** The organization's Trading Name. */
    fromOrg!: string;
    mailNo!: string;
    /** Comes from Aconex as a string - UTC Timezone in the format yyyy-MM-dd'T'hh:mm:ss.SSS'Z' */
    sentDateUtc?: Date | undefined;
    subject!: string;

    constructor(data?: IAconexMailMetadataMailAttachmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailId = _data["mailId"];
            this.fromName = _data["fromName"];
            this.fromOrg = _data["fromOrg"];
            this.mailNo = _data["mailNo"];
            this.sentDateUtc = _data["sentDateUtc"] ? new Date(_data["sentDateUtc"].toString()) : <any>undefined;
            this.subject = _data["subject"];
        }
    }

    static fromJS(data: any): AconexMailMetadataMailAttachmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new AconexMailMetadataMailAttachmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailId"] = this.mailId;
        data["fromName"] = this.fromName;
        data["fromOrg"] = this.fromOrg;
        data["mailNo"] = this.mailNo;
        data["sentDateUtc"] = this.sentDateUtc ? this.sentDateUtc.toISOString() : <any>undefined;
        data["subject"] = this.subject;
        return data;
    }
}

export interface IAconexMailMetadataMailAttachmentModel {
    /** The id of the mail attached to this mail. */
    mailId: string;
    /** FirstName + " " + LastName */
    fromName: string;
    /** The organization's Trading Name. */
    fromOrg: string;
    mailNo: string;
    /** Comes from Aconex as a string - UTC Timezone in the format yyyy-MM-dd'T'hh:mm:ss.SSS'Z' */
    sentDateUtc?: Date | undefined;
    subject: string;
}

/** Contains Aconex Mail Metadata that is relevant to OneTrack. (This is essentially a one to one mapping of the EF AconexMailMetadataModel, the difference is that this model is for exposing to the outside world. This model is intended to be shared, so can be used by multiple endpoints. However it's likely that it won't get used all that much because very few endpoints really need to return this amount of data.) */
export class AconexMailMetadataModel implements IAconexMailMetadataModel {
    /** The User Site of the user that the Mail is associated with. This is usually either the current user, or the user who originally imported the Mail from Aconex. (This property does not appear in the Aconex API version of this model, we have to set it ourselves manually.) */
    userSite?: string | undefined;
    mailId!: string;
    /** One of : Don't Process, Error, Waiting Approval, Approved, Rejected */
    approvalStatus?: string | undefined;
    /** Gets or sets the list of attachments. (Type: Group

This section lists attachments on this mail.) */
    attachments!: AconexMailMetadataAttachmentsModel;
    /** The body of the mail.

Note: Includes formatting metadata such as font and text alignment. The mail body is capped at a maximum size of 2GB. */
    mailData!: string;
    /** 0 = Not Confidential

1 = Confidential */
    confidentialFlag!: number;
    projectDetails?: AconexMailMetadataProjectDetailsModel | undefined;
    correspondenceType!: string;
    toUsers!: AconexMailMetadataRecipientModel[];
    mailNo!: string;
    fax!: string;
    footer!: string;
    fromUserDetails?: AconexMailMetadataUserDetailsModel | undefined;
    notes!: AconexMailMetadataNoteModel[];
    projectId!: string;
    /** May be an empty element. */
    reasonForIssue!: string;
    responseRequired?: AconexMailMetadataResponseRequiredModel | undefined;
    richMailText!: boolean;
    /** Converted from Aconex string response */
    sentDateUtc?: Date | undefined;
    /** Returned when return_fields parameter includes the value "tostatusid" Specifies the status of the mail which will be one of:

- Outstanding

- N/A

- Responded

- Partial

- Overdue

- Closed-Out

Configured available values for Responded

- Closed

- Completed

- Answered

Configured available values for Closed-Out

- Confirmed

- Accepted

- Agreed

- Closed */
    status!: string;
    subject!: string;
    /** The id of the thread that this mail belongs to. */
    threadId!: string;
    /** Indicates if the mail is associated to a FaxLog. */
    faxLog!: boolean;
    /** Links for a resource related to this mail */
    links!: AconexMailMetadataLinkModel[];

    constructor(data?: IAconexMailMetadataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.attachments = new AconexMailMetadataAttachmentsModel();
            this.toUsers = [];
            this.notes = [];
            this.links = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userSite = _data["userSite"];
            this.mailId = _data["mailId"];
            this.approvalStatus = _data["approvalStatus"];
            this.attachments = _data["attachments"] ? AconexMailMetadataAttachmentsModel.fromJS(_data["attachments"]) : new AconexMailMetadataAttachmentsModel();
            this.mailData = _data["mailData"];
            this.confidentialFlag = _data["confidentialFlag"];
            this.projectDetails = _data["projectDetails"] ? AconexMailMetadataProjectDetailsModel.fromJS(_data["projectDetails"]) : <any>undefined;
            this.correspondenceType = _data["correspondenceType"];
            if (Array.isArray(_data["toUsers"])) {
                this.toUsers = [] as any;
                for (let item of _data["toUsers"])
                    this.toUsers!.push(AconexMailMetadataRecipientModel.fromJS(item));
            }
            this.mailNo = _data["mailNo"];
            this.fax = _data["fax"];
            this.footer = _data["footer"];
            this.fromUserDetails = _data["fromUserDetails"] ? AconexMailMetadataUserDetailsModel.fromJS(_data["fromUserDetails"]) : <any>undefined;
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(AconexMailMetadataNoteModel.fromJS(item));
            }
            this.projectId = _data["projectId"];
            this.reasonForIssue = _data["reasonForIssue"];
            this.responseRequired = _data["responseRequired"] ? AconexMailMetadataResponseRequiredModel.fromJS(_data["responseRequired"]) : <any>undefined;
            this.richMailText = _data["richMailText"];
            this.sentDateUtc = _data["sentDateUtc"] ? new Date(_data["sentDateUtc"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.subject = _data["subject"];
            this.threadId = _data["threadId"];
            this.faxLog = _data["faxLog"];
            if (Array.isArray(_data["links"])) {
                this.links = [] as any;
                for (let item of _data["links"])
                    this.links!.push(AconexMailMetadataLinkModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AconexMailMetadataModel {
        data = typeof data === 'object' ? data : {};
        let result = new AconexMailMetadataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userSite"] = this.userSite;
        data["mailId"] = this.mailId;
        data["approvalStatus"] = this.approvalStatus;
        data["attachments"] = this.attachments ? this.attachments.toJSON() : <any>undefined;
        data["mailData"] = this.mailData;
        data["confidentialFlag"] = this.confidentialFlag;
        data["projectDetails"] = this.projectDetails ? this.projectDetails.toJSON() : <any>undefined;
        data["correspondenceType"] = this.correspondenceType;
        if (Array.isArray(this.toUsers)) {
            data["toUsers"] = [];
            for (let item of this.toUsers)
                data["toUsers"].push(item.toJSON());
        }
        data["mailNo"] = this.mailNo;
        data["fax"] = this.fax;
        data["footer"] = this.footer;
        data["fromUserDetails"] = this.fromUserDetails ? this.fromUserDetails.toJSON() : <any>undefined;
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        data["projectId"] = this.projectId;
        data["reasonForIssue"] = this.reasonForIssue;
        data["responseRequired"] = this.responseRequired ? this.responseRequired.toJSON() : <any>undefined;
        data["richMailText"] = this.richMailText;
        data["sentDateUtc"] = this.sentDateUtc ? this.sentDateUtc.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["subject"] = this.subject;
        data["threadId"] = this.threadId;
        data["faxLog"] = this.faxLog;
        if (Array.isArray(this.links)) {
            data["links"] = [];
            for (let item of this.links)
                data["links"].push(item.toJSON());
        }
        return data;
    }
}

/** Contains Aconex Mail Metadata that is relevant to OneTrack. (This is essentially a one to one mapping of the EF AconexMailMetadataModel, the difference is that this model is for exposing to the outside world. This model is intended to be shared, so can be used by multiple endpoints. However it's likely that it won't get used all that much because very few endpoints really need to return this amount of data.) */
export interface IAconexMailMetadataModel {
    /** The User Site of the user that the Mail is associated with. This is usually either the current user, or the user who originally imported the Mail from Aconex. (This property does not appear in the Aconex API version of this model, we have to set it ourselves manually.) */
    userSite?: string | undefined;
    mailId: string;
    /** One of : Don't Process, Error, Waiting Approval, Approved, Rejected */
    approvalStatus?: string | undefined;
    /** Gets or sets the list of attachments. (Type: Group

This section lists attachments on this mail.) */
    attachments: AconexMailMetadataAttachmentsModel;
    /** The body of the mail.

Note: Includes formatting metadata such as font and text alignment. The mail body is capped at a maximum size of 2GB. */
    mailData: string;
    /** 0 = Not Confidential

1 = Confidential */
    confidentialFlag: number;
    projectDetails?: AconexMailMetadataProjectDetailsModel | undefined;
    correspondenceType: string;
    toUsers: AconexMailMetadataRecipientModel[];
    mailNo: string;
    fax: string;
    footer: string;
    fromUserDetails?: AconexMailMetadataUserDetailsModel | undefined;
    notes: AconexMailMetadataNoteModel[];
    projectId: string;
    /** May be an empty element. */
    reasonForIssue: string;
    responseRequired?: AconexMailMetadataResponseRequiredModel | undefined;
    richMailText: boolean;
    /** Converted from Aconex string response */
    sentDateUtc?: Date | undefined;
    /** Returned when return_fields parameter includes the value "tostatusid" Specifies the status of the mail which will be one of:

- Outstanding

- N/A

- Responded

- Partial

- Overdue

- Closed-Out

Configured available values for Responded

- Closed

- Completed

- Answered

Configured available values for Closed-Out

- Confirmed

- Accepted

- Agreed

- Closed */
    status: string;
    subject: string;
    /** The id of the thread that this mail belongs to. */
    threadId: string;
    /** Indicates if the mail is associated to a FaxLog. */
    faxLog: boolean;
    /** Links for a resource related to this mail */
    links: AconexMailMetadataLinkModel[];
}

export class AconexMailMetadataNoteModel implements IAconexMailMetadataNoteModel {
    fromUserId!: string;
    /** Up to 2GB per note. */
    noteContents!: string;
    /** Comes from Aconex as a string - UTC timezone yyyy-MM-dd'T'hh:mm:ss.SSS'Z' */
    timeCreatedUtc?: Date | undefined;

    constructor(data?: IAconexMailMetadataNoteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromUserId = _data["fromUserId"];
            this.noteContents = _data["noteContents"];
            this.timeCreatedUtc = _data["timeCreatedUtc"] ? new Date(_data["timeCreatedUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AconexMailMetadataNoteModel {
        data = typeof data === 'object' ? data : {};
        let result = new AconexMailMetadataNoteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromUserId"] = this.fromUserId;
        data["noteContents"] = this.noteContents;
        data["timeCreatedUtc"] = this.timeCreatedUtc ? this.timeCreatedUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAconexMailMetadataNoteModel {
    fromUserId: string;
    /** Up to 2GB per note. */
    noteContents: string;
    /** Comes from Aconex as a string - UTC timezone yyyy-MM-dd'T'hh:mm:ss.SSS'Z' */
    timeCreatedUtc?: Date | undefined;
}

export class AconexMailMetadataProjectDetailsModel implements IAconexMailMetadataProjectDetailsModel {
    address1!: string;
    address2!: string;
    address3!: string;
    city!: string;
    country!: string;
    logoPath!: string;
    name!: string;
    postCode!: string;
    state!: string;

    constructor(data?: IAconexMailMetadataProjectDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.address3 = _data["address3"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.logoPath = _data["logoPath"];
            this.name = _data["name"];
            this.postCode = _data["postCode"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): AconexMailMetadataProjectDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new AconexMailMetadataProjectDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["address3"] = this.address3;
        data["city"] = this.city;
        data["country"] = this.country;
        data["logoPath"] = this.logoPath;
        data["name"] = this.name;
        data["postCode"] = this.postCode;
        data["state"] = this.state;
        return data;
    }
}

export interface IAconexMailMetadataProjectDetailsModel {
    address1: string;
    address2: string;
    address3: string;
    city: string;
    country: string;
    logoPath: string;
    name: string;
    postCode: string;
    state: string;
}

export class AconexMailMetadataRecipientModel implements IAconexMailMetadataRecipientModel {
    organizationId!: string;
    organizationName!: string;
    /** Specifies the status of the mail for this distribution.
<list type="bullet"><item>Outstanding</item><item>N/A</item><item>Responded</item><item>Overdue</item><item>Closed-Out</item></list>
Configured available values for Responded
<list type="bullet"><item>Closed</item><item>Completed</item><item>Answered</item></list>
Configured available values for Closed-Out
<list type="bullet"><item>Confirmed</item><item>Accepted</item><item>Agreed</item><item>Closed-Out</item></list> */
    status!: string;
    /** <list type="bullet">
  <item>TO</item>
  <item>CC</item>
  <item>BCC</item>
</list> */
    distributionType!: string;
    /** The name of the recipient (including title). */
    name!: string;
    userId!: string;

    constructor(data?: IAconexMailMetadataRecipientModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.status = _data["status"];
            this.distributionType = _data["distributionType"];
            this.name = _data["name"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AconexMailMetadataRecipientModel {
        data = typeof data === 'object' ? data : {};
        let result = new AconexMailMetadataRecipientModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["status"] = this.status;
        data["distributionType"] = this.distributionType;
        data["name"] = this.name;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IAconexMailMetadataRecipientModel {
    organizationId: string;
    organizationName: string;
    /** Specifies the status of the mail for this distribution.
<list type="bullet"><item>Outstanding</item><item>N/A</item><item>Responded</item><item>Overdue</item><item>Closed-Out</item></list>
Configured available values for Responded
<list type="bullet"><item>Closed</item><item>Completed</item><item>Answered</item></list>
Configured available values for Closed-Out
<list type="bullet"><item>Confirmed</item><item>Accepted</item><item>Agreed</item><item>Closed-Out</item></list> */
    status: string;
    /** <list type="bullet">
  <item>TO</item>
  <item>CC</item>
  <item>BCC</item>
</list> */
    distributionType: string;
    /** The name of the recipient (including title). */
    name: string;
    userId: string;
}

export class AconexMailMetadataRegisteredDocumentAttachmentModel implements IAconexMailMetadataRegisteredDocumentAttachmentModel {
    /** This is a reference to a registered document.

Notes:

1. attachmentId is not the same value as the documentid. Please refer to the Download Mail Attachment API service for further information.

2. When the transmittal attachment is confidential AND the user is not in the transmittal recipient list or documents access list, attachmentId is omitted.
 */
    attachmentId!: string;
    /** Confidentiality status of the attached registered document, as determined from the sender's point of view.

Note: This status value is retained if the correspondence is forwarded, with attachments intact; i.e the status always reflects the current confidentiality of the original sender's document, even after the correspondence has been sent.s */
    confidential!: boolean;
    /** The id of the registered document attached to this sent mail.

Note: This document belongs to the sender of the mail and is only available to sender organization users; i.e. is not provided for received mail of which RegisteredAs is the relevant field. */
    documentId?: string | undefined;
    documentNo!: string;
    fileName!: string;
    /** The filesize (measured in bytes) of the registered document attached to this mail. */
    fileSize!: number;
    revision!: string;
    /** Comes from Aconex as a string - UTC Timezone in the format yyyy-MM-dd'T'hh:mm:ss.SSS'Z' */
    revisionDateUtc?: Date | undefined;
    /** The id of the attached registered document in the recipient organization's document register.

Note: This is available only if the document has already been registered from the mail. Also only available to recipient organizations; i.e. is not provided for sent mails of which documentId is the relevant field. */
    registeredAs?: string | undefined;
    status!: string;
    title!: string;

    constructor(data?: IAconexMailMetadataRegisteredDocumentAttachmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attachmentId = _data["attachmentId"];
            this.confidential = _data["confidential"];
            this.documentId = _data["documentId"];
            this.documentNo = _data["documentNo"];
            this.fileName = _data["fileName"];
            this.fileSize = _data["fileSize"];
            this.revision = _data["revision"];
            this.revisionDateUtc = _data["revisionDateUtc"] ? new Date(_data["revisionDateUtc"].toString()) : <any>undefined;
            this.registeredAs = _data["registeredAs"];
            this.status = _data["status"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): AconexMailMetadataRegisteredDocumentAttachmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new AconexMailMetadataRegisteredDocumentAttachmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachmentId"] = this.attachmentId;
        data["confidential"] = this.confidential;
        data["documentId"] = this.documentId;
        data["documentNo"] = this.documentNo;
        data["fileName"] = this.fileName;
        data["fileSize"] = this.fileSize;
        data["revision"] = this.revision;
        data["revisionDateUtc"] = this.revisionDateUtc ? this.revisionDateUtc.toISOString() : <any>undefined;
        data["registeredAs"] = this.registeredAs;
        data["status"] = this.status;
        data["title"] = this.title;
        return data;
    }
}

export interface IAconexMailMetadataRegisteredDocumentAttachmentModel {
    /** This is a reference to a registered document.

Notes:

1. attachmentId is not the same value as the documentid. Please refer to the Download Mail Attachment API service for further information.

2. When the transmittal attachment is confidential AND the user is not in the transmittal recipient list or documents access list, attachmentId is omitted.
 */
    attachmentId: string;
    /** Confidentiality status of the attached registered document, as determined from the sender's point of view.

Note: This status value is retained if the correspondence is forwarded, with attachments intact; i.e the status always reflects the current confidentiality of the original sender's document, even after the correspondence has been sent.s */
    confidential: boolean;
    /** The id of the registered document attached to this sent mail.

Note: This document belongs to the sender of the mail and is only available to sender organization users; i.e. is not provided for received mail of which RegisteredAs is the relevant field. */
    documentId?: string | undefined;
    documentNo: string;
    fileName: string;
    /** The filesize (measured in bytes) of the registered document attached to this mail. */
    fileSize: number;
    revision: string;
    /** Comes from Aconex as a string - UTC Timezone in the format yyyy-MM-dd'T'hh:mm:ss.SSS'Z' */
    revisionDateUtc?: Date | undefined;
    /** The id of the attached registered document in the recipient organization's document register.

Note: This is available only if the document has already been registered from the mail. Also only available to recipient organizations; i.e. is not provided for sent mails of which documentId is the relevant field. */
    registeredAs?: string | undefined;
    status: string;
    title: string;
}

export class AconexMailMetadataResponseRequiredModel implements IAconexMailMetadataResponseRequiredModel {
    /** UTC format yyyy-MM-dd'T'hh:mm:ss.SSS'Z' */
    responseRequiredDateUtc?: Date | undefined;
    /** May be an empty element. */
    responseRequiredMessage!: string;

    constructor(data?: IAconexMailMetadataResponseRequiredModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseRequiredDateUtc = _data["responseRequiredDateUtc"] ? new Date(_data["responseRequiredDateUtc"].toString()) : <any>undefined;
            this.responseRequiredMessage = _data["responseRequiredMessage"];
        }
    }

    static fromJS(data: any): AconexMailMetadataResponseRequiredModel {
        data = typeof data === 'object' ? data : {};
        let result = new AconexMailMetadataResponseRequiredModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseRequiredDateUtc"] = this.responseRequiredDateUtc ? this.responseRequiredDateUtc.toISOString() : <any>undefined;
        data["responseRequiredMessage"] = this.responseRequiredMessage;
        return data;
    }
}

export interface IAconexMailMetadataResponseRequiredModel {
    /** UTC format yyyy-MM-dd'T'hh:mm:ss.SSS'Z' */
    responseRequiredDateUtc?: Date | undefined;
    /** May be an empty element. */
    responseRequiredMessage: string;
}

export class AconexMailMetadataUserDetailsModel implements IAconexMailMetadataUserDetailsModel {
    organizationId!: string;
    /** This element will contain an attribute providing the full HTTP path to the logo of the said organization. */
    logoPath?: string | undefined;
    /** If the LogoPath element is present, this attribute will exist and its value will be a full HTTP path to the sender organization's logo. */
    href?: string | undefined;
    organizationName!: string;
    /** The name of the sender (including title). */
    name!: string;
    userId!: string;

    constructor(data?: IAconexMailMetadataUserDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.logoPath = _data["logoPath"];
            this.href = _data["href"];
            this.organizationName = _data["organizationName"];
            this.name = _data["name"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AconexMailMetadataUserDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new AconexMailMetadataUserDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["logoPath"] = this.logoPath;
        data["href"] = this.href;
        data["organizationName"] = this.organizationName;
        data["name"] = this.name;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IAconexMailMetadataUserDetailsModel {
    organizationId: string;
    /** This element will contain an attribute providing the full HTTP path to the logo of the said organization. */
    logoPath?: string | undefined;
    /** If the LogoPath element is present, this attribute will exist and its value will be a full HTTP path to the sender organization's logo. */
    href?: string | undefined;
    organizationName: string;
    /** The name of the sender (including title). */
    name: string;
    userId: string;
}

/** Address Object <see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2577727514/Address+Object" /> */
export class AddressModel implements IAddressModel {
    line1!: string;
    line2?: string | undefined;
    suburb!: string;
    state!: string;
    postcode!: string;
    country!: string;

    constructor(data?: IAddressModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.line1 = _data["line1"];
            this.line2 = _data["line2"];
            this.suburb = _data["suburb"];
            this.state = _data["state"];
            this.postcode = _data["postcode"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): AddressModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddressModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["line1"] = this.line1;
        data["line2"] = this.line2;
        data["suburb"] = this.suburb;
        data["state"] = this.state;
        data["postcode"] = this.postcode;
        data["country"] = this.country;
        return data;
    }
}

/** Address Object <see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2577727514/Address+Object" /> */
export interface IAddressModel {
    line1: string;
    line2?: string | undefined;
    suburb: string;
    state: string;
    postcode: string;
    country: string;
}

/** Basic Claim Model [Basic Claim Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2276033144/Segment+Instance+Details+Object#Basic-Claim-Object) */
export class BasicClaimModel implements IBasicClaimModel {
    /** Public Id for OneTrack.EFDatabase.App.Models.Workflows.SegmentInstance */
    gid?: string;
    /** A user defined contract identifier */
    reference?: string | undefined;
    /** Created Utc */
    createdUtc?: Date;
    /** The Segment Instance Status

1 = InProgress (Segment is unresolved, this is the initial status for most segments)

2 = Suspended (Segment is unresolved but is marked as suspended, post MVP this will include additional logic for ‘Stopping the ticking of clocks’)

3 = InfoRequestedAndNotSuspended (Segment is unresolved and is noting that additional information has been requested)

4 = InfoRequestedAndSuspended (Effectively the same as both ‘Info Requested and Not Suspended’ and ‘Suspended’)

16 = Complete (Segment has been resolved)

17 = Withdrawn (Segment has been withdrawn (this is specially for when a contractor withdraws a claim))

18 = Cancelled (Segment has been cancelled (this is specifically for when the principal cancels a claim))

19 = Disputed (Segment is resolved and has been marked as being in dispute, Post MVP this means an additional dispute workflow as been created)

20 = LegalDispute (Same as Disputed but for Legal Disputes) */
    status?: SegmentInstanceStatus;
    dueDate?: string | undefined;
    responseTimeAlertsEnabled!: boolean;

    constructor(data?: IBasicClaimModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.reference = _data["reference"];
            this.createdUtc = _data["createdUtc"] ? new Date(_data["createdUtc"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.dueDate = _data["dueDate"];
            this.responseTimeAlertsEnabled = _data["responseTimeAlertsEnabled"];
        }
    }

    static fromJS(data: any): BasicClaimModel {
        data = typeof data === 'object' ? data : {};
        let result = new BasicClaimModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["reference"] = this.reference;
        data["createdUtc"] = this.createdUtc ? this.createdUtc.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["dueDate"] = this.dueDate;
        data["responseTimeAlertsEnabled"] = this.responseTimeAlertsEnabled;
        return data;
    }
}

/** Basic Claim Model [Basic Claim Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2276033144/Segment+Instance+Details+Object#Basic-Claim-Object) */
export interface IBasicClaimModel {
    /** Public Id for OneTrack.EFDatabase.App.Models.Workflows.SegmentInstance */
    gid?: string;
    /** A user defined contract identifier */
    reference?: string | undefined;
    /** Created Utc */
    createdUtc?: Date;
    /** The Segment Instance Status

1 = InProgress (Segment is unresolved, this is the initial status for most segments)

2 = Suspended (Segment is unresolved but is marked as suspended, post MVP this will include additional logic for ‘Stopping the ticking of clocks’)

3 = InfoRequestedAndNotSuspended (Segment is unresolved and is noting that additional information has been requested)

4 = InfoRequestedAndSuspended (Effectively the same as both ‘Info Requested and Not Suspended’ and ‘Suspended’)

16 = Complete (Segment has been resolved)

17 = Withdrawn (Segment has been withdrawn (this is specially for when a contractor withdraws a claim))

18 = Cancelled (Segment has been cancelled (this is specifically for when the principal cancels a claim))

19 = Disputed (Segment is resolved and has been marked as being in dispute, Post MVP this means an additional dispute workflow as been created)

20 = LegalDispute (Same as Disputed but for Legal Disputes) */
    status?: SegmentInstanceStatus;
    dueDate?: string | undefined;
    responseTimeAlertsEnabled: boolean;
}

/** Basic Contract Model Defined for use in a <seealso cref="T:OneTrack.Api.Models.ListSegmentInstanceModel" /> but could be used elsewhere [Segment Instance List Object | Basic Contract Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2287435777/Segment+Instance+List+Object#Basic-Contract-Object) */
export class BasicContractModel implements IBasicContractModel {
    /** Public Id for OneTrack.EFDatabase.App.Models.Contracts.Contract */
    gid!: string;
    /** User defined reference for this contract */
    reference!: string;
    /** Contract Name */
    name!: string;
    /** Contract Timezone 

Used for validation and formatting
 (A TZ database name.
<seealso href="https://en.wikipedia.org/wiki/List_of_tz_database_time_zones#List">Wikipedia List of tz database time zones</seealso>) */
    timezone!: string;
    contactEmail?: string | undefined;
    /** OneTrack.Data.Enums.ContractStatus
<seealso href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Contract-Status">Enums | Contract Status</seealso>

1 = Active (Contract is active, at this point settings can’t be edited)

2 = Pending (Partway through setup or in pending mode where configuration can be edited)

3 = Terminated (Post MVP)

4 = PracticalCompletion (Post MVP)

5 = FinalCompletion (Post MVP)

6 = Suspended (Post MVP)

7 = Draft (Contract is still in wizard phase)

8 = Cancelled (Post MVP) */
    status!: ContractStatus;
    /** Sql Server generated Timestamp that is altered every time the Contract row is modified */
    rowVersion!: string;

    constructor(data?: IBasicContractModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.reference = _data["reference"];
            this.name = _data["name"];
            this.timezone = _data["timezone"];
            this.contactEmail = _data["contactEmail"];
            this.status = _data["status"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): BasicContractModel {
        data = typeof data === 'object' ? data : {};
        let result = new BasicContractModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["reference"] = this.reference;
        data["name"] = this.name;
        data["timezone"] = this.timezone;
        data["contactEmail"] = this.contactEmail;
        data["status"] = this.status;
        data["rowVersion"] = this.rowVersion;
        return data;
    }
}

/** Basic Contract Model Defined for use in a <seealso cref="T:OneTrack.Api.Models.ListSegmentInstanceModel" /> but could be used elsewhere [Segment Instance List Object | Basic Contract Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2287435777/Segment+Instance+List+Object#Basic-Contract-Object) */
export interface IBasicContractModel {
    /** Public Id for OneTrack.EFDatabase.App.Models.Contracts.Contract */
    gid: string;
    /** User defined reference for this contract */
    reference: string;
    /** Contract Name */
    name: string;
    /** Contract Timezone 

Used for validation and formatting
 (A TZ database name.
<seealso href="https://en.wikipedia.org/wiki/List_of_tz_database_time_zones#List">Wikipedia List of tz database time zones</seealso>) */
    timezone: string;
    contactEmail?: string | undefined;
    /** OneTrack.Data.Enums.ContractStatus
<seealso href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Contract-Status">Enums | Contract Status</seealso>

1 = Active (Contract is active, at this point settings can’t be edited)

2 = Pending (Partway through setup or in pending mode where configuration can be edited)

3 = Terminated (Post MVP)

4 = PracticalCompletion (Post MVP)

5 = FinalCompletion (Post MVP)

6 = Suspended (Post MVP)

7 = Draft (Contract is still in wizard phase)

8 = Cancelled (Post MVP) */
    status: ContractStatus;
    /** Sql Server generated Timestamp that is altered every time the Contract row is modified */
    rowVersion: string;
}

/** Basic Project Model [Project Details Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2276032922/Project+Details+Object) */
export class BasicProjectModel implements IBasicProjectModel {
    /** Public Id */
    gid?: string;
    /** Public Id of Organisation */
    organisationGid?: string;
    /** Contract Name */
    name?: string | undefined;
    /** Project Timezone 

Used for defaulting timezone for contracts (A TZ database name.
<seealso href="https://en.wikipedia.org/wiki/List_of_tz_database_time_zones#List">Wikipedia List of tz database time zones</seealso>) */
    timezone?: string | undefined;
    /** OneTrack.Data.Enums.ProjectStatus
<seealso href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Project-Status">Enums | Project Status</seealso>

1 = Active (Project is active)

2 = Pending (Project is pending)

3 = Suspended (Project is suspended)

4 = Complete (Project is complete) */
    status?: ProjectStatus;

    constructor(data?: IBasicProjectModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.organisationGid = _data["organisationGid"];
            this.name = _data["name"];
            this.timezone = _data["timezone"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): BasicProjectModel {
        data = typeof data === 'object' ? data : {};
        let result = new BasicProjectModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["organisationGid"] = this.organisationGid;
        data["name"] = this.name;
        data["timezone"] = this.timezone;
        data["status"] = this.status;
        return data;
    }
}

/** Basic Project Model [Project Details Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2276032922/Project+Details+Object) */
export interface IBasicProjectModel {
    /** Public Id */
    gid?: string;
    /** Public Id of Organisation */
    organisationGid?: string;
    /** Contract Name */
    name?: string | undefined;
    /** Project Timezone 

Used for defaulting timezone for contracts (A TZ database name.
<seealso href="https://en.wikipedia.org/wiki/List_of_tz_database_time_zones#List">Wikipedia List of tz database time zones</seealso>) */
    timezone?: string | undefined;
    /** OneTrack.Data.Enums.ProjectStatus
<seealso href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Project-Status">Enums | Project Status</seealso>

1 = Active (Project is active)

2 = Pending (Project is pending)

3 = Suspended (Project is suspended)

4 = Complete (Project is complete) */
    status?: ProjectStatus;
}

/** Basic Segment Model Used on its own as well as the item in <seealso cref="T:OneTrack.Api.Models.ListSegmentInstanceModel" /> [Basic Segment Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2342846627/Basic+Segment+Object) */
export class BasicSegmentModel implements IBasicSegmentModel {
    /** Public Id for OneTrack.EFDatabase.App.Models.Workflows.Segment */
    gid!: string;
    /** Gid to look this segment up in the manifest */
    manifestSegmentGid!: string;
    /** Segment Name */
    name!: string;
    /** Segment Short Name (e.g. NoLD) */
    shortName!: string;
    /** Segment Context like (e.g. Previous NoLD Given) */
    context?: string | undefined;
    /** Segment Process Type

1 = Notice (Segment (and SegmentInstance) should to be processed as a Notice)

2 = Claim (Segment (and SegmentInstance) should to be processed as a Claim)

3 = Direction (Segment (and SegmentInstance) should be processed as a Direction (note: post-mvp))

4 = RFIInbound (Segment (and SegmentInstance) should be processed as an RFI Inbound)

5 = RFIOutbound (Segment (and SegmentInstance) should be processed as an RFI Outbound)

6 = Variation (Segment (and SegmentInstance) should be processed as a Variation 

This is a variation created by the principal. It might be follow a proposal, or might be stand alone.)

7 = VariationProposal (Segment (and SegmentInstance) should be processed as a Variation Proposal 

This is the principal proposing a variation to the contractor and getting a response to the proposal)

8 = VariationRequest (Segment (and SegmentInstance) should be processed as a Variation Request 

This is the contractor requesting a variation from the principal) */
    segmentProcessType!: SegmentProcessType;
    /** Configuration for this particular segment */
    config!: DataDrivenSegmentConfigModel;
    /** The workflow related to this segment */
    workflow!: BasicWorkflowModel;

    constructor(data?: IBasicSegmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.config = new DataDrivenSegmentConfigModel();
            this.workflow = new BasicWorkflowModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.manifestSegmentGid = _data["manifestSegmentGid"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.context = _data["context"];
            this.segmentProcessType = _data["segmentProcessType"];
            this.config = _data["config"] ? DataDrivenSegmentConfigModel.fromJS(_data["config"]) : new DataDrivenSegmentConfigModel();
            this.workflow = _data["workflow"] ? BasicWorkflowModel.fromJS(_data["workflow"]) : new BasicWorkflowModel();
        }
    }

    static fromJS(data: any): BasicSegmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new BasicSegmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["manifestSegmentGid"] = this.manifestSegmentGid;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["context"] = this.context;
        data["segmentProcessType"] = this.segmentProcessType;
        data["config"] = this.config ? this.config.toJSON() : <any>undefined;
        data["workflow"] = this.workflow ? this.workflow.toJSON() : <any>undefined;
        return data;
    }
}

/** Basic Segment Model Used on its own as well as the item in <seealso cref="T:OneTrack.Api.Models.ListSegmentInstanceModel" /> [Basic Segment Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2342846627/Basic+Segment+Object) */
export interface IBasicSegmentModel {
    /** Public Id for OneTrack.EFDatabase.App.Models.Workflows.Segment */
    gid: string;
    /** Gid to look this segment up in the manifest */
    manifestSegmentGid: string;
    /** Segment Name */
    name: string;
    /** Segment Short Name (e.g. NoLD) */
    shortName: string;
    /** Segment Context like (e.g. Previous NoLD Given) */
    context?: string | undefined;
    /** Segment Process Type

1 = Notice (Segment (and SegmentInstance) should to be processed as a Notice)

2 = Claim (Segment (and SegmentInstance) should to be processed as a Claim)

3 = Direction (Segment (and SegmentInstance) should be processed as a Direction (note: post-mvp))

4 = RFIInbound (Segment (and SegmentInstance) should be processed as an RFI Inbound)

5 = RFIOutbound (Segment (and SegmentInstance) should be processed as an RFI Outbound)

6 = Variation (Segment (and SegmentInstance) should be processed as a Variation 

This is a variation created by the principal. It might be follow a proposal, or might be stand alone.)

7 = VariationProposal (Segment (and SegmentInstance) should be processed as a Variation Proposal 

This is the principal proposing a variation to the contractor and getting a response to the proposal)

8 = VariationRequest (Segment (and SegmentInstance) should be processed as a Variation Request 

This is the contractor requesting a variation from the principal) */
    segmentProcessType: SegmentProcessType;
    /** Configuration for this particular segment */
    config: DataDrivenSegmentConfigModel;
    /** The workflow related to this segment */
    workflow: BasicWorkflowModel;
}

/** Summary of a claim [Basic Summary Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2276033144/Segment+Instance+Details+Object#Basic-Summary-Object) */
export class BasicSummaryModel implements IBasicSummaryModel {
    /** Run identifier from Evaluation */
    runGid!: string;
    /** Summary data from the Evaluation */
    summary!: DataDrivenSummaryModel[];
    /** Details of the User that Created the Run that this summary is from */
    created?: DataDrivenModifiedModel | undefined;
    /** Details of the User that Finished the Run that this summary is from */
    finished?: DataDrivenModifiedModel | undefined;

    constructor(data?: IBasicSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.summary = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.runGid = _data["runGid"];
            if (Array.isArray(_data["summary"])) {
                this.summary = [] as any;
                for (let item of _data["summary"])
                    this.summary!.push(DataDrivenSummaryModel.fromJS(item));
            }
            this.created = _data["created"] ? DataDrivenModifiedModel.fromJS(_data["created"]) : <any>undefined;
            this.finished = _data["finished"] ? DataDrivenModifiedModel.fromJS(_data["finished"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BasicSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new BasicSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["runGid"] = this.runGid;
        if (Array.isArray(this.summary)) {
            data["summary"] = [];
            for (let item of this.summary)
                data["summary"].push(item.toJSON());
        }
        data["created"] = this.created ? this.created.toJSON() : <any>undefined;
        data["finished"] = this.finished ? this.finished.toJSON() : <any>undefined;
        return data;
    }
}

/** Summary of a claim [Basic Summary Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2276033144/Segment+Instance+Details+Object#Basic-Summary-Object) */
export interface IBasicSummaryModel {
    /** Run identifier from Evaluation */
    runGid: string;
    /** Summary data from the Evaluation */
    summary: DataDrivenSummaryModel[];
    /** Details of the User that Created the Run that this summary is from */
    created?: DataDrivenModifiedModel | undefined;
    /** Details of the User that Finished the Run that this summary is from */
    finished?: DataDrivenModifiedModel | undefined;
}

export class BasicWorkflowModel implements IBasicWorkflowModel {
    gid!: string;
    name!: string;
    shortName!: string;
    contractWorkflowCannotBeDeleted!: boolean;

    constructor(data?: IBasicWorkflowModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.contractWorkflowCannotBeDeleted = _data["contractWorkflowCannotBeDeleted"];
        }
    }

    static fromJS(data: any): BasicWorkflowModel {
        data = typeof data === 'object' ? data : {};
        let result = new BasicWorkflowModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["contractWorkflowCannotBeDeleted"] = this.contractWorkflowCannotBeDeleted;
        return data;
    }
}

export interface IBasicWorkflowModel {
    gid: string;
    name: string;
    shortName: string;
    contractWorkflowCannotBeDeleted: boolean;
}

/** Cut down Evaluation Object that can be returned to the Client [Client Evaluation Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2669838337/Client+Evaluation+Object) */
export class ClientEvaluationModel implements IClientEvaluationModel {
    /** For storing keys that the rules set. 

May be empty. */
    keys!: string[];
    /** For storing key value pairs that the rules set. 

These are generally used for information to be put on screen in the client side rendering. 

They are available when running rules, so information can be shared between rules, but care should be taken. 
 */
    context2?: any | undefined;
    /** Unique Identifier for the Run that this Evaluation belongs to */
    runGid!: string;
    /** The Key for the Phase associated with the Instance this Evaluation is based on */
    phaseKey?: string | undefined;
    /** Details of the User that created the Instance that this Evaluation is based on. 
 */
    created?: DataDrivenModifiedModel | undefined;
    /** Details of the User that completed the Instance that this Evaluation is based on. 
 */
    finished?: DataDrivenModifiedModel | undefined;

    constructor(data?: IClientEvaluationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.keys = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["keys"])) {
                this.keys = [] as any;
                for (let item of _data["keys"])
                    this.keys!.push(item);
            }
            this.context2 = _data["context2"];
            this.runGid = _data["runGid"];
            this.phaseKey = _data["phaseKey"];
            this.created = _data["created"] ? DataDrivenModifiedModel.fromJS(_data["created"]) : <any>undefined;
            this.finished = _data["finished"] ? DataDrivenModifiedModel.fromJS(_data["finished"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ClientEvaluationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientEvaluationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.keys)) {
            data["keys"] = [];
            for (let item of this.keys)
                data["keys"].push(item);
        }
        data["context2"] = this.context2;
        data["runGid"] = this.runGid;
        data["phaseKey"] = this.phaseKey;
        data["created"] = this.created ? this.created.toJSON() : <any>undefined;
        data["finished"] = this.finished ? this.finished.toJSON() : <any>undefined;
        return data;
    }
}

/** Cut down Evaluation Object that can be returned to the Client [Client Evaluation Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2669838337/Client+Evaluation+Object) */
export interface IClientEvaluationModel {
    /** For storing keys that the rules set. 

May be empty. */
    keys: string[];
    /** For storing key value pairs that the rules set. 

These are generally used for information to be put on screen in the client side rendering. 

They are available when running rules, so information can be shared between rules, but care should be taken. 
 */
    context2?: any | undefined;
    /** Unique Identifier for the Run that this Evaluation belongs to */
    runGid: string;
    /** The Key for the Phase associated with the Instance this Evaluation is based on */
    phaseKey?: string | undefined;
    /** Details of the User that created the Instance that this Evaluation is based on. 
 */
    created?: DataDrivenModifiedModel | undefined;
    /** Details of the User that completed the Instance that this Evaluation is based on. 
 */
    finished?: DataDrivenModifiedModel | undefined;
}

export class ContractCalendarModel implements IContractCalendarModel {
    /** Contract Calendars Gid */
    gid?: string;
    /** Contracts Organisation Calendar Gid */
    organisationCalendarGid?: string;
    /** Contract calendars name */
    name?: string | undefined;

    constructor(data?: IContractCalendarModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.organisationCalendarGid = _data["organisationCalendarGid"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ContractCalendarModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContractCalendarModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["organisationCalendarGid"] = this.organisationCalendarGid;
        data["name"] = this.name;
        return data;
    }
}

export interface IContractCalendarModel {
    /** Contract Calendars Gid */
    gid?: string;
    /** Contracts Organisation Calendar Gid */
    organisationCalendarGid?: string;
    /** Contract calendars name */
    name?: string | undefined;
}

/** Details for a specific Contract ([Contract Details Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2280325580/Contract+Details+Object)) */
export class ContractDetailsModel implements IContractDetailsModel {
    /** Contract Public Id */
    gid!: string;
    /** Contract’s Project Public Id */
    projectGid!: string;
    /** Contract’s Project's Organisation Public Id */
    organisationGid!: string;
    /** User defined name for this contract */
    name!: string;
    /** User defined reference for this contract */
    reference!: string;
    /** Type details for this contract */
    type!: ContractTypeModel;
    /** Contractor contract is contracted to */
    contractor?: string | undefined;
    /** Contract Description */
    description?: string | undefined;
    /** Contracts contact name */
    contactName?: string | undefined;
    /** Contracts contact email */
    contactEmail?: string | undefined;
    /** Contracts contact phone */
    contactPhone?: string | undefined;
    /** Contracts status

1 = Active (Contract is active, at this point settings can’t be edited)

2 = Pending (Partway through setup or in pending mode where configuration can be edited)

3 = Terminated (Post MVP)

4 = PracticalCompletion (Post MVP)

5 = FinalCompletion (Post MVP)

6 = Suspended (Post MVP)

7 = Draft (Contract is still in wizard phase)

8 = Cancelled (Post MVP) */
    status!: ContractStatus;
    /** Contracts Timezone */
    timezone!: string;
    /** Contracts Budget */
    budget?: number | undefined;
    /** Contracts start date */
    dateOfContract?: string | undefined;
    /** Contracts projected completion date */
    projectedCompletionDate!: string;
    /** Null if not specified */
    tendersClosedDate?: string | undefined;
    /** Contracts initially assigned completion date */
    revisedCompletionDate!: string;
    /** The Most Recently Agreed Date For Practical Completion */
    mostRecentlyAgreedDateForPracticalCompletion?: string | undefined;
    /** Sql Server generated Timestamp that is altered every time the Contract row is modified */
    rowVersion!: string;
    /** Workday calendar used for contract */
    workdayCalendar!: ContractCalendarModel;
    /** Business calendar used for contract */
    businessCalendar!: ContractCalendarModel;
    /** List of contracts workflows */
    workflows!: ContractWorkflowModel[];

    constructor(data?: IContractDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.type = new ContractTypeModel();
            this.workdayCalendar = new ContractCalendarModel();
            this.businessCalendar = new ContractCalendarModel();
            this.workflows = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.projectGid = _data["projectGid"];
            this.organisationGid = _data["organisationGid"];
            this.name = _data["name"];
            this.reference = _data["reference"];
            this.type = _data["type"] ? ContractTypeModel.fromJS(_data["type"]) : new ContractTypeModel();
            this.contractor = _data["contractor"];
            this.description = _data["description"];
            this.contactName = _data["contactName"];
            this.contactEmail = _data["contactEmail"];
            this.contactPhone = _data["contactPhone"];
            this.status = _data["status"];
            this.timezone = _data["timezone"];
            this.budget = _data["budget"];
            this.dateOfContract = _data["dateOfContract"];
            this.projectedCompletionDate = _data["projectedCompletionDate"];
            this.tendersClosedDate = _data["tendersClosedDate"];
            this.revisedCompletionDate = _data["revisedCompletionDate"];
            this.mostRecentlyAgreedDateForPracticalCompletion = _data["mostRecentlyAgreedDateForPracticalCompletion"];
            this.rowVersion = _data["rowVersion"];
            this.workdayCalendar = _data["workdayCalendar"] ? ContractCalendarModel.fromJS(_data["workdayCalendar"]) : new ContractCalendarModel();
            this.businessCalendar = _data["businessCalendar"] ? ContractCalendarModel.fromJS(_data["businessCalendar"]) : new ContractCalendarModel();
            if (Array.isArray(_data["workflows"])) {
                this.workflows = [] as any;
                for (let item of _data["workflows"])
                    this.workflows!.push(ContractWorkflowModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContractDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContractDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["projectGid"] = this.projectGid;
        data["organisationGid"] = this.organisationGid;
        data["name"] = this.name;
        data["reference"] = this.reference;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["contractor"] = this.contractor;
        data["description"] = this.description;
        data["contactName"] = this.contactName;
        data["contactEmail"] = this.contactEmail;
        data["contactPhone"] = this.contactPhone;
        data["status"] = this.status;
        data["timezone"] = this.timezone;
        data["budget"] = this.budget;
        data["dateOfContract"] = this.dateOfContract;
        data["projectedCompletionDate"] = this.projectedCompletionDate;
        data["tendersClosedDate"] = this.tendersClosedDate;
        data["revisedCompletionDate"] = this.revisedCompletionDate;
        data["mostRecentlyAgreedDateForPracticalCompletion"] = this.mostRecentlyAgreedDateForPracticalCompletion;
        data["rowVersion"] = this.rowVersion;
        data["workdayCalendar"] = this.workdayCalendar ? this.workdayCalendar.toJSON() : <any>undefined;
        data["businessCalendar"] = this.businessCalendar ? this.businessCalendar.toJSON() : <any>undefined;
        if (Array.isArray(this.workflows)) {
            data["workflows"] = [];
            for (let item of this.workflows)
                data["workflows"].push(item.toJSON());
        }
        return data;
    }
}

/** Details for a specific Contract ([Contract Details Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2280325580/Contract+Details+Object)) */
export interface IContractDetailsModel {
    /** Contract Public Id */
    gid: string;
    /** Contract’s Project Public Id */
    projectGid: string;
    /** Contract’s Project's Organisation Public Id */
    organisationGid: string;
    /** User defined name for this contract */
    name: string;
    /** User defined reference for this contract */
    reference: string;
    /** Type details for this contract */
    type: ContractTypeModel;
    /** Contractor contract is contracted to */
    contractor?: string | undefined;
    /** Contract Description */
    description?: string | undefined;
    /** Contracts contact name */
    contactName?: string | undefined;
    /** Contracts contact email */
    contactEmail?: string | undefined;
    /** Contracts contact phone */
    contactPhone?: string | undefined;
    /** Contracts status

1 = Active (Contract is active, at this point settings can’t be edited)

2 = Pending (Partway through setup or in pending mode where configuration can be edited)

3 = Terminated (Post MVP)

4 = PracticalCompletion (Post MVP)

5 = FinalCompletion (Post MVP)

6 = Suspended (Post MVP)

7 = Draft (Contract is still in wizard phase)

8 = Cancelled (Post MVP) */
    status: ContractStatus;
    /** Contracts Timezone */
    timezone: string;
    /** Contracts Budget */
    budget?: number | undefined;
    /** Contracts start date */
    dateOfContract?: string | undefined;
    /** Contracts projected completion date */
    projectedCompletionDate: string;
    /** Null if not specified */
    tendersClosedDate?: string | undefined;
    /** Contracts initially assigned completion date */
    revisedCompletionDate: string;
    /** The Most Recently Agreed Date For Practical Completion */
    mostRecentlyAgreedDateForPracticalCompletion?: string | undefined;
    /** Sql Server generated Timestamp that is altered every time the Contract row is modified */
    rowVersion: string;
    /** Workday calendar used for contract */
    workdayCalendar: ContractCalendarModel;
    /** Business calendar used for contract */
    businessCalendar: ContractCalendarModel;
    /** List of contracts workflows */
    workflows: ContractWorkflowModel[];
}

export class ContractTypeModel implements IContractTypeModel {
    /** Public id for contract type */
    gid?: string;
    /** Contract type name */
    name?: string | undefined;
    description?: string | undefined;
    isGlobal?: boolean;

    constructor(data?: IContractTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isGlobal = _data["isGlobal"];
        }
    }

    static fromJS(data: any): ContractTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContractTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isGlobal"] = this.isGlobal;
        return data;
    }
}

export interface IContractTypeModel {
    /** Public id for contract type */
    gid?: string;
    /** Contract type name */
    name?: string | undefined;
    description?: string | undefined;
    isGlobal?: boolean;
}

/** Object that includes all the data submitted to [API00807R01 - POST Insert New Contract](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2439348405/API00807R01+-+POST+Insert+New+Contract) ([Contract Wizard object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2285240325/Contract+Wizard+object)            Used in: [API00807R01 - POST Insert New Contract](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2439348405/API00807R01+-+POST+Insert+New+Contract) ) */
export class ContractWizardModel implements IContractWizardModel {
    /** User defined name for this contract (Always editable 
) */
    name!: string;
    /** User defined reference for this contract (Only editable if the Contract.ContractStatus is <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Draft" /> or <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Pending" />
) */
    reference!: string;
    /** Type for this contract (Only editable if the Contract.ContractStatus is <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Draft" /> or <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Pending" />
) */
    typeGid?: string | undefined;
    /** Name of Contractor that contract is contracted to. 
 (Referred to as 'Contractor' in the Contract UI
Always editable 
) */
    contractorName?: string | undefined;
    /** Contract description. 
 (Always editable 
) */
    description?: string | undefined;
    /** Not divided into first and last name as the form input is a single text field. 
 (Always editable 
) */
    contactName?: string | undefined;
    /** Email address for the Contract's Contact person (Always editable 
) */
    contactEmail?: string | undefined;
    /** Phone number for the Contract's Contact person (Always editable 
) */
    contactPhone?: string | undefined;
    /** Timezone for contract that matches a tz database entry (Only editable if the Contract.ContractStatus is <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Draft" /> or <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Pending" />
) */
    timezone!: string;
    /** If undefined/empty property on table is to be set to null (Referred to as 'Initial Budget' in the Contract UI 

Always editable 
) */
    budget?: number | undefined;
    /** No time component (yyyy-mm-dd only) 
 (Referred to as 'Date of Contract' in the Contract UI 

Only editable if the Contract.ContractStatus is <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Draft" /> or <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Pending" />
) */
    contractStartDate?: string | undefined;
    /** No time component (yyyy-mm-dd only) (Referred to as 'Initial Date for Practical Completion' in the Contract UI 

Only editable if the Contract.ContractStatus is <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Draft" /> or <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Pending" />
) */
    projectedEndDate!: string;
    /** Leave as Null if no date provided 

No time component (yyyy-mm-dd only) (Referred to as 'Date Tenders Closed' in the Contract UI 

Only editable if the Contract.ContractStatus is <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Draft" /> or <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Pending" />
) */
    tendersClosedDate?: string | undefined;
    /** Public identifier for calendar, specifically for OneTrack.EFDatabase.App.Models.Organisations.Calendar. 
 (Only editable if the Contract.ContractStatus is <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Draft" /> or <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Pending" />
) */
    workingCalendarGid?: string | undefined;
    /** Public identifier for calendar, specifically for OneTrack.EFDatabase.App.Models.Organisations.Calendar. 
 (Only editable if the Contract.ContractStatus is <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Draft" /> or <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Pending" />
) */
    businessCalendarGid?: string | undefined;
    /** Public Id for this contract, generated on UI side */
    contractGid!: string;
    /** Public id for the project this contract is for, specifically for Table: Project */
    projectGid!: string;

    constructor(data?: IContractWizardModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.reference = _data["reference"];
            this.typeGid = _data["typeGid"];
            this.contractorName = _data["contractorName"];
            this.description = _data["description"];
            this.contactName = _data["contactName"];
            this.contactEmail = _data["contactEmail"];
            this.contactPhone = _data["contactPhone"];
            this.timezone = _data["timezone"];
            this.budget = _data["budget"];
            this.contractStartDate = _data["contractStartDate"];
            this.projectedEndDate = _data["projectedEndDate"];
            this.tendersClosedDate = _data["tendersClosedDate"];
            this.workingCalendarGid = _data["workingCalendarGid"];
            this.businessCalendarGid = _data["businessCalendarGid"];
            this.contractGid = _data["contractGid"];
            this.projectGid = _data["projectGid"];
        }
    }

    static fromJS(data: any): ContractWizardModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContractWizardModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["reference"] = this.reference;
        data["typeGid"] = this.typeGid;
        data["contractorName"] = this.contractorName;
        data["description"] = this.description;
        data["contactName"] = this.contactName;
        data["contactEmail"] = this.contactEmail;
        data["contactPhone"] = this.contactPhone;
        data["timezone"] = this.timezone;
        data["budget"] = this.budget;
        data["contractStartDate"] = this.contractStartDate;
        data["projectedEndDate"] = this.projectedEndDate;
        data["tendersClosedDate"] = this.tendersClosedDate;
        data["workingCalendarGid"] = this.workingCalendarGid;
        data["businessCalendarGid"] = this.businessCalendarGid;
        data["contractGid"] = this.contractGid;
        data["projectGid"] = this.projectGid;
        return data;
    }
}

/** Object that includes all the data submitted to [API00807R01 - POST Insert New Contract](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2439348405/API00807R01+-+POST+Insert+New+Contract) ([Contract Wizard object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2285240325/Contract+Wizard+object)            Used in: [API00807R01 - POST Insert New Contract](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2439348405/API00807R01+-+POST+Insert+New+Contract) ) */
export interface IContractWizardModel {
    /** User defined name for this contract (Always editable 
) */
    name: string;
    /** User defined reference for this contract (Only editable if the Contract.ContractStatus is <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Draft" /> or <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Pending" />
) */
    reference: string;
    /** Type for this contract (Only editable if the Contract.ContractStatus is <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Draft" /> or <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Pending" />
) */
    typeGid?: string | undefined;
    /** Name of Contractor that contract is contracted to. 
 (Referred to as 'Contractor' in the Contract UI
Always editable 
) */
    contractorName?: string | undefined;
    /** Contract description. 
 (Always editable 
) */
    description?: string | undefined;
    /** Not divided into first and last name as the form input is a single text field. 
 (Always editable 
) */
    contactName?: string | undefined;
    /** Email address for the Contract's Contact person (Always editable 
) */
    contactEmail?: string | undefined;
    /** Phone number for the Contract's Contact person (Always editable 
) */
    contactPhone?: string | undefined;
    /** Timezone for contract that matches a tz database entry (Only editable if the Contract.ContractStatus is <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Draft" /> or <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Pending" />
) */
    timezone: string;
    /** If undefined/empty property on table is to be set to null (Referred to as 'Initial Budget' in the Contract UI 

Always editable 
) */
    budget?: number | undefined;
    /** No time component (yyyy-mm-dd only) 
 (Referred to as 'Date of Contract' in the Contract UI 

Only editable if the Contract.ContractStatus is <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Draft" /> or <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Pending" />
) */
    contractStartDate?: string | undefined;
    /** No time component (yyyy-mm-dd only) (Referred to as 'Initial Date for Practical Completion' in the Contract UI 

Only editable if the Contract.ContractStatus is <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Draft" /> or <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Pending" />
) */
    projectedEndDate: string;
    /** Leave as Null if no date provided 

No time component (yyyy-mm-dd only) (Referred to as 'Date Tenders Closed' in the Contract UI 

Only editable if the Contract.ContractStatus is <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Draft" /> or <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Pending" />
) */
    tendersClosedDate?: string | undefined;
    /** Public identifier for calendar, specifically for OneTrack.EFDatabase.App.Models.Organisations.Calendar. 
 (Only editable if the Contract.ContractStatus is <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Draft" /> or <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Pending" />
) */
    workingCalendarGid?: string | undefined;
    /** Public identifier for calendar, specifically for OneTrack.EFDatabase.App.Models.Organisations.Calendar. 
 (Only editable if the Contract.ContractStatus is <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Draft" /> or <seealso cref="F:OneTrack.Data.Enums.ContractStatus.Pending" />
) */
    businessCalendarGid?: string | undefined;
    /** Public Id for this contract, generated on UI side */
    contractGid: string;
    /** Public id for the project this contract is for, specifically for Table: Project */
    projectGid: string;
}

/** Details for a specific Contract in form used on forms and POST requests (Used in: [API00807 - POST Insert New Contract](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2280325359/API00807+-+POST+Insert+New+Contract) ) */
export class ContractWorkflowFormModel implements IContractWorkflowFormModel {
    /** Gid of the Contract Workflow, in the Table: Contract Workflow. This can either be the Gid for a new ContractWorkflow or for a preexisting ContractWorkflow. */
    contractWorkflowGid!: string;
    /** Gid of workflow, specifically for: Table: Workflow */
    workflowGid!: string;
    /** Whether or not this contract has been amended */
    isAmended!: boolean;

    constructor(data?: IContractWorkflowFormModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractWorkflowGid = _data["contractWorkflowGid"];
            this.workflowGid = _data["workflowGid"];
            this.isAmended = _data["isAmended"];
        }
    }

    static fromJS(data: any): ContractWorkflowFormModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContractWorkflowFormModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractWorkflowGid"] = this.contractWorkflowGid;
        data["workflowGid"] = this.workflowGid;
        data["isAmended"] = this.isAmended;
        return data;
    }
}

/** Details for a specific Contract in form used on forms and POST requests (Used in: [API00807 - POST Insert New Contract](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2280325359/API00807+-+POST+Insert+New+Contract) ) */
export interface IContractWorkflowFormModel {
    /** Gid of the Contract Workflow, in the Table: Contract Workflow. This can either be the Gid for a new ContractWorkflow or for a preexisting ContractWorkflow. */
    contractWorkflowGid: string;
    /** Gid of workflow, specifically for: Table: Workflow */
    workflowGid: string;
    /** Whether or not this contract has been amended */
    isAmended: boolean;
}

export class ContractWorkflowModel implements IContractWorkflowModel {
    /** ContractWorkflow Gid */
    gid?: string;
    /** Base Workflow gid */
    workflowGid?: string;
    /** Contract workflow name */
    name?: string | undefined;
    /** Shortened version of Workflow name */
    shortName?: string | undefined;
    /** Whether of not this particular ContractWorkflow has been altered */
    isAmended?: boolean;

    constructor(data?: IContractWorkflowModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.workflowGid = _data["workflowGid"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.isAmended = _data["isAmended"];
        }
    }

    static fromJS(data: any): ContractWorkflowModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContractWorkflowModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["workflowGid"] = this.workflowGid;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["isAmended"] = this.isAmended;
        return data;
    }
}

export interface IContractWorkflowModel {
    /** ContractWorkflow Gid */
    gid?: string;
    /** Base Workflow gid */
    workflowGid?: string;
    /** Contract workflow name */
    name?: string | undefined;
    /** Shortened version of Workflow name */
    shortName?: string | undefined;
    /** Whether of not this particular ContractWorkflow has been altered */
    isAmended?: boolean;
}

/** Properties that will be used for the email that will be sent when a segment instance is finalised. These are used in the Email Contractor Dialog and can be changed by the user. [Email Properties Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2459074794/Email+Properties+Object) */
export class EmailPropertiesModel implements IEmailPropertiesModel {
    senderUserGid!: string;
    senderUserFirstName!: string;
    senderUserLastName!: string;
    recipients!: string[];
    subject!: string;

    constructor(data?: IEmailPropertiesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.recipients = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.senderUserGid = _data["senderUserGid"];
            this.senderUserFirstName = _data["senderUserFirstName"];
            this.senderUserLastName = _data["senderUserLastName"];
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(item);
            }
            this.subject = _data["subject"];
        }
    }

    static fromJS(data: any): EmailPropertiesModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmailPropertiesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["senderUserGid"] = this.senderUserGid;
        data["senderUserFirstName"] = this.senderUserFirstName;
        data["senderUserLastName"] = this.senderUserLastName;
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item);
        }
        data["subject"] = this.subject;
        return data;
    }
}

/** Properties that will be used for the email that will be sent when a segment instance is finalised. These are used in the Email Contractor Dialog and can be changed by the user. [Email Properties Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2459074794/Email+Properties+Object) */
export interface IEmailPropertiesModel {
    senderUserGid: string;
    senderUserFirstName: string;
    senderUserLastName: string;
    recipients: string[];
    subject: string;
}

export class EntityModifiedResponseModel implements IEntityModifiedResponseModel {
    rowVersion!: string;

    constructor(data?: IEntityModifiedResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): EntityModifiedResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new EntityModifiedResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowVersion"] = this.rowVersion;
        return data;
    }
}

export interface IEntityModifiedResponseModel {
    rowVersion: string;
}

export class LastModifiedModel implements ILastModifiedModel {
    utc?: Date;
    byGid?: string;
    byFirstName?: string | undefined;
    byLastName?: string | undefined;

    constructor(data?: ILastModifiedModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.utc = _data["utc"] ? new Date(_data["utc"].toString()) : <any>undefined;
            this.byGid = _data["byGid"];
            this.byFirstName = _data["byFirstName"];
            this.byLastName = _data["byLastName"];
        }
    }

    static fromJS(data: any): LastModifiedModel {
        data = typeof data === 'object' ? data : {};
        let result = new LastModifiedModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["utc"] = this.utc ? this.utc.toISOString() : <any>undefined;
        data["byGid"] = this.byGid;
        data["byFirstName"] = this.byFirstName;
        data["byLastName"] = this.byLastName;
        return data;
    }
}

export interface ILastModifiedModel {
    utc?: Date;
    byGid?: string;
    byFirstName?: string | undefined;
    byLastName?: string | undefined;
}

/** List Contract Model <see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2276000239/List+Contract+Object" /> */
export class ListContractModel implements IListContractModel {
    /** The public id for the contract */
    gid!: string;
    /** The contracts name */
    name!: string;
    /** A user defined contract identifier */
    reference!: string;
    /** Contract Timezone, used for formatting and time logic */
    timezone!: string;
    /** The public id for the contracts associated [Table: Project](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/1315078292/Table%3A+Project) */
    projectGid!: string;
    /** The public id for the contracts associated [Table: Contract Type](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/1340441076/Table%3A+Contract+Type) */
    typeGid!: string;
    /** The associated contract types name */
    typeName!: string;
    /** The contracts status
For MVP this indicates whether or not administrative action has commenced on the contract (OneTrack.Data.Enums.ContractStatus
<seealso href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums?focusedCommentId=2190377611#Contract-Status">Enums | Contract-Status</seealso>)

1 = Active (Contract is active, at this point settings can’t be edited)

2 = Pending (Partway through setup or in pending mode where configuration can be edited)

3 = Terminated (Post MVP)

4 = PracticalCompletion (Post MVP)

5 = FinalCompletion (Post MVP)

6 = Suspended (Post MVP)

7 = Draft (Contract is still in wizard phase)

8 = Cancelled (Post MVP) */
    status!: ContractStatus;
    /** The contracts start date */
    startDate?: string | undefined;
    /** The contracts traffic lights */
    trafficLights!: TrafficLightsModel;
    /** Current User's Organisation User Status info for the Organisation that owns the Project that the Contract belongs to */
    organisationUser?: UserStatusModel | undefined;
    /** Current User's Project User Status info for the Project that the Contract belongs to */
    projectUser?: UserStatusModel | undefined;
    /** Supplied User's Contract User Status info for the Contract */
    contractUser?: UserStatusModel | undefined;
    /** End date defined in contract */
    projectedEndDate!: string;
    /** Revised PC Date based on Approved Claims */
    revisedEndDate?: string | undefined;
    /** The Most Recently Agreed Date For Practical Completion */
    mostRecentlyAgreedDateForPracticalCompletion?: string | undefined;
    /** Sql Server generated Timestamp that is altered every time the Contract row is modified */
    rowVersion!: string;

    constructor(data?: IListContractModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.trafficLights = new TrafficLightsModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.name = _data["name"];
            this.reference = _data["reference"];
            this.timezone = _data["timezone"];
            this.projectGid = _data["projectGid"];
            this.typeGid = _data["typeGid"];
            this.typeName = _data["typeName"];
            this.status = _data["status"];
            this.startDate = _data["startDate"];
            this.trafficLights = _data["trafficLights"] ? TrafficLightsModel.fromJS(_data["trafficLights"]) : new TrafficLightsModel();
            this.organisationUser = _data["organisationUser"] ? UserStatusModel.fromJS(_data["organisationUser"]) : <any>undefined;
            this.projectUser = _data["projectUser"] ? UserStatusModel.fromJS(_data["projectUser"]) : <any>undefined;
            this.contractUser = _data["contractUser"] ? UserStatusModel.fromJS(_data["contractUser"]) : <any>undefined;
            this.projectedEndDate = _data["projectedEndDate"];
            this.revisedEndDate = _data["revisedEndDate"];
            this.mostRecentlyAgreedDateForPracticalCompletion = _data["mostRecentlyAgreedDateForPracticalCompletion"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): ListContractModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListContractModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["name"] = this.name;
        data["reference"] = this.reference;
        data["timezone"] = this.timezone;
        data["projectGid"] = this.projectGid;
        data["typeGid"] = this.typeGid;
        data["typeName"] = this.typeName;
        data["status"] = this.status;
        data["startDate"] = this.startDate;
        data["trafficLights"] = this.trafficLights ? this.trafficLights.toJSON() : <any>undefined;
        data["organisationUser"] = this.organisationUser ? this.organisationUser.toJSON() : <any>undefined;
        data["projectUser"] = this.projectUser ? this.projectUser.toJSON() : <any>undefined;
        data["contractUser"] = this.contractUser ? this.contractUser.toJSON() : <any>undefined;
        data["projectedEndDate"] = this.projectedEndDate;
        data["revisedEndDate"] = this.revisedEndDate;
        data["mostRecentlyAgreedDateForPracticalCompletion"] = this.mostRecentlyAgreedDateForPracticalCompletion;
        data["rowVersion"] = this.rowVersion;
        return data;
    }
}

/** List Contract Model <see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2276000239/List+Contract+Object" /> */
export interface IListContractModel {
    /** The public id for the contract */
    gid: string;
    /** The contracts name */
    name: string;
    /** A user defined contract identifier */
    reference: string;
    /** Contract Timezone, used for formatting and time logic */
    timezone: string;
    /** The public id for the contracts associated [Table: Project](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/1315078292/Table%3A+Project) */
    projectGid: string;
    /** The public id for the contracts associated [Table: Contract Type](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/1340441076/Table%3A+Contract+Type) */
    typeGid: string;
    /** The associated contract types name */
    typeName: string;
    /** The contracts status
For MVP this indicates whether or not administrative action has commenced on the contract (OneTrack.Data.Enums.ContractStatus
<seealso href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums?focusedCommentId=2190377611#Contract-Status">Enums | Contract-Status</seealso>)

1 = Active (Contract is active, at this point settings can’t be edited)

2 = Pending (Partway through setup or in pending mode where configuration can be edited)

3 = Terminated (Post MVP)

4 = PracticalCompletion (Post MVP)

5 = FinalCompletion (Post MVP)

6 = Suspended (Post MVP)

7 = Draft (Contract is still in wizard phase)

8 = Cancelled (Post MVP) */
    status: ContractStatus;
    /** The contracts start date */
    startDate?: string | undefined;
    /** The contracts traffic lights */
    trafficLights: TrafficLightsModel;
    /** Current User's Organisation User Status info for the Organisation that owns the Project that the Contract belongs to */
    organisationUser?: UserStatusModel | undefined;
    /** Current User's Project User Status info for the Project that the Contract belongs to */
    projectUser?: UserStatusModel | undefined;
    /** Supplied User's Contract User Status info for the Contract */
    contractUser?: UserStatusModel | undefined;
    /** End date defined in contract */
    projectedEndDate: string;
    /** Revised PC Date based on Approved Claims */
    revisedEndDate?: string | undefined;
    /** The Most Recently Agreed Date For Practical Completion */
    mostRecentlyAgreedDateForPracticalCompletion?: string | undefined;
    /** Sql Server generated Timestamp that is altered every time the Contract row is modified */
    rowVersion: string;
}

/** Segment Instance List Model Thin version of the claim object for use on lists [Segment Instance List Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2287435777/SegmentInstance+List+Object) */
export class ListSegmentInstanceModel implements IListSegmentInstanceModel {
    /** Public Id for OneTrack.EFDatabase.App.Models.Workflows.SegmentInstance */
    gid!: string;
    /** A user defined contract identifier */
    reference!: string;
    /** The time this entry was added to the database in UTC */
    createdUtc!: Date;
    /** No time component */
    dueDate?: string | undefined;
    /** OneTrack.Data.Enums.SegmentInstanceStatus
<seealso href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Segment-Instance-Status">Enums | Segment Instance Status</seealso>

1 = InProgress (Segment is unresolved, this is the initial status for most segments)

2 = Suspended (Segment is unresolved but is marked as suspended, post MVP this will include additional logic for ‘Stopping the ticking of clocks’)

3 = InfoRequestedAndNotSuspended (Segment is unresolved and is noting that additional information has been requested)

4 = InfoRequestedAndSuspended (Effectively the same as both ‘Info Requested and Not Suspended’ and ‘Suspended’)

16 = Complete (Segment has been resolved)

17 = Withdrawn (Segment has been withdrawn (this is specially for when a contractor withdraws a claim))

18 = Cancelled (Segment has been cancelled (this is specifically for when the principal cancels a claim))

19 = Disputed (Segment is resolved and has been marked as being in dispute, Post MVP this means an additional dispute workflow as been created)

20 = LegalDispute (Same as Disputed but for Legal Disputes) */
    status!: SegmentInstanceStatus;
    /** Segment Instance Granted Time */
    grantedTime?: number | undefined;
    /** OneTrack.Data.Enums.TimePeriodUnit

<seealso href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Time-Period-Unit">Enums | Time Period Unit</seealso>

1 = Hours (A time period of hours)

2 = Days (A time period of days)

3 = Weeks (A time period of weeks) */
    grantedTimeUnit?: TimePeriodUnit | undefined;
    /** OneTrack.Data.Enums.TimePeriodUnit

<seealso href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Well+Known+Enums#Calendar-Type">Enums | Calendar Type</seealso>

1 = Working (Working calendar)

2 = Business (Business calendar)

3 = CalendarDays (Every regular calendar day (Every regular calendar day, no weekdays or weekends and no holidays. Just regular sequential days.)) */
    grantedTimeCalendarType?: CalendarType | undefined;
    /** OneTrack.Data.Enums.SegmentInstanceResolution

<seealso href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Segment-Instance-Resolution">Enums | Segment Instance Resolution</seealso>

1 = Accepted (Segment has been accepted, claimed time/budget granted by the principal is added to the contract.)

2 = Rejected (Segment has been rejected, any claimed time/budget is noted but not added to the contract.)

3 = Indeterminate (Resolution not possible at this point.) */
    resolution?: SegmentInstanceResolution | undefined;
    /** Whether or not the resolution of this segment has been changed */
    resolutionChanged!: boolean;
    /** Basic details for associated OneTrack.EFDatabase.App.Models.Contracts.Contract */
    contract!: BasicContractModel;
    /** Basic details for associated OneTrack.EFDatabase.App.Models.Workflows.Workflow */
    workflowSegment!: BasicSegmentModel;
    /** In the future the object this property uses will become more complex, when this happens this should be replaced with a simple object. */
    project!: BasicProjectModel;
    /** Are Response Time Alerts (Traffic Lights) Enabled for this SegmentInstance */
    responseTimeAlertsEnabled!: boolean;
    /** Whether or not the SegmentInstance is to be excluded from Practical Completion Date Calculations. */
    noLongerAffectingPC!: boolean;
    /** The traffic light colour to use for the segment instance

0 = None (There is no colour)

1 = Green (Green - usually indicates a everything is going swimmingly)

2 = Amber (Amber - usually indicates a warning that something is almost overdue)

3 = Red (Red - usually indicates Overdue) */
    trafficLightColour!: TrafficLightColour;

    constructor(data?: IListSegmentInstanceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.contract = new BasicContractModel();
            this.workflowSegment = new BasicSegmentModel();
            this.project = new BasicProjectModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.reference = _data["reference"];
            this.createdUtc = _data["createdUtc"] ? new Date(_data["createdUtc"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"];
            this.status = _data["status"];
            this.grantedTime = _data["grantedTime"];
            this.grantedTimeUnit = _data["grantedTimeUnit"];
            this.grantedTimeCalendarType = _data["grantedTimeCalendarType"];
            this.resolution = _data["resolution"];
            this.resolutionChanged = _data["resolutionChanged"];
            this.contract = _data["contract"] ? BasicContractModel.fromJS(_data["contract"]) : new BasicContractModel();
            this.workflowSegment = _data["workflowSegment"] ? BasicSegmentModel.fromJS(_data["workflowSegment"]) : new BasicSegmentModel();
            this.project = _data["project"] ? BasicProjectModel.fromJS(_data["project"]) : new BasicProjectModel();
            this.responseTimeAlertsEnabled = _data["responseTimeAlertsEnabled"];
            this.noLongerAffectingPC = _data["noLongerAffectingPC"];
            this.trafficLightColour = _data["trafficLightColour"];
        }
    }

    static fromJS(data: any): ListSegmentInstanceModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListSegmentInstanceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["reference"] = this.reference;
        data["createdUtc"] = this.createdUtc ? this.createdUtc.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate;
        data["status"] = this.status;
        data["grantedTime"] = this.grantedTime;
        data["grantedTimeUnit"] = this.grantedTimeUnit;
        data["grantedTimeCalendarType"] = this.grantedTimeCalendarType;
        data["resolution"] = this.resolution;
        data["resolutionChanged"] = this.resolutionChanged;
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        data["workflowSegment"] = this.workflowSegment ? this.workflowSegment.toJSON() : <any>undefined;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["responseTimeAlertsEnabled"] = this.responseTimeAlertsEnabled;
        data["noLongerAffectingPC"] = this.noLongerAffectingPC;
        data["trafficLightColour"] = this.trafficLightColour;
        return data;
    }
}

/** Segment Instance List Model Thin version of the claim object for use on lists [Segment Instance List Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2287435777/SegmentInstance+List+Object) */
export interface IListSegmentInstanceModel {
    /** Public Id for OneTrack.EFDatabase.App.Models.Workflows.SegmentInstance */
    gid: string;
    /** A user defined contract identifier */
    reference: string;
    /** The time this entry was added to the database in UTC */
    createdUtc: Date;
    /** No time component */
    dueDate?: string | undefined;
    /** OneTrack.Data.Enums.SegmentInstanceStatus
<seealso href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Segment-Instance-Status">Enums | Segment Instance Status</seealso>

1 = InProgress (Segment is unresolved, this is the initial status for most segments)

2 = Suspended (Segment is unresolved but is marked as suspended, post MVP this will include additional logic for ‘Stopping the ticking of clocks’)

3 = InfoRequestedAndNotSuspended (Segment is unresolved and is noting that additional information has been requested)

4 = InfoRequestedAndSuspended (Effectively the same as both ‘Info Requested and Not Suspended’ and ‘Suspended’)

16 = Complete (Segment has been resolved)

17 = Withdrawn (Segment has been withdrawn (this is specially for when a contractor withdraws a claim))

18 = Cancelled (Segment has been cancelled (this is specifically for when the principal cancels a claim))

19 = Disputed (Segment is resolved and has been marked as being in dispute, Post MVP this means an additional dispute workflow as been created)

20 = LegalDispute (Same as Disputed but for Legal Disputes) */
    status: SegmentInstanceStatus;
    /** Segment Instance Granted Time */
    grantedTime?: number | undefined;
    /** OneTrack.Data.Enums.TimePeriodUnit

<seealso href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Time-Period-Unit">Enums | Time Period Unit</seealso>

1 = Hours (A time period of hours)

2 = Days (A time period of days)

3 = Weeks (A time period of weeks) */
    grantedTimeUnit?: TimePeriodUnit | undefined;
    /** OneTrack.Data.Enums.TimePeriodUnit

<seealso href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Well+Known+Enums#Calendar-Type">Enums | Calendar Type</seealso>

1 = Working (Working calendar)

2 = Business (Business calendar)

3 = CalendarDays (Every regular calendar day (Every regular calendar day, no weekdays or weekends and no holidays. Just regular sequential days.)) */
    grantedTimeCalendarType?: CalendarType | undefined;
    /** OneTrack.Data.Enums.SegmentInstanceResolution

<seealso href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Segment-Instance-Resolution">Enums | Segment Instance Resolution</seealso>

1 = Accepted (Segment has been accepted, claimed time/budget granted by the principal is added to the contract.)

2 = Rejected (Segment has been rejected, any claimed time/budget is noted but not added to the contract.)

3 = Indeterminate (Resolution not possible at this point.) */
    resolution?: SegmentInstanceResolution | undefined;
    /** Whether or not the resolution of this segment has been changed */
    resolutionChanged: boolean;
    /** Basic details for associated OneTrack.EFDatabase.App.Models.Contracts.Contract */
    contract: BasicContractModel;
    /** Basic details for associated OneTrack.EFDatabase.App.Models.Workflows.Workflow */
    workflowSegment: BasicSegmentModel;
    /** In the future the object this property uses will become more complex, when this happens this should be replaced with a simple object. */
    project: BasicProjectModel;
    /** Are Response Time Alerts (Traffic Lights) Enabled for this SegmentInstance */
    responseTimeAlertsEnabled: boolean;
    /** Whether or not the SegmentInstance is to be excluded from Practical Completion Date Calculations. */
    noLongerAffectingPC: boolean;
    /** The traffic light colour to use for the segment instance

0 = None (There is no colour)

1 = Green (Green - usually indicates a everything is going swimmingly)

2 = Amber (Amber - usually indicates a warning that something is almost overdue)

3 = Red (Red - usually indicates Overdue) */
    trafficLightColour: TrafficLightColour;
}

export class ProfileModel implements IProfileModel {
    /** First Name of the User */
    firstName?: string | undefined;
    /** Last Name of the User */
    lastName?: string | undefined;
    /** Email of the User */
    email?: string | undefined;
    /** The optional mobile number of the user */
    mobile?: string | undefined;
    /** The optional date of birth of the user */
    dateOfBirth?: string;

    constructor(data?: IProfileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.mobile = _data["mobile"];
            this.dateOfBirth = _data["dateOfBirth"];
        }
    }

    static fromJS(data: any): ProfileModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["mobile"] = this.mobile;
        data["dateOfBirth"] = this.dateOfBirth;
        return data;
    }
}

export interface IProfileModel {
    /** First Name of the User */
    firstName?: string | undefined;
    /** Last Name of the User */
    lastName?: string | undefined;
    /** Email of the User */
    email?: string | undefined;
    /** The optional mobile number of the user */
    mobile?: string | undefined;
    /** The optional date of birth of the user */
    dateOfBirth?: string;
}

/** Details for Emails sent as part of the finalisation of a Segment Instance [Segment Instance Email  Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2463989800/Segment+Instance+Email+Object) */
export class SegmentInstanceEmailModel implements ISegmentInstanceEmailModel {
    /** The Identifier of the Run that triggered this Email to be sent */
    runGid!: string;
    /** The unique identifier of the user who initiated the finalisation and sent the email. */
    senderUserGid!: string;
    senderUserFirstName!: string;
    senderUserLastName!: string;
    recipients!: string[];
    subject!: string;
    content!: string;
    sentDateTimeUTC!: Date;

    constructor(data?: ISegmentInstanceEmailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.recipients = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.runGid = _data["runGid"];
            this.senderUserGid = _data["senderUserGid"];
            this.senderUserFirstName = _data["senderUserFirstName"];
            this.senderUserLastName = _data["senderUserLastName"];
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(item);
            }
            this.subject = _data["subject"];
            this.content = _data["content"];
            this.sentDateTimeUTC = _data["sentDateTimeUTC"] ? new Date(_data["sentDateTimeUTC"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SegmentInstanceEmailModel {
        data = typeof data === 'object' ? data : {};
        let result = new SegmentInstanceEmailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["runGid"] = this.runGid;
        data["senderUserGid"] = this.senderUserGid;
        data["senderUserFirstName"] = this.senderUserFirstName;
        data["senderUserLastName"] = this.senderUserLastName;
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item);
        }
        data["subject"] = this.subject;
        data["content"] = this.content;
        data["sentDateTimeUTC"] = this.sentDateTimeUTC ? this.sentDateTimeUTC.toISOString() : <any>undefined;
        return data;
    }
}

/** Details for Emails sent as part of the finalisation of a Segment Instance [Segment Instance Email  Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2463989800/Segment+Instance+Email+Object) */
export interface ISegmentInstanceEmailModel {
    /** The Identifier of the Run that triggered this Email to be sent */
    runGid: string;
    /** The unique identifier of the user who initiated the finalisation and sent the email. */
    senderUserGid: string;
    senderUserFirstName: string;
    senderUserLastName: string;
    recipients: string[];
    subject: string;
    content: string;
    sentDateTimeUTC: Date;
}

/** Traffic Lights Object <see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2328756336/Traffic+lights+object" /> */
export class TrafficLightsModel implements ITrafficLightsModel {
    green?: number;
    yellow?: number;
    red?: number;

    constructor(data?: ITrafficLightsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.green = _data["green"];
            this.yellow = _data["yellow"];
            this.red = _data["red"];
        }
    }

    static fromJS(data: any): TrafficLightsModel {
        data = typeof data === 'object' ? data : {};
        let result = new TrafficLightsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["green"] = this.green;
        data["yellow"] = this.yellow;
        data["red"] = this.red;
        return data;
    }
}

/** Traffic Lights Object <see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2328756336/Traffic+lights+object" /> */
export interface ITrafficLightsModel {
    green?: number;
    yellow?: number;
    red?: number;
}

/** User Status Object <see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2588213249/User+Status+object" /> */
export class UserStatusModel implements IUserStatusModel {
    gid!: string;
    /** [Organisation User Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Well+Known+Enums#Organisation-User-Status)

            Status types users can use

1 = Active (Organisation/Project/Contract User is active)

2 = Invited (Organisation/Project/Contract User is Invited)

3 = RejectedInvitation (Organisation/Project/Contract User has Rejected Invitation)

4 = Inactive (Organisation/Project/Contract User is Inactive) */
    status!: OrganisationUserStatus;
    title!: string;

    constructor(data?: IUserStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.status = _data["status"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): UserStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["status"] = this.status;
        data["title"] = this.title;
        return data;
    }
}

/** User Status Object <see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2588213249/User+Status+object" /> */
export interface IUserStatusModel {
    gid: string;
    /** [Organisation User Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Well+Known+Enums#Organisation-User-Status)

            Status types users can use

1 = Active (Organisation/Project/Contract User is active)

2 = Invited (Organisation/Project/Contract User is Invited)

3 = RejectedInvitation (Organisation/Project/Contract User has Rejected Invitation)

4 = Inactive (Organisation/Project/Contract User is Inactive) */
    status: OrganisationUserStatus;
    title: string;
}

/** User Status Object <see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2615377921/User+Status+With+Actions+object" /> */
export class UserStatusWithActionsModel implements IUserStatusWithActionsModel {
    gid!: string;
    /** [Organisation User Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Well+Known+Enums#Organisation-User-Status)

            Status types users can use

1 = Active (Organisation/Project/Contract User is active)

2 = Invited (Organisation/Project/Contract User is Invited)

3 = RejectedInvitation (Organisation/Project/Contract User has Rejected Invitation)

4 = Inactive (Organisation/Project/Contract User is Inactive) */
    status!: OrganisationUserStatus;
    title!: string;
    availableActions!: UserActions[];

    constructor(data?: IUserStatusWithActionsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.availableActions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.status = _data["status"];
            this.title = _data["title"];
            if (Array.isArray(_data["availableActions"])) {
                this.availableActions = [] as any;
                for (let item of _data["availableActions"])
                    this.availableActions!.push(item);
            }
        }
    }

    static fromJS(data: any): UserStatusWithActionsModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserStatusWithActionsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["status"] = this.status;
        data["title"] = this.title;
        if (Array.isArray(this.availableActions)) {
            data["availableActions"] = [];
            for (let item of this.availableActions)
                data["availableActions"].push(item);
        }
        return data;
    }
}

/** User Status Object <see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2615377921/User+Status+With+Actions+object" /> */
export interface IUserStatusWithActionsModel {
    gid: string;
    /** [Organisation User Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Well+Known+Enums#Organisation-User-Status)

            Status types users can use

1 = Active (Organisation/Project/Contract User is active)

2 = Invited (Organisation/Project/Contract User is Invited)

3 = RejectedInvitation (Organisation/Project/Contract User has Rejected Invitation)

4 = Inactive (Organisation/Project/Contract User is Inactive) */
    status: OrganisationUserStatus;
    title: string;
    availableActions: UserActions[];
}

/** Workflow Update Model [Workflow Update Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2689859618/Workflow+Update+Object) */
export class WorkflowUpdateModel implements IWorkflowUpdateModel {
    /** The Evaluation. 
 */
    evaluation!: ClientEvaluationModel;
    /** The Date. 
 */
    dueDate?: string | undefined;
    contractRowVersion!: string;
    /** The colour of the traffic light

0 = None (There is no colour)

1 = Green (Green - usually indicates a everything is going swimmingly)

2 = Amber (Amber - usually indicates a warning that something is almost overdue)

3 = Red (Red - usually indicates Overdue) */
    trafficLightColour!: TrafficLightColour;

    constructor(data?: IWorkflowUpdateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.evaluation = new ClientEvaluationModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.evaluation = _data["evaluation"] ? ClientEvaluationModel.fromJS(_data["evaluation"]) : new ClientEvaluationModel();
            this.dueDate = _data["dueDate"];
            this.contractRowVersion = _data["contractRowVersion"];
            this.trafficLightColour = _data["trafficLightColour"];
        }
    }

    static fromJS(data: any): WorkflowUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["evaluation"] = this.evaluation ? this.evaluation.toJSON() : <any>undefined;
        data["dueDate"] = this.dueDate;
        data["contractRowVersion"] = this.contractRowVersion;
        data["trafficLightColour"] = this.trafficLightColour;
        return data;
    }
}

/** Workflow Update Model [Workflow Update Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2689859618/Workflow+Update+Object) */
export interface IWorkflowUpdateModel {
    /** The Evaluation. 
 */
    evaluation: ClientEvaluationModel;
    /** The Date. 
 */
    dueDate?: string | undefined;
    contractRowVersion: string;
    /** The colour of the traffic light

0 = None (There is no colour)

1 = Green (Green - usually indicates a everything is going swimmingly)

2 = Amber (Amber - usually indicates a warning that something is almost overdue)

3 = Red (Red - usually indicates Overdue) */
    trafficLightColour: TrafficLightColour;
}

export class TestModel implements ITestModel {
    aString?: string | undefined;

    constructor(data?: ITestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aString = _data["aString"];
        }
    }

    static fromJS(data: any): TestModel {
        data = typeof data === 'object' ? data : {};
        let result = new TestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aString"] = this.aString;
        return data;
    }
}

export interface ITestModel {
    aString?: string | undefined;
}

/** The Aconex Interaction Status 0 = Success (Interaction with the Aconex API was successful) 1 = NoTokenInformation (There was no Token Information available to perform the interaction with the Aconex API) 2 = RefreshTokenExpired (The Refresh Token available to for interaction with the Aconex API has expired) 3 = AccessTokenExpired (The Access Token available to for interaction with the Aconex API has expired (Note: This does not indicate that future interactions will fail, it only indicates that the Access Token will need to be refreshed before the next interaction.)) 4 = InteractionFailed (The Aconex API Interaction failed (Usually this indicates that the Aconex API returned a 'non authentication' related error message)) */
export enum AconexInteractionStatus {
    Success = 0,
    NoTokenInformation = 1,
    RefreshTokenExpired = 2,
    AccessTokenExpired = 3,
    InteractionFailed = 4,
}

/** [Calendar Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Well+Known+Enums#Calendar-Status)            Status types calendars can use 1 = Active (Calendar is active) 2 = Inactive (Calendar is inactive) */
export enum CalendarStatus {
    Active = 1,
    Inactive = 2,
}

/** [Calendar Type](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Well+Known+Enums#Calendar-Type)            The type of calendar 1 = Working (Working calendar) 2 = Business (Business calendar) 3 = CalendarDays (Every regular calendar day (Every regular calendar day, no weekdays or weekends and no holidays. Just regular sequential days.)) */
export enum CalendarType {
    Working = 1,
    Business = 2,
    CalendarDays = 3,
}

/** Enum to define the contractual implication for Not meeting a condition [Consequence](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Consequence) 1 = Barred (Contractor claim is disqualified.) 2 = Breach (Up to Superintendent’s discretion.) 3 = Nil (No legal impact if condition not met) 4 = NA (Not Applicable, not required) */
export enum Consequence {
    Barred = 1,
    Breach = 2,
    Nil = 3,
    NA = 4,
}

/** [Contract Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Contract-Status)            Status types contracts can use 1 = Active (Contract is active, at this point settings can’t be edited) 2 = Pending (Partway through setup or in pending mode where configuration can be edited) 3 = Terminated (Post MVP) 4 = PracticalCompletion (Post MVP) 5 = FinalCompletion (Post MVP) 6 = Suspended (Post MVP) 7 = Draft (Contract is still in wizard phase) 8 = Cancelled (Post MVP) */
export enum ContractStatus {
    Active = 1,
    Pending = 2,
    Terminated = 3,
    PracticalCompletion = 4,
    FinalCompletion = 5,
    Suspended = 6,
    Draft = 7,
    Cancelled = 8,
}

/** Whether a specific Data Entry Item is required, optional or not allowed [Data Entry Requirement](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Data-Entry-Requirement) 1 = Mandatory (The data entry item is required) 2 = Optional (The data entry item is Optional) 3 = Forbidden (The data entry item is Forbidden and will likely fail validation if it is filled in) */
export enum DataEntryRequirement {
    Mandatory = 1,
    Optional = 2,
    Forbidden = 3,
}

/** Type of ways for documents to be received [Document Retrieval Type](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Document-Receival-Type) 1 = AusPost (Australia Post) 2 = Courier (Courier) 3 = Email (Email) 4 = Aconex (Aconex) 5 = Fax (Fax) 6 = Other (Other) */
export enum DocumentReceivalType {
    AusPost = 1,
    Courier = 2,
    Email = 3,
    Aconex = 4,
    Fax = 5,
    Other = 6,
}

/** The type of association between the Segment Instance and the Document Version 0 = OneTrack (Documents created in OneTrack) 1 = AconexDocument (Documents imported from an Aconex Document) 2 = AconexMail (Documents imported from an Aconex Mail) */
export enum DocumentSource {
    OneTrack = 0,
    AconexDocument = 1,
    AconexMail = 2,
}

/** How to calculate the segment instance due date [Phase Due Date Calculation Method](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Due-Date-Calculation-Method) 1 = RetainExisting (No due date calculations at all. Leave the existing due date (if any) alone) 2 = NoDueDate (No due date at all, reset back to null) 3 = SmartDetect (Looks for Due Date response, then looks in Parameters for due date config) 4 = UserDefined (Looks for Due Date response) 5 = Amendments (Looks in Parameters for due date config from the Amendments) 6 = UserDefinedRetainExisting (Look for Due Date Responses. If not found, retains the existing due date.) */
export enum DueDateCalculationMethod {
    RetainExisting = 1,
    NoDueDate = 2,
    SmartDetect = 3,
    UserDefined = 4,
    Amendments = 5,
    UserDefinedRetainExisting = 6,
}

/** [Duration Adjustment](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Duration-Adjustment)            Adjustment for Duration 1 = Days (Duration Adjustment is in Days) 2 = Percentage (Duration Adjustment is as a Percentage) */
export enum DurationAdjustment {
    Days = 1,
    Percentage = 2,
}

/** Enum to define the layout type for data driven wizard [Layout Type](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Layout-Type) 2 = Page (Page display for layout for data driven section) 3 = Dialog (Dialog display for layout within data driven definition) 4 = ConfirmDialog (Confirmation Dialog for layout within data driven definition) */
export enum LayoutType {
    Page = 2,
    Dialog = 3,
    ConfirmDialog = 4,
}

/** [Organisation Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Well+Known+Enums#Organisation-Status)            Status types organisations can use 1 = Active (The organisation is active) 2 = Pending (The organisation is pending) 3 = Suspended (The organisation has been suspended) 4 = Inactive (The organisation is inactive) */
export enum OrganisationStatus {
    Active = 1,
    Pending = 2,
    Suspended = 3,
    Inactive = 4,
}

/** [Organisation Type](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Organisation-Type)            Type that an Organisation can be 1 = NotSet (A more specific organisation type has not been set) 2 = Principal (The organisation is active) 3 = HeadContractor (Head Contractor) 4 = ProjectManager (Project Manager) 5 = Subcontractor (Subcontractor) 6 = DevelopmentManagementConsultancy (Development Management Consultancy) */
export enum OrganisationType {
    NotSet = 1,
    Principal = 2,
    HeadContractor = 3,
    ProjectManager = 4,
    Subcontractor = 5,
    DevelopmentManagementConsultancy = 6,
}

/** [Organisation User Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Well+Known+Enums#Organisation-User-Status)            Status types users can use 1 = Active (Organisation/Project/Contract User is active) 2 = Invited (Organisation/Project/Contract User is Invited) 3 = RejectedInvitation (Organisation/Project/Contract User has Rejected Invitation) 4 = Inactive (Organisation/Project/Contract User is Inactive) */
export enum OrganisationUserStatus {
    Active = 1,
    Invited = 2,
    RejectedInvitation = 3,
    Inactive = 4,
}

/** [Permission Level](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Permission-Level) 1 = View (View only permission) 2 = Edit (Edit permission) */
export enum PermissionLevel {
    View = 1,
    Edit = 2,
}

/** [Project Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Project-Status)            Status types projects can use 1 = Active (Project is active) 2 = Pending (Project is pending) 3 = Suspended (Project is suspended) 4 = Complete (Project is complete) */
export enum ProjectStatus {
    Active = 1,
    Pending = 2,
    Suspended = 3,
    Complete = 4,
}

/** The type of association between the Segment Instance and the Document Version 0 = Originating (The document was the document that began the workflow) 1 = Supporting (The document is a supporting document for the workflow) 2 = Response (The document was a response to the workflow) */
export enum SegmentInstanceDocumentVersionAssociationType {
    Originating = 0,
    Supporting = 1,
    Response = 2,
}

/** The ways a segment can be resolved [Segment Instance Resolution](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Segment-Instance-Resolution) 1 = Accepted (Segment has been accepted, claimed time/budget granted by the principal is added to the contract.) 2 = Rejected (Segment has been rejected, any claimed time/budget is noted but not added to the contract.) 3 = Indeterminate (Resolution not possible at this point.) */
export enum SegmentInstanceResolution {
    Accepted = 1,
    Rejected = 2,
    Indeterminate = 3,
}

/** [Segment Instance Status](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Segment-Instance-Status)            The status of the Segment Instance (The status type is how this status is broadly referenced within the system and is used in logic. For the sake of simplifying logic 'Open' statuses have a value less than 16 and 'Closed' statuses are equal to or greater than 16. <seealso cref="F:OneTrack.Data.SegmentInstanceStatusConstants.MinOpenValue" />,  <seealso cref="F:OneTrack.Data.SegmentInstanceStatusConstants.MaxOpenValue" />, <seealso cref="F:OneTrack.Data.SegmentInstanceStatusConstants.MinClosedValue" /> and  <seealso cref="F:OneTrack.Data.SegmentInstanceStatusConstants.MaxClosedValue" />) 1 = InProgress (Segment is unresolved, this is the initial status for most segments) 2 = Suspended (Segment is unresolved but is marked as suspended, post MVP this will include additional logic for ‘Stopping the ticking of clocks’) 3 = InfoRequestedAndNotSuspended (Segment is unresolved and is noting that additional information has been requested) 4 = InfoRequestedAndSuspended (Effectively the same as both ‘Info Requested and Not Suspended’ and ‘Suspended’) 16 = Complete (Segment has been resolved) 17 = Withdrawn (Segment has been withdrawn (this is specially for when a contractor withdraws a claim)) 18 = Cancelled (Segment has been cancelled (this is specifically for when the principal cancels a claim)) 19 = Disputed (Segment is resolved and has been marked as being in dispute, Post MVP this means an additional dispute workflow as been created) 20 = LegalDispute (Same as Disputed but for Legal Disputes) */
export enum SegmentInstanceStatus {
    InProgress = 1,
    Suspended = 2,
    InfoRequestedAndNotSuspended = 3,
    InfoRequestedAndSuspended = 4,
    Complete = 16,
    Withdrawn = 17,
    Cancelled = 18,
    Disputed = 19,
    LegalDispute = 20,
}

/** Whether a SegmentInstance must have a OneTrack.Data.Enums.SegmentInstanceStatus that falls into the Open, Closed or OpenOrClosed category [Data Entry Requirement](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Data-Entry-Requirement) 1 = MustBeOpen (The Segment Instance must have a Status that falls into the Open category) 2 = CanBeOpenOrClosed (The Segment Instance can have a Status that falls into the Open or the Closed category) 3 = MustBeClosed (The Segment Instance must have a Status that falls into the Open category) */
export enum SegmentInstanceStatusRequirement {
    MustBeOpen = 1,
    CanBeOpenOrClosed = 2,
    MustBeClosed = 3,
}

/** The ways a segment can be processed [Segment Process Type](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Segment-Process-Type) 1 = Notice (Segment (and SegmentInstance) should to be processed as a Notice) 2 = Claim (Segment (and SegmentInstance) should to be processed as a Claim) 3 = Direction (Segment (and SegmentInstance) should be processed as a Direction (note: post-mvp)) 4 = RFIInbound (Segment (and SegmentInstance) should be processed as an RFI Inbound) 5 = RFIOutbound (Segment (and SegmentInstance) should be processed as an RFI Outbound) 6 = Variation (Segment (and SegmentInstance) should be processed as a Variation This is a variation created by the principal. It might be follow a proposal, or might be stand alone.) 7 = VariationProposal (Segment (and SegmentInstance) should be processed as a Variation Proposal This is the principal proposing a variation to the contractor and getting a response to the proposal) 8 = VariationRequest (Segment (and SegmentInstance) should be processed as a Variation Request This is the contractor requesting a variation from the principal) */
export enum SegmentProcessType {
    Notice = 1,
    Claim = 2,
    Direction = 3,
    RFIInbound = 4,
    RFIOutbound = 5,
    Variation = 6,
    VariationProposal = 7,
    VariationRequest = 8,
}

/** [Time Period Unit](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Well+Known+Enums#Time-Period-Unit)            The Time Period Unit 1 = Hours (A time period of hours) 2 = Days (A time period of days) 3 = Weeks (A time period of weeks) */
export enum TimePeriodUnit {
    Hours = 1,
    Days = 2,
    Weeks = 3,
}

/** The colour of the traffic light 0 = None (There is no colour) 1 = Green (Green - usually indicates a everything is going swimmingly) 2 = Amber (Amber - usually indicates a warning that something is almost overdue) 3 = Red (Red - usually indicates Overdue) */
export enum TrafficLightColour {
    None = 0,
    Green = 1,
    Amber = 2,
    Red = 3,
}

/** The ways a segment can be processed [User Actions](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#User-Actions) 1 = Create (Create new item) 2 = View (View the item in question) 3 = Edit (Edit the item in question) 4 = Deactivate (Deactivate the Organisation/Project/Contract User) 5 = Reinvite (Reinvite the Organisation/Project/Contract User) 6 = Invite (Invite to an Organisation/Project/Contract) 7 = Remove (Remove the item in question) */
export enum UserActions {
    Create = 1,
    View = 2,
    Edit = 3,
    Deactivate = 4,
    Reinvite = 5,
    Invite = 6,
    Remove = 7,
}

/** Details for Button object in Layout for Json document ([Data Driven Button Details Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2441314632/Data+Driven+Button+Details+Object)) */
export class ButtonDetailsModel implements IButtonDetailsModel {
    /** Text for button */
    buttonText?: string | undefined;
    /** Command to execute if button clicked */
    command?: string | undefined;
    /** Hides button */
    isHidden?: boolean | undefined;

    constructor(data?: IButtonDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buttonText = _data["buttonText"];
            this.command = _data["command"];
            this.isHidden = _data["isHidden"];
        }
    }

    static fromJS(data: any): ButtonDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ButtonDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buttonText"] = this.buttonText;
        data["command"] = this.command;
        data["isHidden"] = this.isHidden;
        return data;
    }
}

/** Details for Button object in Layout for Json document ([Data Driven Button Details Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2441314632/Data+Driven+Button+Details+Object)) */
export interface IButtonDetailsModel {
    /** Text for button */
    buttonText?: string | undefined;
    /** Command to execute if button clicked */
    command?: string | undefined;
    /** Hides button */
    isHidden?: boolean | undefined;
}

/** Available Actions object to allow Rules to specify what actions are now available to the user ([Data Driven Available Action](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2681864193/Data+Driven+Available+Action)) */
export class DataDrivenAvailableActionModel implements IDataDrivenAvailableActionModel {
    /** Unique Key value for the set of Available Actions 
 */
    key!: string;
    /** Should the 'send email dialog' be shown or not 

Mutually exclusive with <seealso cref="P:OneTrack.DataDriven.Models.DataDrivenAvailableActionModel.ShowRfiOutboundPrompt" /> (they can't both be true) 

Defaults to false. */
    sendEmail?: boolean | undefined;
    /** The SegmentManifestGid to be used to locate the Segment when creating a Child SegmentInstance when Finalise is called 

Defaults to null/empty */
    typeOfChildSegmentInstanceToCreate?: string | undefined;
    /** The phase to swap to, either in this claim or in the new claim. */
    nextPhaseKey?: string | undefined;
    /** If we end up creating a new Run, should the responses be copied. 

For use in "I have entered some data and I would like to think about it" situations, 
where we want the current run to be closed off so we get the "I’m thinking about the data entered" timestamp from finishing the run, 
but we also want the data pre filled in the new run when the user comes back to the workflow. 

Defaults to false 
 */
    copyCurrentRunResponsesToNewRun?: boolean | undefined;
    /** The Status value (Complete/Withdrawn/Cancelled) for use when finalizing the segment instance. 

Can be left as null in a "continue to wait" situation. 

Defaults to null/empty. 

1 = InProgress (Segment is unresolved, this is the initial status for most segments)

2 = Suspended (Segment is unresolved but is marked as suspended, post MVP this will include additional logic for ‘Stopping the ticking of clocks’)

3 = InfoRequestedAndNotSuspended (Segment is unresolved and is noting that additional information has been requested)

4 = InfoRequestedAndSuspended (Effectively the same as both ‘Info Requested and Not Suspended’ and ‘Suspended’)

16 = Complete (Segment has been resolved)

17 = Withdrawn (Segment has been withdrawn (this is specially for when a contractor withdraws a claim))

18 = Cancelled (Segment has been cancelled (this is specifically for when the principal cancels a claim))

19 = Disputed (Segment is resolved and has been marked as being in dispute, Post MVP this means an additional dispute workflow as been created)

20 = LegalDispute (Same as Disputed but for Legal Disputes) */
    outcome?: SegmentInstanceStatus | undefined;
    /** The Resolution value (accepted/rejected/etc) for use when finalizing the segment instance. 

Can be left as null in a "continue to wait" situation. 

Defaults to null/empty. 

1 = Accepted (Segment has been accepted, claimed time/budget granted by the principal is added to the contract.)

2 = Rejected (Segment has been rejected, any claimed time/budget is noted but not added to the contract.)

3 = Indeterminate (Resolution not possible at this point.) */
    resolution?: SegmentInstanceResolution | undefined;
    /** Should the current run be finalised when Finalise is called. 
 */
    finaliseCurrentRun?: boolean | undefined;
    /** String to be used in as the main text of the Option in 'Result Implementation Options' in <seealso href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2683994113/F12200R09+-+Claim+Results">F12200R09 - Claim Results</seealso>
 (Note for rule authors: these are under a “Do you wish to proceed?” heading. 
 
As such, the text should be worded as an affirmative or a negative leader. Eg:  
<list type="bullet"><item>"Yes, send request"</item><item>"No, cancel request"</item></list>
Not just:
<list type="bullet"><item>"Send"</item><item>"Cancel"</item></list>) */
    optionText!: string;
    /** String to be used in as the sub text of the Option in'Result Implementation Options' in <seealso href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2683994113/F12200R09+-+Claim+Results">F12200R09 - Claim Results</seealso>

Defaults to null */
    optionSubText?: string | undefined;
    /** String to be used on the Accept Button in <seealso href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2683994113/F12200R09+-+Claim+Results">F12200R09 - Claim Results</seealso>
 */
    acceptButtonText!: string;
    /** Whether this action should cause a "Start RFI Outbound?" dialog prompt or not. 

Mutually exclusive with <seealso cref="P:OneTrack.DataDriven.Models.DataDrivenAvailableActionModel.SendEmail" /> (they can't both be true) 

If set, TypeOfChildSegmentInstanceToCreate must be set.An Outcome and a Resolution should also be set, but not strictly required. 

Defaults to false 
 */
    showRfiOutboundPrompt?: boolean | undefined;

    constructor(data?: IDataDrivenAvailableActionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.sendEmail = _data["sendEmail"];
            this.typeOfChildSegmentInstanceToCreate = _data["typeOfChildSegmentInstanceToCreate"];
            this.nextPhaseKey = _data["nextPhaseKey"];
            this.copyCurrentRunResponsesToNewRun = _data["copyCurrentRunResponsesToNewRun"];
            this.outcome = _data["outcome"];
            this.resolution = _data["resolution"];
            this.finaliseCurrentRun = _data["finaliseCurrentRun"];
            this.optionText = _data["optionText"];
            this.optionSubText = _data["optionSubText"];
            this.acceptButtonText = _data["acceptButtonText"];
            this.showRfiOutboundPrompt = _data["showRfiOutboundPrompt"];
        }
    }

    static fromJS(data: any): DataDrivenAvailableActionModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataDrivenAvailableActionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["sendEmail"] = this.sendEmail;
        data["typeOfChildSegmentInstanceToCreate"] = this.typeOfChildSegmentInstanceToCreate;
        data["nextPhaseKey"] = this.nextPhaseKey;
        data["copyCurrentRunResponsesToNewRun"] = this.copyCurrentRunResponsesToNewRun;
        data["outcome"] = this.outcome;
        data["resolution"] = this.resolution;
        data["finaliseCurrentRun"] = this.finaliseCurrentRun;
        data["optionText"] = this.optionText;
        data["optionSubText"] = this.optionSubText;
        data["acceptButtonText"] = this.acceptButtonText;
        data["showRfiOutboundPrompt"] = this.showRfiOutboundPrompt;
        return data;
    }
}

/** Available Actions object to allow Rules to specify what actions are now available to the user ([Data Driven Available Action](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2681864193/Data+Driven+Available+Action)) */
export interface IDataDrivenAvailableActionModel {
    /** Unique Key value for the set of Available Actions 
 */
    key: string;
    /** Should the 'send email dialog' be shown or not 

Mutually exclusive with <seealso cref="P:OneTrack.DataDriven.Models.DataDrivenAvailableActionModel.ShowRfiOutboundPrompt" /> (they can't both be true) 

Defaults to false. */
    sendEmail?: boolean | undefined;
    /** The SegmentManifestGid to be used to locate the Segment when creating a Child SegmentInstance when Finalise is called 

Defaults to null/empty */
    typeOfChildSegmentInstanceToCreate?: string | undefined;
    /** The phase to swap to, either in this claim or in the new claim. */
    nextPhaseKey?: string | undefined;
    /** If we end up creating a new Run, should the responses be copied. 

For use in "I have entered some data and I would like to think about it" situations, 
where we want the current run to be closed off so we get the "I’m thinking about the data entered" timestamp from finishing the run, 
but we also want the data pre filled in the new run when the user comes back to the workflow. 

Defaults to false 
 */
    copyCurrentRunResponsesToNewRun?: boolean | undefined;
    /** The Status value (Complete/Withdrawn/Cancelled) for use when finalizing the segment instance. 

Can be left as null in a "continue to wait" situation. 

Defaults to null/empty. 

1 = InProgress (Segment is unresolved, this is the initial status for most segments)

2 = Suspended (Segment is unresolved but is marked as suspended, post MVP this will include additional logic for ‘Stopping the ticking of clocks’)

3 = InfoRequestedAndNotSuspended (Segment is unresolved and is noting that additional information has been requested)

4 = InfoRequestedAndSuspended (Effectively the same as both ‘Info Requested and Not Suspended’ and ‘Suspended’)

16 = Complete (Segment has been resolved)

17 = Withdrawn (Segment has been withdrawn (this is specially for when a contractor withdraws a claim))

18 = Cancelled (Segment has been cancelled (this is specifically for when the principal cancels a claim))

19 = Disputed (Segment is resolved and has been marked as being in dispute, Post MVP this means an additional dispute workflow as been created)

20 = LegalDispute (Same as Disputed but for Legal Disputes) */
    outcome?: SegmentInstanceStatus | undefined;
    /** The Resolution value (accepted/rejected/etc) for use when finalizing the segment instance. 

Can be left as null in a "continue to wait" situation. 

Defaults to null/empty. 

1 = Accepted (Segment has been accepted, claimed time/budget granted by the principal is added to the contract.)

2 = Rejected (Segment has been rejected, any claimed time/budget is noted but not added to the contract.)

3 = Indeterminate (Resolution not possible at this point.) */
    resolution?: SegmentInstanceResolution | undefined;
    /** Should the current run be finalised when Finalise is called. 
 */
    finaliseCurrentRun?: boolean | undefined;
    /** String to be used in as the main text of the Option in 'Result Implementation Options' in <seealso href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2683994113/F12200R09+-+Claim+Results">F12200R09 - Claim Results</seealso>
 (Note for rule authors: these are under a “Do you wish to proceed?” heading. 
 
As such, the text should be worded as an affirmative or a negative leader. Eg:  
<list type="bullet"><item>"Yes, send request"</item><item>"No, cancel request"</item></list>
Not just:
<list type="bullet"><item>"Send"</item><item>"Cancel"</item></list>) */
    optionText: string;
    /** String to be used in as the sub text of the Option in'Result Implementation Options' in <seealso href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2683994113/F12200R09+-+Claim+Results">F12200R09 - Claim Results</seealso>

Defaults to null */
    optionSubText?: string | undefined;
    /** String to be used on the Accept Button in <seealso href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2683994113/F12200R09+-+Claim+Results">F12200R09 - Claim Results</seealso>
 */
    acceptButtonText: string;
    /** Whether this action should cause a "Start RFI Outbound?" dialog prompt or not. 

Mutually exclusive with <seealso cref="P:OneTrack.DataDriven.Models.DataDrivenAvailableActionModel.SendEmail" /> (they can't both be true) 

If set, TypeOfChildSegmentInstanceToCreate must be set.An Outcome and a Resolution should also be set, but not strictly required. 

Defaults to false 
 */
    showRfiOutboundPrompt?: boolean | undefined;
}

/** Issue item object to provide details of question(s) that indicate an issue with a claim ([Data Driven Column Header Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2417393820/Data+Driven+Column+Header+Object)) */
export class DataDrivenColumnHeaderModel implements IDataDrivenColumnHeaderModel {
    title!: string;
    columnIndex!: number;

    constructor(data?: IDataDrivenColumnHeaderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.columnIndex = _data["columnIndex"];
        }
    }

    static fromJS(data: any): DataDrivenColumnHeaderModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataDrivenColumnHeaderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["columnIndex"] = this.columnIndex;
        return data;
    }
}

/** Issue item object to provide details of question(s) that indicate an issue with a claim ([Data Driven Column Header Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2417393820/Data+Driven+Column+Header+Object)) */
export interface IDataDrivenColumnHeaderModel {
    title: string;
    columnIndex: number;
}

/** Config - a Key/Value pair object ([Data Driven Config Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2661285921/Data+Driven+Config)) */
export class DataDrivenConfigModel implements IDataDrivenConfigModel {
    /** Unique key for value */
    key?: string | undefined;
    /** Any string value */
    value?: string | undefined;
    /** An array of string values */
    values?: string[] | undefined;
    /** A dynamic object for storing more complex values. */
    data?: any | undefined;

    constructor(data?: IDataDrivenConfigModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): DataDrivenConfigModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataDrivenConfigModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        data["data"] = this.data;
        return data;
    }
}

/** Config - a Key/Value pair object ([Data Driven Config Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2661285921/Data+Driven+Config)) */
export interface IDataDrivenConfigModel {
    /** Unique key for value */
    key?: string | undefined;
    /** Any string value */
    value?: string | undefined;
    /** An array of string values */
    values?: string[] | undefined;
    /** A dynamic object for storing more complex values. */
    data?: any | undefined;
}

/** Base class that specialised Result models must inherit from ([OT Result Base](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927583/Data+Driven+Result+Object#OT-Result-Base)            Swashbuckle Doco here: [Enrich Polymorphic Base Classes with Discriminator Metadata]( https://github.com/domaindrivendev/Swashbuckle.AspNetCore#enrich-polymorphic-base-classes-with-discriminator-metadata)) */
export class DataDrivenResultBaseModel implements IDataDrivenResultBaseModel {

    protected _discriminator: string;

    constructor(data?: IDataDrivenResultBaseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "DataDrivenResultBaseModel";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DataDrivenResultBaseModel {
        data = typeof data === 'object' ? data : {};
        if (data["resultType"] === "TextValueModel") {
            let result = new DataDrivenTextValueModel();
            result.init(data);
            return result;
        }
        if (data["resultType"] === "OptionsValueModel") {
            let result = new DataDrivenOptionValueModel();
            result.init(data);
            return result;
        }
        if (data["resultType"] === "OptionsValueWithOtherModel") {
            let result = new DataDrivenOptionValueWithOtherModel();
            result.init(data);
            return result;
        }
        if (data["resultType"] === "OptionsValueWithConsequenceModel") {
            let result = new DataDrivenOptionValueWithConsequenceModel();
            result.init(data);
            return result;
        }
        if (data["resultType"] === "OptionsListModel") {
            let result = new DataDrivenOptionsListModel();
            result.init(data);
            return result;
        }
        if (data["resultType"] === "OptionsListWithOtherModel") {
            let result = new DataDrivenOptionsListWithOtherModel();
            result.init(data);
            return result;
        }
        if (data["resultType"] === "DaySelectionModel") {
            let result = new DataDrivenDaySelectionModel();
            result.init(data);
            return result;
        }
        if (data["resultType"] === "DateValueModel") {
            let result = new DataDrivenDateValueModel();
            result.init(data);
            return result;
        }
        if (data["resultType"] === "DaysOrDateModel") {
            let result = new DataDrivenDaysOrDateModel();
            result.init(data);
            return result;
        }
        if (data["resultType"] === "OverridableKeyValueModel") {
            let result = new DataDrivenOverridableKeyValueModel();
            result.init(data);
            return result;
        }
        if (data["resultType"] === "OverridableDateValueModel") {
            let result = new DataDrivenOverridableDateValueModel();
            result.init(data);
            return result;
        }
        if (data["resultType"] === "OverridableDurationModel") {
            let result = new DataDrivenOverridableDurationModel();
            result.init(data);
            return result;
        }
        if (data["resultType"] === "ModifyingFactorModel") {
            let result = new DataDrivenModifyingFactorModel();
            result.init(data);
            return result;
        }
        if (data["resultType"] === "DocumentDetailsModel") {
            let result = new DataDrivenDocumentDetailsModel();
            result.init(data);
            return result;
        }
        let result = new DataDrivenResultBaseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultType"] = this._discriminator;
        return data;
    }
}

/** Base class that specialised Result models must inherit from ([OT Result Base](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927583/Data+Driven+Result+Object#OT-Result-Base)            Swashbuckle Doco here: [Enrich Polymorphic Base Classes with Discriminator Metadata]( https://github.com/domaindrivendev/Swashbuckle.AspNetCore#enrich-polymorphic-base-classes-with-discriminator-metadata)) */
export interface IDataDrivenResultBaseModel {
}

/** One of the possible data types for OneTrack.DataDriven.Models.DataDrivenResponseModel.Result (See: [OT Date Value](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927583/Data+Driven+Result+Object#OT-Date-Value) ) */
export class DataDrivenDateValueModel extends DataDrivenResultBaseModel implements IDataDrivenDateValueModel {
    date!: string;

    constructor(data?: IDataDrivenDateValueModel) {
        super(data);
        this._discriminator = "DateValueModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.date = _data["date"];
        }
    }

    static fromJS(data: any): DataDrivenDateValueModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataDrivenDateValueModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        super.toJSON(data);
        return data;
    }
}

/** One of the possible data types for OneTrack.DataDriven.Models.DataDrivenResponseModel.Result (See: [OT Date Value](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927583/Data+Driven+Result+Object#OT-Date-Value) ) */
export interface IDataDrivenDateValueModel extends IDataDrivenResultBaseModel {
    date: string;
}

/** One of the possible data types for OneTrack.DataDriven.Models.DataDrivenResponseModel.Result (See: [OT Day Selection](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927583/Data+Driven+Result+Object#OT-Day-Selection) Used In: <list type="bullet"><item>[FC11015 - OT WF Day Selection](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2285404439/FC11015+-+OT+WF+Day+Selection)</item></list>) */
export class DataDrivenDaySelectionModel extends DataDrivenResultBaseModel implements IDataDrivenDaySelectionModel {
    number!: number;
    /** [Calendar Type](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Well+Known+Enums#Calendar-Type)

            The type of calendar */
    calendarType!: CalendarType;

    constructor(data?: IDataDrivenDaySelectionModel) {
        super(data);
        this._discriminator = "DaySelectionModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.number = _data["number"];
            this.calendarType = _data["calendarType"];
        }
    }

    static fromJS(data: any): DataDrivenDaySelectionModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataDrivenDaySelectionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["calendarType"] = this.calendarType;
        super.toJSON(data);
        return data;
    }
}

/** One of the possible data types for OneTrack.DataDriven.Models.DataDrivenResponseModel.Result (See: [OT Day Selection](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927583/Data+Driven+Result+Object#OT-Day-Selection) Used In: <list type="bullet"><item>[FC11015 - OT WF Day Selection](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2285404439/FC11015+-+OT+WF+Day+Selection)</item></list>) */
export interface IDataDrivenDaySelectionModel extends IDataDrivenResultBaseModel {
    number: number;
    /** [Calendar Type](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Well+Known+Enums#Calendar-Type)

            The type of calendar */
    calendarType: CalendarType;
}

/** One of the possible data types for OneTrack.DataDriven.Models.DataDrivenResponseModel.Result (See: [OT Days Or Date](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927583/Data+Driven+Result+Object#OT-Days-Or-Date) Used In: <list type="bullet"><item>[FC12057 - OT WF Days Or Date](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2681077787/FC12057+-+OT+WF+Days+Or+Date)</item></list>) */
export class DataDrivenDaysOrDateModel extends DataDrivenResultBaseModel implements IDataDrivenDaysOrDateModel {
    /** Date value. 

If filled in, Number and Calendar Type are ignored. */
    date?: string | undefined;
    /** Numerical value result. 

If filled in, Calendar Type is mandatory. */
    number?: number | undefined;
    /** Reference to relevant calendar. 

If filled in, Number is mandatory. */
    calendarType?: CalendarType | undefined;

    constructor(data?: IDataDrivenDaysOrDateModel) {
        super(data);
        this._discriminator = "DaysOrDateModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.date = _data["date"];
            this.number = _data["number"];
            this.calendarType = _data["calendarType"];
        }
    }

    static fromJS(data: any): DataDrivenDaysOrDateModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataDrivenDaysOrDateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["number"] = this.number;
        data["calendarType"] = this.calendarType;
        super.toJSON(data);
        return data;
    }
}

/** One of the possible data types for OneTrack.DataDriven.Models.DataDrivenResponseModel.Result (See: [OT Days Or Date](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927583/Data+Driven+Result+Object#OT-Days-Or-Date) Used In: <list type="bullet"><item>[FC12057 - OT WF Days Or Date](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2681077787/FC12057+-+OT+WF+Days+Or+Date)</item></list>) */
export interface IDataDrivenDaysOrDateModel extends IDataDrivenResultBaseModel {
    /** Date value. 

If filled in, Number and Calendar Type are ignored. */
    date?: string | undefined;
    /** Numerical value result. 

If filled in, Calendar Type is mandatory. */
    number?: number | undefined;
    /** Reference to relevant calendar. 

If filled in, Number is mandatory. */
    calendarType?: CalendarType | undefined;
}

/** Definition Object to define data driven form for either Workflow Amendments or Segment definition. Object is in the form of a Json document. ([Data Driven Definition Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2373091347/Data+Driven+Definition+Object)) */
export class DataDrivenDefinitionModel implements IDataDrivenDefinitionModel {
    gid!: string;
    versionId!: number;
    layouts!: DataDrivenLayoutModel[];
    /** Layout Key for Final / Confirmation dialog if required */
    finalStep?: string | undefined;
    /** Default response where required ([Data Driven Instance Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2358607962/Data+Driven+Instance+Object)) */
    defaultResponse?: DataDrivenInstanceModel | undefined;
    /** Optional evaluation object. (Only required for claim / segment) 

Only required server side, can be removed when returning to client ([Data Driven Evaluation Rules Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2382758419/Data+Driven+Evaluation+Rules+Object)) */
    evaluation?: DataDrivenEvaluationRulesModel | undefined;

    constructor(data?: IDataDrivenDefinitionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.layouts = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.versionId = _data["versionId"];
            if (Array.isArray(_data["layouts"])) {
                this.layouts = [] as any;
                for (let item of _data["layouts"])
                    this.layouts!.push(DataDrivenLayoutModel.fromJS(item));
            }
            this.finalStep = _data["finalStep"];
            this.defaultResponse = _data["defaultResponse"] ? DataDrivenInstanceModel.fromJS(_data["defaultResponse"]) : <any>undefined;
            this.evaluation = _data["evaluation"] ? DataDrivenEvaluationRulesModel.fromJS(_data["evaluation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DataDrivenDefinitionModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataDrivenDefinitionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["versionId"] = this.versionId;
        if (Array.isArray(this.layouts)) {
            data["layouts"] = [];
            for (let item of this.layouts)
                data["layouts"].push(item.toJSON());
        }
        data["finalStep"] = this.finalStep;
        data["defaultResponse"] = this.defaultResponse ? this.defaultResponse.toJSON() : <any>undefined;
        data["evaluation"] = this.evaluation ? this.evaluation.toJSON() : <any>undefined;
        return data;
    }
}

/** Definition Object to define data driven form for either Workflow Amendments or Segment definition. Object is in the form of a Json document. ([Data Driven Definition Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2373091347/Data+Driven+Definition+Object)) */
export interface IDataDrivenDefinitionModel {
    gid: string;
    versionId: number;
    layouts: DataDrivenLayoutModel[];
    /** Layout Key for Final / Confirmation dialog if required */
    finalStep?: string | undefined;
    /** Default response where required ([Data Driven Instance Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2358607962/Data+Driven+Instance+Object)) */
    defaultResponse?: DataDrivenInstanceModel | undefined;
    /** Optional evaluation object. (Only required for claim / segment) 

Only required server side, can be removed when returning to client ([Data Driven Evaluation Rules Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2382758419/Data+Driven+Evaluation+Rules+Object)) */
    evaluation?: DataDrivenEvaluationRulesModel | undefined;
}

/** Details for Section Object which is part of Data Driven Definition Object in form of Json document ([Data Driven Depends On Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927556/Data+Driven+Depends+On+Object)) */
export class DataDrivenDependsOnModel implements IDataDrivenDependsOnModel {
    /** Array of values that this object depends on */
    options!: string[][];
    /** Action to take if one or more options from above not selected. Optional for dialog */
    onNotActive?: string | undefined;
    /** Resets response value to parent claim response value for this question on hide or disable. */
    resetToParentResponseOnNotActive?: boolean | undefined;

    constructor(data?: IDataDrivenDependsOnModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.options = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(item);
            }
            this.onNotActive = _data["onNotActive"];
            this.resetToParentResponseOnNotActive = _data["resetToParentResponseOnNotActive"];
        }
    }

    static fromJS(data: any): DataDrivenDependsOnModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataDrivenDependsOnModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item);
        }
        data["onNotActive"] = this.onNotActive;
        data["resetToParentResponseOnNotActive"] = this.resetToParentResponseOnNotActive;
        return data;
    }
}

/** Details for Section Object which is part of Data Driven Definition Object in form of Json document ([Data Driven Depends On Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927556/Data+Driven+Depends+On+Object)) */
export interface IDataDrivenDependsOnModel {
    /** Array of values that this object depends on */
    options: string[][];
    /** Action to take if one or more options from above not selected. Optional for dialog */
    onNotActive?: string | undefined;
    /** Resets response value to parent claim response value for this question on hide or disable. */
    resetToParentResponseOnNotActive?: boolean | undefined;
}

/** One of the possible data types for OneTrack.DataDriven.Models.DataDrivenResponseModel.Result (See: [OT Document Details](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927583/Data+Driven+Result+Object#OT-Document-Details) Used In: <list type="bullet"><item>[FC12056 - OT WF Document Details](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2681143297/FC12056+-+OT+WF+Document+Details)</item></list>) */
export class DataDrivenDocumentDetailsModel extends DataDrivenResultBaseModel implements IDataDrivenDocumentDetailsModel {
    documentName!: string;
    /** How the document was received */
    documentReceivalType!: DocumentReceivalType;
    /** If Document Receival type is set to other, this is MANDATORY. 

If Document Receival type is not set to other this field should be ignored. */
    documentReceivalDescription?: string | undefined;
    /** Optional text associated with response */
    documentCreationDate!: string;
    documentReceivedUtc?: Date | undefined;
    documentDeemedReceivedUtc?: Date | undefined;

    constructor(data?: IDataDrivenDocumentDetailsModel) {
        super(data);
        this._discriminator = "DocumentDetailsModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentName = _data["documentName"];
            this.documentReceivalType = _data["documentReceivalType"];
            this.documentReceivalDescription = _data["documentReceivalDescription"];
            this.documentCreationDate = _data["documentCreationDate"];
            this.documentReceivedUtc = _data["documentReceivedUtc"] ? new Date(_data["documentReceivedUtc"].toString()) : <any>undefined;
            this.documentDeemedReceivedUtc = _data["documentDeemedReceivedUtc"] ? new Date(_data["documentDeemedReceivedUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DataDrivenDocumentDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataDrivenDocumentDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentName"] = this.documentName;
        data["documentReceivalType"] = this.documentReceivalType;
        data["documentReceivalDescription"] = this.documentReceivalDescription;
        data["documentCreationDate"] = this.documentCreationDate;
        data["documentReceivedUtc"] = this.documentReceivedUtc ? this.documentReceivedUtc.toISOString() : <any>undefined;
        data["documentDeemedReceivedUtc"] = this.documentDeemedReceivedUtc ? this.documentDeemedReceivedUtc.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

/** One of the possible data types for OneTrack.DataDriven.Models.DataDrivenResponseModel.Result (See: [OT Document Details](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927583/Data+Driven+Result+Object#OT-Document-Details) Used In: <list type="bullet"><item>[FC12056 - OT WF Document Details](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2681143297/FC12056+-+OT+WF+Document+Details)</item></list>) */
export interface IDataDrivenDocumentDetailsModel extends IDataDrivenResultBaseModel {
    documentName: string;
    /** How the document was received */
    documentReceivalType: DocumentReceivalType;
    /** If Document Receival type is set to other, this is MANDATORY. 

If Document Receival type is not set to other this field should be ignored. */
    documentReceivalDescription?: string | undefined;
    /** Optional text associated with response */
    documentCreationDate: string;
    documentReceivedUtc?: Date | undefined;
    documentDeemedReceivedUtc?: Date | undefined;
}

/** Details for Server object which is only required for server side processing ([Data Driven Evaluation Rules Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2382758419/Data+Driven+Evaluation+Rules+Object)) */
export class DataDrivenEvaluationRulesModel implements IDataDrivenEvaluationRulesModel {
    rules!: DataDrivenRuleModel[];
    /** Dictionary-esque collection of Parameter objects 

Can be hardcoded into the manifest/definition, and also can be populated by Rules */
    parameters?: DataDrivenPropertyModel[] | undefined;
    /** Dictionary-esque collection of Config objects 

Can be hardcoded into the manifest/definition, and also can be populated by Rules */
    configs?: DataDrivenConfigModel[] | undefined;
    /** Dictionary-esque collection of Keys 

Can be hardcoded into the manifest/definition, and also can be populated by Rules */
    configKeys?: string[] | undefined;
    /** Message templates */
    messageTemplates?: DataDrivenMessageTemplateModel[] | undefined;

    constructor(data?: IDataDrivenEvaluationRulesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.rules = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(DataDrivenRuleModel.fromJS(item));
            }
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(DataDrivenPropertyModel.fromJS(item));
            }
            if (Array.isArray(_data["configs"])) {
                this.configs = [] as any;
                for (let item of _data["configs"])
                    this.configs!.push(DataDrivenConfigModel.fromJS(item));
            }
            if (Array.isArray(_data["configKeys"])) {
                this.configKeys = [] as any;
                for (let item of _data["configKeys"])
                    this.configKeys!.push(item);
            }
            if (Array.isArray(_data["messageTemplates"])) {
                this.messageTemplates = [] as any;
                for (let item of _data["messageTemplates"])
                    this.messageTemplates!.push(DataDrivenMessageTemplateModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DataDrivenEvaluationRulesModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataDrivenEvaluationRulesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item.toJSON());
        }
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item.toJSON());
        }
        if (Array.isArray(this.configs)) {
            data["configs"] = [];
            for (let item of this.configs)
                data["configs"].push(item.toJSON());
        }
        if (Array.isArray(this.configKeys)) {
            data["configKeys"] = [];
            for (let item of this.configKeys)
                data["configKeys"].push(item);
        }
        if (Array.isArray(this.messageTemplates)) {
            data["messageTemplates"] = [];
            for (let item of this.messageTemplates)
                data["messageTemplates"].push(item.toJSON());
        }
        return data;
    }
}

/** Details for Server object which is only required for server side processing ([Data Driven Evaluation Rules Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2382758419/Data+Driven+Evaluation+Rules+Object)) */
export interface IDataDrivenEvaluationRulesModel {
    rules: DataDrivenRuleModel[];
    /** Dictionary-esque collection of Parameter objects 

Can be hardcoded into the manifest/definition, and also can be populated by Rules */
    parameters?: DataDrivenPropertyModel[] | undefined;
    /** Dictionary-esque collection of Config objects 

Can be hardcoded into the manifest/definition, and also can be populated by Rules */
    configs?: DataDrivenConfigModel[] | undefined;
    /** Dictionary-esque collection of Keys 

Can be hardcoded into the manifest/definition, and also can be populated by Rules */
    configKeys?: string[] | undefined;
    /** Message templates */
    messageTemplates?: DataDrivenMessageTemplateModel[] | undefined;
}

/** Details for a response to a data driven form ([Data Driven Instance Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2358607962/Data+Driven+Instance+Object)) */
export class DataDrivenInstanceModel implements IDataDrivenInstanceModel {
    gid!: string;
    /** Unique Identifier for the Run that this Evaluation belongs to */
    runGid!: string;
    versionId!: number;
    /** For initial request, property will be an empty array */
    responses!: DataDrivenResponseModel[];
    /** Details of the User that created the Instance that this Evaluation is based on. 
 ([Data Driven Modified Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2684387381/Data+Driven+Modified+Object)) */
    created?: DataDrivenModifiedModel | undefined;
    /** Details of the User that completed this Instance. 
 ([Data Driven Modified Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2684387381/Data+Driven+Modified+Object)) */
    finished?: DataDrivenModifiedModel | undefined;
    /** The Key for the Phase associated with the Instance this Evaluation is based on */
    phaseKey?: string | undefined;

    constructor(data?: IDataDrivenInstanceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.responses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.runGid = _data["runGid"];
            this.versionId = _data["versionId"];
            if (Array.isArray(_data["responses"])) {
                this.responses = [] as any;
                for (let item of _data["responses"])
                    this.responses!.push(DataDrivenResponseModel.fromJS(item));
            }
            this.created = _data["created"] ? DataDrivenModifiedModel.fromJS(_data["created"]) : <any>undefined;
            this.finished = _data["finished"] ? DataDrivenModifiedModel.fromJS(_data["finished"]) : <any>undefined;
            this.phaseKey = _data["phaseKey"];
        }
    }

    static fromJS(data: any): DataDrivenInstanceModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataDrivenInstanceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["runGid"] = this.runGid;
        data["versionId"] = this.versionId;
        if (Array.isArray(this.responses)) {
            data["responses"] = [];
            for (let item of this.responses)
                data["responses"].push(item.toJSON());
        }
        data["created"] = this.created ? this.created.toJSON() : <any>undefined;
        data["finished"] = this.finished ? this.finished.toJSON() : <any>undefined;
        data["phaseKey"] = this.phaseKey;
        return data;
    }
}

/** Details for a response to a data driven form ([Data Driven Instance Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2358607962/Data+Driven+Instance+Object)) */
export interface IDataDrivenInstanceModel {
    gid: string;
    /** Unique Identifier for the Run that this Evaluation belongs to */
    runGid: string;
    versionId: number;
    /** For initial request, property will be an empty array */
    responses: DataDrivenResponseModel[];
    /** Details of the User that created the Instance that this Evaluation is based on. 
 ([Data Driven Modified Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2684387381/Data+Driven+Modified+Object)) */
    created?: DataDrivenModifiedModel | undefined;
    /** Details of the User that completed this Instance. 
 ([Data Driven Modified Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2684387381/Data+Driven+Modified+Object)) */
    finished?: DataDrivenModifiedModel | undefined;
    /** The Key for the Phase associated with the Instance this Evaluation is based on */
    phaseKey?: string | undefined;
}

/** Collection of data driven Instances that contain responses given to data driven questions ([Data Driven Instances Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2684616705/Data+Driven+Instances+Object)) */
export class DataDrivenInstancesModel implements IDataDrivenInstancesModel {
    /** Unique identifier for parent object 

(i.e. Gid from either [Table: Contract Workflow](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2150596665/Table+Segment+Instance">Table: Segment Instance</see>  or <see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/1343062682/Table+Contract+Workflow)) */
    gid!: string;
    /** List of Instances. May be empty. 
 */
    instances!: DataDrivenInstanceModel[];

    constructor(data?: IDataDrivenInstancesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.instances = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            if (Array.isArray(_data["instances"])) {
                this.instances = [] as any;
                for (let item of _data["instances"])
                    this.instances!.push(DataDrivenInstanceModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DataDrivenInstancesModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataDrivenInstancesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        if (Array.isArray(this.instances)) {
            data["instances"] = [];
            for (let item of this.instances)
                data["instances"].push(item.toJSON());
        }
        return data;
    }
}

/** Collection of data driven Instances that contain responses given to data driven questions ([Data Driven Instances Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2684616705/Data+Driven+Instances+Object)) */
export interface IDataDrivenInstancesModel {
    /** Unique identifier for parent object 

(i.e. Gid from either [Table: Contract Workflow](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2150596665/Table+Segment+Instance">Table: Segment Instance</see>  or <see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/1343062682/Table+Contract+Workflow)) */
    gid: string;
    /** List of Instances. May be empty. 
 */
    instances: DataDrivenInstanceModel[];
}

/** Details for Layout Object which is part of  Data Driven Definition Object  in form of Json document ([Data Driven Layout Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2373091365/Data+Driven+Layout+Object)) */
export class DataDrivenLayoutModel implements IDataDrivenLayoutModel {
    /** Identifier for layout (Unique per workflow) */
    key!: string;
    /** How to display layout

2 = Page (Page display for layout for data driven section)

3 = Dialog (Dialog display for layout within data driven definition)

4 = ConfirmDialog (Confirmation Dialog for layout within data driven definition) */
    type!: LayoutType;
    /** Only required for multi page / multi step layout */
    stepName?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    /** Order of Layouts */
    orderIndex!: number;
    /** Layout is dependant on one or more selected options from another question (i.e dialog dependant on option being selected) ([Data Driven Depends On Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927556/Data+Driven+Depends+On+Object)) */
    dependsOn?: DataDrivenDependsOnModel | undefined;
    sections!: DataDrivenSectionModel[];
    /** Details for Dialog buttons. (Only where required for Dialog) ([Data Driven Dialog Buttons Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2441478411/Data+Driven+Dialog+Buttons+Object)) */
    dialogButtonsOverride?: DialogButtonsOverrideModel | undefined;

    constructor(data?: IDataDrivenLayoutModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sections = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.type = _data["type"];
            this.stepName = _data["stepName"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.orderIndex = _data["orderIndex"];
            this.dependsOn = _data["dependsOn"] ? DataDrivenDependsOnModel.fromJS(_data["dependsOn"]) : <any>undefined;
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(DataDrivenSectionModel.fromJS(item));
            }
            this.dialogButtonsOverride = _data["dialogButtonsOverride"] ? DialogButtonsOverrideModel.fromJS(_data["dialogButtonsOverride"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DataDrivenLayoutModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataDrivenLayoutModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["type"] = this.type;
        data["stepName"] = this.stepName;
        data["title"] = this.title;
        data["description"] = this.description;
        data["orderIndex"] = this.orderIndex;
        data["dependsOn"] = this.dependsOn ? this.dependsOn.toJSON() : <any>undefined;
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item.toJSON());
        }
        data["dialogButtonsOverride"] = this.dialogButtonsOverride ? this.dialogButtonsOverride.toJSON() : <any>undefined;
        return data;
    }
}

/** Details for Layout Object which is part of  Data Driven Definition Object  in form of Json document ([Data Driven Layout Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2373091365/Data+Driven+Layout+Object)) */
export interface IDataDrivenLayoutModel {
    /** Identifier for layout (Unique per workflow) */
    key: string;
    /** How to display layout

2 = Page (Page display for layout for data driven section)

3 = Dialog (Dialog display for layout within data driven definition)

4 = ConfirmDialog (Confirmation Dialog for layout within data driven definition) */
    type: LayoutType;
    /** Only required for multi page / multi step layout */
    stepName?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    /** Order of Layouts */
    orderIndex: number;
    /** Layout is dependant on one or more selected options from another question (i.e dialog dependant on option being selected) ([Data Driven Depends On Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927556/Data+Driven+Depends+On+Object)) */
    dependsOn?: DataDrivenDependsOnModel | undefined;
    sections: DataDrivenSectionModel[];
    /** Details for Dialog buttons. (Only where required for Dialog) ([Data Driven Dialog Buttons Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2441478411/Data+Driven+Dialog+Buttons+Object)) */
    dialogButtonsOverride?: DialogButtonsOverrideModel | undefined;
}

/** Model that contains message templates, details about them and the Depends On Options that indicate whether or not the message templates should be used. ([Data Driven Message Template Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2749071407/Data+Driven+Message+Template+Model)) */
export class DataDrivenMessageTemplateModel implements IDataDrivenMessageTemplateModel {
    /** Key for Message */
    key!: string;
    /** Human readable description of the message */
    description!: string;
    /** Array of option keys that this message is dependent on */
    dependsOnOptions!: string[][] | undefined;
    /** The template for the message to be displayed to user indicating issues with this item */
    recommendationTemplate!: string;
    /** The template for the message to be included in an outgoing email from the user indicating issues with this item */
    emailTemplate!: string;

    constructor(data?: IDataDrivenMessageTemplateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.description = _data["description"];
            if (Array.isArray(_data["dependsOnOptions"])) {
                this.dependsOnOptions = [] as any;
                for (let item of _data["dependsOnOptions"])
                    this.dependsOnOptions!.push(item);
            }
            this.recommendationTemplate = _data["recommendationTemplate"];
            this.emailTemplate = _data["emailTemplate"];
        }
    }

    static fromJS(data: any): DataDrivenMessageTemplateModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataDrivenMessageTemplateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["description"] = this.description;
        if (Array.isArray(this.dependsOnOptions)) {
            data["dependsOnOptions"] = [];
            for (let item of this.dependsOnOptions)
                data["dependsOnOptions"].push(item);
        }
        data["recommendationTemplate"] = this.recommendationTemplate;
        data["emailTemplate"] = this.emailTemplate;
        return data;
    }
}

/** Model that contains message templates, details about them and the Depends On Options that indicate whether or not the message templates should be used. ([Data Driven Message Template Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2749071407/Data+Driven+Message+Template+Model)) */
export interface IDataDrivenMessageTemplateModel {
    /** Key for Message */
    key: string;
    /** Human readable description of the message */
    description: string;
    /** Array of option keys that this message is dependent on */
    dependsOnOptions: string[][] | undefined;
    /** The template for the message to be displayed to user indicating issues with this item */
    recommendationTemplate: string;
    /** The template for the message to be included in an outgoing email from the user indicating issues with this item */
    emailTemplate: string;
}

/** Details of when and who created or modified something data driven ([Data Driven Modified Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2684387381/Data+Driven+Modified+Object)) */
export class DataDrivenModifiedModel implements IDataDrivenModifiedModel {
    /** Date and Time the modification occured */
    utc!: Date;
    /** Identifier for <seealso href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/1350435071/Table+User">Table: User</seealso> that made the change */
    byGid!: string;
    /** First Name of user that made the change */
    byFirstName!: string;
    /** Last Name of user that made the change */
    byLastName!: string;

    constructor(data?: IDataDrivenModifiedModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.utc = _data["utc"] ? new Date(_data["utc"].toString()) : <any>undefined;
            this.byGid = _data["byGid"];
            this.byFirstName = _data["byFirstName"];
            this.byLastName = _data["byLastName"];
        }
    }

    static fromJS(data: any): DataDrivenModifiedModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataDrivenModifiedModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["utc"] = this.utc ? this.utc.toISOString() : <any>undefined;
        data["byGid"] = this.byGid;
        data["byFirstName"] = this.byFirstName;
        data["byLastName"] = this.byLastName;
        return data;
    }
}

/** Details of when and who created or modified something data driven ([Data Driven Modified Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2684387381/Data+Driven+Modified+Object)) */
export interface IDataDrivenModifiedModel {
    /** Date and Time the modification occured */
    utc: Date;
    /** Identifier for <seealso href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/1350435071/Table+User">Table: User</seealso> that made the change */
    byGid: string;
    /** First Name of user that made the change */
    byFirstName: string;
    /** Last Name of user that made the change */
    byLastName: string;
}

/** One of the possible data types for OneTrack.DataDriven.Models.DataDrivenResponseModel.Result (See: [OT Modifying Factor](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927583/Data+Driven+Result+Object#OT-Modifying-Factor) Used In: <list type="bullet"><item>[FC11024 - OT WF Yes No with Factor Control](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2324005078/FC11024+-+OT+WF+Yes+No+with+Factor+Control)</item></list>) */
export class DataDrivenModifyingFactorModel extends DataDrivenResultBaseModel implements IDataDrivenModifyingFactorModel {
    enabled!: boolean;
    /** Administrator supplied value */
    number?: number;
    /** Contractor selected calendar type */
    adjustment?: DurationAdjustment | undefined;
    /** Optional text associated with response */
    text?: string | undefined;

    constructor(data?: IDataDrivenModifyingFactorModel) {
        super(data);
        this._discriminator = "ModifyingFactorModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.enabled = _data["enabled"];
            this.number = _data["number"];
            this.adjustment = _data["adjustment"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): DataDrivenModifyingFactorModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataDrivenModifyingFactorModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["number"] = this.number;
        data["adjustment"] = this.adjustment;
        data["text"] = this.text;
        super.toJSON(data);
        return data;
    }
}

/** One of the possible data types for OneTrack.DataDriven.Models.DataDrivenResponseModel.Result (See: [OT Modifying Factor](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927583/Data+Driven+Result+Object#OT-Modifying-Factor) Used In: <list type="bullet"><item>[FC11024 - OT WF Yes No with Factor Control](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2324005078/FC11024+-+OT+WF+Yes+No+with+Factor+Control)</item></list>) */
export interface IDataDrivenModifyingFactorModel extends IDataDrivenResultBaseModel {
    enabled: boolean;
    /** Administrator supplied value */
    number?: number;
    /** Contractor selected calendar type */
    adjustment?: DurationAdjustment | undefined;
    /** Optional text associated with response */
    text?: string | undefined;
}

/** Details for Option Object which is part of Data Driven Definition Object in form of Json document ([Data Driven Option Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2373091397/Data+Driven+Option+Object)) */
export class DataDrivenOptionModel implements IDataDrivenOptionModel {
    /** Unique Option Key */
    key!: string;
    title?: string | undefined;
    templateTitle?: string | undefined;
    description?: string | undefined;
    /** Order of Options */
    orderIndex!: number;
    /** 

1 = Barred (Contractor claim is disqualified.)

2 = Breach (Up to Superintendent’s discretion.)

3 = Nil (No legal impact if condition not met)

4 = NA (Not Applicable, not required) */
    consequence?: Consequence | undefined;
    /** Target Key (Layout or Question) for any action */
    actionKey?: string | undefined;
    /** Alternate text to be used for substitution into questions */
    alternateTextForQuestionSubstitution?: string | undefined;
    /** Alternate text to be used for substitution into messages */
    alternateTextForMessageSubstitution?: string | undefined;

    constructor(data?: IDataDrivenOptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.title = _data["title"];
            this.templateTitle = _data["templateTitle"];
            this.description = _data["description"];
            this.orderIndex = _data["orderIndex"];
            this.consequence = _data["consequence"];
            this.actionKey = _data["actionKey"];
            this.alternateTextForQuestionSubstitution = _data["alternateTextForQuestionSubstitution"];
            this.alternateTextForMessageSubstitution = _data["alternateTextForMessageSubstitution"];
        }
    }

    static fromJS(data: any): DataDrivenOptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataDrivenOptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["title"] = this.title;
        data["templateTitle"] = this.templateTitle;
        data["description"] = this.description;
        data["orderIndex"] = this.orderIndex;
        data["consequence"] = this.consequence;
        data["actionKey"] = this.actionKey;
        data["alternateTextForQuestionSubstitution"] = this.alternateTextForQuestionSubstitution;
        data["alternateTextForMessageSubstitution"] = this.alternateTextForMessageSubstitution;
        return data;
    }
}

/** Details for Option Object which is part of Data Driven Definition Object in form of Json document ([Data Driven Option Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2373091397/Data+Driven+Option+Object)) */
export interface IDataDrivenOptionModel {
    /** Unique Option Key */
    key: string;
    title?: string | undefined;
    templateTitle?: string | undefined;
    description?: string | undefined;
    /** Order of Options */
    orderIndex: number;
    /** 

1 = Barred (Contractor claim is disqualified.)

2 = Breach (Up to Superintendent’s discretion.)

3 = Nil (No legal impact if condition not met)

4 = NA (Not Applicable, not required) */
    consequence?: Consequence | undefined;
    /** Target Key (Layout or Question) for any action */
    actionKey?: string | undefined;
    /** Alternate text to be used for substitution into questions */
    alternateTextForQuestionSubstitution?: string | undefined;
    /** Alternate text to be used for substitution into messages */
    alternateTextForMessageSubstitution?: string | undefined;
}

/** One of the possible data types for OneTrack.DataDriven.Models.DataDrivenResponseModel.Result (See: [OT Overridable Options Value](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927583/Data+Driven+Result+Object#OT-Overridable-Options-List) Used In: <list type="bullet"><item>[FC11021 - OT WF Dropdown Select](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2237890626/FC11009+-+OT+WF+Parallel+Radio+Buttons">FC11009 - OT WF Parallel Radio Buttons</see></item><item><see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2281275509/FC11014+-+OT+WF+Radio+Button+List">FC11014 - OT WF Radio Button List</see></item><item><see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2237825192/FC11010+-+OT+WF+Filled+Parallel+Radio">FC11010 - OT WF Filled Parallel Radio</see></item><item><see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2309521497/FC11021+-+OT+WF+Dropdown+Select)</item></list>) */
export class DataDrivenOptionValueModel extends DataDrivenResultBaseModel implements IDataDrivenOptionValueModel {
    /** Selected option where question has single valued response */
    key!: string;

    constructor(data?: IDataDrivenOptionValueModel) {
        super(data);
        this._discriminator = "OptionsValueModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.key = _data["key"];
        }
    }

    static fromJS(data: any): DataDrivenOptionValueModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataDrivenOptionValueModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        super.toJSON(data);
        return data;
    }
}

/** One of the possible data types for OneTrack.DataDriven.Models.DataDrivenResponseModel.Result (See: [OT Overridable Options Value](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927583/Data+Driven+Result+Object#OT-Overridable-Options-List) Used In: <list type="bullet"><item>[FC11021 - OT WF Dropdown Select](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2237890626/FC11009+-+OT+WF+Parallel+Radio+Buttons">FC11009 - OT WF Parallel Radio Buttons</see></item><item><see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2281275509/FC11014+-+OT+WF+Radio+Button+List">FC11014 - OT WF Radio Button List</see></item><item><see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2237825192/FC11010+-+OT+WF+Filled+Parallel+Radio">FC11010 - OT WF Filled Parallel Radio</see></item><item><see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2309521497/FC11021+-+OT+WF+Dropdown+Select)</item></list>) */
export interface IDataDrivenOptionValueModel extends IDataDrivenResultBaseModel {
    /** Selected option where question has single valued response */
    key: string;
}

/** One of the possible data types for OneTrack.DataDriven.Models.DataDrivenResponseModel.Result (See: [OT Option Value with Other](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927583/Data+Driven+Result+Object#OT-Option-Value-with-Consequence) ) */
export class DataDrivenOptionValueWithConsequenceModel extends DataDrivenResultBaseModel implements IDataDrivenOptionValueWithConsequenceModel {
    /** Selected option where question has single valued response */
    key!: string;
    title?: string | undefined;
    description?: string | undefined;
    subOptionKey?: string | undefined;
    consequence?: Consequence | undefined;
    /** Alternate text to be used for substitution into questions */
    alternateTextForQuestionSubstitution?: string | undefined;
    /** Alternate text to be used for substitution into messages */
    alternateTextForMessageSubstitution?: string | undefined;

    constructor(data?: IDataDrivenOptionValueWithConsequenceModel) {
        super(data);
        this._discriminator = "OptionsValueWithConsequenceModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.key = _data["key"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.subOptionKey = _data["subOptionKey"];
            this.consequence = _data["consequence"];
            this.alternateTextForQuestionSubstitution = _data["alternateTextForQuestionSubstitution"];
            this.alternateTextForMessageSubstitution = _data["alternateTextForMessageSubstitution"];
        }
    }

    static fromJS(data: any): DataDrivenOptionValueWithConsequenceModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataDrivenOptionValueWithConsequenceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["title"] = this.title;
        data["description"] = this.description;
        data["subOptionKey"] = this.subOptionKey;
        data["consequence"] = this.consequence;
        data["alternateTextForQuestionSubstitution"] = this.alternateTextForQuestionSubstitution;
        data["alternateTextForMessageSubstitution"] = this.alternateTextForMessageSubstitution;
        super.toJSON(data);
        return data;
    }
}

/** One of the possible data types for OneTrack.DataDriven.Models.DataDrivenResponseModel.Result (See: [OT Option Value with Other](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927583/Data+Driven+Result+Object#OT-Option-Value-with-Consequence) ) */
export interface IDataDrivenOptionValueWithConsequenceModel extends IDataDrivenResultBaseModel {
    /** Selected option where question has single valued response */
    key: string;
    title?: string | undefined;
    description?: string | undefined;
    subOptionKey?: string | undefined;
    consequence?: Consequence | undefined;
    /** Alternate text to be used for substitution into questions */
    alternateTextForQuestionSubstitution?: string | undefined;
    /** Alternate text to be used for substitution into messages */
    alternateTextForMessageSubstitution?: string | undefined;
}

/** One of the possible data types for OneTrack.DataDriven.Models.DataDrivenResponseModel.Result (See: [OT Option Value with Other Option](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927583/Data+Driven+Result+Object#OT-Option-Value-with-Other-Option) Used In: <list type="bullet"><item>[FC11022 - OT WF Radio Button List with Other Option ](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2309685396/FC11022+-+OT+WF+Radio+Button+List+with+Other+Option)</item></list>) */
export class DataDrivenOptionValueWithOtherModel extends DataDrivenResultBaseModel implements IDataDrivenOptionValueWithOtherModel {
    /** Selected option where question has single valued response */
    key!: string;
    /** User entered text value */
    title?: string | undefined;

    constructor(data?: IDataDrivenOptionValueWithOtherModel) {
        super(data);
        this._discriminator = "OptionsValueWithOtherModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.key = _data["key"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): DataDrivenOptionValueWithOtherModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataDrivenOptionValueWithOtherModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["title"] = this.title;
        super.toJSON(data);
        return data;
    }
}

/** One of the possible data types for OneTrack.DataDriven.Models.DataDrivenResponseModel.Result (See: [OT Option Value with Other Option](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927583/Data+Driven+Result+Object#OT-Option-Value-with-Other-Option) Used In: <list type="bullet"><item>[FC11022 - OT WF Radio Button List with Other Option ](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2309685396/FC11022+-+OT+WF+Radio+Button+List+with+Other+Option)</item></list>) */
export interface IDataDrivenOptionValueWithOtherModel extends IDataDrivenResultBaseModel {
    /** Selected option where question has single valued response */
    key: string;
    /** User entered text value */
    title?: string | undefined;
}

/** One of the possible data types for OneTrack.DataDriven.Models.DataDrivenResponseModel.Result (See: [OT Overridable Options List](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927583/Data+Driven+Result+Object#OT-Overridable-Options-List) Used In: <list type="bullet"><item>[FC11018 - OT WF Dynamic List - Textarea and Filled Radio Buttons](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2238087314/FC11011+-+OT+Checkbox+List+With+Action">FC11011 - OT Checkbox List With Action</see></item><item><see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2238087334/FC11012+-+OT+WF+Outlined+Checkbox+List">FC11012 - OT WF Outlined Checkbox List</see></item><item><see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2237825260/FC11013+-+OT+WF+Checkbox+List">FC11013 - OT WF Checkbox List</see></item><item><see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2238087314/FC11011+-+OT+Checkbox+List+With+Action">FC11011 - OT Checkbox List With Action</see></item><item><see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2302574819/FC11017+-+OT+WF+Dynamic+List+-+Text+Field+Textarea+and+Filled+Radio+Buttons">FC11017 - OT WF Dynamic List - Text Field, Textarea and Filled Radio Buttons</see></item><item><see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2302574898/FC11018+-+OT+WF+Dynamic+List+-+Textarea+and+Filled+Radio+Buttons)</item></list>) */
export class DataDrivenOptionsListModel extends DataDrivenResultBaseModel implements IDataDrivenOptionsListModel {
    /** Override selected */
    values!: DataDrivenValueModel[];

    constructor(data?: IDataDrivenOptionsListModel) {
        super(data);
        if (!data) {
            this.values = [];
        }
        this._discriminator = "OptionsListModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(DataDrivenValueModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DataDrivenOptionsListModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataDrivenOptionsListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

/** One of the possible data types for OneTrack.DataDriven.Models.DataDrivenResponseModel.Result (See: [OT Overridable Options List](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927583/Data+Driven+Result+Object#OT-Overridable-Options-List) Used In: <list type="bullet"><item>[FC11018 - OT WF Dynamic List - Textarea and Filled Radio Buttons](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2238087314/FC11011+-+OT+Checkbox+List+With+Action">FC11011 - OT Checkbox List With Action</see></item><item><see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2238087334/FC11012+-+OT+WF+Outlined+Checkbox+List">FC11012 - OT WF Outlined Checkbox List</see></item><item><see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2237825260/FC11013+-+OT+WF+Checkbox+List">FC11013 - OT WF Checkbox List</see></item><item><see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2238087314/FC11011+-+OT+Checkbox+List+With+Action">FC11011 - OT Checkbox List With Action</see></item><item><see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2302574819/FC11017+-+OT+WF+Dynamic+List+-+Text+Field+Textarea+and+Filled+Radio+Buttons">FC11017 - OT WF Dynamic List - Text Field, Textarea and Filled Radio Buttons</see></item><item><see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2302574898/FC11018+-+OT+WF+Dynamic+List+-+Textarea+and+Filled+Radio+Buttons)</item></list>) */
export interface IDataDrivenOptionsListModel extends IDataDrivenResultBaseModel {
    /** Override selected */
    values: DataDrivenValueModel[];
}

/** One of the possible data types for OneTrack.DataDriven.Models.DataDrivenResponseModel.Result (See: [OT Overridable Options List](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927583/Data+Driven+Result+Object#OT-Overridable-Options-List) Used In: <list type="bullet"><item>[FC11018 - OT WF Dynamic List - Textarea and Filled Radio Buttons](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2238087314/FC11011+-+OT+Checkbox+List+With+Action">FC11011 - OT Checkbox List With Action</see></item><item><see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2238087334/FC11012+-+OT+WF+Outlined+Checkbox+List">FC11012 - OT WF Outlined Checkbox List</see></item><item><see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2237825260/FC11013+-+OT+WF+Checkbox+List">FC11013 - OT WF Checkbox List</see></item><item><see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2238087314/FC11011+-+OT+Checkbox+List+With+Action">FC11011 - OT Checkbox List With Action</see></item><item><see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2302574819/FC11017+-+OT+WF+Dynamic+List+-+Text+Field+Textarea+and+Filled+Radio+Buttons">FC11017 - OT WF Dynamic List - Text Field, Textarea and Filled Radio Buttons</see></item><item><see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2302574898/FC11018+-+OT+WF+Dynamic+List+-+Textarea+and+Filled+Radio+Buttons)</item></list>) */
export class DataDrivenOptionsListWithOtherModel extends DataDrivenResultBaseModel implements IDataDrivenOptionsListWithOtherModel {
    /** Override selected */
    values!: DataDrivenValueModel[];
    /** User entered text for the Other option */
    otherText?: string | undefined;

    constructor(data?: IDataDrivenOptionsListWithOtherModel) {
        super(data);
        if (!data) {
            this.values = [];
        }
        this._discriminator = "OptionsListWithOtherModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(DataDrivenValueModel.fromJS(item));
            }
            this.otherText = _data["otherText"];
        }
    }

    static fromJS(data: any): DataDrivenOptionsListWithOtherModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataDrivenOptionsListWithOtherModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        data["otherText"] = this.otherText;
        super.toJSON(data);
        return data;
    }
}

/** One of the possible data types for OneTrack.DataDriven.Models.DataDrivenResponseModel.Result (See: [OT Overridable Options List](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927583/Data+Driven+Result+Object#OT-Overridable-Options-List) Used In: <list type="bullet"><item>[FC11018 - OT WF Dynamic List - Textarea and Filled Radio Buttons](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2238087314/FC11011+-+OT+Checkbox+List+With+Action">FC11011 - OT Checkbox List With Action</see></item><item><see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2238087334/FC11012+-+OT+WF+Outlined+Checkbox+List">FC11012 - OT WF Outlined Checkbox List</see></item><item><see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2237825260/FC11013+-+OT+WF+Checkbox+List">FC11013 - OT WF Checkbox List</see></item><item><see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2238087314/FC11011+-+OT+Checkbox+List+With+Action">FC11011 - OT Checkbox List With Action</see></item><item><see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2302574819/FC11017+-+OT+WF+Dynamic+List+-+Text+Field+Textarea+and+Filled+Radio+Buttons">FC11017 - OT WF Dynamic List - Text Field, Textarea and Filled Radio Buttons</see></item><item><see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2302574898/FC11018+-+OT+WF+Dynamic+List+-+Textarea+and+Filled+Radio+Buttons)</item></list>) */
export interface IDataDrivenOptionsListWithOtherModel extends IDataDrivenResultBaseModel {
    /** Override selected */
    values: DataDrivenValueModel[];
    /** User entered text for the Other option */
    otherText?: string | undefined;
}

/** One of the possible data types for OneTrack.DataDriven.Models.DataDrivenResponseModel.Result (See: [OT Overridable Date Value](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927583/Data+Driven+Result+Object#OT-Overridable-Date-Value) Used In: <list type="bullet"><item>[FC11005 - OT Overridable Optional Date](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2238087756/FC11005+-+OT+Overridable+Optional+Date)</item></list>) */
export class DataDrivenOverridableDateValueModel extends DataDrivenResultBaseModel implements IDataDrivenOverridableDateValueModel {
    /** Override selected */
    adminOverride!: boolean;
    /** Contractor supplied value (date, option value) */
    contractorValue?: string | undefined;
    /** Administrator supplied value (date, option value) */
    adminValue?: string | undefined;
    /** Effective date value */
    date?: string | undefined;
    /** Optional text associated with response */
    text?: string | undefined;

    constructor(data?: IDataDrivenOverridableDateValueModel) {
        super(data);
        this._discriminator = "OverridableDateValueModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.adminOverride = _data["adminOverride"];
            this.contractorValue = _data["contractorValue"];
            this.adminValue = _data["adminValue"];
            this.date = _data["date"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): DataDrivenOverridableDateValueModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataDrivenOverridableDateValueModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminOverride"] = this.adminOverride;
        data["contractorValue"] = this.contractorValue;
        data["adminValue"] = this.adminValue;
        data["date"] = this.date;
        data["text"] = this.text;
        super.toJSON(data);
        return data;
    }
}

/** One of the possible data types for OneTrack.DataDriven.Models.DataDrivenResponseModel.Result (See: [OT Overridable Date Value](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927583/Data+Driven+Result+Object#OT-Overridable-Date-Value) Used In: <list type="bullet"><item>[FC11005 - OT Overridable Optional Date](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2238087756/FC11005+-+OT+Overridable+Optional+Date)</item></list>) */
export interface IDataDrivenOverridableDateValueModel extends IDataDrivenResultBaseModel {
    /** Override selected */
    adminOverride: boolean;
    /** Contractor supplied value (date, option value) */
    contractorValue?: string | undefined;
    /** Administrator supplied value (date, option value) */
    adminValue?: string | undefined;
    /** Effective date value */
    date?: string | undefined;
    /** Optional text associated with response */
    text?: string | undefined;
}

/** One of the possible data types for OneTrack.DataDriven.Models.DataDrivenResponseModel.Result (See: [OT Overridable Duration](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927583/Data+Driven+Result+Object#OT-Overridable-Duration) Used In: <list type="bullet"><item>[FC11007 - OT Overridable Optional Duration](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2259091573/FC11007+-+OT+Overridable+Optional+Duration)</item></list>) */
export class DataDrivenOverridableDurationModel extends DataDrivenResultBaseModel implements IDataDrivenOverridableDurationModel {
    /** Override selected */
    adminOverride!: boolean;
    /** Contractor supplied number */
    contractorValue?: number | undefined;
    /** Contractor selected calendar type */
    contractorCalendarType?: CalendarType | undefined;
    /** Administrator supplied number */
    adminValue?: number | undefined;
    /** Administrator selected calendar type */
    adminCalendarType?: CalendarType | undefined;
    /** Effective numerical result */
    number?: number | undefined;
    /** Effective calendar */
    calendarType?: CalendarType | undefined;
    /** Optional text associated with response */
    text?: string | undefined;

    constructor(data?: IDataDrivenOverridableDurationModel) {
        super(data);
        this._discriminator = "OverridableDurationModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.adminOverride = _data["adminOverride"];
            this.contractorValue = _data["contractorValue"];
            this.contractorCalendarType = _data["contractorCalendarType"];
            this.adminValue = _data["adminValue"];
            this.adminCalendarType = _data["adminCalendarType"];
            this.number = _data["number"];
            this.calendarType = _data["calendarType"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): DataDrivenOverridableDurationModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataDrivenOverridableDurationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminOverride"] = this.adminOverride;
        data["contractorValue"] = this.contractorValue;
        data["contractorCalendarType"] = this.contractorCalendarType;
        data["adminValue"] = this.adminValue;
        data["adminCalendarType"] = this.adminCalendarType;
        data["number"] = this.number;
        data["calendarType"] = this.calendarType;
        data["text"] = this.text;
        super.toJSON(data);
        return data;
    }
}

/** One of the possible data types for OneTrack.DataDriven.Models.DataDrivenResponseModel.Result (See: [OT Overridable Duration](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927583/Data+Driven+Result+Object#OT-Overridable-Duration) Used In: <list type="bullet"><item>[FC11007 - OT Overridable Optional Duration](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2259091573/FC11007+-+OT+Overridable+Optional+Duration)</item></list>) */
export interface IDataDrivenOverridableDurationModel extends IDataDrivenResultBaseModel {
    /** Override selected */
    adminOverride: boolean;
    /** Contractor supplied number */
    contractorValue?: number | undefined;
    /** Contractor selected calendar type */
    contractorCalendarType?: CalendarType | undefined;
    /** Administrator supplied number */
    adminValue?: number | undefined;
    /** Administrator selected calendar type */
    adminCalendarType?: CalendarType | undefined;
    /** Effective numerical result */
    number?: number | undefined;
    /** Effective calendar */
    calendarType?: CalendarType | undefined;
    /** Optional text associated with response */
    text?: string | undefined;
}

/** One of the possible data types for OneTrack.DataDriven.Models.DataDrivenResponseModel.Result (See: [OT Overridable Key Value](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927583/Data+Driven+Result+Object#OT-Overridable-Key-Value) Used In: <list type="bullet"><item>[FC11005 - OT Overridable Optional Date](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2238087705/FC11003+-+OT+Overridable+Select">FC11003 - OT Overridable Select</see></item><item><see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2238087756/FC11005+-+OT+Overridable+Optional+Date)</item></list>) */
export class DataDrivenOverridableKeyValueModel extends DataDrivenResultBaseModel implements IDataDrivenOverridableKeyValueModel {
    /** Override selected */
    adminOverride!: boolean;
    /** Contractor supplied value (date, option value) */
    contractorValue?: string | undefined;
    /** Administrator supplied value (date, option value) */
    adminValue?: string | undefined;
    /** Effective selected value */
    key!: string;
    /** Optional text associated with response */
    text?: string | undefined;

    constructor(data?: IDataDrivenOverridableKeyValueModel) {
        super(data);
        this._discriminator = "OverridableKeyValueModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.adminOverride = _data["adminOverride"];
            this.contractorValue = _data["contractorValue"];
            this.adminValue = _data["adminValue"];
            this.key = _data["key"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): DataDrivenOverridableKeyValueModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataDrivenOverridableKeyValueModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminOverride"] = this.adminOverride;
        data["contractorValue"] = this.contractorValue;
        data["adminValue"] = this.adminValue;
        data["key"] = this.key;
        data["text"] = this.text;
        super.toJSON(data);
        return data;
    }
}

/** One of the possible data types for OneTrack.DataDriven.Models.DataDrivenResponseModel.Result (See: [OT Overridable Key Value](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927583/Data+Driven+Result+Object#OT-Overridable-Key-Value) Used In: <list type="bullet"><item>[FC11005 - OT Overridable Optional Date](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2238087705/FC11003+-+OT+Overridable+Select">FC11003 - OT Overridable Select</see></item><item><see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2238087756/FC11005+-+OT+Overridable+Optional+Date)</item></list>) */
export interface IDataDrivenOverridableKeyValueModel extends IDataDrivenResultBaseModel {
    /** Override selected */
    adminOverride: boolean;
    /** Contractor supplied value (date, option value) */
    contractorValue?: string | undefined;
    /** Administrator supplied value (date, option value) */
    adminValue?: string | undefined;
    /** Effective selected value */
    key: string;
    /** Optional text associated with response */
    text?: string | undefined;
}

/** Details of a phase ([Data Driven Phase Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2685796353/Data+Driven+Phase+Object)) */
export class DataDrivenPhaseModel implements IDataDrivenPhaseModel {
    /** Identifier for the Phase */
    key!: string;
    /** Text to be used on screen */
    label!: string;
    /** How to calculate the due date for this phase

1 = RetainExisting (No due date calculations at all. Leave the existing due date (if any) alone)

2 = NoDueDate (No due date at all, reset back to null)

3 = SmartDetect (Looks for Due Date response, then looks in Parameters for due date config)

4 = UserDefined (Looks for Due Date response)

5 = Amendments (Looks in Parameters for due date config from the Amendments)

6 = UserDefinedRetainExisting (Look for Due Date Responses. If not found, retains the existing due date.) */
    dueDateCalculationMethod?: DueDateCalculationMethod | undefined;

    constructor(data?: IDataDrivenPhaseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.label = _data["label"];
            this.dueDateCalculationMethod = _data["dueDateCalculationMethod"];
        }
    }

    static fromJS(data: any): DataDrivenPhaseModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataDrivenPhaseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["label"] = this.label;
        data["dueDateCalculationMethod"] = this.dueDateCalculationMethod;
        return data;
    }
}

/** Details of a phase ([Data Driven Phase Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2685796353/Data+Driven+Phase+Object)) */
export interface IDataDrivenPhaseModel {
    /** Identifier for the Phase */
    key: string;
    /** Text to be used on screen */
    label: string;
    /** How to calculate the due date for this phase

1 = RetainExisting (No due date calculations at all. Leave the existing due date (if any) alone)

2 = NoDueDate (No due date at all, reset back to null)

3 = SmartDetect (Looks for Due Date response, then looks in Parameters for due date config)

4 = UserDefined (Looks for Due Date response)

5 = Amendments (Looks in Parameters for due date config from the Amendments)

6 = UserDefinedRetainExisting (Look for Due Date Responses. If not found, retains the existing due date.) */
    dueDateCalculationMethod?: DueDateCalculationMethod | undefined;
}

/** Property value ([Data Driven Property Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2427551810/Data+Driven+Property+Object)) */
export class DataDrivenPropertyModel implements IDataDrivenPropertyModel {
    /** Unique key for value */
    key?: string | undefined;
    /** Value of property (i.e. key for selected option) */
    value?: string | undefined;
    /** Display text for option */
    title?: string | undefined;
    /** Description text for option */
    description?: string | undefined;
    /** 

1 = Working (Working calendar)

2 = Business (Business calendar)

3 = CalendarDays (Every regular calendar day (Every regular calendar day, no weekdays or weekends and no holidays. Just regular sequential days.)) */
    calendarType?: CalendarType | undefined;
    /** 

1 = Barred (Contractor claim is disqualified.)

2 = Breach (Up to Superintendent’s discretion.)

3 = Nil (No legal impact if condition not met)

4 = NA (Not Applicable, not required) */
    consequence?: Consequence | undefined;
    /** The result the property was created from ([OT Result Base](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927583/Data+Driven+Result+Object#OT-Result-Base)

            Swashbuckle Doco here: [Enrich Polymorphic Base Classes with Discriminator Metadata]( https://github.com/domaindrivendev/Swashbuckle.AspNetCore#enrich-polymorphic-base-classes-with-discriminator-metadata)) */
    result?: DataDrivenResultBaseModel | undefined;
    /** Alternate text to be used for substitution into questions */
    alternateTextForQuestionSubstitution?: string | undefined;
    /** Alternate text to be used for substitution into messages (and other places like response text) */
    alternateTextForMessageSubstitution?: string | undefined;

    constructor(data?: IDataDrivenPropertyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.calendarType = _data["calendarType"];
            this.consequence = _data["consequence"];
            this.result = _data["result"] ? DataDrivenResultBaseModel.fromJS(_data["result"]) : <any>undefined;
            this.alternateTextForQuestionSubstitution = _data["alternateTextForQuestionSubstitution"];
            this.alternateTextForMessageSubstitution = _data["alternateTextForMessageSubstitution"];
        }
    }

    static fromJS(data: any): DataDrivenPropertyModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataDrivenPropertyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["title"] = this.title;
        data["description"] = this.description;
        data["calendarType"] = this.calendarType;
        data["consequence"] = this.consequence;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["alternateTextForQuestionSubstitution"] = this.alternateTextForQuestionSubstitution;
        data["alternateTextForMessageSubstitution"] = this.alternateTextForMessageSubstitution;
        return data;
    }
}

/** Property value ([Data Driven Property Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2427551810/Data+Driven+Property+Object)) */
export interface IDataDrivenPropertyModel {
    /** Unique key for value */
    key?: string | undefined;
    /** Value of property (i.e. key for selected option) */
    value?: string | undefined;
    /** Display text for option */
    title?: string | undefined;
    /** Description text for option */
    description?: string | undefined;
    /** 

1 = Working (Working calendar)

2 = Business (Business calendar)

3 = CalendarDays (Every regular calendar day (Every regular calendar day, no weekdays or weekends and no holidays. Just regular sequential days.)) */
    calendarType?: CalendarType | undefined;
    /** 

1 = Barred (Contractor claim is disqualified.)

2 = Breach (Up to Superintendent’s discretion.)

3 = Nil (No legal impact if condition not met)

4 = NA (Not Applicable, not required) */
    consequence?: Consequence | undefined;
    /** The result the property was created from ([OT Result Base](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927583/Data+Driven+Result+Object#OT-Result-Base)

            Swashbuckle Doco here: [Enrich Polymorphic Base Classes with Discriminator Metadata]( https://github.com/domaindrivendev/Swashbuckle.AspNetCore#enrich-polymorphic-base-classes-with-discriminator-metadata)) */
    result?: DataDrivenResultBaseModel | undefined;
    /** Alternate text to be used for substitution into questions */
    alternateTextForQuestionSubstitution?: string | undefined;
    /** Alternate text to be used for substitution into messages (and other places like response text) */
    alternateTextForMessageSubstitution?: string | undefined;
}

/** Details for Section Object which is part of Data Driven Definition Object in form of Json document ([Data Driven Question Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2373091380/Data+Driven+Question+Object)) */
export class DataDrivenQuestionModel implements IDataDrivenQuestionModel {
    /** Unique key for question */
    key!: string;
    title?: string | undefined;
    description?: string | undefined;
    /** Template used to render question for edit */
    editTemplate!: string;
    /** Template used to render question for display */
    displayTemplate!: string;
    /** Column header details where required for templates */
    columnHeaders?: DataDrivenColumnHeaderModel[] | undefined;
    /** Is a response to the question required. */
    isMandatory!: boolean;
    /** Question is dependant on one or more selected options from another question ([Data Driven Depends On Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927556/Data+Driven+Depends+On+Object)) */
    dependsOn?: DataDrivenDependsOnModel | undefined;
    syncFromQuestion?: DataDrivenSyncFromQuestionModel | undefined;
    /** Placeholder text for TextArea or TextField templates */
    placeholder?: string | undefined;
    /** Title where additional Notes block included */
    notesTitle?: string | undefined;
    /** Description where additional Notes block included */
    notesDescription?: string | undefined;
    /** Placeholder where additional Notes block included */
    notesPlaceholder?: string | undefined;
    /** Show or hide label associated with template. */
    isLabelHidden?: boolean | undefined;
    /** Text for Add Button */
    addButtonText?: string | undefined;
    /** Indent Level */
    indentLevel!: number;
    /** Order of Questions */
    orderIndex!: number;
    /** Array of options for current question */
    options?: DataDrivenOptionModel[] | undefined;
    /** Array of options for current question */
    subOptions?: DataDrivenSubOptionModel[] | undefined;
    /** Required for server side processing only. To be removed when returned as response to client ([Data Driven Server Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2375024641/Data+Driven+Server+Object)) */
    server?: DataDrivenServerModel | undefined;
    /** Property only used for Data Driven Evaluation Object ([OT Result Base](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927583/Data+Driven+Result+Object#OT-Result-Base)

            Swashbuckle Doco here: [Enrich Polymorphic Base Classes with Discriminator Metadata]( https://github.com/domaindrivendev/Swashbuckle.AspNetCore#enrich-polymorphic-base-classes-with-discriminator-metadata)) */
    result?: DataDrivenResultBaseModel | undefined;
    /** Refer to specified Question and retrieve selected options based on Instance. Display only selected Options. 

* Only applies to FC11013 - OT WF Checkbox List for MVP */
    selectedOptionsFromQuestionKeys?: string[] | undefined;
    /** A list of options to ignore from the selectedOptionsFromQuestionKeys. 
 */
    ignoreSelectedOptionsFromQuestionKeys?: string[] | undefined;
    /** Dictionary-esque collection of Config objects */
    configs?: DataDrivenConfigModel[] | undefined;
    /** Alternate text to be used for substitution into questions */
    alternateTextForQuestionSubstitution?: string | undefined;
    /** Alternate text to be used for substitution into messages */
    alternateTextForMessageSubstitution?: string | undefined;

    constructor(data?: IDataDrivenQuestionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.editTemplate = _data["editTemplate"];
            this.displayTemplate = _data["displayTemplate"];
            if (Array.isArray(_data["columnHeaders"])) {
                this.columnHeaders = [] as any;
                for (let item of _data["columnHeaders"])
                    this.columnHeaders!.push(DataDrivenColumnHeaderModel.fromJS(item));
            }
            this.isMandatory = _data["isMandatory"];
            this.dependsOn = _data["dependsOn"] ? DataDrivenDependsOnModel.fromJS(_data["dependsOn"]) : <any>undefined;
            this.syncFromQuestion = _data["syncFromQuestion"] ? DataDrivenSyncFromQuestionModel.fromJS(_data["syncFromQuestion"]) : <any>undefined;
            this.placeholder = _data["placeholder"];
            this.notesTitle = _data["notesTitle"];
            this.notesDescription = _data["notesDescription"];
            this.notesPlaceholder = _data["notesPlaceholder"];
            this.isLabelHidden = _data["isLabelHidden"];
            this.addButtonText = _data["addButtonText"];
            this.indentLevel = _data["indentLevel"];
            this.orderIndex = _data["orderIndex"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(DataDrivenOptionModel.fromJS(item));
            }
            if (Array.isArray(_data["subOptions"])) {
                this.subOptions = [] as any;
                for (let item of _data["subOptions"])
                    this.subOptions!.push(DataDrivenSubOptionModel.fromJS(item));
            }
            this.server = _data["server"] ? DataDrivenServerModel.fromJS(_data["server"]) : <any>undefined;
            this.result = _data["result"] ? DataDrivenResultBaseModel.fromJS(_data["result"]) : <any>undefined;
            if (Array.isArray(_data["selectedOptionsFromQuestionKeys"])) {
                this.selectedOptionsFromQuestionKeys = [] as any;
                for (let item of _data["selectedOptionsFromQuestionKeys"])
                    this.selectedOptionsFromQuestionKeys!.push(item);
            }
            if (Array.isArray(_data["ignoreSelectedOptionsFromQuestionKeys"])) {
                this.ignoreSelectedOptionsFromQuestionKeys = [] as any;
                for (let item of _data["ignoreSelectedOptionsFromQuestionKeys"])
                    this.ignoreSelectedOptionsFromQuestionKeys!.push(item);
            }
            if (Array.isArray(_data["configs"])) {
                this.configs = [] as any;
                for (let item of _data["configs"])
                    this.configs!.push(DataDrivenConfigModel.fromJS(item));
            }
            this.alternateTextForQuestionSubstitution = _data["alternateTextForQuestionSubstitution"];
            this.alternateTextForMessageSubstitution = _data["alternateTextForMessageSubstitution"];
        }
    }

    static fromJS(data: any): DataDrivenQuestionModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataDrivenQuestionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["title"] = this.title;
        data["description"] = this.description;
        data["editTemplate"] = this.editTemplate;
        data["displayTemplate"] = this.displayTemplate;
        if (Array.isArray(this.columnHeaders)) {
            data["columnHeaders"] = [];
            for (let item of this.columnHeaders)
                data["columnHeaders"].push(item.toJSON());
        }
        data["isMandatory"] = this.isMandatory;
        data["dependsOn"] = this.dependsOn ? this.dependsOn.toJSON() : <any>undefined;
        data["syncFromQuestion"] = this.syncFromQuestion ? this.syncFromQuestion.toJSON() : <any>undefined;
        data["placeholder"] = this.placeholder;
        data["notesTitle"] = this.notesTitle;
        data["notesDescription"] = this.notesDescription;
        data["notesPlaceholder"] = this.notesPlaceholder;
        data["isLabelHidden"] = this.isLabelHidden;
        data["addButtonText"] = this.addButtonText;
        data["indentLevel"] = this.indentLevel;
        data["orderIndex"] = this.orderIndex;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        if (Array.isArray(this.subOptions)) {
            data["subOptions"] = [];
            for (let item of this.subOptions)
                data["subOptions"].push(item.toJSON());
        }
        data["server"] = this.server ? this.server.toJSON() : <any>undefined;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        if (Array.isArray(this.selectedOptionsFromQuestionKeys)) {
            data["selectedOptionsFromQuestionKeys"] = [];
            for (let item of this.selectedOptionsFromQuestionKeys)
                data["selectedOptionsFromQuestionKeys"].push(item);
        }
        if (Array.isArray(this.ignoreSelectedOptionsFromQuestionKeys)) {
            data["ignoreSelectedOptionsFromQuestionKeys"] = [];
            for (let item of this.ignoreSelectedOptionsFromQuestionKeys)
                data["ignoreSelectedOptionsFromQuestionKeys"].push(item);
        }
        if (Array.isArray(this.configs)) {
            data["configs"] = [];
            for (let item of this.configs)
                data["configs"].push(item.toJSON());
        }
        data["alternateTextForQuestionSubstitution"] = this.alternateTextForQuestionSubstitution;
        data["alternateTextForMessageSubstitution"] = this.alternateTextForMessageSubstitution;
        return data;
    }
}

/** Details for Section Object which is part of Data Driven Definition Object in form of Json document ([Data Driven Question Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2373091380/Data+Driven+Question+Object)) */
export interface IDataDrivenQuestionModel {
    /** Unique key for question */
    key: string;
    title?: string | undefined;
    description?: string | undefined;
    /** Template used to render question for edit */
    editTemplate: string;
    /** Template used to render question for display */
    displayTemplate: string;
    /** Column header details where required for templates */
    columnHeaders?: DataDrivenColumnHeaderModel[] | undefined;
    /** Is a response to the question required. */
    isMandatory: boolean;
    /** Question is dependant on one or more selected options from another question ([Data Driven Depends On Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927556/Data+Driven+Depends+On+Object)) */
    dependsOn?: DataDrivenDependsOnModel | undefined;
    syncFromQuestion?: DataDrivenSyncFromQuestionModel | undefined;
    /** Placeholder text for TextArea or TextField templates */
    placeholder?: string | undefined;
    /** Title where additional Notes block included */
    notesTitle?: string | undefined;
    /** Description where additional Notes block included */
    notesDescription?: string | undefined;
    /** Placeholder where additional Notes block included */
    notesPlaceholder?: string | undefined;
    /** Show or hide label associated with template. */
    isLabelHidden?: boolean | undefined;
    /** Text for Add Button */
    addButtonText?: string | undefined;
    /** Indent Level */
    indentLevel: number;
    /** Order of Questions */
    orderIndex: number;
    /** Array of options for current question */
    options?: DataDrivenOptionModel[] | undefined;
    /** Array of options for current question */
    subOptions?: DataDrivenSubOptionModel[] | undefined;
    /** Required for server side processing only. To be removed when returned as response to client ([Data Driven Server Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2375024641/Data+Driven+Server+Object)) */
    server?: DataDrivenServerModel | undefined;
    /** Property only used for Data Driven Evaluation Object ([OT Result Base](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927583/Data+Driven+Result+Object#OT-Result-Base)

            Swashbuckle Doco here: [Enrich Polymorphic Base Classes with Discriminator Metadata]( https://github.com/domaindrivendev/Swashbuckle.AspNetCore#enrich-polymorphic-base-classes-with-discriminator-metadata)) */
    result?: DataDrivenResultBaseModel | undefined;
    /** Refer to specified Question and retrieve selected options based on Instance. Display only selected Options. 

* Only applies to FC11013 - OT WF Checkbox List for MVP */
    selectedOptionsFromQuestionKeys?: string[] | undefined;
    /** A list of options to ignore from the selectedOptionsFromQuestionKeys. 
 */
    ignoreSelectedOptionsFromQuestionKeys?: string[] | undefined;
    /** Dictionary-esque collection of Config objects */
    configs?: DataDrivenConfigModel[] | undefined;
    /** Alternate text to be used for substitution into questions */
    alternateTextForQuestionSubstitution?: string | undefined;
    /** Alternate text to be used for substitution into messages */
    alternateTextForMessageSubstitution?: string | undefined;
}

/** Basic details for a workflow ([Data Driven Response Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2370928957/Data+Driven+Response+Object)) */
export class DataDrivenResponseModel implements IDataDrivenResponseModel {
    questionKey!: string;
    /** A place for the UI to put loose data that it needs round tripped. 
 */
    client?: any | undefined;
    /** Indicates whether or not the response is controlled by the system. If set to true, this response cannot be changed by the user. ([OT Result Base](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927583/Data+Driven+Result+Object#OT-Result-Base)

            Swashbuckle Doco here: [Enrich Polymorphic Base Classes with Discriminator Metadata]( https://github.com/domaindrivendev/Swashbuckle.AspNetCore#enrich-polymorphic-base-classes-with-discriminator-metadata)) */
    result!: DataDrivenResultBaseModel;
    /** Indicates whether or not the response is controlled by the system. If set to true, this response cannot be changed by the user. */
    systemControlled?: boolean | undefined;

    constructor(data?: IDataDrivenResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.result = new DataDrivenResultBaseModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionKey = _data["questionKey"];
            this.client = _data["client"];
            this.result = _data["result"] ? DataDrivenResultBaseModel.fromJS(_data["result"]) : new DataDrivenResultBaseModel();
            this.systemControlled = _data["systemControlled"];
        }
    }

    static fromJS(data: any): DataDrivenResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataDrivenResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionKey"] = this.questionKey;
        data["client"] = this.client;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["systemControlled"] = this.systemControlled;
        return data;
    }
}

/** Basic details for a workflow ([Data Driven Response Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2370928957/Data+Driven+Response+Object)) */
export interface IDataDrivenResponseModel {
    questionKey: string;
    /** A place for the UI to put loose data that it needs round tripped. 
 */
    client?: any | undefined;
    /** Indicates whether or not the response is controlled by the system. If set to true, this response cannot be changed by the user. ([OT Result Base](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927583/Data+Driven+Result+Object#OT-Result-Base)

            Swashbuckle Doco here: [Enrich Polymorphic Base Classes with Discriminator Metadata]( https://github.com/domaindrivendev/Swashbuckle.AspNetCore#enrich-polymorphic-base-classes-with-discriminator-metadata)) */
    result: DataDrivenResultBaseModel;
    /** Indicates whether or not the response is controlled by the system. If set to true, this response cannot be changed by the user. */
    systemControlled?: boolean | undefined;
}

/** Details for Rule Object which is part of Data Driven Definition Object in form of Json document ([Data Driven Rule Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2384593067/Data+Driven+Rule+Object)) */
export class DataDrivenRuleModel implements IDataDrivenRuleModel {
    /** Unique Option Key */
    key!: string;
    title!: string;
    configs!: DataDrivenConfigModel[];
    /** Array of option keys that this rule is dependent on */
    dependsOnOptions?: string[][] | undefined;
    /** If true, will stop processing more rules if this rule returns a Reject recommendation */
    stopProcessingOnReject?: boolean;
    /** If true, the rule will only run at the end of the wizard, once we have gathered all of the data. Defaults to true. */
    isRecommendationOnlyRule?: boolean;

    constructor(data?: IDataDrivenRuleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.configs = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.title = _data["title"];
            if (Array.isArray(_data["configs"])) {
                this.configs = [] as any;
                for (let item of _data["configs"])
                    this.configs!.push(DataDrivenConfigModel.fromJS(item));
            }
            if (Array.isArray(_data["dependsOnOptions"])) {
                this.dependsOnOptions = [] as any;
                for (let item of _data["dependsOnOptions"])
                    this.dependsOnOptions!.push(item);
            }
            this.stopProcessingOnReject = _data["stopProcessingOnReject"];
            this.isRecommendationOnlyRule = _data["isRecommendationOnlyRule"];
        }
    }

    static fromJS(data: any): DataDrivenRuleModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataDrivenRuleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["title"] = this.title;
        if (Array.isArray(this.configs)) {
            data["configs"] = [];
            for (let item of this.configs)
                data["configs"].push(item.toJSON());
        }
        if (Array.isArray(this.dependsOnOptions)) {
            data["dependsOnOptions"] = [];
            for (let item of this.dependsOnOptions)
                data["dependsOnOptions"].push(item);
        }
        data["stopProcessingOnReject"] = this.stopProcessingOnReject;
        data["isRecommendationOnlyRule"] = this.isRecommendationOnlyRule;
        return data;
    }
}

/** Details for Rule Object which is part of Data Driven Definition Object in form of Json document ([Data Driven Rule Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2384593067/Data+Driven+Rule+Object)) */
export interface IDataDrivenRuleModel {
    /** Unique Option Key */
    key: string;
    title: string;
    configs: DataDrivenConfigModel[];
    /** Array of option keys that this rule is dependent on */
    dependsOnOptions?: string[][] | undefined;
    /** If true, will stop processing more rules if this rule returns a Reject recommendation */
    stopProcessingOnReject?: boolean;
    /** If true, the rule will only run at the end of the wizard, once we have gathered all of the data. Defaults to true. */
    isRecommendationOnlyRule?: boolean;
}

/** Details for Section Object which is part of Data Driven Definition Object in form of Json document ([Data Driven Section Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927529/Data+Driven+Section+Object)) */
export class DataDrivenSectionModel implements IDataDrivenSectionModel {
    key!: string;
    title?: string | undefined;
    description?: string | undefined;
    /** Order of Sections */
    orderIndex!: number;
    questions!: DataDrivenQuestionModel[];

    constructor(data?: IDataDrivenSectionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.questions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.orderIndex = _data["orderIndex"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(DataDrivenQuestionModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DataDrivenSectionModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataDrivenSectionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["title"] = this.title;
        data["description"] = this.description;
        data["orderIndex"] = this.orderIndex;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        return data;
    }
}

/** Details for Section Object which is part of Data Driven Definition Object in form of Json document ([Data Driven Section Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927529/Data+Driven+Section+Object)) */
export interface IDataDrivenSectionModel {
    key: string;
    title?: string | undefined;
    description?: string | undefined;
    /** Order of Sections */
    orderIndex: number;
    questions: DataDrivenQuestionModel[];
}

/** Configuration details for a segment ([Data Driven Segment Config Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2438923005/Segment+Config+Object)) */
export class DataDrivenSegmentConfigModel implements IDataDrivenSegmentConfigModel {
    contractuallyRequired!: boolean;
    /** Whether a specific Data Entry Item is required, optional or not allowed
[Data Entry Requirement](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Data-Entry-Requirement)

1 = Mandatory (The data entry item is required)

2 = Optional (The data entry item is Optional)

3 = Forbidden (The data entry item is Forbidden and will likely fail validation if it is filled in) */
    parentRequired!: DataEntryRequirement;
    /** Whether the Parent Segment Instance, if supplied, must have a Status that is Open, Closed or OpenOrClosed

1 = MustBeOpen (The Segment Instance must have a Status that falls into the Open category)

2 = CanBeOpenOrClosed (The Segment Instance can have a Status that falls into the Open or the Closed category)

3 = MustBeClosed (The Segment Instance must have a Status that falls into the Open category) */
    parentSegmentInstanceStatusRequirement?: SegmentInstanceStatusRequirement | undefined;
    /** The Short Names of the allowed parent segments for this segment. 

A null/undefined will mean that any parent segment is allowed */
    validParentCodes!: string[];
    /** Whether or not this segment requires Document details at creation time, or whether Document Details are optional at creation time, or whether they are not allowed at all at creation time.  

This only relates to creating/updating the segment instance from the "create workflow" screen. "Forbidden" can still have document details added during the workflow itself.

1 = Mandatory (The data entry item is required)

2 = Optional (The data entry item is Optional)

3 = Forbidden (The data entry item is Forbidden and will likely fail validation if it is filled in) */
    documentRequiredOnCreation?: DataEntryRequirement | undefined;
    /** RFI specific config for a Segment ([Segment RFI Config Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2684846084/Segment+RFI+Config+Object)) */
    rfiConfig?: DataDrivenSegmentRfiConfigModel | undefined;
    /** A list of phases in the Segment Definition */
    phases?: DataDrivenPhaseModel[] | undefined;
    /** The Default Phase */
    defaultPhaseKey?: string | undefined;
    /** Whether responses should be copied from the parent to a child when a new child is created. */
    copyResponsesFromParent?: boolean;
    /** Respond time templates for a segment 
 ([Data Driven Segment Respond Time Template Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2666397736/Data+Driven+Segment+Respond+Time+Templates+Object)) */
    respondTimeTemplate?: DataDrivenSegmentRespondTimeTemplateModel | undefined;
    /** Whether this workflow can created from scratch or not */
    canBeCreatedFromScratch?: boolean;

    constructor(data?: IDataDrivenSegmentConfigModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.validParentCodes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractuallyRequired = _data["contractuallyRequired"];
            this.parentRequired = _data["parentRequired"];
            this.parentSegmentInstanceStatusRequirement = _data["parentSegmentInstanceStatusRequirement"];
            if (Array.isArray(_data["validParentCodes"])) {
                this.validParentCodes = [] as any;
                for (let item of _data["validParentCodes"])
                    this.validParentCodes!.push(item);
            }
            this.documentRequiredOnCreation = _data["documentRequiredOnCreation"];
            this.rfiConfig = _data["rfiConfig"] ? DataDrivenSegmentRfiConfigModel.fromJS(_data["rfiConfig"]) : <any>undefined;
            if (Array.isArray(_data["phases"])) {
                this.phases = [] as any;
                for (let item of _data["phases"])
                    this.phases!.push(DataDrivenPhaseModel.fromJS(item));
            }
            this.defaultPhaseKey = _data["defaultPhaseKey"];
            this.copyResponsesFromParent = _data["copyResponsesFromParent"];
            this.respondTimeTemplate = _data["respondTimeTemplate"] ? DataDrivenSegmentRespondTimeTemplateModel.fromJS(_data["respondTimeTemplate"]) : <any>undefined;
            this.canBeCreatedFromScratch = _data["canBeCreatedFromScratch"];
        }
    }

    static fromJS(data: any): DataDrivenSegmentConfigModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataDrivenSegmentConfigModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractuallyRequired"] = this.contractuallyRequired;
        data["parentRequired"] = this.parentRequired;
        data["parentSegmentInstanceStatusRequirement"] = this.parentSegmentInstanceStatusRequirement;
        if (Array.isArray(this.validParentCodes)) {
            data["validParentCodes"] = [];
            for (let item of this.validParentCodes)
                data["validParentCodes"].push(item);
        }
        data["documentRequiredOnCreation"] = this.documentRequiredOnCreation;
        data["rfiConfig"] = this.rfiConfig ? this.rfiConfig.toJSON() : <any>undefined;
        if (Array.isArray(this.phases)) {
            data["phases"] = [];
            for (let item of this.phases)
                data["phases"].push(item.toJSON());
        }
        data["defaultPhaseKey"] = this.defaultPhaseKey;
        data["copyResponsesFromParent"] = this.copyResponsesFromParent;
        data["respondTimeTemplate"] = this.respondTimeTemplate ? this.respondTimeTemplate.toJSON() : <any>undefined;
        data["canBeCreatedFromScratch"] = this.canBeCreatedFromScratch;
        return data;
    }
}

/** Configuration details for a segment ([Data Driven Segment Config Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2438923005/Segment+Config+Object)) */
export interface IDataDrivenSegmentConfigModel {
    contractuallyRequired: boolean;
    /** Whether a specific Data Entry Item is required, optional or not allowed
[Data Entry Requirement](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2174746740/Enums#Data-Entry-Requirement)

1 = Mandatory (The data entry item is required)

2 = Optional (The data entry item is Optional)

3 = Forbidden (The data entry item is Forbidden and will likely fail validation if it is filled in) */
    parentRequired: DataEntryRequirement;
    /** Whether the Parent Segment Instance, if supplied, must have a Status that is Open, Closed or OpenOrClosed

1 = MustBeOpen (The Segment Instance must have a Status that falls into the Open category)

2 = CanBeOpenOrClosed (The Segment Instance can have a Status that falls into the Open or the Closed category)

3 = MustBeClosed (The Segment Instance must have a Status that falls into the Open category) */
    parentSegmentInstanceStatusRequirement?: SegmentInstanceStatusRequirement | undefined;
    /** The Short Names of the allowed parent segments for this segment. 

A null/undefined will mean that any parent segment is allowed */
    validParentCodes: string[];
    /** Whether or not this segment requires Document details at creation time, or whether Document Details are optional at creation time, or whether they are not allowed at all at creation time.  

This only relates to creating/updating the segment instance from the "create workflow" screen. "Forbidden" can still have document details added during the workflow itself.

1 = Mandatory (The data entry item is required)

2 = Optional (The data entry item is Optional)

3 = Forbidden (The data entry item is Forbidden and will likely fail validation if it is filled in) */
    documentRequiredOnCreation?: DataEntryRequirement | undefined;
    /** RFI specific config for a Segment ([Segment RFI Config Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2684846084/Segment+RFI+Config+Object)) */
    rfiConfig?: DataDrivenSegmentRfiConfigModel | undefined;
    /** A list of phases in the Segment Definition */
    phases?: DataDrivenPhaseModel[] | undefined;
    /** The Default Phase */
    defaultPhaseKey?: string | undefined;
    /** Whether responses should be copied from the parent to a child when a new child is created. */
    copyResponsesFromParent?: boolean;
    /** Respond time templates for a segment 
 ([Data Driven Segment Respond Time Template Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2666397736/Data+Driven+Segment+Respond+Time+Templates+Object)) */
    respondTimeTemplate?: DataDrivenSegmentRespondTimeTemplateModel | undefined;
    /** Whether this workflow can created from scratch or not */
    canBeCreatedFromScratch?: boolean;
}

/** Respond time templates for a segment ([Data Driven Segment Respond Time Template Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2666397736/Data+Driven+Segment+Respond+Time+Templates+Object)) */
export class DataDrivenSegmentRespondTimeTemplateModel implements IDataDrivenSegmentRespondTimeTemplateModel {
    none?: string | undefined;
    fixed?: string | undefined;
    other?: string | undefined;
    userSpecified?: string | undefined;

    constructor(data?: IDataDrivenSegmentRespondTimeTemplateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.none = _data["none"];
            this.fixed = _data["fixed"];
            this.other = _data["other"];
            this.userSpecified = _data["userSpecified"];
        }
    }

    static fromJS(data: any): DataDrivenSegmentRespondTimeTemplateModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataDrivenSegmentRespondTimeTemplateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["none"] = this.none;
        data["fixed"] = this.fixed;
        data["other"] = this.other;
        data["userSpecified"] = this.userSpecified;
        return data;
    }
}

/** Respond time templates for a segment ([Data Driven Segment Respond Time Template Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2666397736/Data+Driven+Segment+Respond+Time+Templates+Object)) */
export interface IDataDrivenSegmentRespondTimeTemplateModel {
    none?: string | undefined;
    fixed?: string | undefined;
    other?: string | undefined;
    userSpecified?: string | undefined;
}

/** RFI specific config for a Segment ([Segment RFI Config Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2684846084/Segment+RFI+Config+Object)) */
export class DataDrivenSegmentRfiConfigModel implements IDataDrivenSegmentRfiConfigModel {
    /** Defaults to false - whether this segment can spawn an RFI Outbound */
    rfiOutboundEnabled!: boolean;
    /** Formerly known as RfiOutboundStopsClock 

Whether the system should prompt the user before creating the RFI Outbound */
    rfiOutboundPromptBeforeCreating?: boolean;
    /** Status to set the parent to when creating the child RFI Outbound. Typically this will be Info Requested.

1 = InProgress (Segment is unresolved, this is the initial status for most segments)

2 = Suspended (Segment is unresolved but is marked as suspended, post MVP this will include additional logic for ‘Stopping the ticking of clocks’)

3 = InfoRequestedAndNotSuspended (Segment is unresolved and is noting that additional information has been requested)

4 = InfoRequestedAndSuspended (Effectively the same as both ‘Info Requested and Not Suspended’ and ‘Suspended’)

16 = Complete (Segment has been resolved)

17 = Withdrawn (Segment has been withdrawn (this is specially for when a contractor withdraws a claim))

18 = Cancelled (Segment has been cancelled (this is specifically for when the principal cancels a claim))

19 = Disputed (Segment is resolved and has been marked as being in dispute, Post MVP this means an additional dispute workflow as been created)

20 = LegalDispute (Same as Disputed but for Legal Disputes) */
    rfiParentStatusWhileOutbound?: SegmentInstanceStatus | undefined;
    /** Resolution of the parent when creating the child RFI Outbound. This only needs setting if Parent Status is set to a Complete status.

1 = Accepted (Segment has been accepted, claimed time/budget granted by the principal is added to the contract.)

2 = Rejected (Segment has been rejected, any claimed time/budget is noted but not added to the contract.)

3 = Indeterminate (Resolution not possible at this point.) */
    rfiParentResolutionWhileOutbound?: SegmentInstanceResolution | undefined;
    /** Phases of the parent that an RFI Outbound can be created in? */
    rfiOutboundPhaseKeys?: string[] | undefined;

    constructor(data?: IDataDrivenSegmentRfiConfigModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rfiOutboundEnabled = _data["rfiOutboundEnabled"];
            this.rfiOutboundPromptBeforeCreating = _data["rfiOutboundPromptBeforeCreating"];
            this.rfiParentStatusWhileOutbound = _data["rfiParentStatusWhileOutbound"];
            this.rfiParentResolutionWhileOutbound = _data["rfiParentResolutionWhileOutbound"];
            if (Array.isArray(_data["rfiOutboundPhaseKeys"])) {
                this.rfiOutboundPhaseKeys = [] as any;
                for (let item of _data["rfiOutboundPhaseKeys"])
                    this.rfiOutboundPhaseKeys!.push(item);
            }
        }
    }

    static fromJS(data: any): DataDrivenSegmentRfiConfigModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataDrivenSegmentRfiConfigModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rfiOutboundEnabled"] = this.rfiOutboundEnabled;
        data["rfiOutboundPromptBeforeCreating"] = this.rfiOutboundPromptBeforeCreating;
        data["rfiParentStatusWhileOutbound"] = this.rfiParentStatusWhileOutbound;
        data["rfiParentResolutionWhileOutbound"] = this.rfiParentResolutionWhileOutbound;
        if (Array.isArray(this.rfiOutboundPhaseKeys)) {
            data["rfiOutboundPhaseKeys"] = [];
            for (let item of this.rfiOutboundPhaseKeys)
                data["rfiOutboundPhaseKeys"].push(item);
        }
        return data;
    }
}

/** RFI specific config for a Segment ([Segment RFI Config Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2684846084/Segment+RFI+Config+Object)) */
export interface IDataDrivenSegmentRfiConfigModel {
    /** Defaults to false - whether this segment can spawn an RFI Outbound */
    rfiOutboundEnabled: boolean;
    /** Formerly known as RfiOutboundStopsClock 

Whether the system should prompt the user before creating the RFI Outbound */
    rfiOutboundPromptBeforeCreating?: boolean;
    /** Status to set the parent to when creating the child RFI Outbound. Typically this will be Info Requested.

1 = InProgress (Segment is unresolved, this is the initial status for most segments)

2 = Suspended (Segment is unresolved but is marked as suspended, post MVP this will include additional logic for ‘Stopping the ticking of clocks’)

3 = InfoRequestedAndNotSuspended (Segment is unresolved and is noting that additional information has been requested)

4 = InfoRequestedAndSuspended (Effectively the same as both ‘Info Requested and Not Suspended’ and ‘Suspended’)

16 = Complete (Segment has been resolved)

17 = Withdrawn (Segment has been withdrawn (this is specially for when a contractor withdraws a claim))

18 = Cancelled (Segment has been cancelled (this is specifically for when the principal cancels a claim))

19 = Disputed (Segment is resolved and has been marked as being in dispute, Post MVP this means an additional dispute workflow as been created)

20 = LegalDispute (Same as Disputed but for Legal Disputes) */
    rfiParentStatusWhileOutbound?: SegmentInstanceStatus | undefined;
    /** Resolution of the parent when creating the child RFI Outbound. This only needs setting if Parent Status is set to a Complete status.

1 = Accepted (Segment has been accepted, claimed time/budget granted by the principal is added to the contract.)

2 = Rejected (Segment has been rejected, any claimed time/budget is noted but not added to the contract.)

3 = Indeterminate (Resolution not possible at this point.) */
    rfiParentResolutionWhileOutbound?: SegmentInstanceResolution | undefined;
    /** Phases of the parent that an RFI Outbound can be created in? */
    rfiOutboundPhaseKeys?: string[] | undefined;
}

/** Details for Server object which is only required for server side processing ([Data Driven Server Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2375024641/Data+Driven+Server+Object)) */
export class DataDrivenServerModel implements IDataDrivenServerModel {
    evaluationKey!: string;
    sectionKey?: string | undefined;
    /** 

1 = Barred (Contractor claim is disqualified.)

2 = Breach (Up to Superintendent’s discretion.)

3 = Nil (No legal impact if condition not met)

4 = NA (Not Applicable, not required) */
    consequence?: Consequence | undefined;

    constructor(data?: IDataDrivenServerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.evaluationKey = _data["evaluationKey"];
            this.sectionKey = _data["sectionKey"];
            this.consequence = _data["consequence"];
        }
    }

    static fromJS(data: any): DataDrivenServerModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataDrivenServerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["evaluationKey"] = this.evaluationKey;
        data["sectionKey"] = this.sectionKey;
        data["consequence"] = this.consequence;
        return data;
    }
}

/** Details for Server object which is only required for server side processing ([Data Driven Server Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2375024641/Data+Driven+Server+Object)) */
export interface IDataDrivenServerModel {
    evaluationKey: string;
    sectionKey?: string | undefined;
    /** 

1 = Barred (Contractor claim is disqualified.)

2 = Breach (Up to Superintendent’s discretion.)

3 = Nil (No legal impact if condition not met)

4 = NA (Not Applicable, not required) */
    consequence?: Consequence | undefined;
}

/** Details for Option Object which is part of Data Driven Definition Object in form of Json document ([Data Driven Sub Option Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2427551909/Data+Driven+Sub+Option+Object)) */
export class DataDrivenSubOptionModel implements IDataDrivenSubOptionModel {
    /** Sub Option Key */
    key!: string;
    /** Sub Option Display Value */
    title!: string;
    /** 

1 = Barred (Contractor claim is disqualified.)

2 = Breach (Up to Superintendent’s discretion.)

3 = Nil (No legal impact if condition not met)

4 = NA (Not Applicable, not required) */
    consequence?: Consequence | undefined;

    constructor(data?: IDataDrivenSubOptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.title = _data["title"];
            this.consequence = _data["consequence"];
        }
    }

    static fromJS(data: any): DataDrivenSubOptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataDrivenSubOptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["title"] = this.title;
        data["consequence"] = this.consequence;
        return data;
    }
}

/** Details for Option Object which is part of Data Driven Definition Object in form of Json document ([Data Driven Sub Option Object](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2427551909/Data+Driven+Sub+Option+Object)) */
export interface IDataDrivenSubOptionModel {
    /** Sub Option Key */
    key: string;
    /** Sub Option Display Value */
    title: string;
    /** 

1 = Barred (Contractor claim is disqualified.)

2 = Breach (Up to Superintendent’s discretion.)

3 = Nil (No legal impact if condition not met)

4 = NA (Not Applicable, not required) */
    consequence?: Consequence | undefined;
}

/** Contains information to summarise an Evaluation ([Data Driven Summary Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2686124033/Data+Driven+Summary+Object)) */
export class DataDrivenSummaryModel implements IDataDrivenSummaryModel {
    /** Unique key value */
    key!: string;
    /** Text to be used on screen */
    label?: string | undefined;
    /** Any string value */
    value?: string | undefined;

    constructor(data?: IDataDrivenSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.label = _data["label"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): DataDrivenSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataDrivenSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["label"] = this.label;
        data["value"] = this.value;
        return data;
    }
}

/** Contains information to summarise an Evaluation ([Data Driven Summary Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2686124033/Data+Driven+Summary+Object)) */
export interface IDataDrivenSummaryModel {
    /** Unique key value */
    key: string;
    /** Text to be used on screen */
    label?: string | undefined;
    /** Any string value */
    value?: string | undefined;
}

export class DataDrivenSyncFromQuestionModel implements IDataDrivenSyncFromQuestionModel {
    questionKey?: string | undefined;
    checkedByDefault?: boolean;

    constructor(data?: IDataDrivenSyncFromQuestionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionKey = _data["questionKey"];
            this.checkedByDefault = _data["checkedByDefault"];
        }
    }

    static fromJS(data: any): DataDrivenSyncFromQuestionModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataDrivenSyncFromQuestionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionKey"] = this.questionKey;
        data["checkedByDefault"] = this.checkedByDefault;
        return data;
    }
}

export interface IDataDrivenSyncFromQuestionModel {
    questionKey?: string | undefined;
    checkedByDefault?: boolean;
}

/** One of the possible data types for OneTrack.DataDriven.Models.DataDrivenResponseModel.Result (See: [OT Text Value](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927583/Data+Driven+Result+Object#OT-Text-Value) Used In: <list type="bullet"><item>[FC11023 - OT WF Numerical Entry Field](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2155053249/FC11001+-+OT+WF+Text+Field">FC11001 - OT WF Text Field</see></item><item><see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2176516323/FC11002+-+OT+WF+Text+Area">FC11002 - OT WF Text Area</see></item><item><see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2309718130/FC11023+-+OT+WF+Numerical+Entry+Field)</item></list>) */
export class DataDrivenTextValueModel extends DataDrivenResultBaseModel implements IDataDrivenTextValueModel {
    /** User entered text value */
    text!: string;

    constructor(data?: IDataDrivenTextValueModel) {
        super(data);
        this._discriminator = "TextValueModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): DataDrivenTextValueModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataDrivenTextValueModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        super.toJSON(data);
        return data;
    }
}

/** One of the possible data types for OneTrack.DataDriven.Models.DataDrivenResponseModel.Result (See: [OT Text Value](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2372927583/Data+Driven+Result+Object#OT-Text-Value) Used In: <list type="bullet"><item>[FC11023 - OT WF Numerical Entry Field](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2155053249/FC11001+-+OT+WF+Text+Field">FC11001 - OT WF Text Field</see></item><item><see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2176516323/FC11002+-+OT+WF+Text+Area">FC11002 - OT WF Text Area</see></item><item><see href="https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2309718130/FC11023+-+OT+WF+Numerical+Entry+Field)</item></list>) */
export interface IDataDrivenTextValueModel extends IDataDrivenResultBaseModel {
    /** User entered text value */
    text: string;
}

/** Details for a specific Contract in form used on forms and POST requests ([Data Driven Value Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2358345868/Data+Driven+Value+Object)) */
export class DataDrivenValueModel implements IDataDrivenValueModel {
    key!: string;
    title?: string | undefined;
    templateTitle?: string | undefined;
    description?: string | undefined;
    /** This is the user selected sub option value */
    subOptionKey?: string | undefined;
    /** Order of Options */
    orderIndex!: number;
    /** Consequence for Option where applicable

1 = Barred (Contractor claim is disqualified.)

2 = Breach (Up to Superintendent’s discretion.)

3 = Nil (No legal impact if condition not met)

4 = NA (Not Applicable, not required) */
    consequence?: Consequence | undefined;
    /** Alternate text to be used for substitution into questions */
    alternateTextForQuestionSubstitution?: string | undefined;
    /** Alternate text to be used for substitution into messages */
    alternateTextForMessageSubstitution?: string | undefined;

    constructor(data?: IDataDrivenValueModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.title = _data["title"];
            this.templateTitle = _data["templateTitle"];
            this.description = _data["description"];
            this.subOptionKey = _data["subOptionKey"];
            this.orderIndex = _data["orderIndex"];
            this.consequence = _data["consequence"];
            this.alternateTextForQuestionSubstitution = _data["alternateTextForQuestionSubstitution"];
            this.alternateTextForMessageSubstitution = _data["alternateTextForMessageSubstitution"];
        }
    }

    static fromJS(data: any): DataDrivenValueModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataDrivenValueModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["title"] = this.title;
        data["templateTitle"] = this.templateTitle;
        data["description"] = this.description;
        data["subOptionKey"] = this.subOptionKey;
        data["orderIndex"] = this.orderIndex;
        data["consequence"] = this.consequence;
        data["alternateTextForQuestionSubstitution"] = this.alternateTextForQuestionSubstitution;
        data["alternateTextForMessageSubstitution"] = this.alternateTextForMessageSubstitution;
        return data;
    }
}

/** Details for a specific Contract in form used on forms and POST requests ([Data Driven Value Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2358345868/Data+Driven+Value+Object)) */
export interface IDataDrivenValueModel {
    key: string;
    title?: string | undefined;
    templateTitle?: string | undefined;
    description?: string | undefined;
    /** This is the user selected sub option value */
    subOptionKey?: string | undefined;
    /** Order of Options */
    orderIndex: number;
    /** Consequence for Option where applicable

1 = Barred (Contractor claim is disqualified.)

2 = Breach (Up to Superintendent’s discretion.)

3 = Nil (No legal impact if condition not met)

4 = NA (Not Applicable, not required) */
    consequence?: Consequence | undefined;
    /** Alternate text to be used for substitution into questions */
    alternateTextForQuestionSubstitution?: string | undefined;
    /** Alternate text to be used for substitution into messages */
    alternateTextForMessageSubstitution?: string | undefined;
}

/** Details for Button object in Layout for Json document ([Data Driven Dialog Buttons Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2441478411/Data+Driven+Dialog+Buttons+Object)) */
export class DialogButtonsOverrideModel implements IDialogButtonsOverrideModel {
    /** Details for Ok Buttons ([Data Driven Button Details Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2441314632/Data+Driven+Button+Details+Object)) */
    okButton?: ButtonDetailsModel | undefined;
    /** Details for Cancel Buttons ([Data Driven Button Details Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2441314632/Data+Driven+Button+Details+Object)) */
    cancelButton?: ButtonDetailsModel | undefined;
    /** Details for View Buttons ([Data Driven Button Details Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2441314632/Data+Driven+Button+Details+Object)) */
    viewButton?: ButtonDetailsModel | undefined;

    constructor(data?: IDialogButtonsOverrideModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.okButton = _data["okButton"] ? ButtonDetailsModel.fromJS(_data["okButton"]) : <any>undefined;
            this.cancelButton = _data["cancelButton"] ? ButtonDetailsModel.fromJS(_data["cancelButton"]) : <any>undefined;
            this.viewButton = _data["viewButton"] ? ButtonDetailsModel.fromJS(_data["viewButton"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DialogButtonsOverrideModel {
        data = typeof data === 'object' ? data : {};
        let result = new DialogButtonsOverrideModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["okButton"] = this.okButton ? this.okButton.toJSON() : <any>undefined;
        data["cancelButton"] = this.cancelButton ? this.cancelButton.toJSON() : <any>undefined;
        data["viewButton"] = this.viewButton ? this.viewButton.toJSON() : <any>undefined;
        return data;
    }
}

/** Details for Button object in Layout for Json document ([Data Driven Dialog Buttons Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2441478411/Data+Driven+Dialog+Buttons+Object)) */
export interface IDialogButtonsOverrideModel {
    /** Details for Ok Buttons ([Data Driven Button Details Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2441314632/Data+Driven+Button+Details+Object)) */
    okButton?: ButtonDetailsModel | undefined;
    /** Details for Cancel Buttons ([Data Driven Button Details Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2441314632/Data+Driven+Button+Details+Object)) */
    cancelButton?: ButtonDetailsModel | undefined;
    /** Details for View Buttons ([Data Driven Button Details Model](https://redgum.atlassian.net/wiki/spaces/ONETRACK/pages/2441314632/Data+Driven+Button+Details+Object)) */
    viewButton?: ButtonDetailsModel | undefined;
}

export class ScenarioInformationModel implements IScenarioInformationModel {
    key?: string | undefined;
    displayName?: string | undefined;
    description?: string | undefined;

    constructor(data?: IScenarioInformationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ScenarioInformationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioInformationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }
}

export interface IScenarioInformationModel {
    key?: string | undefined;
    displayName?: string | undefined;
    description?: string | undefined;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' +
        (d.getMonth() < 9 ? ('0' + (d.getMonth() + 1)) : (d.getMonth() + 1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}